import React, { useState, useRef, useEffect } from "react";

// ── jsPDF dynamisch laden ─────────────────────────────────────────
const loadJsPDF = () => new Promise((resolve) => {
  if(window.jspdf){resolve(window.jspdf.jsPDF);return;}
  const s=document.createElement("script");
  s.src="https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
  s.onload=()=>resolve(window.jspdf.jsPDF);
  document.head.appendChild(s);
});

const erstellePDF = async (absender, empfaenger, betreff, briefTextFn, heuteStr, empfAdresseFn) => {
  const jsPDF = await loadJsPDF();
  const pdfs = [];
  for(const x of empfaenger){
    const doc = new jsPDF({format:"a4",unit:"mm"});
    const a = absender||{};
    const W = 210, ML = 25, MR = 25, textW = W - ML - MR;
    doc.setFont("helvetica","normal");

    // Absender-Zeile oben klein
    doc.setFontSize(8);
    doc.setTextColor(120,120,120);
    doc.text(`${a.name||""} · ${a.strasse||""} · ${a.plz||""} ${a.stadt||""}`, ML, 20);
    doc.setDrawColor(200,200,200);
    doc.line(ML, 22, W-MR, 22);

    // Empfängeradresse
    doc.setFontSize(11);
    doc.setTextColor(30,30,30);
    const adrZeilen = [`${x.mi.anrede||""} ${x.mi.name||""}`, ...(empfAdresseFn(x)).split("\n")].filter(Boolean);
    adrZeilen.forEach((z,i) => doc.text(z, ML, 42 + i*6));

    // Absender rechts
    doc.setFontSize(10);
    doc.setTextColor(60,60,60);
    const absZeilen = [a.name||"", a.strasse||"", `${a.plz||""} ${a.stadt||""}`].filter(Boolean);
    absZeilen.forEach((z,i) => doc.text(z, W-MR, 42+i*6, {align:"right"}));

    // Datum
    doc.setFontSize(10);
    doc.setTextColor(30,30,30);
    doc.text(`${x.obj.stadt||"Ort"}, den ${heuteStr}`, W-MR, 75, {align:"right"});

    // Betreff
    doc.setFont("helvetica","bold");
    doc.setFontSize(11);
    doc.text(`Betreff: ${betreff}`, ML, 88);

    // Brieftext
    doc.setFont("helvetica","normal");
    doc.setFontSize(10);
    doc.setTextColor(30,30,30);
    const btxt = briefTextFn(x);
    const zeilen = doc.splitTextToSize(btxt, textW);
    let y = 98;
    zeilen.forEach(z => {
      if(y > 270){ doc.addPage(); y = 25; }
      doc.text(z, ML, y);
      y += 5.5;
    });

    // Seitenzahl
    doc.setFontSize(8);
    doc.setTextColor(150,150,150);
    doc.text(`Seite 1`, W/2, 290, {align:"center"});

    pdfs.push({doc, name: x.mi.name, dateiname:`Brief_${betreff}_${x.mi.name}_${heuteStr.replace(/\. /g,"-")}.pdf`});
  }
  return pdfs;
};

// ── Logo ──────────────────────────────────────────────────────────
const LOGO_URL = "data:image/svg+xml;base64,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";

// ── Helpers ──────────────────────────────────────────────────────
const useIsMobile = () => {
  const [m, setM] = useState(window.innerWidth < 768);
  useEffect(() => {
    const h = () => setM(window.innerWidth < 768);
    window.addEventListener("resize", h);
    return () => window.removeEventListener("resize", h);
  }, []);
  return m;
};
const uid = () => Math.random().toString(36).slice(2,9);
const fmt = n => Number(n||0).toLocaleString("de-DE",{minimumFractionDigits:2,maximumFractionDigits:2});
const fmtD = s => s ? new Date(s).toLocaleDateString("de-DE") : "—";
const warmmiete = v => Math.round(((+(v.kaltmiete||0))+(+(v.nebenkosten||0))+(+(v.stellplatz||0))+(+(v.kueche||0)))*100)/100;

// Berechnet die anteilige Warmmiete für einen bestimmten Monat, falls Ein- oder Auszug mitten im Monat liegt
const anteiligeMiete = (v, m, y) => {
  const voll = warmmiete(v);
  const parseD = str => { if(!str) return null; const [yr,mo,d]=str.split("-").map(Number); return new Date(yr,mo-1,d||1); };
  const tageImMonat = new Date(y, m+1, 0).getDate();
  let tageAnteilig = tageImMonat;
  const beginn = parseD(v.mietBeginn||v.einzug);
  if (beginn && beginn.getFullYear()===y && beginn.getMonth()===m) {
    tageAnteilig = tageImMonat - beginn.getDate() + 1;
  }
  const ende = parseD(v.mietEnde);
  if (ende && ende.getFullYear()===y && ende.getMonth()===m) {
    tageAnteilig = Math.min(tageAnteilig, ende.getDate());
  }
  if (tageAnteilig === tageImMonat) return voll; // voller Monat, keine Rundungsabweichung
  return Math.round(voll * tageAnteilig / tageImMonat * 100) / 100;
};
const mk = (m,y) => `${m+1}-${y}`;

// Berechnet den n-ten Werktag eines Monats (Mo-Fr, keine Feiertage)
const nterWerktag = (n, monat0basiert, jahr) => {
  let count = 0;
  let tag = 1;
  while(true) {
    const d = new Date(jahr, monat0basiert, tag);
    const dow = d.getDay(); // 0=So, 6=Sa
    if(dow !== 0 && dow !== 6) {
      count++;
      if(count === n) return d;
    }
    tag++;
    if(tag > 31) break;
  }
  return new Date(jahr, monat0basiert, n);
};
const NOW = new Date();
const M0 = NOW.getMonth(), Y0 = NOW.getFullYear(); // 0-basiert (Jan=0)
const MN = ["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"];
const MK = ["Jan","Feb","Mär","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez"];
const STEUER = 0.42;
const auszugDatum = kd => { if(!kd) return null; const d=new Date(kd); d.setMonth(d.getMonth()+3); d.setDate(0); return d.toISOString().split("T")[0]; };
const exportCSV = (rows,fn) => { const a=document.createElement("a"); a.href=URL.createObjectURL(new Blob(["\uFEFF"+rows.map(r=>r.map(c=>`"${String(c??"").replace(/"/g,'""')}"`).join(";")).join("\n")],{type:"text/csv;charset=utf-8;"})); a.download=fn; a.click(); };


// ── Auto-Kategorisierung ─────────────────────────────────────────
const STEUER_REGELN = [
  {keywords:["grundsteuer","grund steuer"],steuerkat:"Umlagefähige Nebenkosten",kategorie:"Betriebskosten"},
  {keywords:["müll","abfall","entsorgung","müllabfuhr"],steuerkat:"Umlagefähige Nebenkosten",kategorie:"Betriebskosten"},
  {keywords:["wasser","abwasser","kanal"],steuerkat:"Umlagefähige Nebenkosten",kategorie:"Betriebskosten"},
  {keywords:["versicherung","gebäude","haftpflicht"],steuerkat:"Umlagefähige Nebenkosten",kategorie:"Versicherung"},
  {keywords:["hausmeister","reinigung","treppenhausreinigung"],steuerkat:"Umlagefähige Nebenkosten",kategorie:"Betriebskosten"},
  {keywords:["heizung","gas","öl","fernwärme","wartung heiz"],steuerkat:"Umlagefähige Nebenkosten",kategorie:"Betriebskosten"},
  {keywords:["aufzug","fahrstuhl"],steuerkat:"Umlagefähige Nebenkosten",kategorie:"Betriebskosten"},
  {keywords:["reparatur","instandhalt","instandsetz","sanierung"],steuerkat:"Werbungskosten",kategorie:"Reparatur"},
  {keywords:["zinsen","kredit","darlehen","finanzierung"],steuerkat:"Werbungskosten",kategorie:"Verwaltung"},
  {keywords:["steuerberater","buchhaltung","verwaltung","hausverwaltung"],steuerkat:"Werbungskosten",kategorie:"Verwaltung"},
  {keywords:["strom","elektro","energie"],steuerkat:"Umlagefähige Nebenkosten",kategorie:"Betriebskosten"},
];

const autoErkenne = (text) => {
  const t = text.toLowerCase();
  for(const regel of STEUER_REGELN){
    if(regel.keywords.some(k=>t.includes(k))){
      return {steuerkat:regel.steuerkat,kategorie:regel.kategorie,erkannt:true};
    }
  }
  return {steuerkat:"Sonstiges",kategorie:"Sonstiges",erkannt:false};
};

// ── Farbthemen ───────────────────────────────────────────────────
const THEMES = {
  carbon: {
    name:"Carbon", icon:"✦",
    bg:"#080810", card:"#0f0f1a", card2:"#141420",
    border:"#1e1e30", b2:"#252538",
    text:"#e8e6f0", muted:"#5a5870", m2:"#3a3850",
    blue:"#6366f1", blue2:"#4f46e5",
    gT:"#818cf8", g2:"#0f0f20",
    rT:"#f87171", r2:"#1a0a0a",
    yT:"#c084fc", y2:"#150a20",
    pT:"#a78bfa", p2:"#100a1e",
  },
  sage: {
    name:"Sage", icon:"🌿",
    bg:"#eef2ee", card:"#f5f8f5", card2:"#e8ede8",
    border:"#ccd8cc", b2:"#bbcabb",
    text:"#2a352a", muted:"#6a7d6a", m2:"#8a9e8a",
    blue:"#4a7c59", blue2:"#3a6447",
    gT:"#3a6447", g2:"#d4e8d8",
    rT:"#c0392b", r2:"#fde8e6",
    yT:"#7a6020", y2:"#f0e8cc",
    pT:"#4a5a7a", p2:"#d8e0f0",
  },
  platin: {
    name:"Platin", icon:"⬜",
    bg:"#111", card:"#1a1a1a", card2:"#222",
    border:"#333", b2:"#444",
    text:"#e8e8e8", muted:"#777", m2:"#555",
    blue:"#888", blue2:"#666",
    gT:"#aaa", g2:"#1a1a1a",
    rT:"#cc4444", r2:"#2a1010",
    yT:"#aa8833", y2:"#1a1500",
    pT:"#888", p2:"#1a1a2a",
  },
  blanc: {
    name:"Blanc", icon:"🤍",
    bg:"#f5f0eb", card:"#faf8f5", card2:"#ede8e0",
    border:"#d8d0c4", b2:"#c8bfb0",
    text:"#1a1410", muted:"#7a6a58", m2:"#9a8a78",
    blue:"#5a3a1a", blue2:"#3a2010",
    gT:"#2a5020", g2:"#d8edd0",
    rT:"#7a2020", r2:"#f0dada",
    yT:"#5a4010", y2:"#f0e8cc",
    pT:"#3a2a5a", p2:"#e8e0f0",
  },
};
const getTheme = () => {
  const saved = localStorage.getItem("immo_theme");
  return THEMES[saved] || THEMES.carbon;
};
let C = getTheme();
const inp = {background:C.card,border:`1px solid ${C.border}`,borderRadius:8,color:C.text,padding:"9px 12px",fontSize:14,width:"100%",outline:"none",boxSizing:"border-box",fontFamily:"inherit"};
const lbl = {color:C.muted,fontSize:11,display:"block",marginBottom:4,textTransform:"uppercase",letterSpacing:.5};
const bP = {background:`linear-gradient(135deg,${C.blue},${C.blue2})`,border:"none",color:"#fff",borderRadius:8,padding:"8px 14px",cursor:"pointer",fontSize:13,fontWeight:600,display:"flex",alignItems:"center",gap:6,whiteSpace:"nowrap"};
const bS = {background:C.card,border:`1px solid ${C.border}`,color:C.muted,borderRadius:8,padding:"8px 14px",cursor:"pointer",fontSize:13,display:"flex",alignItems:"center",gap:6,whiteSpace:"nowrap"};
const bD = {background:C.r2,border:`1px solid ${C.rT}44`,color:C.rT,borderRadius:8,padding:"8px 14px",cursor:"pointer",fontSize:13,display:"flex",alignItems:"center",gap:6,whiteSpace:"nowrap"};

// ── Seed Data ─────────────────────────────────────────────────────
const SEED = {
  bankAccounts:[],
  bankTransactions:[],
  musterMietvertrag:null,
  objekte:[
    {id:"o1",name:"Musterstraße 1, 12345 Musterstadt",adresse:"Musterstraße 1, 12345 Musterstadt",strasse:"Musterstraße 1",plz:"12345",stadt:"Musterstadt"},
    {id:"o2",name:"Hauptstraße 22, 12345 Musterstadt",adresse:"Hauptstraße 22, 12345 Musterstadt",strasse:"Hauptstraße 22",plz:"12345",stadt:"Musterstadt"},
    {id:"o3",name:"Gartenweg 5, 12345 Musterstadt",adresse:"Gartenweg 5, 12345 Musterstadt",strasse:"Gartenweg 5",plz:"12345",stadt:"Musterstadt"},
    {id:"o4",name:"Parkstraße 8, 12345 Musterstadt",adresse:"Parkstraße 8, 12345 Musterstadt",strasse:"Parkstraße 8",plz:"12345",stadt:"Musterstadt"},
  ],
  mieter:[
    {id:"m1",name:"Anna Bauer",anrede:"Frau",email:"anna.bauer@email.de",telefon:"0170 1111111",nachsende:""},
    {id:"m2",name:"Klaus Werner",anrede:"Herr",email:"k.werner@email.de",telefon:"0171 2222222",nachsende:""},
    {id:"m3",name:"Sandra Koch",anrede:"Frau",email:"s.koch@email.de",telefon:"0172 3333333",nachsende:""},
    {id:"m4",name:"Thomas Müller",anrede:"Herr",email:"t.mueller@email.de",telefon:"0173 4444444",nachsende:""},
    {id:"m5",name:"Maria Schmidt",anrede:"Frau",email:"m.schmidt@email.de",telefon:"0174 5555555",nachsende:""},
    {id:"m6",name:"Peter Hoffmann",anrede:"Herr",email:"p.hoffmann@email.de",telefon:"0175 6666666",nachsende:""},
  ],
  absender:{name:"",strasse:"",plz:"",stadt:""},
  vertraege:[
    {id:"v1",objektId:"o1",mieterId:"m1",einheit:"WE 1",kaltmiete:850,nebenkosten:180,stellplatz:60,kueche:0,einzug:"2022-03-01",kaution:2550,kautionBezahlt:true,aktiv:true,kuendigung:null},
    {id:"v2",objektId:"o1",mieterId:"m2",einheit:"WE 2",kaltmiete:920,nebenkosten:200,stellplatz:0,kueche:40,einzug:"2021-06-01",kaution:2760,kautionBezahlt:true,aktiv:true,kuendigung:null},
    {id:"v3",objektId:"o2",mieterId:"m3",einheit:"WE 1",kaltmiete:780,nebenkosten:160,stellplatz:50,kueche:0,einzug:"2020-09-01",kaution:2340,kautionBezahlt:true,aktiv:true,kuendigung:null},
    {id:"v4",objektId:"o2",mieterId:"m4",einheit:"WE 2",kaltmiete:1050,nebenkosten:220,stellplatz:60,kueche:50,einzug:"2023-01-01",kaution:3150,kautionBezahlt:false,aktiv:true,kuendigung:null},
    {id:"v5",objektId:"o3",mieterId:"m5",einheit:"WE 1",kaltmiete:1100,nebenkosten:240,stellplatz:0,kueche:0,einzug:"2019-04-01",kaution:3300,kautionBezahlt:true,aktiv:true,kuendigung:null},
    {id:"v6",objektId:"o4",mieterId:"m6",einheit:"WE 1",kaltmiete:950,nebenkosten:190,stellplatz:70,kueche:0,einzug:"2021-11-01",kaution:2850,kautionBezahlt:true,aktiv:true,kuendigung:null},
  ],
  zahlungen:[],
  offenePosten:[
    {id:"op1",vertragsId:"v4",objektId:"o2",bezeichnung:"NK-Nachzahlung 2024",betrag:380,faelligAm:"2025-06-30",bezahlt:false,gemahnt:false,mahnDatum:null,mahnStufe:0},
  ],
  ausgaben:[
    {id:"a1",objektId:"o1",kategorie:"Reparatur",beschreibung:"Heizung Wartung",betrag:320,datum:"2025-04-15",rechnungNr:"RE-2025-042"},
    {id:"a2",objektId:"o2",kategorie:"Versicherung",beschreibung:"Gebäudeversicherung",betrag:890,datum:"2025-01-10",rechnungNr:"GV-2025-001"},
  ],
  dateien:[],
  mitarbeiter:[
    {id:"ma1",name:"Hans Gruber",rolle:"hausmeister",email:"h.gruber@email.de",telefon:"0176 1234567",objektZugang:["o1","o2"],aktiv:true},
    {id:"ma2",name:"Lisa Neumann",rolle:"verwalter",email:"l.neumann@email.de",telefon:"0177 7654321",objektZugang:["o1","o2","o3","o4"],aktiv:true},
  ],
  aufgaben:[
    {id:"au1",titel:"Fenster abdichten WE 3",objektId:"o1",zugewiesen:"ma1",prioritaet:"hoch",status:"offen",faellig:"2025-06-15",notiz:"Zugluft gemeldet"},
    {id:"au2",titel:"Heizung Jahresinspektion",objektId:"o2",zugewiesen:"ma1",prioritaet:"mittel",status:"in_bearbeitung",faellig:"2025-07-01",notiz:""},
  ],
  nkPositionen:{
    o1:[
      {id:"nk1",bezeichnung:"Grundsteuer",betrag:800,intervall:"jaehrlich",kategorie:"umlagefaehig"},
      {id:"nk2",bezeichnung:"Gebäudeversicherung",betrag:1200,intervall:"jaehrlich",kategorie:"umlagefaehig"},
      {id:"nk3",bezeichnung:"Müllabfuhr",betrag:360,intervall:"jaehrlich",kategorie:"umlagefaehig"},
      {id:"nk4",bezeichnung:"Hausmeister",betrag:2400,intervall:"jaehrlich",kategorie:"umlagefaehig"},
    ],
    o2:[],o3:[],o4:[],
  },
  fixKosten:{
    o1:[],
    o2:[],o3:[],o4:[],
  },
  darlehen:[],
  fotos:{},
  zahlungsplaene:[],
  mietErhoehungen:[],
  rechnungsablage:{},
  erinnerungsSettings:{email:"",typ:"dashboard",vorlauf:3,mahnkosten:{1:0,2:5,3:10},basiszins:2.62},
  autoLogout:30,
  mieterhöhungen:[],
  stundenzettel:[],
  zaehler:{
    // Format: {objektId: {allgemein:[{id,typ,nr,ablesungen:[{stand,datum}]}], wohnungen:{einheit:[{id,typ,nr,ablesungen:[]}]}}}
  },
  objektConfig:{
    o1:{heizung:"zentral",wmz:true,wasserInWohnungen:false,zentral:{strom:{nr:"",stand:"",datum:""},wasser:{nr:"",stand:"",datum:""},gas:{nr:"",stand:"",datum:""}},wohnungen:{"WE 1":{raeume:3,strom:{nr:"",stand:"",datum:""},wmz:[]},"WE 2":{raeume:2,strom:{nr:"",stand:"",datum:""},wmz:[]}}},
    o2:{heizung:"einzel",wmz:false,wasserInWohnungen:true,zentral:{strom:{nr:"",stand:"",datum:""},wasser:{nr:"",stand:"",datum:""}},wohnungen:{"WE 1":{raeume:3,strom:{nr:"",stand:"",datum:""},gas:{nr:"",stand:"",datum:""},wasser:{nr:"",stand:"",datum:""}},"WE 2":{raeume:4,strom:{nr:"",stand:"",datum:""},gas:{nr:"",stand:"",datum:""},wasser:{nr:"",stand:"",datum:""}}}},
    o3:{heizung:"zentral",wmz:false,wasserInWohnungen:false,zentral:{strom:{nr:"",stand:"",datum:""},wasser:{nr:"",stand:"",datum:""},gas:{nr:"",stand:"",datum:""}},wohnungen:{"WE 1":{raeume:3,strom:{nr:"",stand:"",datum:""},wmz:[]}}},
    o4:{heizung:"einzel",wmz:false,wasserInWohnungen:false,zentral:{strom:{nr:"",stand:"",datum:""},wasser:{nr:"",stand:"",datum:""}},wohnungen:{"WE 1":{raeume:2,strom:{nr:"",stand:"",datum:""},gas:{nr:"",stand:"",datum:""}}}},
  },
};

// ── Shared UI ─────────────────────────────────────────────────────
const Bdg = ({col,ch}) => {
  const m = {green:{bg:C.g2,c:C.gT},red:{bg:C.r2,c:C.rT},yellow:{bg:C.y2,c:C.yT},blue:{bg:"#dce8f5",c:C.blue2},purple:{bg:C.p2,c:C.pT}};
  const x = m[col]||m.blue;
  return <span style={{background:x.bg,color:x.c,padding:"2px 9px",borderRadius:20,fontSize:11,fontWeight:600,display:"inline-flex",alignItems:"center",gap:3}}>{ch}</span>;
};
const Modal = ({title,onClose,children,w=520}) => (
  <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.4)",zIndex:2000,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
    <div style={{background:C.card,borderRadius:14,border:`1px solid ${C.b2}`,width:w,maxWidth:"100%",maxHeight:"90vh",overflow:"auto"}} onClick={e=>e.stopPropagation()}>
      <div style={{padding:"16px 20px",borderBottom:`1px solid ${C.border}`,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <span style={{color:C.text,fontWeight:700,fontSize:15}}>{title}</span>
        <button onClick={onClose} style={{background:"none",border:"none",color:C.muted,cursor:"pointer",fontSize:20}}>✕</button>
      </div>
      <div style={{padding:20}}>{children}</div>
    </div>
  </div>
);
const F = ({label,ch}) => <div style={{marginBottom:12}}><label style={lbl}>{label}</label>{ch}</div>;
const Tog = ({label,desc,on,onChange}) => (
  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 0",borderBottom:`1px solid ${C.border}`}}>
    <div><div style={{color:C.text,fontSize:14,fontWeight:600}}>{label}</div>{desc&&<div style={{color:C.muted,fontSize:12,marginTop:2}}>{desc}</div>}</div>
    <button onClick={()=>onChange(!on)} style={{width:42,height:22,borderRadius:11,background:on?C.blue:C.border,border:"none",cursor:"pointer",position:"relative",transition:"background .2s",flexShrink:0}}>
      <span style={{position:"absolute",top:2,left:on?21:2,width:18,height:18,borderRadius:"50%",background:"#fff",transition:"left .2s",display:"block"}}/>
    </button>
  </div>
);

// Absenderkarte mit lokalem Zwischenspeicher (verhindert Fokus-Verlust beim Tippen)
const ErinnerungsCard = ({settings, onSave}) => {
  const def = {email:"",typ:"dashboard",vorlauf:3,mahnkosten:{1:0,2:5,3:10},basiszins:2.62};
  const [s, setS] = useState({...def,...(settings||{})});
  const [gespeichert, setGespeichert] = useState(false);
  useEffect(()=>{ if(settings) setS({...def,...settings}); },[JSON.stringify(settings)]);
  const save = () => { onSave(s); setGespeichert(true); setTimeout(()=>setGespeichert(false),2000); };
  return (<>
    <div style={{background:C.card,borderRadius:11,padding:18,border:`1px solid ${C.border}`,marginTop:14}}>
      <div style={{color:C.muted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:12}}>Erinnerungseinstellungen</div>
      <div style={{display:"flex",flexDirection:"column",gap:10,marginBottom:12}}>
        <div>
          <label style={lbl}>E-Mail für Erinnerungen</label>
          <input style={inp} autoComplete="off" type="email" value={s.email||""} onChange={e=>setS(p=>({...p,email:e.target.value}))} placeholder="deine@email.de"/>
        </div>
        <div>
          <label style={lbl}>Standard-Erinnerungstyp</label>
          <select style={inp} value={s.typ||"dashboard"} onChange={e=>setS(p=>({...p,typ:e.target.value}))}>
            <option value="dashboard">Nur Dashboard</option>
            <option value="email">Nur E-Mail</option>
            <option value="beide">Dashboard & E-Mail</option>
          </select>
        </div>
        <div>
          <label style={lbl}>Vorlaufzeit vor Fälligkeit</label>
          <select style={inp} value={s.vorlauf||3} onChange={e=>setS(p=>({...p,vorlauf:parseInt(e.target.value)}))}>
            <option value={1}>1 Tag vorher</option>
            <option value={3}>3 Tage vorher</option>
          </select>
        </div>
      </div>
      <div style={{color:C.muted,fontSize:11,marginBottom:10}}>Diese Einstellungen gelten für alle Zahlungsziele als Standard.</div>
      <button style={{...bP,width:"100%",justifyContent:"center"}} onClick={save}>{gespeichert?"✓ Gespeichert":"💾 Speichern"}</button>
    </div>
    <div style={{background:C.card,borderRadius:11,padding:18,border:`1px solid ${C.border}`,marginTop:14}}>
      <div style={{color:C.muted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:12}}>Mahnkosten & Verzugszinsen</div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:10}}>
        {[{k:1,l:"Stufe 1 (Erinnerung)"},{k:2,l:"Stufe 2 (1. Mahnung)"},{k:3,l:"Stufe 3 (Letzte Mahnung)"}].map(({k,l})=>(
          <div key={k} style={{gridColumn:k===3?"1/-1":"auto"}}>
            <label style={lbl}>{l} €</label>
            <input type="number" style={inp} value={s.mahnkosten?.[k]??[0,5,10][k-1]}
              onChange={e=>setS(p=>({...p,mahnkosten:{...(p.mahnkosten||{}),[k]:parseFloat(e.target.value)||0}}))}
              placeholder={["0","5","10"][k-1]}/>
          </div>
        ))}
      </div>
      <div style={{marginBottom:12}}>
        <label style={lbl}>Basiszinssatz % (aktuell: 2,62%)</label>
        <input type="number" style={inp} step="0.01" value={s.basiszins??2.62} onChange={e=>setS(p=>({...p,basiszins:parseFloat(e.target.value)||2.62}))} placeholder="2.62"/>
        <div style={{color:C.muted,fontSize:11,marginTop:6}}>Verzugszins = Basiszinssatz + 5% · wird automatisch in Mahnungen berechnet</div>
      </div>
      <button style={{...bP,width:"100%",justifyContent:"center"}} onClick={save}>{gespeichert?"✓ Gespeichert":"💾 Speichern"}</button>
    </div>
  </>);
};

const AbsenderCard = ({absender, onSave}) => {
  const [a, setA] = useState(absender || {name:"",strasse:"",plz:"",stadt:""});
  const [gespeichert, setGespeichert] = useState(false);
  const timerRef = useRef(null);
  useEffect(()=>{
    if(absender) setA(absender);
  }, [JSON.stringify(absender)]);
  const onChange = (field, val) => {
    setA(p=>({...p,[field]:val}));
    setGespeichert(false);
  };
  const save = () => {
    onSave(a);
    setGespeichert(true);
    setTimeout(()=>setGespeichert(false), 2000);
  };
  return (
    <div style={{background:C.card,borderRadius:11,padding:18,border:`1px solid ${C.border}`,marginBottom:14}}>
      <div style={{color:C.muted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:12}}>Absenderdaten (für Briefe)</div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:12}}>
        <div style={{gridColumn:"1/-1"}}><label style={lbl}>Name / Firma</label><input style={inp} autoComplete="off" name="imm-sender" data-lpignore="true" value={a.name||""} onChange={e=>onChange("name",e.target.value)} placeholder="Max Mustermann"/></div>
        <div style={{gridColumn:"1/-1"}}><label style={lbl}>Straße & Hausnummer</label><input style={inp} autoComplete="off" name="imm-street" data-lpignore="true" value={a.strasse||""} onChange={e=>onChange("strasse",e.target.value)} placeholder="Beispielweg 1"/></div>
        <div><label style={lbl}>PLZ</label><input style={inp} autoComplete="off" name="imm-zip" data-lpignore="true" value={a.plz||""} onChange={e=>onChange("plz",e.target.value)} placeholder="12345"/></div>
        <div><label style={lbl}>Stadt</label><input style={inp} autoComplete="off" name="imm-city" data-lpignore="true" value={a.stadt||""} onChange={e=>onChange("stadt",e.target.value)} placeholder="Musterstadt"/></div>
      </div>
      <button style={{...bP,width:"100%",justifyContent:"center"}} onClick={save}>
        {gespeichert?"✓ Gespeichert":"💾 Absenderdaten speichern"}
      </button>
    </div>
  );
};


// ── Finanz-Hilfskomponenten ──────────────────────────────────────
const FinSH = ({ch}) => <div style={{color:C.muted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1.5,marginBottom:12}}>{ch}</div>;
const FinRow = ({l,v,c,bold}) => <div style={{display:"flex",justifyContent:"space-between",padding:"6px 0",borderBottom:`1px solid ${C.border}`}}><span style={{color:C.text,fontSize:13,fontWeight:bold?700:400}}>{l}</span><span style={{color:c||C.text,fontWeight:bold?800:600,fontSize:13}}>{v}</span></div>;

// ── FINANZEN ─────────────────────────────────────────────────────

// ── NK-Positionen Dropdown ────────────────────────────────────────
const NKDropdown = ({oId, positionen, jahrBetrag, intervallLabel, upd, setNkEditForm}) => {
  const [offen, setOffen] = useState(false);
  const jahresGesamt = positionen.reduce((s,p)=>s+jahrBetrag(p),0);
  return (
    <div style={{marginBottom:12}}>
      <button onClick={()=>setOffen(v=>!v)} style={{width:"100%",background:C.card2,border:`1px solid ${C.border}`,borderRadius:8,padding:"9px 12px",cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:offen?0:0}}>
        <div style={{display:"flex",alignItems:"center",gap:8}}>
          <span style={{color:C.text,fontWeight:600,fontSize:13}}>Laufende NK-Positionen</span>
          <span style={{background:C.card,color:C.muted,fontSize:11,padding:"1px 7px",borderRadius:10,border:`1px solid ${C.border}`}}>{positionen.length}</span>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <span style={{color:C.muted,fontSize:12}}>{fmt(jahresGesamt)} €/Jahr</span>
          <span style={{color:C.muted,fontSize:12}}>{offen?"▲":"▼"}</span>
        </div>
      </button>
      {offen&&(
        <div style={{background:C.card2,borderRadius:"0 0 8px 8px",border:`1px solid ${C.border}`,borderTop:"none",padding:"4px 0"}}>
          {positionen.length===0?(
            <div style={{padding:"12px",color:C.muted,fontSize:12,textAlign:"center"}}>Noch keine Positionen angelegt</div>
          ):positionen.map((p,i)=>(
            <div key={p.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"7px 12px",borderBottom:i<positionen.length-1?`1px solid ${C.border}`:"none"}}>
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                <Bdg col={p.kategorie==="umlagefaehig"?"green":"yellow"} ch={p.kategorie==="umlagefaehig"?"umlagef.":"Werb.kosten"}/>
                <span style={{color:C.text,fontSize:13}}>{p.bezeichnung}</span>
              </div>
              <div style={{display:"flex",gap:8,alignItems:"center"}}>
                <span style={{color:C.muted,fontSize:12}}>{fmt(p.betrag)} € {intervallLabel[p.intervall]}</span>
                <span style={{color:C.rT,fontSize:12,fontWeight:600}}>{fmt(jahrBetrag(p))} €/Jahr</span>
                <button style={{background:"none",border:"none",color:C.muted,cursor:"pointer",fontSize:13,padding:"2px 4px"}} title="Bearbeiten" onClick={()=>setNkEditForm({oId, position:p})}>✏️</button>
                <button style={{...bD,padding:"3px 7px",fontSize:11}} onClick={()=>{if(window.confirm(`"${p.bezeichnung}" wirklich löschen?`))upd("nkPositionen",nn=>({...nn,[oId]:(nn?.[oId]||[]).filter(x=>x.id!==p.id)}));}}>🗑</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const Finanzen = ({ctx}) => {
  const isMobile = useIsMobile();
const {db,upd,say,getOb,vvObj,istObj,zdA,getMi,gesamtE,gesamtA,exportCSV,fmtD,fmt,uid,user,token,setModal} = ctx;
  const [fj,setFj] = useState(Y0);
  const [expandedMonat,setExpandedMonat] = useState(null); // 0-basierter Monatsindex oder null
  const [finTab,setFinTab] = useState("uebersicht");
  const [nkModal,setNkModal] = useState(null); // {objektId} or null
  const [fkModal,setFkModal] = useState(null);
  const [fkEditForm,setFkEditForm] = useState(null); // {oId, position}
  const [belegModal,setBelegModal] = useState(false);
  const [nkForm,setNkForm] = useState({bezeichnung:"",betrag:"",intervall:"monatlich",kategorie:"umlagefaehig",eingabeArt:"intervall",jahresSumme:""});
  const [nkEditForm,setNkEditForm] = useState(null); // {oId, position}
  const [fkForm,setFkForm] = useState({bezeichnung:"",betrag:"",intervall:"monatlich"});
  const [dModal,setDModal] = useState(false); // true = neu anlegen
  const [dEditForm,setDEditForm] = useState(null); // Darlehen-Objekt zum Bearbeiten
  const [dForm,setDForm] = useState({objektId:"",bezeichnung:"",restschuld:"",zinsBetrag:"",tilgungBetrag:"",beginn:new Date().toISOString().split("T")[0],hatBausparvertrag:false,bausparBank:"",bausparGuthaben:"",bausparSparrate:"",bausparTilgung:"",bausparZielsumme:""});

  // ── Hilfsfunktionen ──
  const jahrBetrag = (pos) => {
    const b = parseFloat(pos.betrag)||0;
    if(pos.intervall==="monatlich") return b*12;
    if(pos.intervall==="halbjaehrlich") return b*2;
    if(pos.intervall==="quartalsweise") return b*4;
    return b; // jaehrlich
  };

  const nkEinnahmen = (oId) => {
    const vv = vvObj(oId);
    return vv.reduce((s,v)=>{
      const monatlicheNK = parseFloat(v.nebenkosten)||0;
      return s + (monatlicheNK * 12);
    },0);
  };

  const nkAusgaben = (oId) => {
    const positionenBetrag = (db.nkPositionen?.[oId]||[]).filter(p=>p.kategorie==="umlagefaehig").reduce((s,p)=>s+jahrBetrag(p),0);
    const belegeBetrag = db.ausgaben.filter(a=>a.objektId===oId&&a.steuerkat==="Umlagefähige Nebenkosten"&&a.datum?.startsWith(String(fj))).reduce((s,a)=>s+parseFloat(a.betrag||0),0);
    return positionenBetrag + belegeBetrag;
  };

  // ── Darlehen: Zins/Tilgung direkt in € + Restlaufzeit ──
  // Zins und Tilgung werden direkt als € pro Monat eingegeben (keine Prozentrechnung)
  const darlehenMonat = (d) => {
    const zins = parseFloat(d.zinsBetrag)||0;
    const tilgung = parseFloat(d.tilgungBetrag)||0;
    return { zins, tilgung };
  };
  // Vereinfachte Restlaufzeit: Restschuld ÷ aktuelle monatliche Tilgung (bei gleichbleibender Tilgungsrate)
  const darlehenRestlaufzeit = (d) => {
    const schuld = parseFloat(d.restschuld)||0;
    const tilgung = parseFloat(d.tilgungBetrag)||0;
    if (tilgung <= 0) return Infinity;
    return Math.ceil(schuld / tilgung);
  };
  // Restlaufzeit über den Bausparvertrag: Zeit bis Bausparsumme (Zielsumme) durch Guthaben + monatliche Einzahlung erreicht ist
  const darlehenRestlaufzeitBauspar = (d) => {
    const guthaben = parseFloat(d.bausparGuthaben)||0;
    const ziel = parseFloat(d.bausparZielsumme)||0;
    // Tilgung-Feld nutzen falls ausgefüllt, sonst auf Sparrate zurückfallen
    const tilgung = (parseFloat(d.bausparTilgung)||0) > 0 ? parseFloat(d.bausparTilgung) : (parseFloat(d.bausparSparrate)||0);
    if (guthaben >= ziel) return 0;
    if (tilgung <= 0) return Infinity;
    return Math.ceil((ziel - guthaben) / tilgung);
  };
  // Wandelt Darlehen in Zins/Tilgung-Ausgabeneinträge für ein Jahr um (vereinfacht: aktuelle Monatsbeträge über alle 12 Monate)
  const darlehenAlsAusgaben = (jahr) => {
    const ergebnis = [];
    (db.darlehen||[]).forEach(d => {
      const { zins, tilgung } = darlehenMonat(d);
      for (let m = 0; m < 12; m++) {
        const datum = `${jahr}-${String(m+1).padStart(2,"0")}-01`;
        if (zins > 0) ergebnis.push({
          id:`${d.id}_zins_${m}`, objektId:d.objektId, datum,
          beschreibung:`${d.bezeichnung} – Zinsen`, betrag:zins.toFixed(2),
          kategorie:"Finanzierung", steuerkat:"Werbungskosten", wiederkehrend:true,
        });
        if (tilgung > 0) ergebnis.push({
          id:`${d.id}_tilgung_${m}`, objektId:d.objektId, datum,
          beschreibung:`${d.bezeichnung} – Tilgung`, betrag:tilgung.toFixed(2),
          kategorie:"Finanzierung", steuerkat:"Tilgung (kein Aufwand)", wiederkehrend:true,
        });
      }
    });
    return ergebnis;
  };

  // Wandelt hochgeladene/manuelle Ausgaben mit Zahlungsintervall in periodisierte Einzelbeträge um.
  // "einmalig" (Standard) = unverändert. Andere Intervalle verteilen den Betrag anteilig auf Folgeperioden.
  const periodisiereAusgaben = (jahr) => {
    const perioden = {monatlich:12, quartalsweise:4, halbjaehrlich:2, jaehrlich:1};
    const ergebnis = [];
    db.ausgaben.forEach(a => {
      const intervall = a.intervall || "einmalig";
      if (intervall === "einmalig") {
        if (a.datum?.startsWith(String(jahr))) ergebnis.push(a);
        return;
      }
      const n = perioden[intervall] || 1;
      const betragProPeriode = parseFloat(a.betrag||0) / n;
      const [startY, startM] = (a.datum||`${jahr}-01-01`).split("-").map(Number);
      const schritt = 12 / n;
      for (let i = 0; i < n; i++) {
        const monatIndex = (startM - 1) + i * schritt;
        const y = startY + Math.floor(monatIndex / 12);
        const m = ((monatIndex % 12) + 12) % 12;
        if (y !== jahr) continue;
        ergebnis.push({...a, id:`${a.id}_p${i}`, datum:`${y}-${String(m+1).padStart(2,"0")}-01`, betrag:betragProPeriode, _periodisiert:true, _original:a});
      }
    });
    return ergebnis;
  };

  // Wandelt laufende NK-Positionen in einzelne Ausgaben-Einträge für ein Jahr um (für Jahresabschluss/Belege-Übersicht)
  const nkAlsAusgaben = (jahr) => {
    const perioden = {monatlich:12, quartalsweise:4, halbjaehrlich:2, jaehrlich:1};
    const ergebnis = [];
    Object.entries(db.nkPositionen||{}).forEach(([oId, positionen]) => {
      (positionen||[]).forEach(p => {
        const n = perioden[p.intervall] || 1;
        const schritt = 12 / n;
        for (let i = 0; i < n; i++) {
          const monat = Math.round(i * schritt); // 0-basiert
          ergebnis.push({
            id: `${p.id}_${i}`,
            objektId: oId,
            datum: `${jahr}-${String(monat+1).padStart(2,"0")}-01`,
            beschreibung: p.bezeichnung,
            betrag: p.betrag,
            kategorie: "Laufende Kosten",
            steuerkat: p.kategorie==="umlagefaehig" ? "Umlagefähige Nebenkosten" : "Werbungskosten",
            wiederkehrend: true,
          });
        }
      });
    });
    return ergebnis;
  };
  const fixKostenJahr = (oId) => (db.fixKosten?.[oId]||[]).reduce((s,p)=>s+jahrBetrag(p),0);
  const kaltEinnahmen = (oId) => vvObj(oId).reduce((s,v)=>s+(parseFloat(v.kaltmiete)||0)*12,0);

  const nkAusgabenJahr = [...nkAlsAusgaben(fj), ...darlehenAlsAusgaben(fj)]; // einmal berechnen, für Monatsdiagramm wiederverwenden
  const mv=Array.from({length:12},(_,m)=>{
    const istZukunft = fj > Y0 || (fj===Y0 && m > NOW.getMonth());
    return {
      m:MK[m],
      e:db.zahlungen.filter(z=>z.monat===mk(m,fj)).reduce((s,z)=>s+parseFloat(z.betrag||0),0),
      eSoll:db.vertraege.filter(v=>v.aktiv&&!v.leerstand).reduce((s,v)=>s+warmmiete(v),0),
      a: istZukunft ? 0 : (
        periodisiereAusgaben(fj).filter(a=>a.datum?.startsWith(`${fj}-${String(m+1).padStart(2,"0")}`)).reduce((s,a)=>s+parseFloat(a.betrag),0)
        + nkAusgabenJahr.filter(a=>a.datum?.startsWith(`${fj}-${String(m+1).padStart(2,"0")}`)).reduce((s,a)=>s+parseFloat(a.betrag),0)
      )
    };
  });
  const maxV=Math.max(...mv.map(x=>Math.max(x.e,x.a)),1);

  // Einnahmen/Ausgaben oben in der Übersicht = Summe aus dem Monatlichen Verlauf (garantiert konsistent, nur bis aktuellem Monat)
  const einnIst=mv.reduce((s,x)=>s+x.e,0);
  const ausg=mv.reduce((s,x)=>s+x.a,0);
  // Soll-Einnahmen: Warmmiete × Monate seit Mietbeginn bis heute/Jahresende
  const einnSoll = db.vertraege.filter(v=>v.aktiv&&!v.leerstand).reduce((s,v)=>s+warmmiete(v),0)*12;
  const einn = einnIst; // Tatsächlich eingegangen
  const netto=einn-ausg,steuer=Math.max(0,netto*STEUER);


  const intervallLabel = {monatlich:"/ Monat",jaehrlich:"/ Jahr",halbjaehrlich:"/ Halbjahr",quartalsweise:"/ Quartal"};

  return (
    <div style={{padding:isMobile?"10px 10px 0":"28px",overflowY:"auto",flex:1,WebkitOverflowScrolling:"touch"}}>
      {/* Header */}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
        <div>
          <h2 style={{color:C.text,fontSize:20,fontWeight:800,margin:0}}>Finanzen & Steuer</h2>
          <p style={{color:C.muted,fontSize:12,marginTop:3}}>Steuersatz: {(STEUER*100).toFixed(0)}% · {fj}</p>
        </div>
        <div style={{display:"flex",gap:8,alignItems:"center"}}>
          <button style={{...bS,padding:"6px 10px"}} onClick={()=>setFj(y=>y-1)}>◀</button>
          <span style={{color:C.text,fontWeight:700,fontSize:15,minWidth:50,textAlign:"center"}}>{fj}</span>
          <button style={{...bS,padding:"6px 10px"}} onClick={()=>setFj(y=>y+1)}>▶</button>
          <button style={{...bS,fontSize:12}} onClick={()=>{exportCSV([["Monat","Einnahmen","Ausgaben","Netto"],...mv.map(x=>[x.m,x.e.toFixed(2),x.a.toFixed(2),(x.e-x.a).toFixed(2)])],`Kassenbuch_${fj}.csv`);say("CSV exportiert ✓");}}>⬇ CSV</button>
        </div>
      </div>

      {/* Tabs */}
      <div style={{display:"flex",gap:2,marginBottom:22,borderBottom:`1px solid ${C.border}`,overflowX:"auto",WebkitOverflowScrolling:"touch",scrollbarWidth:"none"}}>
        {[{id:"uebersicht",l:"📊 Übersicht"},{id:"jahresabschluss",l:"📋 Jahresabschluss"},{id:"liquidplanung",l:"💧 Liquiditätsplanung"},{id:"nebenkosten",l:"🏠 Nebenkosten"},{id:"liquiditaet",l:"💰 Kaltmiete"},{id:"darlehen",l:"🏛 Darlehen"},{id:"bank",l:"🏦 Bankabgleich"},...(ctx.user?.role==="admin"?[{id:"zahlungsplan",l:"🎯 Zahlungsziele"}]:[]),{id:"belege",l:"🧾 Belege"},{id:"steuern",l:"📑 Steuer"}].map(t=>(
          <button key={t.id} onClick={()=>setFinTab(t.id)} style={{background:"none",border:"none",color:finTab===t.id?C.blue:C.muted,padding:"9px 13px",cursor:"pointer",fontSize:13,fontWeight:finTab===t.id?700:400,borderBottom:finTab===t.id?`2px solid ${C.blue}`:"2px solid transparent",whiteSpace:"nowrap",flexShrink:0}}>{t.l}</button>
        ))}
      </div>

      {/* ── GESAMTÜBERSICHT ── */}
      {finTab==="uebersicht"&&(
        <div>
          <div style={{display:"grid",gridTemplateColumns:isMobile?"repeat(2,1fr)":"repeat(4,1fr)",gap:12,marginBottom:20}}>
            {[
              {l:"Einnahmen",v:fmt(einnIst),c:C.gT},
              {l:"Ausgaben",v:fmt(ausg),c:C.rT},
              {l:"Netto-Gewinn",v:fmt(netto),c:netto>=0?C.gT:C.rT},
              {l:`Steuer (~${(STEUER*100).toFixed(0)}%)`,v:fmt(steuer),c:C.yT},
            ].map((k,i)=>(
              <div key={i} style={{background:C.card,borderRadius:11,padding:"16px 18px",border:`1px solid ${C.border}`}}>
                <div style={{color:C.muted,fontSize:11,textTransform:"uppercase",marginBottom:5}}>{k.l}</div>
                <div style={{color:k.c,fontSize:18,fontWeight:800}}>{k.v} €</div>
              </div>
            ))}
          </div>
          <div style={{background:`linear-gradient(135deg,${C.blue},${C.pT})`,borderRadius:11,padding:"16px 22px",marginBottom:20,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div><div style={{color:C.muted2||"rgba(255,255,255,.6)",fontSize:12,marginBottom:3}}>Netto nach Steuer {fj}</div><div style={{color:"#fff",fontSize:24,fontWeight:800}}>{fmt(netto-steuer)} €</div></div>
            <div style={{color:"rgba(255,255,255,.4)",fontSize:12}}>nach ~{(STEUER*100).toFixed(0)}% Einkommensteuer</div>
          </div>
          <div style={{background:C.card,borderRadius:11,padding:20,marginBottom:18,border:`1px solid ${C.border}`}}>
            <FinSH ch={`Monatlicher Verlauf ${fj}`}/>
            <div style={{display:"flex",gap:6,alignItems:"flex-end",height:160}}>
              {mv.map((x,i)=>(
                <div key={i} onClick={()=>setExpandedMonat(p=>p===i?null:i)} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",gap:2,cursor:"pointer",background:expandedMonat===i?C.card2:"transparent",borderRadius:6,padding:"2px 0"}}>
                  <div style={{width:"100%",display:"flex",gap:1,alignItems:"flex-end",height:110}}>
                    <div style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"flex-end"}}>
                      {x.e>0&&<div style={{color:C.gT,fontSize:7,marginBottom:1,whiteSpace:"nowrap"}}>{fmt(x.e)}</div>}
                      <div style={{width:"100%",background:`${C.gT}88`,borderRadius:"3px 3px 0 0",height:`${(x.e/maxV)*100}%`,minHeight:x.e>0?2:0}}/>
                    </div>
                    <div style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"flex-end"}}>
                      {x.a>0&&<div style={{color:C.rT,fontSize:7,marginBottom:1,whiteSpace:"nowrap"}}>{fmt(x.a)}</div>}
                      <div style={{width:"100%",background:`${C.rT}88`,borderRadius:"3px 3px 0 0",height:`${(x.a/maxV)*100}%`,minHeight:x.a>0?2:0}}/>
                    </div>
                  </div>
                  <span style={{color:expandedMonat===i?C.blue2:C.muted,fontSize:9,fontWeight:expandedMonat===i?700:400}}>{x.m}</span>
                  {(x.e>0||x.a>0)&&<span style={{color:(x.e-x.a)>=0?C.gT:C.rT,fontSize:7,fontWeight:700}}>{(x.e-x.a)>=0?"+":""}{fmt(x.e-x.a)}</span>}
                </div>
              ))}
            </div>

            {/* Detailliste für angeklickten Monat */}
            {expandedMonat!==null&&(()=>{
              const mStr = `${fj}-${String(expandedMonat+1).padStart(2,"0")}`;
              const einnahmenM = db.zahlungen.filter(z=>z.monat===mk(expandedMonat,fj)).map(z=>{
                const v = db.vertraege.find(x=>x.id===z.vertragsId);
                const mi = v ? getMi(v.mieterId) : null;
                const obj = v ? getOb(v.objektId) : null;
                return {...z, miName:mi?.name||"—", objAdresse:obj?.adresse||"—", einheit:v?.einheit||""};
              }).sort((a,b)=>(a.datum||"").localeCompare(b.datum||""));
              const ausgabenM = [...periodisiereAusgaben(fj).filter(a=>a.datum?.startsWith(mStr)), ...nkAusgabenJahr.filter(a=>a.datum?.startsWith(mStr))].map(a=>{
                const obj = getOb(a.objektId);
                return {...a, objAdresse:obj?.adresse||"—"};
              }).sort((a,b)=>(a.datum||"").localeCompare(b.datum||""));
              return (
                <div style={{marginTop:16,borderTop:`1px solid ${C.border}`,paddingTop:16}}>
                  <div style={{color:C.text,fontWeight:700,fontSize:14,marginBottom:12}}>{MN[expandedMonat]} {fj} – Details</div>
                  <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"1fr 1fr",gap:14}}>
                    <div>
                      <div style={{color:C.gT,fontWeight:700,fontSize:12,textTransform:"uppercase",letterSpacing:1,marginBottom:8}}>Einnahmen ({einnahmenM.length})</div>
                      {einnahmenM.length===0?<div style={{color:C.muted,fontSize:12}}>Keine Einnahmen erfasst</div>:einnahmenM.map((z,i)=>(
                        <div key={i} style={{display:"flex",justifyContent:"space-between",padding:"7px 10px",background:i%2===0?C.card2:"transparent",borderRadius:6,fontSize:12,marginBottom:2}}>
                          <div><span style={{color:C.text}}>{z.miName}</span><span style={{color:C.muted}}> · {z.objAdresse}{z.einheit?` (${z.einheit})`:""}</span></div>
                          <span style={{color:C.gT,fontWeight:600,whiteSpace:"nowrap"}}>{fmt(z.betrag)} €</span>
                        </div>
                      ))}
                    </div>
                    <div>
                      <div style={{color:C.rT,fontWeight:700,fontSize:12,textTransform:"uppercase",letterSpacing:1,marginBottom:8}}>Ausgaben ({ausgabenM.length})</div>
                      {ausgabenM.length===0?<div style={{color:C.muted,fontSize:12}}>Keine Ausgaben erfasst</div>:ausgabenM.map((a,i)=>(
                        <div key={i} style={{display:"flex",justifyContent:"space-between",padding:"7px 10px",background:i%2===0?C.card2:"transparent",borderRadius:6,fontSize:12,marginBottom:2}}>
                          <div><span style={{color:C.text}}>{a.beschreibung}</span><span style={{color:C.muted}}> · {a.objAdresse}</span>{a.wiederkehrend&&<span style={{color:C.muted,fontSize:10}}> (wiederkehrend)</span>}</div>
                          <span style={{color:C.rT,fontWeight:600,whiteSpace:"nowrap"}}>{fmt(a.betrag)} €</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              );
            })()}
            <div style={{display:"flex",gap:14,marginTop:8}}>
              <span style={{color:C.muted,fontSize:11,display:"flex",alignItems:"center",gap:4}}><span style={{width:9,height:9,background:`${C.gT}88`,borderRadius:2,display:"inline-block"}}/>Einnahmen</span>
              <span style={{color:C.muted,fontSize:11,display:"flex",alignItems:"center",gap:4}}><span style={{width:9,height:9,background:`${C.rT}88`,borderRadius:2,display:"inline-block"}}/>Ausgaben</span>
            </div>

            {/* Monatstabelle - klare Zahlen statt nur Balken */}
            <div style={{overflowX:"auto",WebkitOverflowScrolling:"touch",marginTop:16}}>
              <table style={{width:"100%",borderCollapse:"collapse",minWidth:560}}>
                <thead><tr style={{background:C.card2}}>
                  <th style={{color:C.muted,fontSize:11,padding:"6px 8px",textAlign:"left",fontWeight:600}}>Monat</th>
                  {mv.map((x,i)=><th key={i} style={{color:C.muted,fontSize:10,padding:"6px 4px",textAlign:"right",fontWeight:600}}>{x.m}</th>)}
                </tr></thead>
                <tbody>
                  <tr style={{borderTop:`1px solid ${C.border}`}}>
                    <td style={{padding:"6px 8px",color:C.gT,fontSize:11,fontWeight:600}}>Einnahmen</td>
                    {mv.map((x,i)=><td key={i} style={{padding:"6px 4px",color:C.gT,fontSize:11,textAlign:"right",whiteSpace:"nowrap"}}>{x.e>0?fmt(x.e):"—"}</td>)}
                  </tr>
                  <tr style={{borderTop:`1px solid ${C.border}`}}>
                    <td style={{padding:"6px 8px",color:C.rT,fontSize:11,fontWeight:600}}>Ausgaben</td>
                    {mv.map((x,i)=><td key={i} style={{padding:"6px 4px",color:C.rT,fontSize:11,textAlign:"right",whiteSpace:"nowrap"}}>{x.a>0?fmt(x.a):"—"}</td>)}
                  </tr>
                  <tr style={{borderTop:`2px solid ${C.border}`,background:C.card2}}>
                    <td style={{padding:"6px 8px",color:C.text,fontSize:11,fontWeight:700}}>Netto</td>
                    {mv.map((x,i)=>{const n=x.e-x.a;return <td key={i} style={{padding:"6px 4px",color:n>=0?C.gT:C.rT,fontSize:11,fontWeight:700,textAlign:"right",whiteSpace:"nowrap"}}>{x.e>0||x.a>0?`${n>=0?"+":""}${fmt(n)}`:"—"}</td>;})}
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Summen-Tabelle */}
            {(()=>{
              const totE=mv.reduce((s,x)=>s+x.e,0);
              const totA=mv.reduce((s,x)=>s+x.a,0);
              const totN=totE-totA;
              return (
                <div style={{marginTop:14,borderTop:`1px solid ${C.border}`,paddingTop:12,display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8}}>
                  {[
                    {l:"Einnahmen",v:fmt(totE),c:C.gT},
                    {l:"Ausgaben",v:fmt(totA),c:C.rT},
                    {l:"Netto",v:fmt(totN),c:totN>=0?C.gT:C.rT},
                    {l:`Steuer (~${(STEUER*100).toFixed(0)}%)`,v:fmt(Math.max(0,totN*STEUER)),c:C.yT},
                  ].map((k,i)=>(
                    <div key={i} style={{background:C.card2,borderRadius:9,padding:"10px 12px",textAlign:"center",border:`1px solid ${C.border}`}}>
                      <div style={{color:C.muted,fontSize:11,marginBottom:4}}>{k.l}</div>
                      <div style={{color:k.c,fontWeight:800,fontSize:15}}>{k.v} €</div>
                    </div>
                  ))}
                </div>
              );
            })()}
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
            <div style={{background:C.card,borderRadius:11,padding:18,border:`1px solid ${C.border}`}}>
              <FinSH ch="Einnahmen nach Objekt"/>
              {db.objekte.map(o=>{
                const e=vvObj(o.id).reduce((s,v)=>s+db.zahlungen.filter(z=>z.vertragsId===v.id&&z.monat.endsWith(String(fj))).reduce((ss,z)=>ss+parseFloat(z.betrag),0),0);
                return <FinRow key={o.id} l={o.adresse} v={`${fmt(e)} €`} c={C.gT}/>;
              })}
            </div>
            <div style={{background:C.card,borderRadius:11,padding:18,border:`1px solid ${C.border}`}}>
              <FinSH ch="Ausgaben nach Kategorie"/>
              {(()=>{
                const katS={};
                periodisiereAusgaben(fj).forEach(a=>{katS[a.steuerkat||a.kategorie]=(katS[a.steuerkat||a.kategorie]||0)+parseFloat(a.betrag);});
                return Object.keys(katS).length===0?<p style={{color:C.muted,fontSize:13}}>Keine Ausgaben {fj}.</p>:Object.entries(katS).sort(([,a],[,b])=>b-a).map(([k,s])=><FinRow key={k} l={k} v={`${fmt(s)} €`} c={C.rT}/>);
              })()}
            </div>
          </div>
        </div>
      )}

      {/* ── JAHRESABSCHLUSS ── */}
      {finTab==="jahresabschluss"&&(()=>{
        const jahre = [fj-2, fj-1, fj];
        // Tatsächliche Einnahmen (eingegangene Zahlungen) für gewähltes Jahr
        const einnJ = db.zahlungen.filter(z=>z.monat.endsWith(String(fj))).reduce((s,z)=>s+parseFloat(z.betrag||0),0);
        const ausgJ = periodisiereAusgaben(fj).reduce((s,a)=>s+parseFloat(a.betrag||0),0)
          + [...nkAlsAusgaben(fj),...darlehenAlsAusgaben(fj)].reduce((s,a)=>s+parseFloat(a.betrag||0),0);
        const nettoJ = einnJ - ausgJ;
        return (
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20,flexWrap:"wrap",gap:10}}>
              <div>
                <div style={{color:C.text,fontWeight:800,fontSize:18}}>Jahresabschluss {fj}</div>
                <div style={{color:C.muted,fontSize:12,marginTop:3}}>Einnahmen-Überschuss-Rechnung (EÜR)</div>
              </div>
              <button style={bP} onClick={()=>{
                const rows = [["Jahresabschluss ImManager",fj],[""],["EINNAHMEN"],
                  ...db.objekte.map(o=>[o.adresse, (vvObj(o.id).reduce((s,v)=>s+warmmiete(v),0)*12).toFixed(2)+" €"]),
                  ["Gesamt Einnahmen", einnJ.toFixed(2)+" €"],[""],["AUSGABEN"],
                  ...periodisiereAusgaben(fj).map(a=>[a.beschreibung,parseFloat(a.betrag).toFixed(2)+" €",a.kategorie,fmtD(a.datum)]),
                  ["Gesamt Ausgaben", ausgJ.toFixed(2)+" €"],[""],["ERGEBNIS"],
                  ["Netto-Gewinn", nettoJ.toFixed(2)+" €"],
                  ["Geschätzte Steuer ("+((STEUER*100).toFixed(0))+"%)", (nettoJ*STEUER).toFixed(2)+" €"],
                  ["Netto nach Steuer", (nettoJ-(nettoJ*STEUER)).toFixed(2)+" €"],
                ];
                const csv = "\uFEFF"+rows.map(r=>r.join(";")).join("\n");
                const blob = new Blob([csv],{type:"text/csv;charset=utf-8"});
                const url = URL.createObjectURL(blob);
                const a=document.createElement("a");a.href=url;a.download=`Jahresabschluss_${fj}.csv`;a.click();
                URL.revokeObjectURL(url); say("CSV exportiert ✓");
              }}>⬇ CSV für Steuerberater</button>
            </div>

            {/* Jahresvergleich */}
            <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"repeat(3,1fr)",gap:12,marginBottom:20}}>
              {jahre.map(j=>{
                const e=db.zahlungen.filter(z=>z.monat.endsWith(String(j))).reduce((s,z)=>s+parseFloat(z.betrag||0),0);
                const a=db.ausgaben.filter(x=>new Date(x.datum).getFullYear()===j).reduce((s,x)=>s+parseFloat(x.betrag||0),0)
                  + [...nkAlsAusgaben(j),...darlehenAlsAusgaben(j)].reduce((s,x)=>s+parseFloat(x.betrag||0),0);
                const n=e-a;
                return (
                  <div key={j} style={{background:j===fj?`${C.blue}15`:C.card,borderRadius:11,padding:16,border:`1px solid ${j===fj?C.blue:C.border}`}}>
                    <div style={{color:j===fj?C.blue:C.muted,fontWeight:700,fontSize:13,marginBottom:10}}>{j}{j===fj?" ◀":""}</div>
                    <div style={{display:"flex",justifyContent:"space-between",marginBottom:4,fontSize:12}}>
                      <span style={{color:C.muted}}>Einnahmen</span><span style={{color:C.gT,fontWeight:600}}>{fmt(e)} €</span>
                    </div>
                    <div style={{display:"flex",justifyContent:"space-between",marginBottom:6,fontSize:12}}>
                      <span style={{color:C.muted}}>Ausgaben</span><span style={{color:C.rT,fontWeight:600}}>{fmt(a)} €</span>
                    </div>
                    <div style={{display:"flex",justifyContent:"space-between",paddingTop:6,borderTop:`1px solid ${C.border}`,fontSize:13}}>
                      <span style={{color:C.text,fontWeight:700}}>Ergebnis</span><span style={{color:n>=0?C.gT:C.rT,fontWeight:800}}>{fmt(n)} €</span>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* EÜR Detail */}
            <div style={{background:C.card,borderRadius:11,border:`1px solid ${C.border}`,overflow:"hidden",marginBottom:12}}>
              <div style={{padding:"10px 16px",background:C.g2,borderBottom:`1px solid ${C.border}`,color:C.gT,fontWeight:700,fontSize:12}}>EINNAHMEN {fj} (tatsächlich eingegangen)</div>
              {db.objekte.map(o=>{
                const zahlungenObj = db.zahlungen.filter(z=>z.monat.endsWith(String(fj))&&vvObj(o.id).some(v=>v.id===z.vertragsId));
                const v=zahlungenObj.reduce((s,z)=>s+parseFloat(z.betrag||0),0);
                return v>0&&<div key={o.id} style={{display:"flex",justifyContent:"space-between",padding:"9px 16px",borderBottom:`1px solid ${C.border}`,fontSize:13}}>
                  <span style={{color:C.muted}}>{o.adresse}</span>
                  <span style={{color:C.text,fontWeight:600}}>{fmt(v)} €</span>
                </div>;
              })}
              {einnJ===0&&<div style={{padding:14,color:C.muted,fontSize:12}}>Keine Zahlungseingänge für {fj} erfasst</div>}
              <div style={{display:"flex",justifyContent:"space-between",padding:"10px 16px",background:C.g2,fontSize:13}}><span style={{color:C.gT,fontWeight:700}}>Gesamt</span><span style={{color:C.gT,fontWeight:800}}>{fmt(einnJ)} €</span></div>
            </div>
            <div style={{background:C.card,borderRadius:11,border:`1px solid ${C.border}`,overflow:"hidden",marginBottom:12}}>
              <div style={{padding:"10px 16px",background:C.r2,borderBottom:`1px solid ${C.border}`,color:C.rT,fontWeight:700,fontSize:12}}>AUSGABEN {fj}</div>
              {(()=>{
                const manuelleAusgaben = periodisiereAusgaben(fj);
                const nkAusgabenListe = [...nkAlsAusgaben(fj), ...darlehenAlsAusgaben(fj)];
                const alleAusgaben = [...manuelleAusgaben, ...nkAusgabenListe].sort((a,b)=>b.datum.localeCompare(a.datum));
                if(alleAusgaben.length===0) return <div style={{padding:14,color:C.muted,fontSize:12}}>Keine Ausgaben erfasst</div>;
                return alleAusgaben.map((a,i)=>(
                  <div key={a.id||i} style={{display:"flex",justifyContent:"space-between",padding:"9px 16px",borderBottom:`1px solid ${C.border}`,fontSize:13,cursor:a.wiederkehrend?"default":"pointer"}}
                    onClick={()=>{if(!a.wiederkehrend)setModal({t:"ausgabe",objektId:a.objektId,bearbeiten:a});}}>
                    <div>
                      <div style={{color:C.text,display:"flex",alignItems:"center",gap:6}}>
                        {a.beschreibung}
                        {a.wiederkehrend&&<span style={{background:C.card2,color:C.muted,fontSize:10,padding:"1px 6px",borderRadius:8,border:`1px solid ${C.border}`}}>wiederkehrend</span>}
                              {a._periodisiert&&<span style={{background:C.card2,color:C.muted,fontSize:10,padding:"1px 6px",borderRadius:8,border:`1px solid ${C.border}`}}>Rate ({a._original?.intervall})</span>}
                      </div>
                      <div style={{color:C.muted,fontSize:11}}>{fmtD(a.datum)} · {a.kategorie}</div>
                    </div>
                    <div style={{display:"flex",alignItems:"center",gap:8}}>
                      <span style={{color:C.rT,fontWeight:600}}>{fmt(a.betrag)} €</span>
                      {!a.wiederkehrend&&<span style={{color:C.muted,fontSize:12}}>✏</span>}
                    </div>
                  </div>
                ));
              })()}
              <div style={{display:"flex",justifyContent:"space-between",padding:"10px 16px",background:C.r2,fontSize:13}}><span style={{color:C.rT,fontWeight:700}}>Gesamt</span><span style={{color:C.rT,fontWeight:800}}>{fmt(ausgJ)} €</span></div>
            </div>
            <div style={{background:`linear-gradient(135deg,${C.blue}22,${C.blue}11)`,borderRadius:11,padding:20,border:`1px solid ${C.blue}44`}}>
              <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:12,textAlign:"center"}}>
                <div><div style={{color:C.muted,fontSize:11,marginBottom:4}}>Einnahmen</div><div style={{color:C.gT,fontWeight:800,fontSize:15}}>{fmt(einnJ)} €</div></div>
                <div><div style={{color:C.muted,fontSize:11,marginBottom:4}}>Ausgaben</div><div style={{color:C.rT,fontWeight:800,fontSize:15}}>{fmt(ausgJ)} €</div></div>
                <div><div style={{color:C.muted,fontSize:11,marginBottom:4}}>Netto</div><div style={{color:nettoJ>=0?C.gT:C.rT,fontWeight:800,fontSize:15}}>{fmt(nettoJ)} €</div></div>
              </div>
              <div style={{textAlign:"center",marginTop:12,paddingTop:12,borderTop:`1px solid ${C.blue}33`}}>
                <div style={{color:C.muted,fontSize:11}}>Geschätzte Steuer ({(STEUER*100).toFixed(0)}%)</div>
                <div style={{color:C.yT,fontWeight:800,fontSize:20,marginTop:2}}>{fmt(nettoJ*STEUER)} €</div>
              </div>
            </div>
          </div>
        );
      })()}

      {/* ── LIQUIDITÄTSPLANUNG ── */}
      {finTab==="liquidplanung"&&(()=>{
        const monate = Array.from({length:12},(_,i)=>{
          const d=new Date(fj,i,1);
          return {label:d.toLocaleString("de-DE",{month:"short"}),m:String(i+1).padStart(2,"0")};
        });
        const monatEinn = db.vertraege.filter(v=>v.aktiv&&!v.leerstand).reduce((s,v)=>s+warmmiete(v),0);
        const monatLs = db.vertraege.filter(v=>v.leerstand&&v.aktiv).reduce((s,v)=>s+(parseFloat(v.nebenkosten)||0),0);
        let kumulativ=0;
        const daten=monate.map(({label,m})=>{
          const ausg=db.ausgaben.filter(a=>{const d=new Date(a.datum);return d.getMonth()+1===parseInt(m)&&d.getFullYear()===fj;}).reduce((s,a)=>s+parseFloat(a.betrag||0),0)+monatLs;
          const netto=monatEinn-ausg;
          kumulativ+=netto;
          return {label,einn:monatEinn,ausg,netto,kumulativ};
        });
        const maxVal=Math.max(...daten.map(d=>Math.max(d.einn,d.ausg)),1);
        return (
          <div>
            <div style={{color:C.text,fontWeight:800,fontSize:18,marginBottom:4}}>Liquiditätsplanung {fj}</div>
            <div style={{color:C.muted,fontSize:12,marginBottom:20}}>Monatliche Cashflow-Übersicht · kumulierter Jahresverlauf</div>
            <div style={{background:C.card,borderRadius:11,padding:16,border:`1px solid ${C.border}`,marginBottom:16,overflowX:"auto"}}>
              <div style={{display:"flex",gap:3,alignItems:"flex-end",height:160,minWidth:480}}>
                {daten.map((d,i)=>(
                  <div key={i} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",gap:2}}>
                    <div style={{width:"100%",display:"flex",gap:1,alignItems:"flex-end",height:120,position:"relative"}}>
                      <div style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"flex-end"}}>
                        {d.einn>0&&<div style={{color:C.gT,fontSize:8,marginBottom:1,whiteSpace:"nowrap"}}>{fmt(d.einn)}</div>}
                        <div style={{width:"100%",background:C.gT,borderRadius:"3px 3px 0 0",height:`${(d.einn/maxVal)*100}%`,opacity:.8,minHeight:2}}/>
                      </div>
                      <div style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"flex-end"}}>
                        {d.ausg>0&&<div style={{color:C.rT,fontSize:8,marginBottom:1,whiteSpace:"nowrap"}}>{fmt(d.ausg)}</div>}
                        <div style={{width:"100%",background:C.rT,borderRadius:"3px 3px 0 0",height:`${(d.ausg/maxVal)*100}%`,opacity:.8,minHeight:2}}/>
                      </div>
                    </div>
                    <div style={{color:C.muted,fontSize:9}}>{d.label}</div>
                    <div style={{color:d.netto>=0?C.gT:C.rT,fontSize:8,fontWeight:700}}>{d.netto>=0?"+":""}{fmt(d.netto)}</div>
                  </div>
                ))}
              </div>
              <div style={{display:"flex",gap:16,justifyContent:"center",marginTop:8}}>
                <div style={{display:"flex",alignItems:"center",gap:4,fontSize:11,color:C.muted}}><div style={{width:10,height:10,background:C.gT,borderRadius:2}}/> Einnahmen</div>
                <div style={{display:"flex",alignItems:"center",gap:4,fontSize:11,color:C.muted}}><div style={{width:10,height:10,background:C.rT,borderRadius:2}}/> Ausgaben</div>
                <div style={{display:"flex",alignItems:"center",gap:4,fontSize:11,color:C.muted}}><div style={{width:10,height:10,background:C.blue,borderRadius:2}}/> Netto</div>
              </div>
            </div>
            <div style={{background:C.card,borderRadius:11,border:`1px solid ${C.border}`,overflow:"hidden"}}>
              <div style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr 1fr",padding:"9px 14px",background:C.card2,borderBottom:`1px solid ${C.border}`,fontSize:11,color:C.muted,fontWeight:700}}>
                <span>Monat</span><span style={{textAlign:"right"}}>Einnahmen</span><span style={{textAlign:"right"}}>Ausgaben</span><span style={{textAlign:"right"}}>Netto</span><span style={{textAlign:"right"}}>Kumulativ</span>
              </div>
              {daten.map((d,i)=>(
                <div key={i} style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr 1fr",padding:"8px 14px",borderBottom:`1px solid ${C.border}`,fontSize:12}}>
                  <span style={{color:C.text,fontWeight:600}}>{d.label}</span>
                  <span style={{color:C.gT,textAlign:"right"}}>{fmt(d.einn)}</span>
                  <span style={{color:C.rT,textAlign:"right"}}>{fmt(d.ausg)}</span>
                  <span style={{color:d.netto>=0?C.gT:C.rT,textAlign:"right",fontWeight:600}}>{fmt(d.netto)}</span>
                  <span style={{color:d.kumulativ>=0?C.gT:C.rT,textAlign:"right",fontWeight:700}}>{fmt(d.kumulativ)}</span>
                </div>
              ))}
            </div>
          </div>
        );
      })()}

      {/* ── NEBENKOSTEN-ANALYSE ── */}
      {finTab==="nebenkosten"&&(
        <div>
          <p style={{color:C.muted,fontSize:13,marginBottom:20}}>Eingenommene NK-Vorauszahlungen vs. tatsächliche NK-Ausgaben pro Objekt · Hochrechnung auf {fj}</p>
          {db.objekte.map(o=>{
            const einnNK = nkEinnahmen(o.id);
            const ausgNK = nkAusgaben(o.id);
            const diff = einnNK - ausgNK;
            const gedeckt = diff >= 0;
            const positionen = db.nkPositionen?.[o.id]||[];
            return (
              <div key={o.id} style={{background:C.card,borderRadius:12,padding:20,marginBottom:16,border:`1px solid ${gedeckt?C.border:C.rT}`}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:14}}>
                  <div>
                    <div style={{color:C.text,fontWeight:700,fontSize:15}}>{o.adresse}</div>
                    <div style={{color:C.muted,fontSize:12,marginTop:2}}>{vvObj(o.id).length} Mieteinheiten</div>
                  </div>
                  <div style={{textAlign:"right"}}>
                    <div style={{color:gedeckt?C.gT:C.rT,fontWeight:800,fontSize:16}}>{gedeckt?"✓ Gedeckt":"⚠ Unterdeckung"}</div>
                    <div style={{color:gedeckt?C.gT:C.rT,fontSize:13,fontWeight:600}}>{gedeckt?"+":""}{fmt(diff)} €/Jahr</div>
                  </div>
                </div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
                  <div style={{background:C.g2,borderRadius:9,padding:"10px 14px"}}>
                    <div style={{color:C.muted,fontSize:11,marginBottom:3}}>NK-Einnahmen (Jahreshochrechnung)</div>
                    <div style={{color:C.gT,fontWeight:800,fontSize:17}}>{fmt(einnNK)} €</div>
                    <div style={{color:C.muted,fontSize:11,marginTop:2}}>= {vvObj(o.id).length} Mieter × 12 Monate</div>
                  </div>
                  <div style={{background:gedeckt?C.card2:C.r2,borderRadius:9,padding:"10px 14px"}}>
                    <div style={{color:C.muted,fontSize:11,marginBottom:3}}>NK-Ausgaben (umlagefähig)</div>
                    <div style={{color:gedeckt?C.text:C.rT,fontWeight:800,fontSize:17}}>{fmt(ausgNK)} €</div>
                    <div style={{color:C.muted,fontSize:11,marginTop:2}}>{positionen.filter(p=>p.kategorie==="umlagefaehig").length} Positionen</div>
                  </div>
                </div>
                {/* NK-Positionen als Dropdown */}
                {positionen.length>0&&(
                  <NKDropdown oId={o.id} positionen={positionen} jahrBetrag={jahrBetrag} intervallLabel={intervallLabel} upd={upd} setNkEditForm={setNkEditForm}/>
                )}
                {/* Hochgeladene Belege mit Kategorie "Umlagefähige Nebenkosten" */}
                {(()=>{
                  const belegeNK = db.ausgaben.filter(a=>a.objektId===o.id&&a.steuerkat==="Umlagefähige Nebenkosten"&&a.datum?.startsWith(String(fj)));
                  if(belegeNK.length===0) return null;
                  const summeBelege = belegeNK.reduce((s,a)=>s+parseFloat(a.betrag||0),0);
                  return (
                    <div style={{marginBottom:12}}>
                      <div style={{color:C.muted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:8}}>
                        Hochgeladene Belege ({belegeNK.length}) · {fmt(summeBelege)} € gesamt
                      </div>
                      {belegeNK.map(a=>(
                        <div key={a.id} onClick={()=>setModal({t:"ausgabe",objektId:a.objektId,bearbeiten:a})} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"7px 10px",background:C.card2,borderRadius:7,marginBottom:4,fontSize:12,cursor:"pointer"}}>
                          <div><span style={{color:C.text}}>{a.beschreibung}</span><span style={{color:C.muted}}> · {fmtD(a.datum)} · {a.kategorie}{a.intervall&&a.intervall!=="einmalig"&&` · ${a.intervall}`}</span></div>
                          <div style={{display:"flex",alignItems:"center",gap:6}}>
                            <span style={{color:C.rT,fontWeight:600}}>{fmt(a.betrag)} €</span>
                            <span style={{color:C.muted,fontSize:11}}>✏</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  );
                })()}
                {!gedeckt&&(
                  <div style={{background:C.y2,borderRadius:8,padding:"8px 12px",marginBottom:12,fontSize:12,color:C.yT}}>
                    ⚠ Empfehlung: NK-Vorauszahlung um {fmt(Math.abs(diff)/12/vvObj(o.id).length)}/Monat pro Mieter erhöhen
                  </div>
                )}
                <button style={{...bP,fontSize:12}} onClick={()=>setNkModal(o.id)}>＋ Kosten hinzufügen (z.B. Hausmeister, Grundsteuer, Versicherung)</button>
              </div>
            );
          })}
          {/* NK hinzufügen Modal inline */}
          {nkModal&&(
            <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.4)",zIndex:2000,display:"flex",alignItems:"center",justifyContent:"center"}}>
              <div style={{background:C.card,borderRadius:14,padding:24,width:500,border:`1px solid ${C.b2}`}} onClick={e=>e.stopPropagation()}>
                <div style={{color:C.text,fontWeight:700,fontSize:15,marginBottom:16}}>NK-Position hinzufügen · {getOb(nkModal)?.adresse}</div>
                <div style={{background:C.card2,borderRadius:8,padding:"8px 12px",marginBottom:14,fontSize:11,color:C.muted}}>
                  💡 Auch für laufende Kosten wie Hausmeister (Minijob), Reinigungskraft, Winterdienst o.ä. – diese fließen automatisch in die NK-Abrechnung der Mieter ein
                </div>
                <div style={{display:"flex",gap:6,marginBottom:14}}>
                  <button onClick={()=>setNkForm(p=>({...p,eingabeArt:"intervall"}))} style={{flex:1,padding:"7px",borderRadius:7,border:`2px solid ${(nkForm.eingabeArt||"intervall")==="intervall"?C.blue:C.border}`,background:(nkForm.eingabeArt||"intervall")==="intervall"?`${C.blue}12`:C.card2,color:(nkForm.eingabeArt||"intervall")==="intervall"?C.blue2:C.muted,fontWeight:600,fontSize:12,cursor:"pointer"}}>Betrag pro Intervall</button>
                  <button onClick={()=>setNkForm(p=>({...p,eingabeArt:"jahr"}))} style={{flex:1,padding:"7px",borderRadius:7,border:`2px solid ${nkForm.eingabeArt==="jahr"?C.blue:C.border}`,background:nkForm.eingabeArt==="jahr"?`${C.blue}12`:C.card2,color:nkForm.eingabeArt==="jahr"?C.blue2:C.muted,fontWeight:600,fontSize:12,cursor:"pointer"}}>Jahresgesamtsumme</button>
                </div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:14}}>
                  <div style={{gridColumn:"1/-1"}}><label style={lbl}>Bezeichnung</label><input style={inp} value={nkForm.bezeichnung} onChange={e=>setNkForm(p=>({...p,bezeichnung:e.target.value}))} placeholder="z.B. Grundsteuer, Hausmeister Minijob, Gebäudeversicherung"/></div>
                  {nkForm.eingabeArt==="jahr"?(
                    <div style={{gridColumn:"1/-1"}}><label style={lbl}>Jahresgesamtsumme (€)</label><input type="number" style={inp} value={nkForm.jahresSumme||""} onChange={e=>setNkForm(p=>({...p,jahresSumme:e.target.value}))} placeholder="z.B. 1200"/></div>
                  ):(
                    <div><label style={lbl}>Betrag (€)</label><input type="number" style={inp} value={nkForm.betrag} onChange={e=>setNkForm(p=>({...p,betrag:e.target.value}))}/></div>
                  )}
                  <div style={nkForm.eingabeArt==="jahr"?{gridColumn:"1/-1"}:{}}><label style={lbl}>Intervall</label><select style={inp} value={nkForm.intervall} onChange={e=>setNkForm(p=>({...p,intervall:e.target.value}))}><option value="monatlich">Monatlich</option><option value="quartalsweise">Quartalsweise</option><option value="halbjaehrlich">Halbjährlich</option><option value="jaehrlich">Jährlich</option></select></div>
                  <div style={{gridColumn:"1/-1"}}><label style={lbl}>Kategorie</label><select style={inp} value={nkForm.kategorie} onChange={e=>setNkForm(p=>({...p,kategorie:e.target.value}))}><option value="umlagefaehig">Umlagefähig (auf Mieter umlegbar)</option><option value="werbungskosten">Werbungskosten (steuerlich absetzbar)</option></select></div>
                </div>
                {nkForm.eingabeArt==="jahr"&&nkForm.jahresSumme>0&&(()=>{
                  const perioden = {monatlich:12,quartalsweise:4,halbjaehrlich:2,jaehrlich:1}[nkForm.intervall]||1;
                  const proIntervall = parseFloat(nkForm.jahresSumme)/perioden;
                  const intervallLabelKurz = {monatlich:"Monat",quartalsweise:"Quartal",halbjaehrlich:"Halbjahr",jaehrlich:"Jahr"}[nkForm.intervall];
                  return (
                    <div style={{background:C.g2,borderRadius:8,padding:"10px 12px",marginBottom:14,color:C.gT,fontSize:13}}>
                      ✓ Errechneter Betrag: <strong>{fmt(proIntervall)} € pro {intervallLabelKurz}</strong> ({fmt(nkForm.jahresSumme)} € ÷ {perioden})
                    </div>
                  );
                })()}
                <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
                  <button style={bS} onClick={()=>setNkModal(null)}>Abbrechen</button>
                  <button style={bP} onClick={()=>{
                    let betragZuSpeichern = nkForm.betrag;
                    if(nkForm.eingabeArt==="jahr"){
                      if(!nkForm.jahresSumme) return;
                      const perioden = {monatlich:12,quartalsweise:4,halbjaehrlich:2,jaehrlich:1}[nkForm.intervall]||1;
                      betragZuSpeichern = (parseFloat(nkForm.jahresSumme)/perioden).toFixed(2);
                    }
                    if(!nkForm.bezeichnung||!betragZuSpeichern)return;
                    const { eingabeArt, jahresSumme, ...nkFormRest } = nkForm;
                    upd("nkPositionen",nn=>({...nn,[nkModal]:[...(nn?.[nkModal]||[]),{...nkFormRest,betrag:betragZuSpeichern,id:uid()}]}));
                    setNkForm({bezeichnung:"",betrag:"",intervall:"monatlich",kategorie:"umlagefaehig",eingabeArt:"intervall",jahresSumme:""});
                    setNkModal(null);say("Position hinzugefügt ✓");
                  }}>Speichern</button>
                </div>
              </div>
            </div>
          )}

          {nkEditForm&&(
            <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.4)",zIndex:2000,display:"flex",alignItems:"center",justifyContent:"center"}} onClick={()=>setNkEditForm(null)}>
              <div style={{background:C.card,borderRadius:14,padding:24,width:500,border:`1px solid ${C.b2}`}} onClick={e=>e.stopPropagation()}>
                <div style={{color:C.text,fontWeight:700,fontSize:15,marginBottom:16}}>NK-Position bearbeiten</div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:14}}>
                  <div style={{gridColumn:"1/-1"}}><label style={lbl}>Bezeichnung</label><input style={inp} value={nkEditForm.position.bezeichnung} onChange={e=>setNkEditForm(p=>({...p,position:{...p.position,bezeichnung:e.target.value}}))}/></div>
                  <div><label style={lbl}>Betrag (€)</label><input type="number" style={inp} value={nkEditForm.position.betrag} onChange={e=>setNkEditForm(p=>({...p,position:{...p.position,betrag:e.target.value}}))}/></div>
                  <div><label style={lbl}>Intervall</label><select style={inp} value={nkEditForm.position.intervall} onChange={e=>setNkEditForm(p=>({...p,position:{...p.position,intervall:e.target.value}}))}><option value="monatlich">Monatlich</option><option value="quartalsweise">Quartalsweise</option><option value="halbjaehrlich">Halbjährlich</option><option value="jaehrlich">Jährlich</option></select></div>
                  <div style={{gridColumn:"1/-1"}}><label style={lbl}>Kategorie</label><select style={inp} value={nkEditForm.position.kategorie} onChange={e=>setNkEditForm(p=>({...p,position:{...p.position,kategorie:e.target.value}}))}><option value="umlagefaehig">Umlagefähig (auf Mieter umlegbar)</option><option value="werbungskosten">Werbungskosten (steuerlich absetzbar)</option></select></div>
                </div>
                <div style={{display:"flex",gap:8,justifyContent:"space-between"}}>
                  <button style={bD} onClick={()=>{
                    if(window.confirm(`"${nkEditForm.position.bezeichnung}" wirklich löschen?`)){
                      upd("nkPositionen",nn=>({...nn,[nkEditForm.oId]:(nn?.[nkEditForm.oId]||[]).filter(x=>x.id!==nkEditForm.position.id)}));
                      say("Gelöscht");setNkEditForm(null);
                    }
                  }}>🗑 Löschen</button>
                  <div style={{display:"flex",gap:8}}>
                    <button style={bS} onClick={()=>setNkEditForm(null)}>Abbrechen</button>
                    <button style={bP} onClick={()=>{
                      if(!nkEditForm.position.bezeichnung||!nkEditForm.position.betrag)return;
                      upd("nkPositionen",nn=>({...nn,[nkEditForm.oId]:(nn?.[nkEditForm.oId]||[]).map(x=>x.id===nkEditForm.position.id?nkEditForm.position:x)}));
                      say("Aktualisiert ✓");setNkEditForm(null);
                    }}>Speichern</button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {/* ── LIQUIDITÄT & KALTMIETE ── */}
      {finTab==="liquiditaet"&&(
        <div>
          <p style={{color:C.muted,fontSize:13,marginBottom:20}}>Kaltmiete-Einnahmen vs. fixe Ausgaben (Darlehen, Versicherung etc.) · verfügbare Liquidität pro Objekt</p>
          {/* Gesamtübersicht */}
          {(()=>{
            const gesamtKalt = db.objekte.reduce((s,o)=>s+kaltEinnahmen(o.id),0);
            const gesamtFix = db.objekte.reduce((s,o)=>s+fixKostenJahr(o.id),0);
            const gesamtNK = db.objekte.reduce((s,o)=>s+nkEinnahmen(o.id),0);
            const gesamtNKAusg = db.objekte.reduce((s,o)=>s+nkAusgaben(o.id),0);
            const liquiditaet = gesamtKalt - gesamtFix;
            const steuerEst = Math.max(0,liquiditaet*STEUER);
            return (
              <div style={{background:`linear-gradient(135deg,${C.blue},${C.pT})`,borderRadius:12,padding:"18px 22px",marginBottom:20,display:"grid",gridTemplateColumns:isMobile?"repeat(2,1fr)":"repeat(4,1fr)",gap:isMobile?8:12,gap:16}}>
                {[{l:"Kaltmiete/Jahr",v:fmt(gesamtKalt),u:"€"},{l:"Fixkosten/Jahr",v:fmt(gesamtFix),u:"€"},{l:"Liquidität vor Steuer",v:fmt(liquiditaet),u:"€"},{l:"Est. Steuer",v:fmt(steuerEst),u:"€"}].map((k,i)=>(
                  <div key={i}>
                    <div style={{color:C.muted2||"rgba(255,255,255,.6)",fontSize:11,marginBottom:4}}>{k.l}</div>
                    <div style={{color:"rgba(255,255,255,.95)",fontSize:18,fontWeight:800}}>{k.v} {k.u}</div>
                  </div>
                ))}
              </div>
            );
          })()}

          {db.objekte.map(o=>{
            const kalt = kaltEinnahmen(o.id);
            const fix = fixKostenJahr(o.id);
            const liq = kalt - fix;
            const fixPos = db.fixKosten?.[o.id]||[];
            return (
              <div key={o.id} style={{background:C.card,borderRadius:12,padding:20,marginBottom:16,border:`1px solid ${C.border}`}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:14}}>
                  <div style={{color:C.text,fontWeight:700,fontSize:15}}>{o.adresse}</div>
                  <div style={{color:liq>=0?C.gT:C.rT,fontWeight:800,fontSize:16}}>{fmt(liq)} €/Jahr verfügbar</div>
                </div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10,marginBottom:14}}>
                  <div style={{background:C.g2,borderRadius:9,padding:"10px 14px"}}>
                    <div style={{color:C.muted,fontSize:11}}>Kaltmiete/Jahr</div>
                    <div style={{color:C.gT,fontWeight:800,fontSize:16}}>{fmt(kalt)} €</div>
                  </div>
                  <div style={{background:C.r2,borderRadius:9,padding:"10px 14px"}}>
                    <div style={{color:C.muted,fontSize:11}}>Fixkosten/Jahr</div>
                    <div style={{color:C.rT,fontWeight:800,fontSize:16}}>{fmt(fix)} €</div>
                  </div>
                  <div style={{background:liq>=0?C.g2:C.r2,borderRadius:9,padding:"10px 14px"}}>
                    <div style={{color:C.muted,fontSize:11}}>Netto-Liquidität</div>
                    <div style={{color:liq>=0?C.gT:C.rT,fontWeight:800,fontSize:16}}>{fmt(liq)} €</div>
                  </div>
                </div>
                {fixPos.length>0&&(
                  <div style={{marginBottom:12}}>
                    <div style={{color:C.muted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:8}}>Fixe Ausgaben</div>
                    {fixPos.map(p=>(
                      <div key={p.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"6px 0",borderBottom:`1px solid ${C.border}`}}>
                        <span style={{color:C.text,fontSize:13}}>{p.bezeichnung}</span>
                        <div style={{display:"flex",gap:8,alignItems:"center"}}>
                          <span style={{color:C.muted,fontSize:12}}>{fmt(p.betrag)} € {intervallLabel[p.intervall]}</span>
                          <span style={{color:C.rT,fontSize:12,fontWeight:600}}>{fmt(jahrBetrag(p))} €/Jahr</span>
                          <button style={{background:"none",border:"none",color:C.muted,cursor:"pointer",fontSize:13,padding:"2px 4px"}} title="Bearbeiten" onClick={()=>setFkEditForm({oId:o.id, position:p})}>✏️</button>
                          <button style={{...bD,padding:"3px 7px",fontSize:11}} onClick={()=>{if(window.confirm(`"${p.bezeichnung}" wirklich löschen?`))upd("fixKosten",ff=>({...ff,[o.id]:(ff?.[o.id]||[]).filter(x=>x.id!==p.id)}));}}>🗑</button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                <button style={{...bS,fontSize:12}} onClick={()=>setFkModal(o.id)}>＋ Fixkosten hinzufügen</button>
              </div>
            );
          })}

          {/* Fixkosten Modal */}
          {fkModal&&(
            <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.4)",zIndex:2000,display:"flex",alignItems:"center",justifyContent:"center"}}>
              <div style={{background:C.card,borderRadius:14,padding:24,width:460,border:`1px solid ${C.b2}`}} onClick={e=>e.stopPropagation()}>
                <div style={{color:C.text,fontWeight:700,fontSize:15,marginBottom:16}}>Fixkosten hinzufügen · {getOb(fkModal)?.adresse}</div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:14}}>
                  <div style={{gridColumn:"1/-1"}}><label style={lbl}>Bezeichnung</label><input style={inp} value={fkForm.bezeichnung} onChange={e=>setFkForm(p=>({...p,bezeichnung:e.target.value}))} placeholder="z.B. Darlehen / Tilgung"/></div>
                  <div><label style={lbl}>Betrag (€)</label><input type="number" style={inp} value={fkForm.betrag} onChange={e=>setFkForm(p=>({...p,betrag:e.target.value}))}/></div>
                  <div><label style={lbl}>Intervall</label><select style={inp} value={fkForm.intervall} onChange={e=>setFkForm(p=>({...p,intervall:e.target.value}))}><option value="monatlich">Monatlich</option><option value="quartalsweise">Quartalsweise</option><option value="halbjaehrlich">Halbjährlich</option><option value="jaehrlich">Jährlich</option></select></div>
                </div>
                <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
                  <button style={bS} onClick={()=>setFkModal(null)}>Abbrechen</button>
                  <button style={bP} onClick={()=>{
                    if(!fkForm.bezeichnung||!fkForm.betrag)return;
                    upd("fixKosten",ff=>({...ff,[fkModal]:[...(ff?.[fkModal]||[]),{...fkForm,id:uid()}]}));
                    setFkForm({bezeichnung:"",betrag:"",intervall:"monatlich"});
                    setFkModal(null);say("Fixkosten hinzugefügt ✓");
                  }}>Speichern</button>
                </div>
              </div>
            </div>
          )}

          {fkEditForm&&(
            <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.4)",zIndex:2000,display:"flex",alignItems:"center",justifyContent:"center"}} onClick={()=>setFkEditForm(null)}>
              <div style={{background:C.card,borderRadius:14,padding:24,width:460,border:`1px solid ${C.b2}`}} onClick={e=>e.stopPropagation()}>
                <div style={{color:C.text,fontWeight:700,fontSize:15,marginBottom:16}}>Fixkosten bearbeiten</div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:14}}>
                  <div style={{gridColumn:"1/-1"}}><label style={lbl}>Bezeichnung</label><input style={inp} value={fkEditForm.position.bezeichnung} onChange={e=>setFkEditForm(p=>({...p,position:{...p.position,bezeichnung:e.target.value}}))}/></div>
                  <div><label style={lbl}>Betrag (€)</label><input type="number" style={inp} value={fkEditForm.position.betrag} onChange={e=>setFkEditForm(p=>({...p,position:{...p.position,betrag:e.target.value}}))}/></div>
                  <div><label style={lbl}>Intervall</label><select style={inp} value={fkEditForm.position.intervall} onChange={e=>setFkEditForm(p=>({...p,position:{...p.position,intervall:e.target.value}}))}><option value="monatlich">Monatlich</option><option value="quartalsweise">Quartalsweise</option><option value="halbjaehrlich">Halbjährlich</option><option value="jaehrlich">Jährlich</option></select></div>
                </div>
                <div style={{display:"flex",gap:8,justifyContent:"space-between"}}>
                  <button style={bD} onClick={()=>{
                    if(window.confirm(`"${fkEditForm.position.bezeichnung}" wirklich löschen?`)){
                      upd("fixKosten",ff=>({...ff,[fkEditForm.oId]:(ff?.[fkEditForm.oId]||[]).filter(x=>x.id!==fkEditForm.position.id)}));
                      say("Gelöscht");setFkEditForm(null);
                    }
                  }}>🗑 Löschen</button>
                  <div style={{display:"flex",gap:8}}>
                    <button style={bS} onClick={()=>setFkEditForm(null)}>Abbrechen</button>
                    <button style={bP} onClick={()=>{
                      if(!fkEditForm.position.bezeichnung||!fkEditForm.position.betrag)return;
                      upd("fixKosten",ff=>({...ff,[fkEditForm.oId]:(ff?.[fkEditForm.oId]||[]).map(x=>x.id===fkEditForm.position.id?fkEditForm.position:x)}));
                      say("Aktualisiert ✓");setFkEditForm(null);
                    }}>Speichern</button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}


      {/* ── BELEGE & AUSGABEN ── */}
      {finTab==="belege"&&(
        <div>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18}}>
            <div>
              <p style={{color:C.muted,fontSize:13,margin:0}}>Rechnungen hochladen · KI erkennt automatisch Betrag, Kategorie und steuerliche Zuordnung</p>
            </div>
            <button style={bP} onClick={()=>setBelegModal(true)}>＋ Beleg hochladen</button>
          </div>

          {/* Ausgaben-Tabelle mit Steuerkat */}
          {(()=>{
            const alleAusgaben = [...periodisiereAusgaben(fj), ...nkAlsAusgaben(fj), ...darlehenAlsAusgaben(fj)];
            const nachObjekt = {};
            db.objekte.forEach(o=>{nachObjekt[o.id]=alleAusgaben.filter(a=>a.objektId===o.id);});
            return (
              <div>
                {/* Zusammenfassung */}
                <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"repeat(3,1fr)",gap:12,marginBottom:20}}>
                  {(()=>{
                    const umlag = alleAusgaben.filter(a=>a.steuerkat==="Umlagefähige Nebenkosten").reduce((s,a)=>s+parseFloat(a.betrag),0);
                    const werb = alleAusgaben.filter(a=>a.steuerkat==="Werbungskosten").reduce((s,a)=>s+parseFloat(a.betrag),0);
                    const sonst = alleAusgaben.filter(a=>!a.steuerkat||a.steuerkat==="Sonstiges").reduce((s,a)=>s+parseFloat(a.betrag),0);
                    return [
                      {l:"Umlagefähige NK",v:fmt(umlag),c:C.gT,info:"Auf Mieter umlegbar"},
                      {l:"Werbungskosten",v:fmt(werb),c:C.blue,info:"Steuerlich absetzbar"},
                      {l:"Sonstiges",v:fmt(sonst),c:C.muted,info:"Nicht kategorisiert"},
                    ].map((k,i)=>(
                      <div key={i} style={{background:C.card,borderRadius:11,padding:"14px 16px",border:`1px solid ${C.border}`}}>
                        <div style={{color:C.muted,fontSize:11,textTransform:"uppercase",marginBottom:4}}>{k.l}</div>
                        <div style={{color:k.c,fontSize:17,fontWeight:800}}>{k.v} €</div>
                        <div style={{color:C.muted,fontSize:11,marginTop:3}}>{k.info}</div>
                      </div>
                    ));
                  })()}
                </div>

                {/* Pro Objekt */}
                {db.objekte.map(o=>{
                  const ausgaben = nachObjekt[o.id]||[];
                  if(ausgaben.length===0) return null;
                  return (
                    <div key={o.id} style={{background:C.card,borderRadius:12,padding:18,marginBottom:14,border:`1px solid ${C.border}`}}>
                      <div style={{color:C.text,fontWeight:700,fontSize:14,marginBottom:12}}>{o.adresse}</div>
                      <div style={{overflowX:"auto",WebkitOverflowScrolling:"touch"}}>
                      <table style={{width:"100%",borderCollapse:"collapse",minWidth:600}}>
                        <thead><tr style={{background:C.card2}}>
                          {["Datum","Rech.-Nr.","Beschreibung","Kategorie","Steuerlich","Betrag",""].map((h,i)=>(
                            <th key={i} style={{color:C.muted,fontSize:11,padding:"8px 10px",textAlign:i>=5?"right":"left",fontWeight:600,whiteSpace:"nowrap"}}>{h}</th>
                          ))}
                        </tr></thead>
                        <tbody>{ausgaben.sort((a,b)=>b.datum.localeCompare(a.datum)).map((a,ri)=>(
                          <tr key={a.id} style={{background:ri%2===0?C.card:C.card2,borderTop:`1px solid ${C.border}`}}>
                            <td style={{padding:"8px 10px",color:C.muted,fontSize:12,whiteSpace:"nowrap"}}>{fmtD(a.datum)}</td>
                            <td style={{padding:"8px 10px",color:C.text,fontSize:11,fontFamily:"monospace",whiteSpace:"nowrap"}}>{a.rechnungNr||"—"}</td>
                            <td style={{padding:"8px 10px",color:C.text,fontSize:12}}>
                              {a.beschreibung}
                              {a.wiederkehrend&&<span style={{background:C.card2,color:C.muted,fontSize:9,padding:"1px 5px",borderRadius:6,border:`1px solid ${C.border}`,marginLeft:6}}>wiederkehrend</span>}
                            </td>
                            <td style={{padding:"8px 10px",whiteSpace:"nowrap"}}><Bdg col="blue" ch={a.kategorie}/></td>
                            <td style={{padding:"8px 10px",whiteSpace:"nowrap"}}>
                              <Bdg col={a.steuerkat==="Umlagefähige Nebenkosten"?"green":a.steuerkat==="Werbungskosten"?"blue":"yellow"} ch={a.steuerkat||"Sonstiges"}/>
                            </td>
                            <td style={{padding:"8px 10px",color:C.rT,fontWeight:700,textAlign:"right",whiteSpace:"nowrap"}}>{fmt(a.betrag)} €</td>
                            <td style={{padding:"8px 10px",textAlign:"right"}}>
                              {!a.wiederkehrend&&<button style={{...bD,padding:"3px 7px",fontSize:11}} onClick={()=>{upd("ausgaben",aa=>aa.filter(x=>x.id!==a.id));say("Gelöscht");}}>🗑</button>}
                            </td>
                          </tr>
                        ))}</tbody>
                      </table>
                      </div>
                      <div style={{display:"flex",justifyContent:"flex-end",marginTop:8,gap:16}}>
                        <span style={{color:C.muted,fontSize:12}}>Gesamt: <strong style={{color:C.rT}}>{fmt(ausgaben.reduce((s,a)=>s+parseFloat(a.betrag),0))} €</strong></span>
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })()}

          {/* Beleg-Upload Modal */}
          {belegModal&&<BelegUploadModal onClose={()=>setBelegModal(false)} db={db} upd={upd} say={say} token={token}/>}
        </div>
      )}

      {/* ── STEUER ── */}

      {/* ── ZAHLUNGSZIELE ── */}
      {finTab==="zahlungsplan"&&(()=>{
        const plaene = db.zahlungsplaene||[];
        const heute = new Date().toISOString().split("T")[0];

        // Berechne Gesamtbezahlt und Status pro Plan
        const planInfo = (p) => {
          const gezahlt = (p.raten||[]).filter(r=>r.bezahlt).reduce((s,r)=>s+parseFloat(r.betrag||0),0);
          const gesamt = parseFloat(p.gesamtbetrag||0);
          const offen = gesamt - gezahlt;
          const fertig = offen <= 0;
          return {gezahlt, gesamt, offen, fertig};
        };

        // Dashboard-Erinnerungen prüfen
        const erinnerungen = [];
        plaene.forEach(p=>{
          if(planInfo(p).fertig) return;
          (p.raten||[]).filter(r=>!r.bezahlt).forEach(r=>{
            const diff = Math.ceil((new Date(r.datum)-new Date())/(1000*60*60*24));
            const vorlauf = r.vorlauf||db.erinnerungsSettings?.vorlauf||3;
            const erinTyp = r.erinTyp||db.erinnerungsSettings?.typ||"dashboard";
            if(diff>=0 && diff<=vorlauf){
              erinnerungen.push({plan:p,rate:r,diff,erinTyp});
              // E-Mail senden wenn typ="email" oder "beide" und noch nicht gesendet
              if((erinTyp==="email"||erinTyp==="beide")&&!r.emailGesendet&&db.erinnerungsSettings?.email){
                const email=db.erinnerungsSettings.email;
                fetch("/api/email",{method:"POST",headers:{"Content-Type":"application/json",Authorization:`Bearer ${token}`},
                  body:JSON.stringify({to:email,toName:"ImManager",subject:`⏰ Rate fällig: ${p.bezeichnung}`,
                    text:`Rate ${fmt(r.betrag)} € für "${p.bezeichnung}" ist ${diff===0?"heute":"in "+diff+" Tag(en)"} fällig (${fmtD(r.datum)}).`})
                }).then(()=>{
                  upd("zahlungsplaene",pp=>pp.map(x=>x.id!==p.id?x:{...x,raten:x.raten.map(rt=>rt.id!==r.id?rt:{...rt,emailGesendet:true})}));
                }).catch(()=>{});
              }
            }
          });
        });

        return (
          <div>
            {/* Erinnerungen Banner */}
            {erinnerungen.length>0&&(
              <div style={{background:C.r2,border:`1px solid ${C.rT}44`,borderRadius:10,padding:"12px 16px",marginBottom:18}}>
                <div style={{color:C.rT,fontWeight:700,fontSize:13,marginBottom:8}}>⏰ {erinnerungen.length} fällige Rate(n) in Kürze</div>
                {erinnerungen.map((e,i)=>(
                  <div key={i} style={{color:C.rT,fontSize:12,marginBottom:3}}>
                    • {e.plan.bezeichnung} – Rate {fmt(e.rate.betrag)} € {e.diff===0?"heute fällig":`in ${e.diff} Tag(en)`}
                  </div>
                ))}
              </div>
            )}

            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18}}>
              <div>
                <div style={{color:C.text,fontWeight:700,fontSize:15}}>Zahlungsziele</div>
                <div style={{color:C.muted,fontSize:12,marginTop:2}}>Eigene Verbindlichkeiten · Raten · Rechnungsablage</div>
              </div>
              <button style={bP} onClick={()=>setModal({t:"neuerPlan"})}>＋ Neues Zahlungsziel</button>
            </div>

            {/* Aktive Pläne */}
            {plaene.length===0&&(
              <div style={{background:C.card2,borderRadius:12,padding:40,textAlign:"center",border:`2px dashed ${C.border}`}}>
                <div style={{fontSize:36,marginBottom:10}}>📋</div>
                <div style={{color:C.muted,fontSize:13}}>Noch keine Zahlungsziele angelegt</div>
              </div>
            )}
            {plaene.map(p=>{
              const {gezahlt,gesamt,offen,fertig} = planInfo(p);
              const prozent = gesamt>0?Math.min(100,(gezahlt/gesamt)*100):0;
              const obj = db.objekte.find(o=>o.id===p.objektId);
              const istForderung = p.richtung==="forderung";
              const vertragMi = istForderung && p.vertragsId ? db.vertraege.find(v=>v.id===p.vertragsId) : null;
              const miName = vertragMi ? getMi(vertragMi.mieterId)?.name : null;
              return (
                <div key={p.id} style={{background:C.card,borderRadius:12,padding:18,marginBottom:14,border:`1px solid ${fertig?C.gT+"44":C.border}`}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:12}}>
                    <div>
                      <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
                        <span style={{color:C.text,fontWeight:700,fontSize:15}}>{p.bezeichnung}</span>
                        {fertig&&<span style={{background:C.g2,color:C.gT,fontSize:11,padding:"2px 8px",borderRadius:10,fontWeight:600}}>✓ Erledigt</span>}
                        {istForderung
                          ?<span style={{background:`${C.blue}18`,color:C.blue2,fontSize:11,padding:"2px 8px",borderRadius:10,fontWeight:600}}>💰 {miName||"Mieter"}{vertragMi?` · ${vertragMi.einheit}`:""}</span>
                          :<span style={{background:C.card2,color:C.muted,fontSize:11,padding:"2px 8px",borderRadius:10}}>{p.kategorie}</span>}
                      </div>
                      <div style={{color:C.muted,fontSize:12,marginTop:3}}>{obj?.adresse||"Kein Objekt"} · Gesamt: {fmt(gesamt)} €</div>
                    </div>
                    <div style={{textAlign:"right"}}>
                      <div style={{color:fertig?C.gT:C.rT,fontWeight:700,fontSize:16}}>{fmt(offen)} € offen</div>
                      <div style={{color:C.muted,fontSize:11}}>{fmt(gezahlt)} € bezahlt</div>
                    </div>
                  </div>

                  {/* Fortschrittsbalken */}
                  <div style={{background:C.card2,borderRadius:99,height:8,marginBottom:14,overflow:"hidden"}}>
                    <div style={{background:`linear-gradient(135deg,${C.blue},${C.pT})`,width:`${prozent}%`,height:"100%",borderRadius:99,transition:"width .3s"}}/>
                  </div>

                  {/* Raten */}
                  <div style={{marginBottom:10}}>
                    <div style={{color:C.muted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:8}}>Raten</div>
                    {(p.raten||[]).map((r,ri)=>{
                      const diff=Math.ceil((new Date(r.datum)-new Date())/(1000*60*60*24));
                      const faellig=!r.bezahlt&&diff<=3&&diff>=0;
                      const ueberfaellig=!r.bezahlt&&diff<0;
                      return (
                        <div key={r.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"7px 10px",borderRadius:7,marginBottom:5,background:ueberfaellig?C.r2:faellig?C.y2:C.card2,border:`1px solid ${ueberfaellig?C.rT+"44":faellig?C.yT+"44":C.border}`}}>
                          <div style={{display:"flex",gap:10,alignItems:"center"}}>
                            <input type="checkbox" checked={r.bezahlt||false} onChange={()=>{
                              upd("zahlungsplaene",pp=>pp.map(x=>x.id!==p.id?x:{...x,raten:x.raten.map((rt,i)=>i!==ri?rt:{...rt,bezahlt:!rt.bezahlt,bezahltAm:!rt.bezahlt?heute:null})}));
                              // Falls fertig: Rechnung in Rechnungsablage verschieben
                              const newGezahlt = (p.raten||[]).reduce((s,rt,i)=>s+parseFloat(i===ri&&!r.bezahlt?rt.betrag:rt.bezahlt?rt.betrag:0),0);
                              if(newGezahlt>=gesamt && p.datei){
                                upd("rechnungsablage",ra=>{
                                  const cur=ra||{};
                                  const objAblage=cur[p.objektId]||{werbungskosten:[],nebenkosten:[],sonstiges:[]};
                                  const kat=p.kategorie==="Werbungskosten"?"werbungskosten":p.kategorie==="Umlagefähige Nebenkosten"?"nebenkosten":"sonstiges";
                                  return {...cur,[p.objektId]:{...objAblage,[kat]:[...objAblage[kat],{id:uid(),name:p.bezeichnung,datum:heute,betrag:gesamt,datei:p.datei,dateiName:p.dateiName}]}};
                                });
                                say("Zahlung abgeschlossen – Rechnung archiviert ✓");
                              }
                            }}/>
                            <span style={{color:r.bezahlt?C.muted:ueberfaellig?C.rT:C.text,fontSize:13,textDecoration:r.bezahlt?"line-through":"none"}}>
                              Rate {ri+1}: {fmt(r.betrag)} €
                            </span>
                            {ueberfaellig&&<span style={{color:C.rT,fontSize:11,fontWeight:600}}>ÜBERFÄLLIG</span>}
                            {faellig&&<span style={{color:C.yT,fontSize:11,fontWeight:600}}>in {diff}d fällig</span>}
                          </div>
                          <span style={{color:C.muted,fontSize:12}}>{fmtD(r.datum)}</span>
                        </div>
                      );
                    })}
                  </div>

                  <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
                    {p.datei&&<button style={{...bS,fontSize:12}} onClick={()=>window.open(p.datei,"_blank")}>📄 Rechnung</button>}
                    {fertig&&<button style={{...bS,fontSize:12,color:C.gT}} onClick={()=>{
                      if(p.datei){
                        upd("rechnungsablage",ra=>{
                          const cur=ra||{};
                          const objAblage=cur[p.objektId]||{werbungskosten:[],nebenkosten:[],sonstiges:[]};
                          const kat=p.kategorie==="Werbungskosten"?"werbungskosten":p.kategorie==="Umlagefähige Nebenkosten"?"nebenkosten":"sonstiges";
                          return {...cur,[p.objektId]:{...objAblage,[kat]:[...objAblage[kat],{id:uid(),name:p.bezeichnung,datum:heute,betrag:gesamt,datei:p.datei,dateiName:p.dateiName}]}};
                        });
                        say("In Rechnungsablage verschoben ✓");
                      }
                    }}>📁 Archivieren</button>}
                    <button style={{...bD,fontSize:12}} onClick={()=>{if(window.confirm("Plan löschen?"))upd("zahlungsplaene",pp=>pp.filter(x=>x.id!==p.id));}}>🗑</button>
                  </div>
                </div>
              );
            })}

            {/* Rechnungsablage */}
            <div style={{marginTop:28}}>
              <div style={{color:C.text,fontWeight:700,fontSize:15,marginBottom:4}}>Rechnungsablage</div>
              <div style={{color:C.muted,fontSize:12,marginBottom:16}}>Archivierte Rechnungen nach Objekt und Kategorie</div>
              {db.objekte.map(o=>{
                const ablage=(db.rechnungsablage||{})[o.id]||{werbungskosten:[],nebenkosten:[],sonstiges:[]};
                const alle=[...ablage.werbungskosten||[],...ablage.nebenkosten||[],...ablage.sonstiges||[]];
                if(alle.length===0) return null;
                return (
                  <div key={o.id} style={{background:C.card,borderRadius:12,padding:16,marginBottom:14,border:`1px solid ${C.border}`}}>
                    <div style={{color:C.text,fontWeight:700,fontSize:14,marginBottom:12}}>{o.adresse}</div>
                    {[{key:"werbungskosten",l:"Werbungskosten"},{key:"nebenkosten",l:"Umlagefähige Nebenkosten"},{key:"sonstiges",l:"Sonstiges"}].map(({key,l})=>{
                      const items=ablage[key]||[];
                      if(items.length===0) return null;
                      return (
                        <div key={key} style={{marginBottom:12}}>
                          <div style={{color:C.muted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:7}}>{l}</div>
                          {items.map(it=>(
                            <div key={it.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"7px 10px",background:C.card2,borderRadius:7,marginBottom:5}}>
                              <div>
                                <span style={{color:C.text,fontSize:13}}>{it.name}</span>
                                <span style={{color:C.muted,fontSize:11,marginLeft:10}}>{fmtD(it.datum)}</span>
                              </div>
                              <div style={{display:"flex",gap:8,alignItems:"center"}}>
                                <span style={{color:C.text,fontWeight:600,fontSize:13}}>{fmt(it.betrag)} €</span>
                                {it.datei&&<button style={{...bS,padding:"3px 8px",fontSize:11}} onClick={()=>window.open(it.datei,"_blank")}>📄</button>}
                                <button style={{...bD,padding:"3px 8px",fontSize:11}} onClick={()=>{
                                  upd("rechnungsablage",ra=>{const cur={...ra};const obj={...cur[o.id]};obj[key]=(obj[key]||[]).filter(x=>x.id!==it.id);cur[o.id]=obj;return cur;});
                                }}>🗑</button>
                              </div>
                            </div>
                          ))}
                        </div>
                      );
                    })}
                  </div>
                );
              })}
              {db.objekte.every(o=>{const a=(db.rechnungsablage||{})[o.id]||{};return [...(a.werbungskosten||[]),...(a.nebenkosten||[]),...(a.sonstiges||[])].length===0;})&&(
                <div style={{background:C.card2,borderRadius:10,padding:24,textAlign:"center",color:C.muted,fontSize:13}}>Noch keine archivierten Rechnungen</div>
              )}
            </div>
          </div>
        );
      })()}

      {/* ── BANKABGLEICH ── */}
      {/* ── DARLEHEN ── */}
      {finTab==="darlehen"&&(
        <div>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18}}>
            <p style={{color:C.muted,fontSize:13,margin:0}}>Darlehen je Objekt verwalten · Restlaufzeit wird aus Restschuld und aktueller Tilgung geschätzt</p>
            <button style={bP} onClick={()=>{setDForm({objektId:db.objekte[0]?.id||"",bezeichnung:"",restschuld:"",zinsBetrag:"",tilgungBetrag:"",beginn:new Date().toISOString().split("T")[0],hatBausparvertrag:false,bausparBank:"",bausparGuthaben:"",bausparSparrate:"",bausparTilgung:"",bausparZielsumme:""});setDModal(true);}}>＋ Darlehen anlegen</button>
          </div>

          {(db.darlehen||[]).length===0?(
            <div style={{color:C.muted,textAlign:"center",padding:40,fontSize:13}}>Noch keine Darlehen erfasst</div>
          ):(
            <div style={{display:"flex",flexDirection:"column",gap:12}}>
              {(db.darlehen||[]).map(d=>{
                const obj = getOb(d.objektId);
                const { zins, tilgung } = darlehenMonat(d);
                const restMonateNormal = darlehenRestlaufzeit(d);
                const restMonateBauspar = darlehenRestlaufzeitBauspar(d);
                const restMonate = d.hatBausparvertrag ? restMonateBauspar : restMonateNormal;
                const tilgungFehlt = d.hatBausparvertrag
                  ? ((parseFloat(d.bausparTilgung)||0) <= 0 && (parseFloat(d.bausparSparrate)||0) <= 0) && (parseFloat(d.bausparGuthaben)||0) < (parseFloat(d.bausparZielsumme)||0)
                  : (parseFloat(d.tilgungBetrag)||0) <= 0;
                const jahre = restMonate===Infinity?null:Math.floor(restMonate/12);
                const monateRest = restMonate===Infinity?null:restMonate%12;
                const bausparFortschritt = d.hatBausparvertrag && d.bausparZielsumme>0
                  ? Math.min(100, (parseFloat(d.bausparGuthaben)||0)/parseFloat(d.bausparZielsumme)*100)
                  : null;
                return (
                  <div key={d.id} style={{background:C.card,borderRadius:12,padding:18,border:`1px solid ${C.border}`}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:12}}>
                      <div>
                        <div style={{color:C.text,fontWeight:700,fontSize:15}}>{d.bezeichnung}</div>
                        <div style={{color:C.muted,fontSize:12,marginTop:2}}>{obj?.adresse||"Kein Objekt zugeordnet"}</div>
                      </div>
                      <div style={{display:"flex",gap:6}}>
                        <button style={{background:"none",border:"none",color:C.muted,cursor:"pointer",fontSize:14}} title="Bearbeiten" onClick={()=>{setDEditForm(d);}}>✏️</button>
                        <button style={{background:"none",border:"none",color:C.rT,cursor:"pointer",fontSize:14}} title="Löschen" onClick={()=>{if(window.confirm(`"${d.bezeichnung}" wirklich löschen?`))upd("darlehen",dd=>(dd||[]).filter(x=>x.id!==d.id));}}>🗑</button>
                      </div>
                    </div>
                    <div style={{display:"grid",gridTemplateColumns:isMobile?"repeat(2,1fr)":"repeat(4,1fr)",gap:10,marginBottom:14}}>
                      <div style={{background:C.card2,borderRadius:8,padding:"9px 12px"}}>
                        <div style={{color:C.muted,fontSize:10,marginBottom:2}}>Restschuld</div>
                        <div style={{color:C.text,fontWeight:700,fontSize:14}}>{fmt(d.restschuld)} €</div>
                      </div>
                      <div style={{background:C.card2,borderRadius:8,padding:"9px 12px"}}>
                        <div style={{color:C.muted,fontSize:10,marginBottom:2}}>Zinsen / Monat</div>
                        <div style={{color:C.rT,fontWeight:700,fontSize:14}}>{fmt(d.zinsBetrag)} €</div>
                      </div>
                      <div style={{background:C.card2,borderRadius:8,padding:"9px 12px"}}>
                        <div style={{color:C.muted,fontSize:10,marginBottom:2}}>Tilgung / Monat</div>
                        <div style={{color:C.blue2,fontWeight:700,fontSize:14}}>{fmt(d.tilgungBetrag)} €</div>
                      </div>
                      <div style={{background:tilgungFehlt?C.r2:C.g2,borderRadius:8,padding:"9px 12px"}}>
                        <div style={{color:tilgungFehlt?C.rT:C.gT,fontSize:10,marginBottom:2}}>Restlaufzeit{d.hatBausparvertrag?" (Bausparvertrag)":" (geschätzt)"}</div>
                        <div style={{color:tilgungFehlt?C.rT:C.gT,fontWeight:700,fontSize:14}}>
                          {restMonate===0?"✓ erreicht":tilgungFehlt?"⚠ n/a":`${jahre} J. ${monateRest} M.`}
                        </div>
                      </div>
                    </div>
                    {tilgungFehlt&&(
                      <div style={{background:C.r2,borderRadius:7,padding:"8px 12px",marginBottom:10,color:C.rT,fontSize:12}}>
                        {d.hatBausparvertrag
                          ?"⚠ Keine Bauspar-Tilgung eingetragen – Restlaufzeit kann nicht berechnet werden."
                          :"⚠ Keine Tilgung eingetragen – Restlaufzeit kann nicht berechnet werden."}
                      </div>
                    )}
                    {d.hatBausparvertrag&&(
                      <div style={{background:C.card2,borderRadius:8,padding:"10px 12px",marginTop:8,border:`1px solid ${C.border}`}}>
                        <div style={{color:C.text,fontWeight:600,fontSize:12,marginBottom:6}}>🏦 Verknüpfter Bausparvertrag{d.bausparBank?` · ${d.bausparBank}`:""}</div>
                        <div style={{display:"flex",gap:16,fontSize:12,color:C.muted,marginBottom:bausparFortschritt!==null?6:0,flexWrap:"wrap"}}>
                          <span>Guthaben: <strong style={{color:C.text}}>{fmt(d.bausparGuthaben)} €</strong></span>
                          {d.bausparSparrate&&<span>Sparrate: <strong style={{color:C.text}}>{fmt(d.bausparSparrate)} €/Monat</strong></span>}
                          {d.bausparTilgung&&<span>Tilgung: <strong style={{color:C.blue2}}>{fmt(d.bausparTilgung)} €/Monat</strong></span>}
                          {d.bausparZielsumme&&<span>Ziel: <strong style={{color:C.text}}>{fmt(d.bausparZielsumme)} €</strong></span>}
                        </div>
                        {bausparFortschritt!==null&&(
                          <div style={{background:C.border,borderRadius:6,height:6,overflow:"hidden"}}>
                            <div style={{background:C.blue,height:"100%",width:`${bausparFortschritt}%`}}/>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
              {(()=>{
                const gesamtRestschuld = (db.darlehen||[]).reduce((s,d)=>s+(parseFloat(d.restschuld)||0),0);
                const gesamtZins = (db.darlehen||[]).reduce((s,d)=>s+darlehenMonat(d).zins,0);
                const gesamtTilgung = (db.darlehen||[]).reduce((s,d)=>s+darlehenMonat(d).tilgung,0);
                const gesamtRate = gesamtZins + gesamtTilgung;
                return (
                  <div style={{background:`linear-gradient(135deg,${C.blue}22,${C.blue}11)`,borderRadius:11,padding:18,border:`1px solid ${C.blue}44`}}>
                    <div style={{color:C.blue2,fontWeight:700,fontSize:13,marginBottom:10}}>Gesamt alle Darlehen</div>
                    <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,textAlign:"center"}}>
                      <div><div style={{color:C.muted,fontSize:11,marginBottom:3}}>Restschuld</div><div style={{color:C.text,fontWeight:800,fontSize:15}}>{fmt(gesamtRestschuld)} €</div></div>
                      <div><div style={{color:C.muted,fontSize:11,marginBottom:3}}>Monatsrate</div><div style={{color:C.text,fontWeight:800,fontSize:15}}>{fmt(gesamtRate)} €</div></div>
                      <div><div style={{color:C.muted,fontSize:11,marginBottom:3}}>Zinsen/Monat</div><div style={{color:C.rT,fontWeight:800,fontSize:15}}>{fmt(gesamtZins)} €</div></div>
                      <div><div style={{color:C.muted,fontSize:11,marginBottom:3}}>Tilgung/Monat</div><div style={{color:C.blue2,fontWeight:800,fontSize:15}}>{fmt(gesamtTilgung)} €</div></div>
                    </div>
                  </div>
                );
              })()}
            </div>
          )}

          {dModal&&(
            <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.4)",zIndex:2000,display:"flex",alignItems:"center",justifyContent:"center",overflowY:"auto",padding:20}} onClick={()=>setDModal(false)}>
              <div style={{background:C.card,borderRadius:14,padding:24,width:500,border:`1px solid ${C.b2}`,maxHeight:"90vh",overflowY:"auto"}} onClick={e=>e.stopPropagation()}>
                <div style={{color:C.text,fontWeight:700,fontSize:15,marginBottom:16}}>Darlehen anlegen</div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:14}}>
                  <div style={{gridColumn:"1/-1"}}><label style={lbl}>Objekt</label>
                    <select style={inp} value={dForm.objektId} onChange={e=>setDForm(p=>({...p,objektId:e.target.value}))}>
                      {db.objekte.map(o=><option key={o.id} value={o.id}>{o.adresse}</option>)}
                    </select>
                  </div>
                  <div style={{gridColumn:"1/-1"}}><label style={lbl}>Bezeichnung</label><input style={inp} value={dForm.bezeichnung} onChange={e=>setDForm(p=>({...p,bezeichnung:e.target.value}))} placeholder="z.B. Darlehen Sparkasse Witten"/></div>
                  <div style={{gridColumn:"1/-1"}}><label style={lbl}>Restschuld (€)</label><input type="number" style={inp} value={dForm.restschuld} onChange={e=>setDForm(p=>({...p,restschuld:e.target.value}))} onWheel={e=>e.target.blur()}/></div>
                  <div><label style={lbl}>Zinsen (€/Monat)</label><input type="number" style={inp} value={dForm.zinsBetrag} onChange={e=>setDForm(p=>({...p,zinsBetrag:e.target.value}))} onWheel={e=>e.target.blur()} placeholder="tatsächlich gezahlt"/></div>
                  <div><label style={lbl}>Tilgung (€/Monat)</label><input type="number" style={inp} value={dForm.tilgungBetrag} onChange={e=>setDForm(p=>({...p,tilgungBetrag:e.target.value}))} onWheel={e=>e.target.blur()} placeholder="tatsächlich gezahlt"/></div>
                  <div style={{gridColumn:"1/-1"}}><label style={lbl}>Beginn</label><input type="date" style={inp} value={dForm.beginn} onChange={e=>setDForm(p=>({...p,beginn:e.target.value}))}/></div>
                </div>
                <div style={{background:C.card2,borderRadius:8,padding:"8px 12px",marginBottom:14,fontSize:11,color:C.muted}}>
                  💡 Zinsen und Tilgung bitte als tatsächlich gezahlten €-Betrag pro Monat eintragen (siehe Kontoauszug/Bank). Fließt automatisch in die Ausgaben ein (Zinsen = steuerlich absetzbar, Tilgung = nicht absetzbar).
                </div>
                <label style={{display:"flex",alignItems:"center",gap:8,marginBottom:14,cursor:"pointer"}}>
                  <input type="checkbox" checked={dForm.hatBausparvertrag} onChange={e=>setDForm(p=>({...p,hatBausparvertrag:e.target.checked}))}/>
                  <span style={{color:C.text,fontSize:13,fontWeight:600}}>🏦 Bausparvertrag verknüpfen</span>
                </label>
                {dForm.hatBausparvertrag&&(
                  <div style={{background:C.card2,borderRadius:8,padding:14,marginBottom:14,border:`1px solid ${C.border}`}}>
                    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                      <div style={{gridColumn:"1/-1"}}><label style={lbl}>Bausparkasse / Anbieter</label><input style={inp} value={dForm.bausparBank} onChange={e=>setDForm(p=>({...p,bausparBank:e.target.value}))} placeholder="z.B. Schwäbisch Hall"/></div>
                      <div><label style={lbl}>Aktuelles Guthaben (€)</label><input type="number" style={inp} value={dForm.bausparGuthaben} onChange={e=>setDForm(p=>({...p,bausparGuthaben:e.target.value}))} onWheel={e=>e.target.blur()}/></div>
                      <div><label style={lbl}>Sparrate (€/Monat)</label><input type="number" style={inp} value={dForm.bausparSparrate} onChange={e=>setDForm(p=>({...p,bausparSparrate:e.target.value}))} onWheel={e=>e.target.blur()}/></div>
                      <div><label style={lbl}>Tilgung (€/Monat)</label><input type="number" style={inp} value={dForm.bausparTilgung} onChange={e=>setDForm(p=>({...p,bausparTilgung:e.target.value}))} onWheel={e=>e.target.blur()} placeholder="für Restlaufzeit-Berechnung"/></div>
                      <div style={{gridColumn:"1/-1"}}><label style={lbl}>Bausparsumme (Ziel, €)</label><input type="number" style={inp} value={dForm.bausparZielsumme} onChange={e=>setDForm(p=>({...p,bausparZielsumme:e.target.value}))} onWheel={e=>e.target.blur()}/></div>
                    </div>
                  </div>
                )}
                <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
                  <button style={bS} onClick={()=>setDModal(false)}>Abbrechen</button>
                  <button style={bP} onClick={()=>{
                    if(!dForm.bezeichnung||!dForm.restschuld){say("Bitte Bezeichnung und Restschuld ausfüllen");return;}
                    upd("darlehen",dd=>[...(dd||[]),{...dForm,id:uid()}]);
                    setDModal(false);say("Darlehen angelegt ✓");
                  }}>Speichern</button>
                </div>
              </div>
            </div>
          )}

          {dEditForm&&(
            <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.4)",zIndex:2000,display:"flex",alignItems:"center",justifyContent:"center",overflowY:"auto",padding:20}} onClick={()=>setDEditForm(null)}>
              <div style={{background:C.card,borderRadius:14,padding:24,width:500,border:`1px solid ${C.b2}`,maxHeight:"90vh",overflowY:"auto"}} onClick={e=>e.stopPropagation()}>
                <div style={{color:C.text,fontWeight:700,fontSize:15,marginBottom:16}}>Darlehen bearbeiten</div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:14}}>
                  <div style={{gridColumn:"1/-1"}}><label style={lbl}>Objekt</label>
                    <select style={inp} value={dEditForm.objektId} onChange={e=>setDEditForm(p=>({...p,objektId:e.target.value}))}>
                      {db.objekte.map(o=><option key={o.id} value={o.id}>{o.adresse}</option>)}
                    </select>
                  </div>
                  <div style={{gridColumn:"1/-1"}}><label style={lbl}>Bezeichnung</label><input style={inp} value={dEditForm.bezeichnung} onChange={e=>setDEditForm(p=>({...p,bezeichnung:e.target.value}))}/></div>
                  <div style={{gridColumn:"1/-1"}}><label style={lbl}>Restschuld (€)</label><input type="number" style={inp} value={dEditForm.restschuld} onChange={e=>setDEditForm(p=>({...p,restschuld:e.target.value}))} onWheel={e=>e.target.blur()}/></div>
                  <div><label style={lbl}>Zinsen (€/Monat)</label><input type="number" style={inp} value={dEditForm.zinsBetrag} onChange={e=>setDEditForm(p=>({...p,zinsBetrag:e.target.value}))} onWheel={e=>e.target.blur()}/></div>
                  <div><label style={lbl}>Tilgung (€/Monat)</label><input type="number" style={inp} value={dEditForm.tilgungBetrag} onChange={e=>setDEditForm(p=>({...p,tilgungBetrag:e.target.value}))} onWheel={e=>e.target.blur()}/></div>
                  <div style={{gridColumn:"1/-1"}}><label style={lbl}>Beginn</label><input type="date" style={inp} value={dEditForm.beginn} onChange={e=>setDEditForm(p=>({...p,beginn:e.target.value}))}/></div>
                </div>
                <label style={{display:"flex",alignItems:"center",gap:8,marginBottom:14,cursor:"pointer"}}>
                  <input type="checkbox" checked={dEditForm.hatBausparvertrag||false} onChange={e=>setDEditForm(p=>({...p,hatBausparvertrag:e.target.checked}))}/>
                  <span style={{color:C.text,fontSize:13,fontWeight:600}}>🏦 Bausparvertrag verknüpfen</span>
                </label>
                {dEditForm.hatBausparvertrag&&(
                  <div style={{background:C.card2,borderRadius:8,padding:14,marginBottom:14,border:`1px solid ${C.border}`}}>
                    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                      <div style={{gridColumn:"1/-1"}}><label style={lbl}>Bausparkasse / Anbieter</label><input style={inp} value={dEditForm.bausparBank||""} onChange={e=>setDEditForm(p=>({...p,bausparBank:e.target.value}))} placeholder="z.B. Schwäbisch Hall"/></div>
                      <div><label style={lbl}>Aktuelles Guthaben (€)</label><input type="number" style={inp} value={dEditForm.bausparGuthaben||""} onChange={e=>setDEditForm(p=>({...p,bausparGuthaben:e.target.value}))} onWheel={e=>e.target.blur()}/></div>
                      <div><label style={lbl}>Sparrate (€/Monat)</label><input type="number" style={inp} value={dEditForm.bausparSparrate||""} onChange={e=>setDEditForm(p=>({...p,bausparSparrate:e.target.value}))} onWheel={e=>e.target.blur()}/></div>
                      <div><label style={lbl}>Tilgung (€/Monat)</label><input type="number" style={inp} value={dEditForm.bausparTilgung||""} onChange={e=>setDEditForm(p=>({...p,bausparTilgung:e.target.value}))} onWheel={e=>e.target.blur()} placeholder="für Restlaufzeit-Berechnung"/></div>
                      <div style={{gridColumn:"1/-1"}}><label style={lbl}>Bausparsumme (Ziel, €)</label><input type="number" style={inp} value={dEditForm.bausparZielsumme||""} onChange={e=>setDEditForm(p=>({...p,bausparZielsumme:e.target.value}))} onWheel={e=>e.target.blur()}/></div>
                    </div>
                  </div>
                )}
                <div style={{display:"flex",gap:8,justifyContent:"space-between"}}>
                  <button style={bD} onClick={()=>{
                    if(window.confirm(`"${dEditForm.bezeichnung}" wirklich löschen?`)){
                      upd("darlehen",dd=>(dd||[]).filter(x=>x.id!==dEditForm.id));
                      say("Gelöscht");setDEditForm(null);
                    }
                  }}>🗑 Löschen</button>
                  <div style={{display:"flex",gap:8}}>
                    <button style={bS} onClick={()=>setDEditForm(null)}>Abbrechen</button>
                    <button style={bP} onClick={()=>{
                      if(!dEditForm.bezeichnung||!dEditForm.restschuld)return;
                      upd("darlehen",dd=>(dd||[]).map(x=>x.id===dEditForm.id?dEditForm:x));
                      say("Aktualisiert ✓");setDEditForm(null);
                    }}>Speichern</button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {finTab==="bank"&&<BankabgleichTab ctx={ctx}/>}

            {finTab==="steuern"&&(
        <div>
          <p style={{color:C.muted,fontSize:13,marginBottom:20}}>Steuerliche Übersicht für {fj} · alle Beträge sind Schätzungen, kein Steuerberater-Ersatz</p>
          {(()=>{
            const gesamtKalt = db.objekte.reduce((s,o)=>s+kaltEinnahmen(o.id),0);
            const gesamtNK = db.objekte.reduce((s,o)=>s+nkEinnahmen(o.id),0);
            const werbungskostenBelege = periodisiereAusgaben(fj).filter(a=>a.steuerkat==="Werbungskosten").reduce((s,a)=>s+parseFloat(a.betrag),0);
            const darlehenZinsenJahr = darlehenAlsAusgaben(fj).filter(a=>a.steuerkat==="Werbungskosten").reduce((s,a)=>s+parseFloat(a.betrag||0),0);
            const darlehenTilgungJahr = darlehenAlsAusgaben(fj).filter(a=>a.steuerkat==="Tilgung (kein Aufwand)").reduce((s,a)=>s+parseFloat(a.betrag||0),0);
            const werbungskosten = werbungskostenBelege + darlehenZinsenJahr;
            const nkAusgabenGesamt = db.objekte.reduce((s,o)=>s+nkAusgaben(o.id),0);
            const gesamtFixK = db.objekte.reduce((s,o)=>s+fixKostenJahr(o.id),0);
            const einkommen = gesamtKalt - werbungskosten;
            const steuerBasis = Math.max(0,einkommen);
            const steuerEst = steuerBasis * STEUER;
            return (
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
                <div style={{background:C.card,borderRadius:12,padding:20,border:`1px solid ${C.border}`}}>
                  <FinSH ch="Einnahmen"/>
                  <FinRow l="Kaltmiete (Jahreshochr.)" v={`${fmt(gesamtKalt)} €`} c={C.gT}/>
                  <FinRow l="NK-Vorauszahlungen" v={`${fmt(gesamtNK)} €`} c={C.gT}/>
                  <FinRow l="Summe Einnahmen" v={`${fmt(gesamtKalt+gesamtNK)} €`} c={C.gT} bold/>
                </div>
                <div style={{background:C.card,borderRadius:12,padding:20,border:`1px solid ${C.border}`}}>
                  <FinSH ch="Absetzbare Ausgaben (Werbungskosten)"/>
                  <FinRow l="Werbungskosten (Belege)" v={`${fmt(werbungskostenBelege)} €`} c={C.rT}/>
                  <FinRow l="Darlehenszinsen" v={`${fmt(darlehenZinsenJahr)} €`} c={C.rT}/>
                  <FinRow l="NK-Ausgaben (umlagefähig)" v={`${fmt(nkAusgabenGesamt)} €`} c={C.rT}/>
                  <FinRow l="Fixkosten" v={`${fmt(gesamtFixK)} €`} c={C.rT}/>
                  <FinRow l="Summe Ausgaben" v={`${fmt(werbungskosten+nkAusgabenGesamt+gesamtFixK)} €`} c={C.rT} bold/>
                  {darlehenTilgungJahr>0&&<div style={{color:C.muted,fontSize:11,marginTop:8}}>ℹ Darlehenstilgung ({fmt(darlehenTilgungJahr)} €) mindert die Liquidität, ist aber steuerlich nicht absetzbar (kein Werbungskostenabzug)</div>}
                </div>
                <div style={{background:C.card,borderRadius:12,padding:20,border:`1px solid ${C.border}`,gridColumn:"1/-1"}}>
                  <FinSH ch={`Steuerberechnung ${fj} (Schätzung)`}/>
                  <FinRow l="Einnahmen gesamt" v={`${fmt(gesamtKalt+gesamtNK)} €`}/>
                  <FinRow l="Abzüglich Werbungskosten" v={`− ${fmt(werbungskosten)} €`} c={C.rT}/>
                  <FinRow l="Steuerpflichtiges Einkommen" v={`${fmt(steuerBasis)} €`} bold/>
                  <FinRow l={`Einkommensteuer (~${(STEUER*100).toFixed(0)}%)`} v={`${fmt(steuerEst)} €`} c={C.yT} bold/>
                  <div style={{background:`linear-gradient(135deg,${C.blue},${C.pT})`,borderRadius:9,padding:"12px 16px",marginTop:12,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <span style={{color:"rgba(255,255,255,.8)",fontSize:13}}>Netto nach Steuer</span>
                    <span style={{color:"#fff",fontWeight:800,fontSize:20}}>{fmt(gesamtKalt+gesamtNK-steuerEst-nkAusgabenGesamt-gesamtFixK-darlehenZinsenJahr-darlehenTilgungJahr)} €</span>
                  </div>
                  <div style={{color:C.muted,fontSize:11,marginTop:10}}>⚠ Diese Berechnung ist eine vereinfachte Schätzung. Bitte mit deinem Steuerberater abstimmen.</div>
                </div>

                {/* Mieter-Auswertung für Steuerberater, je Objekt gruppiert */}
                <div style={{background:C.card,borderRadius:12,padding:20,border:`1px solid ${C.border}`,gridColumn:"1/-1"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
                    <FinSH ch={`Auswertung je Mieter ${fj} (für Steuerberater)`}/>
                    <button style={{...bS,fontSize:12}} onClick={()=>{
                      const zeilen = [["Objekt","Mieter","Einheit","Kaltmiete gezahlt","Nebenkosten gezahlt","Gesamt gezahlt","Anzahl Zahlungen"]];
                      db.objekte.forEach(obj=>{
                        db.vertraege.filter(v=>!v.leerstand&&v.objektId===obj.id).forEach(v=>{
                          const mi = getMi(v.mieterId);
                          const zahlungenJ = db.zahlungen.filter(z=>z.vertragsId===v.id&&z.monat.endsWith(String(fj)));
                          if(zahlungenJ.length===0) return;
                          const gesamtGezahlt = zahlungenJ.reduce((s,z)=>s+parseFloat(z.betrag||0),0);
                          const kaltAnteil = warmmiete(v)>0 ? (parseFloat(v.kaltmiete)||0)/warmmiete(v) : 1;
                          const kaltGezahlt = gesamtGezahlt * kaltAnteil;
                          const nkGezahlt = gesamtGezahlt - kaltGezahlt;
                          zeilen.push([
                            obj.adresse, mi?.name||"—", v.einheit||"—",
                            kaltGezahlt.toFixed(2), nkGezahlt.toFixed(2), gesamtGezahlt.toFixed(2), zahlungenJ.length
                          ]);
                        });
                      });
                      const csv = zeilen.map(r=>r.map(c=>`"${c}"`).join(";")).join("\n");
                      const blob = new Blob(["\uFEFF"+csv],{type:"text/csv;charset=utf-8"});
                      const url = URL.createObjectURL(blob);
                      const a = document.createElement("a"); a.href=url; a.download=`Mieterauswertung_${fj}.csv`; a.click();
                      URL.revokeObjectURL(url);
                    }}>⬇ CSV für Steuerberater</button>
                  </div>

                  {(()=>{
                    const objekteMitDaten = db.objekte.map(obj=>{
                      const zeilen = [];
                      db.vertraege.filter(v=>!v.leerstand&&v.objektId===obj.id).forEach(v=>{
                        const mi = getMi(v.mieterId);
                        const zahlungenJ = db.zahlungen.filter(z=>z.vertragsId===v.id&&z.monat.endsWith(String(fj)));
                        if(zahlungenJ.length===0) return;
                        const gesamtGezahlt = zahlungenJ.reduce((s,z)=>s+parseFloat(z.betrag||0),0);
                        const kaltAnteil = warmmiete(v)>0 ? (parseFloat(v.kaltmiete)||0)/warmmiete(v) : 1;
                        const kaltGezahlt = gesamtGezahlt * kaltAnteil;
                        const nkGezahlt = gesamtGezahlt - kaltGezahlt;
                        zeilen.push({v,mi,kaltGezahlt,nkGezahlt,gesamtGezahlt});
                      });
                      return {obj, zeilen};
                    }).filter(x=>x.zeilen.length>0);

                    if(objekteMitDaten.length===0) return <div style={{color:C.muted,fontSize:12,textAlign:"center",padding:16}}>Keine Zahlungen für {fj} erfasst</div>;

                    return objekteMitDaten.map(({obj,zeilen})=>{
                      const summeKalt = zeilen.reduce((s,z)=>s+z.kaltGezahlt,0);
                      const summeNk = zeilen.reduce((s,z)=>s+z.nkGezahlt,0);
                      const summeGesamt = zeilen.reduce((s,z)=>s+z.gesamtGezahlt,0);
                      return (
                        <div key={obj.id} style={{marginBottom:18}}>
                          <div style={{color:C.text,fontWeight:700,fontSize:13,marginBottom:8}}>{obj.adresse}</div>
                          <div style={{overflowX:"auto",WebkitOverflowScrolling:"touch"}}>
                            <table style={{width:"100%",borderCollapse:"collapse",minWidth:520}}>
                              <thead><tr style={{background:C.card2}}>
                                {["Mieter","Einheit","Kaltmiete gez.","NK gez.","Gesamt"].map((h,i)=>(
                                  <th key={i} style={{color:C.muted,fontSize:11,padding:"8px 10px",textAlign:i>=2?"right":"left",fontWeight:600,whiteSpace:"nowrap"}}>{h}</th>
                                ))}
                              </tr></thead>
                              <tbody>
                                {zeilen.map((z,i)=>(
                                  <tr key={i} style={{background:i%2===0?C.card:C.card2,borderTop:`1px solid ${C.border}`}}>
                                    <td style={{padding:"8px 10px",color:C.text,fontSize:12}}>{z.mi?.name||"—"}</td>
                                    <td style={{padding:"8px 10px",color:C.muted,fontSize:12}}>{z.v.einheit||"—"}</td>
                                    <td style={{padding:"8px 10px",color:C.gT,fontWeight:600,fontSize:12,textAlign:"right",whiteSpace:"nowrap"}}>{fmt(z.kaltGezahlt)} €</td>
                                    <td style={{padding:"8px 10px",color:C.blue2,fontWeight:600,fontSize:12,textAlign:"right",whiteSpace:"nowrap"}}>{fmt(z.nkGezahlt)} €</td>
                                    <td style={{padding:"8px 10px",color:C.text,fontWeight:700,fontSize:12,textAlign:"right",whiteSpace:"nowrap"}}>{fmt(z.gesamtGezahlt)} €</td>
                                  </tr>
                                ))}
                                <tr style={{background:C.card2,borderTop:`2px solid ${C.border}`}}>
                                  <td colSpan={2} style={{padding:"8px 10px",color:C.muted,fontWeight:700,fontSize:12}}>Zwischensumme</td>
                                  <td style={{padding:"8px 10px",color:C.gT,fontWeight:800,fontSize:12,textAlign:"right",whiteSpace:"nowrap"}}>{fmt(summeKalt)} €</td>
                                  <td style={{padding:"8px 10px",color:C.blue2,fontWeight:800,fontSize:12,textAlign:"right",whiteSpace:"nowrap"}}>{fmt(summeNk)} €</td>
                                  <td style={{padding:"8px 10px",color:C.text,fontWeight:800,fontSize:12,textAlign:"right",whiteSpace:"nowrap"}}>{fmt(summeGesamt)} €</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      );
                    });
                  })()}
                  <div style={{color:C.muted,fontSize:11,marginTop:4}}>ℹ Kaltmiete/NK-Aufteilung erfolgt anteilig nach dem Verhältnis im aktuellen Mietvertrag (nicht rückwirkend bei Mietänderungen im Jahresverlauf).</div>
                </div>
              </div>
            );
          })()}
        </div>
      )}
    </div>
  );
};


// ── BELEG UPLOAD MODAL ───────────────────────────────────────────
const BelegUploadModal = ({onClose, db, upd, say, token}) => {
  const scanRef = useRef();
  const [schritt,setSchritt] = useState("upload"); // upload | bestaetigen
  const [scanning,setScanning] = useState(false);
  const [f,setF] = useState({
    objektId:"",kategorie:"Reparatur",steuerkat:"Sonstiges",
    beschreibung:"",betrag:"",datum:new Date().toISOString().split("T")[0],
    rechnungNr:"",erkannt:false
  });

  const scanBeleg = async (dateien) => {
    const dateiListe = Array.isArray(dateien) ? dateien : [dateien];
    if(dateiListe.length === 0) return;
    setScanning(true);
    try {
      // Bild komprimieren falls zu groß (Handy-Fotos sind oft 5-15 MB)
      const komprimiereBild = (file) => new Promise((resolve) => {
        try {
          if (!file || !file.type || !file.type.startsWith("image/")) { resolve(file); return; }
          const img = new window.Image();
          const url = URL.createObjectURL(file);
          const timeout = setTimeout(() => { URL.revokeObjectURL(url); resolve(file); }, 8000);
          img.onload = () => {
            clearTimeout(timeout);
            try {
              const maxDim = 2000; // höher für bessere Texterkennung auf Belegen
              let width = img.naturalWidth || img.width;
              let height = img.naturalHeight || img.height;
              if (!width || !height) { URL.revokeObjectURL(url); resolve(file); return; }
              if (width > maxDim || height > maxDim) {
                if (width > height) { height = Math.round(height * maxDim / width); width = maxDim; }
                else { width = Math.round(width * maxDim / height); height = maxDim; }
              }
              const canvas = document.createElement("canvas");
              canvas.width = width; canvas.height = height;
              const ctx = canvas.getContext("2d");
              ctx.drawImage(img, 0, 0, width, height);
              canvas.toBlob(blob => {
                URL.revokeObjectURL(url);
                if (blob) resolve(new File([blob], file.name||"foto.jpg", { type: "image/jpeg" }));
                else resolve(file);
              }, "image/jpeg", 0.90); // höhere Qualität für bessere KI-Texterkennung
            } catch(e) { URL.revokeObjectURL(url); resolve(file); }
          };
          img.onerror = () => { clearTimeout(timeout); URL.revokeObjectURL(url); resolve(file); };
          img.src = url;
        } catch(e) { resolve(file); }
      });

      // Alle Seiten komprimieren und zu Base64 konvertieren
      const bilder = await Promise.all(dateiListe.map(async (datei) => {
        const kompDatei = await komprimiereBild(datei);
        const base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result.split(",")[1]);
          reader.onerror = reject;
          reader.readAsDataURL(kompDatei);
        });
        return { base64, mediaType: kompDatei.type || "image/jpeg" };
      }));

      const objektListe = db.objekte.map(o=>o.adresse).join(", ");

      // Echter KI-Scan via Anthropic (unterstützt mehrere Seiten)
      const response = await fetch("/api/scan-beleg", {
        method: "POST",
        headers: {"Content-Type":"application/json", "Authorization": `Bearer ${token}`},
        body: JSON.stringify({bilder, objektListe}),
      });

      if(!response.ok) {
        let serverMsg = `HTTP ${response.status}`;
        try { const errBody = await response.json(); if(errBody.error) serverMsg = errBody.error; } catch(e) {}
        throw new Error(serverMsg);
      }
      const data = await response.json();

      // Objekt aus Hinweis ermitteln
      let erkannteObjektId = "";
      if(data.objektHinweis) {
        const match = db.objekte.find(o=>o.adresse.toLowerCase().includes(data.objektHinweis.toLowerCase()));
        if(match) erkannteObjektId = match.id;
      }

      setF(p=>({
        ...p,
        beschreibung: data.beschreibung || dateiListe[0].name.replace(/\.[^.]+$/,""),
        betrag: String(data.betrag || ""),
        datum: data.datum || new Date().toISOString().split("T")[0],
        rechnungNr: data.rechnungNr || "",
        steuerkat: data.steuerkat || "Sonstiges",
        kategorie: data.kategorie || "Sonstiges",
        objektId: erkannteObjektId || p.objektId,
        erkannt: true,
      }));
      setSchritt("bestaetigen");
    } catch(err) {
      console.error("[scanBeleg] Fehler:", err);
      // Fallback auf Auto-Erkennung aus Dateiname
      const erkannt = autoErkenne(dateiListe[0].name);
      setF(p=>({...p,
        beschreibung: dateiListe[0].name.replace(/\.[^.]+$/,"").replace(/[-_]/g," "),
        steuerkat: erkannt.steuerkat, kategorie: erkannt.kategorie, erkannt: false,
        _scanFehler: err.message || String(err),
      }));
      setSchritt("bestaetigen");
      say("KI-Scan fehlgeschlagen – bitte manuell ausfüllen");
    } finally {
      setScanning(false);
    }
  };

  const speichern = () => {
    if(!f.betrag||!f.objektId){say("Bitte Objekt und Betrag ausfüllen");return;}
    upd("ausgaben",aa=>[...aa,{...f,id:uid()}]);
    say("Beleg gebucht ✓");
    onClose();
  };

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.5)",zIndex:3000,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
      <div style={{background:C.card,borderRadius:16,border:`1px solid ${C.b2}`,width:560,maxHeight:"90vh",overflow:"auto"}} onClick={e=>e.stopPropagation()}>
        <div style={{padding:"18px 22px",borderBottom:`1px solid ${C.border}`,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div>
            <span style={{color:C.text,fontWeight:700,fontSize:15}}>Beleg hochladen</span>
            <div style={{color:C.muted,fontSize:12,marginTop:2}}>{schritt==="upload"?"Schritt 1: Datei auswählen":"Schritt 2: Prüfen & Bestätigen"}</div>
          </div>
          <button onClick={onClose} style={{background:"none",border:"none",color:C.muted,cursor:"pointer",fontSize:20}}>✕</button>
        </div>
        <div style={{padding:22}}>
          {schritt==="upload"&&(
            <div>
              <div style={{background:C.card2,borderRadius:12,padding:28,textAlign:"center",border:`2px dashed ${C.b2}`,cursor:"pointer",marginBottom:12}}
                onClick={()=>scanRef.current?.click()}>
                <input ref={scanRef} type="file" accept=".pdf,.jpg,.jpeg,.png" multiple style={{display:"none"}}
                  onChange={e=>{if(e.target.files.length) scanBeleg(Array.from(e.target.files));}}/>
                {scanning?(
                  <div style={{color:C.blue}}>
                    <div style={{fontSize:32,marginBottom:8}}>⟳</div>
                    <div style={{fontSize:14,fontWeight:600}}>KI analysiert Rechnung…</div>
                    <div style={{color:C.muted,fontSize:12,marginTop:4}}>Erkennt Betrag, Kategorie und steuerliche Zuordnung</div>
                  </div>
                ):(
                  <>
                    <div style={{fontSize:40,marginBottom:10}}>📄</div>
                    <div style={{color:C.text,fontWeight:600,fontSize:14}}>PDF oder Bild(er) hochladen</div>
                    <div style={{color:C.muted,fontSize:12,marginTop:6}}>KI erkennt automatisch: Betrag · Datum · Kategorie · Steuerliche Einordnung</div>
                    <div style={{color:C.muted,fontSize:11,marginTop:4}}>Mehrere Seiten? Einfach mehrere Dateien gleichzeitig auswählen</div>
                  </>
                )}
              </div>
              {/* Kamera-Button für Mobilgeräte */}
              <label style={{...bS,width:"100%",justifyContent:"center",cursor:"pointer",marginBottom:12,display:"flex",alignItems:"center",gap:8}}>
                📷 Mit Kamera scannen (mehrere Seiten möglich)
                <input type="file" style={{display:"none"}} accept="image/*" capture="environment" multiple
                  onChange={e=>{if(e.target.files.length) scanBeleg(Array.from(e.target.files));}}/>
              </label>
              <div style={{background:C.g2,borderRadius:8,padding:"10px 14px",fontSize:12,color:C.gT}}>
                ✓ KI-Erkennung aktiv · Claude analysiert Betrag, Datum, Kategorie und steuerliche Einordnung automatisch
              </div>
            </div>
          )}

          {schritt==="bestaetigen"&&(
            <div>
              {f.erkannt&&(
                <div style={{background:C.g2,borderRadius:8,padding:"10px 14px",marginBottom:14,fontSize:12,color:C.gT,display:"flex",alignItems:"center",gap:8}}>
                  ✓ KI hat Beschreibung erkannt und automatisch kategorisiert – bitte prüfen und ggf. korrigieren
                </div>
              )}
              {f._scanFehler&&(
                <div style={{background:C.r2,borderRadius:8,padding:"10px 14px",marginBottom:14,fontSize:12,color:C.rT}}>
                  ⚠ KI-Scan fehlgeschlagen: {f._scanFehler}
                </div>
              )}
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:14}}>
                <div style={{gridColumn:"1/-1"}}>
                  <label style={lbl}>Objekt *</label>
                  <select style={inp} value={f.objektId} onChange={e=>setF(p=>({...p,objektId:e.target.value}))}>
                    <option value="">— Objekt wählen —</option>
                    {db.objekte.map(o=><option key={o.id} value={o.id}>{o.adresse}</option>)}
                  </select>
                </div>
                <div style={{gridColumn:"1/-1"}}>
                  <label style={lbl}>Beschreibung</label>
                  <input style={inp} value={f.beschreibung}
                    onChange={e=>{
                      const erkannt=autoErkenne(e.target.value);
                      setF(p=>({...p,beschreibung:e.target.value,steuerkat:erkannt.steuerkat,kategorie:erkannt.kategorie}));
                    }}
                    placeholder="Beschreibung der Rechnung"/>
                  {f.beschreibung&&<div style={{color:C.muted,fontSize:11,marginTop:3}}>Erkannt: {f.steuerkat}</div>}
                </div>
                <div>
                  <label style={lbl}>Betrag (€) *</label>
                  <input type="number" style={inp} value={f.betrag} onChange={e=>setF(p=>({...p,betrag:e.target.value}))}/>
                </div>
                <div>
                  <label style={lbl}>Datum</label>
                  <input type="date" style={inp} value={f.datum} onChange={e=>setF(p=>({...p,datum:e.target.value}))}/>
                </div>
                <div>
                  <label style={lbl}>Rechnungs-Nr.</label>
                  <input style={inp} value={f.rechnungNr} onChange={e=>setF(p=>({...p,rechnungNr:e.target.value}))}/>
                </div>
                <div>
                  <label style={lbl}>Kategorie</label>
                  <select style={inp} value={f.kategorie} onChange={e=>setF(p=>({...p,kategorie:e.target.value}))}>
                    {["Reparatur","Instandhaltung","Versicherung","Verwaltung","Betriebskosten","Grundsteuer","Straßenreinigung","Müllabfuhr","Sonstiges"].map(k=><option key={k}>{k}</option>)}
                  </select>
                </div>
                <div style={{gridColumn:"1/-1"}}>
                  <label style={lbl}>Steuerliche Einordnung</label>
                  <div style={{display:"flex",gap:8}}>
                    {["Umlagefähige Nebenkosten","Werbungskosten","Sonstiges"].map(s=>(
                      <button key={s} onClick={()=>setF(p=>({...p,steuerkat:s}))}
                        style={{flex:1,padding:"8px",borderRadius:8,border:`2px solid ${f.steuerkat===s?C.blue:C.border}`,background:f.steuerkat===s?`${C.blue}12`:C.card2,color:f.steuerkat===s?C.blue2:C.text,fontWeight:600,fontSize:11,cursor:"pointer"}}>
                        {s}
                      </button>
                    ))}
                  </div>
                  <div style={{color:C.muted,fontSize:11,marginTop:6}}>
                    {f.steuerkat==="Umlagefähige Nebenkosten"&&"Kann auf Mieter umgelegt werden (Nebenkostenabrechnung)"}
                    {f.steuerkat==="Werbungskosten"&&"Steuerlich absetzbar als Werbungskosten bei V+V"}
                    {f.steuerkat==="Sonstiges"&&"Nicht kategorisiert – bitte manuell prüfen"}
                  </div>
                </div>
              </div>
              <div style={{display:"flex",gap:8,justifyContent:"space-between"}}>
                <button style={bS} onClick={()=>setSchritt("upload")}>← Zurück</button>
                <div style={{display:"flex",gap:8}}>
                  <button style={bS} onClick={onClose}>Abbrechen</button>
                  <button style={bP} onClick={speichern}>✓ Beleg buchen</button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};




// ── PASSWORT ÄNDERN KARTE ─────────────────────────────────────────
const PwCard = ({token}) => {
  const [f,setF] = useState({alt:"",neu:"",neu2:""});
  const [msg,setMsg] = useState(null); // {ok, text}
  const [loading,setLoading] = useState(false);
  const inpS = inp;
  const save = async () => {
    if(!f.alt||!f.neu||!f.neu2){setMsg({ok:false,text:"Alle Felder ausfüllen"});return;}
    if(f.neu!==f.neu2){setMsg({ok:false,text:"Neues Passwort stimmt nicht überein"});return;}
    if(f.neu.length<6){setMsg({ok:false,text:"Passwort mindestens 6 Zeichen"});return;}
    setLoading(true);setMsg(null);
    const r = await fetch("/api/change-password",{method:"POST",headers:{"Content-Type":"application/json",Authorization:`Bearer ${token}`},body:JSON.stringify({oldPassword:f.alt,newPassword:f.neu})});
    const data = await r.json();
    setLoading(false);
    if(!r.ok){setMsg({ok:false,text:data.error||"Fehler"});return;}
    setMsg({ok:true,text:"Passwort geändert ✓"});
    setF({alt:"",neu:"",neu2:""});
  };
  return (
    <div style={{background:C.card,borderRadius:11,padding:16,border:`1px solid ${C.border}`,marginTop:12}}>
      <div style={{color:C.muted,fontSize:10,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:12}}>Passwort ändern</div>
      <div style={{display:"flex",flexDirection:"column",gap:8,marginBottom:10}}>
        <div><label style={{color:C.muted,fontSize:11,display:"block",marginBottom:3}}>Aktuelles Passwort</label><input type="password" autoComplete="current-password" data-lpignore="true" style={inpS} value={f.alt} onChange={e=>setF(p=>({...p,alt:e.target.value}))}/></div>
        <div><label style={{color:C.muted,fontSize:11,display:"block",marginBottom:3}}>Neues Passwort</label><input type="password" autoComplete="new-password" style={inpS} value={f.neu} onChange={e=>setF(p=>({...p,neu:e.target.value}))}/></div>
        <div><label style={{color:C.muted,fontSize:11,display:"block",marginBottom:3}}>Neues Passwort bestätigen</label><input type="password" autoComplete="new-password" style={inpS} value={f.neu2} onChange={e=>setF(p=>({...p,neu2:e.target.value}))}/></div>
      </div>
      {msg&&<div style={{background:msg.ok?C.g2:C.r2,borderRadius:7,padding:"7px 10px",color:msg.ok?C.gT:C.rT,fontSize:12,marginBottom:8}}>{msg.text}</div>}
      <button style={{background:`linear-gradient(135deg,${C.blue},${C.blue2})`,border:"none",color:"#fff",borderRadius:8,padding:"8px 14px",cursor:"pointer",fontSize:13,fontWeight:600}} onClick={save} disabled={loading}>{loading?"Speichern…":"Passwort ändern"}</button>
    </div>
  );
};


// ── 2FA EINSTELLUNGEN KARTE ───────────────────────────────────────
const TwoFACard = ({token}) => {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showDisable, setShowDisable] = useState(false);
  const [disablePw, setDisablePw] = useState("");
  const [msg, setMsg] = useState(null);
  const [setupData, setSetupData] = useState(null); // {qrUrl, secret}
  const [step, setStep] = useState("idle"); // idle | scan | backup
  const [code, setCode] = useState("");
  const [backupCodes, setBackupCodes] = useState([]);
  const hdrs = {"Content-Type":"application/json", Authorization:`Bearer ${token}`};
  const inpS = {background:C.card2,border:`1px solid ${C.border}`,borderRadius:8,color:C.text,padding:"9px 12px",fontSize:13,width:"100%",outline:"none",boxSizing:"border-box",fontFamily:"inherit"};

  useEffect(()=>{
    fetch("/api/2fa/status",{headers:{Authorization:`Bearer ${token}`}})
      .then(r=>r.json()).then(d=>{setEnabled(d.enabled);setLoading(false);}).catch(()=>setLoading(false));
  },[]);

  const startSetup = async () => {
    const r = await fetch("/api/2fa/setup",{method:"POST",headers:{Authorization:`Bearer ${token}`}});
    const d = await r.json();
    setSetupData(d); setStep("scan");
  };

  const confirmSetup = async () => {
    const r = await fetch("/api/2fa/activate",{method:"POST",headers:hdrs,body:JSON.stringify({code:code.replace(/\s/g,"")})});
    const d = await r.json();
    if(!r.ok){setMsg({ok:false,text:d.error||"Ungültiger Code"});return;}
    setBackupCodes(d.backupCodes); setStep("backup"); setEnabled(true);
  };

  const doDisable = async () => {
    const r = await fetch("/api/2fa/disable",{method:"POST",headers:hdrs,body:JSON.stringify({password:disablePw})});
    const d = await r.json();
    if(!r.ok){setMsg({ok:false,text:d.error||"Fehler"});return;}
    setEnabled(false); setShowDisable(false); setDisablePw(""); setMsg({ok:true,text:"2FA deaktiviert"});
  };

  if(loading) return null;

  return (
    <div style={{background:C.card,borderRadius:11,padding:16,border:`1px solid ${C.border}`,marginTop:12}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
        <div>
          <div style={{color:C.muted,fontSize:10,fontWeight:700,textTransform:"uppercase",letterSpacing:1}}>Zwei-Faktor-Authentifizierung</div>
          <div style={{color:enabled?C.gT:C.muted,fontSize:12,marginTop:2}}>{enabled?"🔐 Aktiv – Dein Konto ist extra geschützt":"⚠️ Nicht aktiv"}</div>
        </div>
        {enabled
          ? <button style={{...Object.fromEntries(Object.entries({background:C.r2,border:`1px solid ${C.rT}44`,color:C.rT,borderRadius:8,padding:"6px 12px",cursor:"pointer",fontSize:12,fontWeight:600}))}} onClick={()=>setShowDisable(p=>!p)}>Deaktivieren</button>
          : <button style={{background:`linear-gradient(135deg,${C.blue},${C.blue2})`,border:"none",color:"#fff",borderRadius:8,padding:"6px 12px",cursor:"pointer",fontSize:12,fontWeight:600}} onClick={startSetup}>Aktivieren</button>
        }
      </div>
      {msg&&<div style={{background:msg.ok?C.g2:C.r2,borderRadius:7,padding:"7px 10px",color:msg.ok?C.gT:C.rT,fontSize:12,marginBottom:10}}>{msg.text}</div>}
      {showDisable&&(
        <div>
          <div style={{color:C.muted,fontSize:12,marginBottom:6}}>Passwort zur Bestätigung:</div>
          <input type="password" style={{...inpS,marginBottom:8}} value={disablePw} onChange={e=>setDisablePw(e.target.value)} placeholder="Dein Passwort"/>
          <button style={{background:C.rT,border:"none",color:"#fff",borderRadius:8,padding:"7px 14px",cursor:"pointer",fontSize:12,fontWeight:600}} onClick={doDisable}>Ja, 2FA deaktivieren</button>
        </div>
      )}
      {step==="scan"&&setupData&&(
        <div style={{marginTop:12}}>
          <div style={{color:C.muted,fontSize:12,marginBottom:10}}>Scanne den QR-Code mit Google Authenticator oder Authy:</div>
          <div style={{textAlign:"center",marginBottom:12}}>
            <img src={setupData.qrUrl} alt="QR" style={{width:160,height:160,borderRadius:8}}/>
          </div>
          <div style={{color:C.muted,fontSize:11,marginBottom:4}}>Manueller Code:</div>
          <div style={{background:C.card2,borderRadius:7,padding:"7px 10px",fontFamily:"monospace",fontSize:11,color:C.text,marginBottom:10,wordBreak:"break-all"}}>{setupData.secret}</div>
          <div style={{color:C.muted,fontSize:12,marginBottom:6}}>6-stelligen Code eingeben:</div>
          <input style={{...inpS,textAlign:"center",letterSpacing:6,fontSize:18,marginBottom:8}} type="text" inputMode="numeric" maxLength={6} value={code} onChange={e=>setCode(e.target.value.replace(/\D/g,""))} placeholder="000000"/>
          <button style={{background:`linear-gradient(135deg,${C.blue},${C.blue2})`,border:"none",color:"#fff",borderRadius:8,padding:"8px 14px",cursor:"pointer",fontSize:13,fontWeight:600}} onClick={confirmSetup} disabled={code.length!==6}>✓ Bestätigen</button>
        </div>
      )}
      {step==="backup"&&(
        <div style={{marginTop:12}}>
          <div style={{color:C.gT,fontWeight:700,fontSize:13,marginBottom:4}}>✅ 2FA aktiviert! Backup-Codes speichern:</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:5,marginBottom:10}}>
            {backupCodes.map((c,i)=><div key={i} style={{fontFamily:"monospace",fontSize:12,color:C.text,padding:"4px 8px",background:C.card2,borderRadius:5,textAlign:"center"}}>{c}</div>)}
          </div>
          <button style={{...Object.fromEntries(Object.entries({background:C.g2,border:`1px solid ${C.gT}44`,color:C.gT,borderRadius:8,padding:"7px 14px",cursor:"pointer",fontSize:12,fontWeight:600}))}} onClick={()=>{setStep("idle");setCode("");setSetupData(null);}}>✓ Codes gespeichert</button>
        </div>
      )}
    </div>
  );
};


// ── BANKABGLEICH KOMPONENTE ───────────────────────────────────────
const BankabgleichTab = ({ctx}) => {
  const {db, token, say, C, bP, bS, bD, inp} = ctx;
  const isMobile = useIsMobile();
  const [accounts, setAccounts] = useState([]);
  const [transactions, setTransactions] = useState({});
  const [loading, setLoading] = useState({});
  const [showAdd, setShowAdd] = useState(false);
  const [selAccount, setSelAccount] = useState(null);
  const [form, setForm] = useState({objektId:"",blz:"45250035",kontonummer:"",loginName:"",pin:""});
  const hdrs = {"Content-Type":"application/json", Authorization:`Bearer ${token}`};

  useEffect(()=>{
    fetch("/api/bank/accounts",{headers:hdrs}).then(r=>r.json()).then(setAccounts).catch(()=>{});
  },[]);

  const loadTransactions = async (accId) => {
    const r = await fetch(`/api/bank/transactions/${accId}`,{headers:hdrs});
    const data = await r.json();
    setTransactions(p=>({...p,[accId]:data}));
    setSelAccount(accId);
  };

  const doSync = async (accId) => {
    setLoading(p=>({...p,[accId]:true}));
    try {
      const r = await fetch(`/api/bank/sync/${accId}`,{method:"POST",headers:hdrs});
      const data = await r.json();
      if(!r.ok){say(data.error||"Fehler beim Abgleich");return;}
      say(`✓ ${data.neue} neue Buchungen · ${data.gematcht} automatisch zugeordnet`);
      await loadTransactions(accId);
      setAccounts(prev=>prev.map(a=>a.id===accId?{...a,last_sync:new Date().toISOString()}:a));
    } catch(e){say("Verbindungsfehler");}
    finally{setLoading(p=>({...p,[accId]:false}));}
  };

  const addAccount = async () => {
    if(!form.objektId||!form.kontonummer||!form.loginName||!form.pin){say("Alle Felder ausfüllen");return;}
    const r = await fetch("/api/bank/accounts",{method:"POST",headers:hdrs,body:JSON.stringify(form)});
    const data = await r.json();
    if(!r.ok){say(data.error||"Fehler");return;}
    say("Konto hinzugefügt ✓");
    setShowAdd(false);
    setForm({objektId:"",blz:"45250035",kontonummer:"",loginName:"",pin:""});
    fetch("/api/bank/accounts",{headers:hdrs}).then(r=>r.json()).then(setAccounts);
  };

  const deleteAccount = async (id) => {
    if(!window.confirm("Bankkonto und alle Transaktionen löschen?")) return;
    await fetch(`/api/bank/accounts/${id}`,{method:"DELETE",headers:hdrs});
    setAccounts(p=>p.filter(a=>a.id!==id));
    say("Konto entfernt");
  };

  const inpS = {background:C.card2,border:`1px solid ${C.border}`,borderRadius:8,color:C.text,padding:"9px 12px",fontSize:13,width:"100%",outline:"none",boxSizing:"border-box",fontFamily:"inherit"};
  const lbl = {color:C.muted,fontSize:11,display:"block",marginBottom:4,textTransform:"uppercase",letterSpacing:.5,marginTop:10};

  return (
    <div style={{padding:isMobile?14:0}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20,flexWrap:"wrap",gap:10}}>
        <div>
          <div style={{color:C.text,fontWeight:800,fontSize:18}}>🏦 Bankabgleich</div>
          <div style={{color:C.muted,fontSize:12,marginTop:3}}>FinTS/HBCI · Direkte Verbindung zur Sparkasse Witten · Automatische Zuordnung</div>
        </div>
        <button style={bP} onClick={()=>setShowAdd(p=>!p)}>＋ Konto hinzufügen</button>
      </div>

      {/* Konto hinzufügen */}
      {showAdd&&(
        <div style={{background:C.card,borderRadius:12,padding:18,border:`1px solid ${C.border}`,marginBottom:20}}>
          <div style={{color:C.text,fontWeight:700,fontSize:14,marginBottom:4}}>Bankkonto verknüpfen</div>
          <div style={{color:C.muted,fontSize:12,marginBottom:14}}>Zugangsdaten werden verschlüsselt auf deinem Server gespeichert – niemals im Browser.</div>
          <div style={{background:C.y2,borderRadius:8,padding:"10px 14px",marginBottom:14,border:`1px solid ${C.yT}33`}}>
            <div style={{color:C.yT,fontSize:12,fontWeight:600}}>🔒 Sicherheitshinweis</div>
            <div style={{color:C.yT,fontSize:11,marginTop:3}}>Für den Bankabgleich (nur Lesen) wird kein TAN benötigt. Überweisungen sind nicht möglich.</div>
          </div>
          <label style={lbl}>Objekt zuordnen</label>
          <select style={inpS} value={form.objektId} onChange={e=>setForm(p=>({...p,objektId:e.target.value}))}>
            <option value="">— Objekt wählen —</option>
            {db.objekte.map(o=><option key={o.id} value={o.id}>{o.adresse}</option>)}
          </select>
          <label style={lbl}>BLZ</label>
          <input style={inpS} value={form.blz} onChange={e=>setForm(p=>({...p,blz:e.target.value}))} placeholder="45250035"/>
          <label style={lbl}>Kontonummer</label>
          <input style={inpS} value={form.kontonummer} onChange={e=>setForm(p=>({...p,kontonummer:e.target.value}))} placeholder="Deine Kontonummer"/>
          <label style={lbl}>Online-Banking Loginname</label>
          <input style={inpS} value={form.loginName} onChange={e=>setForm(p=>({...p,loginName:e.target.value}))} placeholder="Sparkasse Loginname"/>
          <label style={lbl}>PIN (Online-Banking)</label>
          <input type="password" style={inpS} value={form.pin} onChange={e=>setForm(p=>({...p,pin:e.target.value}))} placeholder="••••••••"/>
          <div style={{display:"flex",gap:8,marginTop:14}}>
            <button style={bS} onClick={()=>setShowAdd(false)}>Abbrechen</button>
            <button style={bP} onClick={addAccount}>✓ Konto speichern</button>
          </div>
        </div>
      )}

      {/* Konto-Liste */}
      {accounts.length===0&&!showAdd&&(
        <div style={{background:C.card,borderRadius:12,padding:40,textAlign:"center",border:`1px solid ${C.border}`}}>
          <div style={{fontSize:48,marginBottom:12}}>🏦</div>
          <div style={{color:C.text,fontWeight:700,fontSize:16,marginBottom:8}}>Noch kein Konto verknüpft</div>
          <div style={{color:C.muted,fontSize:13}}>Füge dein Sparkassen-Konto hinzu für automatischen Bankabgleich</div>
        </div>
      )}

      {accounts.map(acc=>{
        const obj = db.objekte.find(o=>o.id===acc.objekt_id);
        const txs = transactions[acc.id];
        const isLoading = loading[acc.id];
        const gematchte = txs?.filter(t=>t.zugeordnet_zu).length||0;
        return (
          <div key={acc.id} style={{background:C.card,borderRadius:12,border:`1px solid ${C.border}`,marginBottom:16,overflow:"hidden"}}>
            {/* Account Header */}
            <div style={{padding:"14px 18px",display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10,borderBottom:`1px solid ${C.border}`}}>
              <div>
                <div style={{display:"flex",alignItems:"center",gap:8}}>
                  <span style={{fontSize:20}}>🏦</span>
                  <div>
                    <div style={{color:C.text,fontWeight:700,fontSize:14}}>{acc.bank_name} · Kto. {acc.kontonummer}</div>
                    <div style={{color:C.muted,fontSize:11}}>{obj?.adresse||"Kein Objekt"} · {acc.iban||"IBAN wird beim Abgleich geladen"}</div>
                  </div>
                </div>
                {acc.last_sync&&<div style={{color:C.muted,fontSize:11,marginTop:4}}>Letzter Abgleich: {new Date(acc.last_sync).toLocaleString("de-DE")}</div>}
              </div>
              <div style={{display:"flex",gap:8}}>
                <button style={{...bP,padding:"8px 14px",fontSize:12}} onClick={()=>doSync(acc.id)} disabled={isLoading}>
                  {isLoading?"⟳ Lädt…":"🔄 Jetzt abgleichen"}
                </button>
                <button style={{...bS,padding:"8px 14px",fontSize:12}} onClick={()=>selAccount===acc.id?setSelAccount(null):loadTransactions(acc.id)}>
                  {selAccount===acc.id?"▲ Schließen":"▼ Buchungen"}
                </button>
                <button style={{...bD,padding:"8px 12px",fontSize:12}} onClick={()=>deleteAccount(acc.id)}>🗑</button>
              </div>
            </div>

            {/* Transaktionen */}
            {selAccount===acc.id&&(
              <div>
                {!txs?(
                  <div style={{padding:20,textAlign:"center",color:C.muted,fontSize:13}}>Lade Buchungen…</div>
                ):txs.length===0?(
                  <div style={{padding:20,textAlign:"center",color:C.muted,fontSize:13}}>Keine Buchungen · Bitte Abgleich durchführen</div>
                ):(
                  <div>
                    <div style={{padding:"10px 18px",background:C.card2,borderBottom:`1px solid ${C.border}`,display:"flex",justifyContent:"space-between",fontSize:12,color:C.muted}}>
                      <span>{txs.length} Buchungen · {gematchte} automatisch zugeordnet</span>
                      <span style={{color:C.gT}}>{gematchte > 0 ? `${Math.round(gematchte/txs.length*100)}% erkannt` : ""}</span>
                    </div>
                    {txs.map((tx,i)=>{
                      const positiv = parseFloat(tx.betrag) > 0;
                      const v = tx.zugeordnet_zu ? db.vertraege.find(x=>x.id===tx.zugeordnet_zu) : null;
                      const m = v ? db.mieter.find(x=>x.id===v.mieterId) : null;
                      return (
                        <div key={i} style={{padding:"10px 18px",borderBottom:`1px solid ${C.border}`,display:"flex",justifyContent:"space-between",alignItems:"center",gap:10,flexWrap:"wrap"}}>
                          <div style={{flex:1,minWidth:0}}>
                            <div style={{display:"flex",alignItems:"center",gap:6}}>
                              <span style={{color:positiv?C.gT:C.rT,fontWeight:700,fontSize:14}}>{positiv?"+":""}{parseFloat(tx.betrag).toLocaleString("de-DE",{minimumFractionDigits:2})} €</span>
                              <span style={{color:C.muted,fontSize:11}}>{new Date(tx.datum).toLocaleDateString("de-DE")}</span>
                              {tx.auto_matched&&<span style={{background:C.g2,color:C.gT,fontSize:10,padding:"1px 6px",borderRadius:10,fontWeight:600}}>auto</span>}
                            </div>
                            <div style={{color:C.text,fontSize:12,marginTop:2,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{tx.auftraggeber||"Unbekannt"}</div>
                            <div style={{color:C.muted,fontSize:11,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{tx.verwendungszweck||""}</div>
                          </div>
                          <div style={{flexShrink:0,textAlign:"right"}}>
                            {m?(
                              <div style={{background:C.g2,color:C.gT,fontSize:11,padding:"3px 8px",borderRadius:8,fontWeight:600}}>✓ {m.name}</div>
                            ):positiv?(
                              <select style={{...inpS,width:"auto",fontSize:11,padding:"4px 8px"}}
                                value={tx.zugeordnet_zu||""}
                                onChange={async e=>{
                                  await fetch(`/api/bank/transactions/${tx.id}/assign`,{method:"POST",headers:hdrs,body:JSON.stringify({vertragsId:e.target.value})});
                                  setTransactions(p=>({...p,[acc.id]:p[acc.id].map(t=>t.id===tx.id?{...t,zugeordnet_zu:e.target.value}:t)}));
                                  say("Zugeordnet ✓");
                                }}>
                                <option value="">Mieter zuordnen…</option>
                                {db.vertraege.filter(v=>v.aktiv&&!v.leerstand&&v.objektId===acc.objekt_id).map(v=>{
                                  const mi=db.mieter.find(m=>m.id===v.mieterId);
                                  return <option key={v.id} value={v.id}>{mi?.name||"?"} · {v.einheit}</option>;
                                })}
                              </select>
                            ):null}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            )}
          </div>
        );
      })}

      <div style={{background:C.card2,borderRadius:10,padding:"12px 16px",border:`1px solid ${C.border}`,marginTop:8}}>
        <div style={{color:C.muted,fontSize:12}}>
          🔒 <strong style={{color:C.text}}>Sicherheit:</strong> Zugangsdaten werden AES-256 verschlüsselt gespeichert. 
          Nur Leserechte – keine Überweisungen möglich. Verbindung direkt zur Sparkasse Witten (BLZ 45250035).
        </div>
      </div>
    </div>
  );
};

// ── BENUTZERVERWALTUNG ────────────────────────────────────────────
const Benutzerverwaltung = ({token, currentUser}) => {
  const isMobile = useIsMobile();
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({email:"",password:"",name:""});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const headers = {"Content-Type":"application/json", Authorization:`Bearer ${token}`};

  const loadUsers = () => {
    fetch("/api/users", {headers}).then(r=>r.json()).then(setUsers).catch(()=>{});
  };

  useEffect(()=>{ loadUsers(); }, []);

  const anlegen = async () => {
    if(!form.email||!form.password){setError("E-Mail und Passwort erforderlich");return;}
    setLoading(true); setError(""); setSuccess("");
    const r = await fetch("/api/users",{method:"POST",headers,body:JSON.stringify({...form,role:form.role||"user"})});
    const data = await r.json();
    setLoading(false);
    if(!r.ok){setError(data.error||"Fehler");return;}
    setSuccess("Benutzer angelegt ✓");
    setForm({email:"",password:"",name:"",role:"user"});
    loadUsers();
  };

  const toggleActive = async (u) => {
    await fetch(`/api/users/${u.id}`,{method:"PATCH",headers,body:JSON.stringify({active:!u.active})});
    loadUsers();
  };

  const loeschen = async (u) => {
    if(!window.confirm(`Benutzer "${u.name||u.email}" wirklich löschen? Alle Daten dieses Benutzers werden gelöscht!`)) return;
    await fetch(`/api/users/${u.id}`,{method:"DELETE",headers});
    loadUsers();
  };

  return (
    <div style={{padding:isMobile?"10px 10px 0":"28px",overflowY:"auto",flex:1,WebkitOverflowScrolling:"touch"}}>
      <h2 style={{color:C.text,fontSize:20,fontWeight:800,margin:"0 0 6px"}}>Benutzerverwaltung</h2>
      <p style={{color:C.muted,fontSize:13,marginBottom:22}}>Nur du als Administrator siehst diese Seite · Jeder Benutzer hat eigene, getrennte Daten</p>

      {/* Neuer Benutzer */}
      <div style={{background:C.card,borderRadius:12,padding:20,border:`1px solid ${C.border}`,marginBottom:22}}>
        <div style={{color:C.muted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1.5,marginBottom:14}}>Neuen Benutzer anlegen</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr",gap:10,marginBottom:14}}>
          <div><label style={lbl}>Name</label><input style={inp} value={form.name} onChange={e=>setForm(f=>({...f,name:e.target.value}))} placeholder="Max Mustermann"/></div>
          <div><label style={lbl}>E-Mail</label><input type="email" style={inp} value={form.email} onChange={e=>setForm(f=>({...f,email:e.target.value}))} placeholder="max@beispiel.de"/></div>
          <div><label style={lbl}>Passwort</label><input type="password" style={inp} value={form.password} onChange={e=>setForm(f=>({...f,password:e.target.value}))} placeholder="Sicheres Passwort"/></div>
          <div><label style={lbl}>Rolle</label>
            <select style={inp} value={form.role||"user"} onChange={e=>setForm(f=>({...f,role:e.target.value}))}>
              <option value="user">Benutzer (voll)</option>
              <option value="mitarbeiter">Mitarbeiter (eingeschränkt)</option>
            </select>
          </div>
        </div>
        {error&&<div style={{background:C.r2,borderRadius:7,padding:"8px 12px",color:C.rT,fontSize:13,marginBottom:10}}>{error}</div>}
        {success&&<div style={{background:C.g2,borderRadius:7,padding:"8px 12px",color:C.gT,fontSize:13,marginBottom:10}}>{success}</div>}
        <button style={bP} onClick={anlegen} disabled={loading}>{loading?"Anlegen…":"＋ Benutzer anlegen"}</button>
      </div>

      {/* Benutzer-Liste */}
      <div style={{background:C.card,borderRadius:12,border:`1px solid ${C.border}`,overflow:"hidden"}}>
        <div style={{padding:"12px 18px",borderBottom:`1px solid ${C.border}`,color:C.muted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1.5}}>
          Alle Benutzer ({users.length})
        </div>
        {users.map((u,ri)=>(
          <div key={u.id} style={{padding:"14px 18px",borderBottom:`1px solid ${C.border}`,display:"flex",justifyContent:"space-between",alignItems:"center",background:ri%2===0?C.card:C.card2}}>
            <div>
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                <span style={{color:C.text,fontWeight:600,fontSize:14}}>{u.name||u.email}</span>
                <Bdg col={u.role==="admin"?"purple":"green"} ch={u.role==="admin"?"Admin":u.role==="mitarbeiter"?"Mitarbeiter":"Benutzer"}/>
                {!u.active&&<Bdg col="red" ch="Gesperrt"/>}
              </div>
              <div style={{color:C.muted,fontSize:12,marginTop:3}}>{u.email} · Erstellt: {new Date(u.created_at).toLocaleDateString("de-DE")}</div>
            </div>
            {u.role!=="admin"&&(
              <div style={{display:"flex",gap:8}}>
                <button style={{...bS,fontSize:12,color:u.active?C.yT:C.gT}} onClick={()=>toggleActive(u)}>{u.active?"Sperren":"Entsperren"}</button>
                <button style={{...bD,fontSize:12}} onClick={()=>loeschen(u)}>Löschen</button>
              </div>
            )}
          </div>
        ))}
        {users.length===0&&<div style={{padding:24,color:C.muted,textAlign:"center",fontSize:13}}>Noch keine Benutzer angelegt.</div>}
      </div>

      <div style={{marginTop:20,background:C.card2,borderRadius:10,padding:"12px 16px",border:`1px solid ${C.border}`}}>
        <p style={{color:C.muted,fontSize:12,margin:0}}>
          ℹ️ Jeder Benutzer hat komplett eigene Daten – Objekte, Mieter, Finanzen sind strikt getrennt.
          Benutzerdaten werden beim Löschen unwiderruflich entfernt.
        </p>
      </div>
    </div>
  );
};

// ═══════════════════════════════════════════════════════════════════
// MAIN APP
// ═══════════════════════════════════════════════════════════════════
// ── ErrorBoundary: verhindert schwarzen Bildschirm bei unerwarteten Fehlern ──
class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { hatFehler: false, fehler: null }; }
  static getDerivedStateFromError(error) { return { hatFehler: true, fehler: error }; }
  componentDidCatch(error, info) { console.error("App-Fehler:", error, info); }
  render() {
    if (this.state.hatFehler) {
      return (
        <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",background:"#0f1419",padding:20}}>
          <div style={{background:"#1a2028",borderRadius:16,padding:28,maxWidth:400,textAlign:"center",border:"1px solid #2a3441"}}>
            <div style={{fontSize:40,marginBottom:12}}>⚠️</div>
            <div style={{color:"#e8eaed",fontWeight:700,fontSize:16,marginBottom:8}}>Etwas ist schiefgelaufen</div>
            <div style={{color:"#8a94a3",fontSize:13,marginBottom:12}}>Die Seite konnte nicht korrekt geladen werden. Bitte lade die Seite neu.</div>
            {this.state.fehler&&<div style={{background:"#0f1419",borderRadius:8,padding:"10px 12px",marginBottom:20,textAlign:"left",fontSize:11,color:"#ff6b6b",fontFamily:"monospace",wordBreak:"break-word",maxHeight:150,overflow:"auto"}}>{String(this.state.fehler.message||this.state.fehler)}{this.state.fehler.stack?"\n\n"+this.state.fehler.stack.split("\n").slice(0,3).join("\n"):""}</div>}
            <button style={{background:"#4a9eff",border:"none",color:"#fff",borderRadius:8,padding:"10px 24px",fontWeight:600,cursor:"pointer",fontSize:14}}
              onClick={()=>window.location.reload()}>🔄 Seite neu laden</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function AppInner() {
  const [db, setDb] = useState(SEED);
  const [nav, setNav] = useState(() => localStorage.getItem("immo_nav")||"dashboard");

  // Verhindert versehentliches Ändern von Zahlenfeldern durch Mausrad-Scrollen
  useEffect(() => {
    const handler = (e) => {
      if (document.activeElement && document.activeElement.type === "number") {
        document.activeElement.blur();
      }
    };
    document.addEventListener("wheel", handler, { passive: true });
    return () => document.removeEventListener("wheel", handler);
  }, []);

  // Nav + selObj speichern
  useEffect(()=>{ if(nav) localStorage.setItem("immo_nav", nav); }, [nav]);
  const [selObj, setSelObj] = useState(() => localStorage.getItem("immo_selObj")||null);
  const [modal, setModal] = useState(null);
  const [sidebar, setSidebar] = useState(true);
  const [monat, setMonat] = useState(M0);
  const [jahr, setJahr] = useState(Y0);
  const [toast, setToast] = useState(null);
  const [search, setSearch] = useState("");
  const [geladen, setGeladen] = useState(false);
  const [theme, setTheme] = useState(() => localStorage.getItem("immo_theme") || "carbon");
  // Update C when theme changes
  C = THEMES[theme] || THEMES.carbon;
  const [user, setUser] = useState(null);
  const [loginForm, setLoginForm] = useState({email:"", password:"", error:"", loading:false});
  const [token, setToken] = useState(() => localStorage.getItem("immo_token") || null);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  // ── Favicon + PWA setzen ──
  useEffect(() => {
    const link = document.querySelector("link[rel~='icon']") || document.createElement("link");
    link.rel = "icon";
    link.href = LOGO_URL;
    document.head.appendChild(link);
    document.title = "ImManager";
  }, []);

  // ── Push-Benachrichtigungen einrichten ──
  const [pushEnabled, setPushEnabled] = useState(false);

  const enablePush = async () => {
    if (!("Notification" in window)) { say("Push nicht unterstützt"); return; }
    const perm = await Notification.requestPermission();
    if (perm === "granted") {
      setPushEnabled(true);
      localStorage.setItem("immo_push", "1");
      say("Push-Benachrichtigungen aktiviert ✓");
      new Notification("ImManager", { body: "Benachrichtigungen aktiviert!", icon: LOGO_URL });
    } else {
      say("Push-Benachrichtigungen abgelehnt");
    }
  };

  // Tägliche Prüfung auf ausstehende Zahlungen
  useEffect(() => {
    if (!user || !geladen) return;
    const push = localStorage.getItem("immo_push") === "1";
    setPushEnabled(push);
    if (!push || Notification.permission !== "granted") return;
    // Prüfe offene Posten älter als 5 Tage
    const heute = new Date();
    const offen = db.offenePosten.filter(p=>{
      if(p.bezahlt||p.leerstandAusgabe) return false;
      const faellig = new Date(p.faelligAm);
      const diffDays = (heute - faellig) / (1000*60*60*24);
      return diffDays > 5;
    });
    if (offen.length > 0) {
      new Notification("ImManager – Offene Zahlungen", {
        body: `${offen.length} Zahlung(en) seit mehr als 5 Tagen offen`,
        icon: LOGO_URL,
      });
    }
  }, [user, geladen]);

  // ── Auth: Token beim Start prüfen ──
  useEffect(() => {
    if (!token) { setGeladen(true); return; }
    fetch("/api/me", { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.ok ? r.json() : null)
      .then(u => {
        if (u) setUser(u);
        else { localStorage.removeItem("immo_token"); setToken(null); }
        setGeladen(true);
      })
      .catch(() => { setGeladen(true); });
  }, []);

  // ── Daten beim Start laden ──
  useEffect(() => {
    if (!token || !user) return;
    fetch("/api/state", { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json())
      .then(data => {
        if (data && data.objekte) {
          // Sicherung: fehlende Objekt-Felder mit leeren Defaults auffüllen
          if (!data.nkPositionen) data.nkPositionen = {};
          if (!data.fixKosten) data.fixKosten = {};
          if (!data.darlehen) data.darlehen = [];
          if (!data.zahlungsplaene) data.zahlungsplaene = [];
          // Migration: alte Leerstand-Posten ohne leerstandAusgabe Flag nachträglich markieren
          if(data.offenePosten) {
            data.offenePosten = data.offenePosten.map(p =>
              !p.leerstandAusgabe && p.bezeichnung?.startsWith("Leerstand NK")
                ? {...p, leerstandAusgabe: true}
                : p
            );
          }
          // Sicherung: Zahlungen nach Auszugsdatum ignorieren
          if(data.zahlungen && data.vertraege) {
            data.zahlungen = data.zahlungen.filter(z => {
              const v = data.vertraege.find(x => x.id === z.vertragsId);
              if(!v?.mietEnde) return true;
              // Monat aus "m-yyyy" parsen
              const [m, y] = z.monat.split("-").map(Number);
              const zahlungsDatum = new Date(y, m-1, 1);
              const auszug = new Date(v.mietEnde);
              return zahlungsDatum <= new Date(auszug.getFullYear(), auszug.getMonth(), 1);
            });
          }
          setDb(data);
        }
        setTimeout(() => setGeladen(true), 300);
      })
      .catch(() => setGeladen(true));
  }, [user]);

  // ── Bei jeder Änderung automatisch speichern ──
  useEffect(() => {
    if (!geladen || !token || !user) return;
    const t = setTimeout(() => {
      fetch("/api/state", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify(db),
      }).catch(err => console.error("Fetch Fehler:", err));
    }, 800); // etwas länger warten
    return () => clearTimeout(t);
  }, [db, geladen]);

  // ── Login ──
  const [twoFAState, setTwoFAState] = useState(null);
  const [trustDays, setTrustDays] = useState(30);
  const [twoFACode, setTwoFACode] = useState("");
  const [twoFAError, setTwoFAError] = useState("");
  const [showSetup2FA, setShowSetup2FA] = useState(false);
  const [setup2FAData, setSetup2FAData] = useState(null); // {qrUrl, secret}
  const [setup2FAStep, setSetup2FAStep] = useState("ask"); // ask | scan | backup
  const [setup2FACode, setSetup2FACode] = useState("");
  const [backupCodes, setBackupCodes] = useState([]);

  const finishLogin = async (tok, usr) => {
    localStorage.setItem("immo_token", tok);
    setToken(tok);
    setUser(usr);
    setGeladen(false);
    fetch("/api/state", { headers: { Authorization: `Bearer ${tok}` } })
      .then(r => r.json())
      .then(d => { if(d && d.objekte) setDb(d); setTimeout(() => setGeladen(true), 300); })
      .catch(() => setGeladen(true));
  };

  const doLogin = async () => {
    setLoginForm(f=>({...f, loading:true, error:""}));
    try {
      const r = await fetch("/api/login", {
        method:"POST", headers:{"Content-Type":"application/json"},
        body: JSON.stringify({email:loginForm.email, password:loginForm.password})
      });
      const data = await r.json();
      if (!r.ok) { setLoginForm(f=>({...f, loading:false, error:data.error||"Fehler"})); return; }
      setLoginForm(f=>({...f, loading:false}));
      if (data.requires2FA) {
        // Prüfe ob Gerät vertrauenswürdig ist
        const deviceId = localStorage.getItem("immo_device_id");
        const trustedToken = deviceId ? localStorage.getItem("immo_trusted_"+deviceId) : null;
        if (trustedToken) {
          const tr = await fetch("/api/2fa/trust-check", {
            method:"POST", headers:{"Content-Type":"application/json"},
            body: JSON.stringify({tempToken: data.tempToken, trustedToken, deviceId})
          });
          const td = await tr.json();
          if (td.token) {
            setLoginForm(f=>({...f, loading:false}));
            await finishLogin(td.token, td.user);
            if (data.firstLogin) setShowSetup2FA(true);
            return;
          } else {
            localStorage.removeItem("immo_trusted_"+deviceId);
          }
        }
        setTwoFAState({tempToken: data.tempToken, user: data.user});
        return;
      }
      await finishLogin(data.token, data.user);
      if (data.firstLogin) setShowSetup2FA(true);
    } catch(e) {
      setLoginForm(f=>({...f, loading:false, error:"Verbindungsfehler"}));
    }
  };

  const doVerify2FA = async () => {
    setTwoFAError("");
    try {
      const deviceId = localStorage.getItem("immo_device_id") || (() => {
        const id = Math.random().toString(36).substr(2,16);
        localStorage.setItem("immo_device_id", id);
        return id;
      })();
      const r = await fetch("/api/2fa/verify", {
        method:"POST", headers:{"Content-Type":"application/json"},
        body: JSON.stringify({tempToken: twoFAState.tempToken, code: twoFACode.replace(/\s/g,""), trustDays, deviceId})
      });
      const data = await r.json();
      if (!r.ok) { setTwoFAError(data.error||"Ungültiger Code"); return; }
      if (data.trustedToken) localStorage.setItem("immo_trusted_"+deviceId, data.trustedToken);
      setTwoFAState(null); setTwoFACode("");
      await finishLogin(data.token, data.user);
    } catch(e) { setTwoFAError("Verbindungsfehler"); }
  };

  const start2FASetup = async () => {
    try {
      const r = await fetch("/api/2fa/setup", {method:"POST", headers:{Authorization:`Bearer ${token}`}});
      const data = await r.json();
      setSetup2FAData(data);
      setSetup2FAStep("scan");
    } catch(e) { say("Fehler beim Setup"); }
  };

  const confirm2FASetup = async () => {
    try {
      const r = await fetch("/api/2fa/activate", {
        method:"POST", headers:{"Content-Type":"application/json", Authorization:`Bearer ${token}`},
        body: JSON.stringify({code: setup2FACode.replace(/\s/g,"")})
      });
      const data = await r.json();
      if (!r.ok) { say(data.error||"Ungültiger Code"); return; }
      setBackupCodes(data.backupCodes);
      setSetup2FAStep("backup");
    } catch(e) { say("Verbindungsfehler"); }
  };


  // ── Auto-Logout ──
  useEffect(() => {
    const mins = db.autoLogout || 30;
    if(mins === 0 || !user) return;
    let timer;
    const reset = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        doLogout();
      }, mins * 60 * 1000);
    };
    const events = ["mousemove","keydown","mousedown","touchstart","scroll","click"];
    events.forEach(e => window.addEventListener(e, reset));
    reset();
    return () => {
      clearTimeout(timer);
      events.forEach(e => window.removeEventListener(e, reset));
    };
  }, [db.autoLogout, user]);

  // ── Logout ──
  const doLogout = () => {
    fetch("/api/logout", { method:"POST", headers:{ Authorization:`Bearer ${token}` }}).catch(()=>{});
    localStorage.removeItem("immo_token");
    setToken(null); setUser(null); setDb(SEED); setGeladen(true);
  };

  const say = msg => { setToast(msg); setTimeout(()=>setToast(null),2800); };
  const upd = (k,fn) => setDb(d=>({...d,[k]:fn(d[k])}));
  const cm = () => setModal(null);

  const getOb = id => db.objekte.find(o=>o.id===id);
  const getMi = id => db.mieter.find(m=>m.id===id);
  const getVt = id => db.vertraege.find(v=>v.id===id);
  const vvObj = id => db.vertraege.filter(v=>v.objektId===id&&v.aktiv&&!v.leerstand);
  const vvObjAll = id => db.vertraege.filter(v=>v.objektId===id&&v.aktiv); // inkl. Leerstand
  const zdA = (vId,m,y) => db.zahlungen.find(z=>z.vertragsId===vId&&z.monat===mk(m,y));
  const sollObj = (id, m=monat, y=jahr) => vvObj(id).reduce((s,v)=>{
    // Vor Mietbeginn: nicht mitzählen
    const parseD = str => { if(!str) return null; const [yr,mo,d]=str.split("-").map(Number); return new Date(yr,mo-1,d||1); };
    const beginn = parseD(v.mietBeginn||v.einzug);
    if(beginn && (y < beginn.getFullYear() || (y===beginn.getFullYear() && m < beginn.getMonth()))) return s;
    // Nach Auszug: nicht mitzählen
    const ende = parseD(v.mietEnde);
    if(ende && new Date(y,m,1) > new Date(ende.getFullYear(), ende.getMonth(), 1)) return s;
    return s+anteiligeMiete(v, m, y);
  },0);
  const istObj = (id,m,y) => vvObj(id).reduce((s,v)=>{const z=zdA(v.id,m,y);return s+(z?parseFloat(z.betrag):0);},0);
  const opOffen = id => db.offenePosten.filter(p=>{
    if(p.objektId!==id||p.bezahlt||p.leerstandAusgabe) return false;
    // Prüfe ob Posten nach Auszugsdatum des Mieters liegt
    if(p.vertragsId && p.faelligAm) {
      const v = db.vertraege.find(x=>x.id===p.vertragsId);
      if(v && !v.aktiv && v.mietEnde && new Date(p.faelligAm) > new Date(v.mietEnde)) return false;
    }
    return true;
  });
  const gesamtE = y => db.zahlungen.filter(z=>z.monat.endsWith(String(y))).reduce((s,z)=>s+parseFloat(z.betrag),0);
  const gesamtA = y => db.ausgaben.filter(a=>a.datum?.startsWith(String(y))).reduce((s,a)=>s+parseFloat(a.betrag),0);

  // Festes Kalenderjahr Jan-Dez (nicht rollierend)
  const monate12 = Array.from({length:12},(_,i)=>({
    m:i, y:jahr,
    key:mk(i,jahr),
    kurz:MK[i],
    akt:i===NOW.getMonth()&&jahr===Y0,
  }));

  // ── DASHBOARD ───────────────────────────────────────────────────
  const Dashboard = () => {
    const isMobile = useIsMobile();
    if(user?.role==="mitarbeiter") return (
      <div style={{padding:isMobile?"8px 10px 0":"28px",overflowY:"auto",flex:1,WebkitOverflowScrolling:"touch"}}>
        <div style={{background:C.y2,borderRadius:12,padding:20,border:`1px solid ${C.yT}44`,marginBottom:20}}>
          <div style={{color:C.yT,fontWeight:700,fontSize:14,marginBottom:4}}>👷 Mitarbeiter-Ansicht</div>
          <div style={{color:C.yT,fontSize:13}}>Du hast eingeschränkten Zugriff. Verfügbar: Aufgaben-Board und Stundenzettel.</div>
        </div>
        <div style={{textAlign:"center",marginTop:40}}>
          <div style={{fontSize:48,marginBottom:12}}>👷</div>
          <div style={{color:C.text,fontWeight:700,fontSize:18,marginBottom:8}}>Hallo, {user.name||user.email}!</div>
          <div style={{color:C.muted,fontSize:14}}>Nutze die Navigation für deine Aufgaben und den Stundenzettel.</div>
          <button style={{...bP,marginTop:20}} onClick={()=>setNav("mitarbeiter")}>Zu meinen Aufgaben →</button>
        </div>
      </div>
    );
    const gSoll=db.objekte.reduce((s,o)=>s+sollObj(o.id,monat,jahr),0);
    const gIst=db.objekte.reduce((s,o)=>s+istObj(o.id,monat,jahr),0);
    const ruck=gSoll-gIst;
    const vorM=()=>{if(monat===0){setMonat(11);setJahr(y=>y-1);}else setMonat(m=>m-1);};
    const nachM=()=>{if(monat===11){setMonat(0);setJahr(y=>y+1);}else setMonat(m=>m+1);};
    return (
      <div style={{padding:isMobile?"8px 10px 0":"28px",overflowY:"auto",flex:1,WebkitOverflowScrolling:"touch"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:isMobile?12:22}}>
          <div>
            <h1 style={{color:C.text,fontSize:isMobile?18:24,fontWeight:800,margin:0}}>Dashboard</h1>
            <p style={{color:C.muted,fontSize:isMobile?11:13,marginTop:2}}>{NOW.toLocaleDateString("de-DE",{weekday:"long",day:"2-digit",month:"long",year:"numeric"})}</p>
          </div>
          <button style={{...bP,padding:isMobile?"6px 10px":"8px 14px",fontSize:isMobile?12:13}} onClick={()=>setModal({t:"objekt"})}>＋ {isMobile?"":"Neues "}Objekt</button>
        </div>
        <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"repeat(3,1fr)",gap:12,marginBottom:22}}>
          {[
            {l:"Soll-Miete",v:`${fmt(gSoll)} €`,c:C.blue},
            {l:"Eingegangen",v:`${fmt(gIst)} €`,c:gIst>=gSoll?C.gT:C.yT},
            {l:ruck>0?"Rückstand":"Alles OK",v:ruck>0?`${fmt(ruck)} €`:"✓",c:ruck>0?C.rT:C.gT},
          ].map((k,i)=>(
            <div key={i} style={{background:C.card,borderRadius:11,padding:"16px 18px",border:`1px solid ${C.border}`}}>
              <div style={{color:C.muted,fontSize:11,textTransform:"uppercase",letterSpacing:.5,marginBottom:5}}>{k.l}</div>
              <div style={{color:k.c,fontSize:20,fontWeight:800}}>{k.v}</div>
            </div>
          ))}
        </div>
        <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:16}}>
          <span style={{color:C.muted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1,flex:1}}>Objekte – {MN[monat]} {jahr}</span>
          <button style={{...bS,padding:"5px 10px"}} onClick={vorM}>◀</button>
          <button style={{...bS,padding:"5px 10px"}} onClick={nachM}>▶</button>
        </div>
        <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"repeat(2,1fr)",gap:isMobile?10:16}}>
          {db.objekte.map(o=>{
            const soll=sollObj(o.id,monat,jahr),ist=istObj(o.id,monat,jahr),rk=soll-ist,rot=rk>0,op=opOffen(o.id).length;
            return (
              <div key={o.id} onClick={()=>{setSelObj(o.id);localStorage.setItem("immo_selObj",o.id);}} style={{background:C.card,borderRadius:12,padding:isMobile?14:20,cursor:"pointer",border:`1px solid ${rot?C.rT:C.border}`,transition:"transform .15s,box-shadow .15s"}}
                onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-2px)";e.currentTarget.style.boxShadow="0 6px 20px rgba(0,0,0,.1)";}}
                onMouseLeave={e=>{e.currentTarget.style.transform="none";e.currentTarget.style.boxShadow="none";}}>
                <div style={{display:"flex",justifyContent:"space-between",marginBottom:10}}>
                  <div>
                    <div style={{color:C.text,fontWeight:700,fontSize:isMobile?14:16,lineHeight:1.3}}>{o.adresse}</div>
                  </div>
                </div>
                {rot&&<div style={{marginBottom:10}}><span style={{color:C.rT,fontWeight:700,fontSize:14}}>Rückstand: {fmt(rk)} €</span></div>}
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:isMobile?5:8}}>
                  {[{l:"Einheiten",v:`${vvObj(o.id).length}`},{l:"Miete Soll",v:`${fmt(soll)} €`},{l:"Off. Posten",v:op>0?`⚠ ${op}`:"✓ 0"}].map((x,i)=>(
                    <div key={i} style={{background:C.bg||C.card2,borderRadius:7,padding:"7px 10px",background:C.card2}}>
                      <div style={{color:C.muted,fontSize:10}}>{x.l}</div>
                      <div style={{color:C.text,fontWeight:700,fontSize:13,marginTop:2}}>{x.v}</div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
        {db.offenePosten.filter(p=>!p.bezahlt&&!p.leerstandAusgabe).length>0&&(
          <div style={{marginTop:24}}>
            <div style={{color:C.muted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1.5,marginBottom:10}}>Offene Posten</div>
            {db.offenePosten.filter(p=>!p.bezahlt&&!p.leerstandAusgabe).map(p=>{
              const ueb=p.faelligAm&&new Date(p.faelligAm)<NOW;
              return (
                <div key={p.id} style={{background:C.card,borderRadius:9,padding:"11px 16px",marginBottom:8,display:"flex",justifyContent:"space-between",alignItems:"center",border:`1px solid ${ueb?C.rT:C.border}`}}>
                  <div>
                    <div style={{color:C.text,fontWeight:600,fontSize:13}}>{p.bezeichnung}</div>
                    <div style={{color:C.muted,fontSize:12}}>{getOb(p.objektId)?.name} · Fällig: {fmtD(p.faelligAm)}</div>
                  </div>
                  <div style={{display:"flex",gap:6,alignItems:"center",flexShrink:0}}>
                    <span style={{color:ueb?C.rT:C.yT,fontWeight:700,fontSize:isMobile?12:13}}>{fmt(p.betrag)} €</span>
                    {ueb&&!isMobile&&<Bdg col="red" ch="Überfällig"/>}
                    <button style={{...bP,padding:"4px 9px",fontSize:11}} onClick={e=>{e.stopPropagation();upd("offenePosten",pp=>pp.map(x=>x.id===p.id?{...x,bezahlt:true}:x));say("Bezahlt ✓");}}>✓ Bezahlt</button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  };

  // ── OBJEKT DETAIL ───────────────────────────────────────────────
  const ObjektDetail = () => {
    const [tab,setTab] = useState("matrix");
    const [expandedCards, setExpandedCards] = useState({});
    const toggleCard = (id) => setExpandedCards(p=>({...p,[id]:!p[id]}));
    const fileRef = useRef();
    const obj = getOb(selObj);
    if(!obj) return null;
    // Aktive Mieter + im aktuellen Jahr ausgezogene Mieter (kein Leerstand in Matrix)
    const vvAktiv = vvObj(selObj);
    const vvLeerstand = db.vertraege.filter(v=>v.objektId===selObj&&v.leerstand&&v.aktiv);
    const vvAusgezogen = db.vertraege.filter(v=>
      v.objektId===selObj && !v.aktiv && !v.leerstand &&
      v.mietEnde && new Date(v.mietEnde).getFullYear() >= jahr
    );
    // Mieter-Tab: alle inkl. Leerstand; Matrix: nur echte Mieter
    // Sortierung: Keller/Souterrain → EG → 1.OG → 2.OG → ... → DG, jeweils links vor rechts
    const stockwerkRang = (einheit) => {
      const s = (einheit||"").toLowerCase();
      if (/garage/.test(s)) return 100;
      if (/souterrain|keller|\bug\b/.test(s)) return -1;
      if (/dachgeschoss|\bdg\b/.test(s)) return 99;
      const og = s.match(/(\d+)\.?\s*(og|obergeschoss)/);
      if (og) return parseInt(og[1]);
      if (/erdgeschoss|\beg\b/.test(s)) return 0;
      return 50; // unbekanntes Format: in die Mitte einsortieren
    };
    const seitenRang = (einheit) => {
      const s = (einheit||"").toLowerCase();
      if (/\blinks\b|\bli\b/.test(s)) return 0;
      if (/\brechts\b|\bre\b/.test(s)) return 1;
      return 0.5;
    };
    const sortiereEinheiten = (liste) => [...liste].sort((a,b)=>{
      const stockDiff = stockwerkRang(a.einheit) - stockwerkRang(b.einheit);
      if (stockDiff !== 0) return stockDiff;
      const seiteDiff = seitenRang(a.einheit) - seitenRang(b.einheit);
      if (seiteDiff !== 0) return seiteDiff;
      return (a.einheit||"").localeCompare(b.einheit||"");
    });
    const vv = sortiereEinheiten([...vvAktiv, ...vvLeerstand, ...vvAusgezogen]);
    const vvMatrix = sortiereEinheiten([...vvAktiv, ...vvAusgezogen]); // ohne Leerstand
    const ausgaben = db.ausgaben.filter(a=>a.objektId===selObj);
    const opList = db.offenePosten.filter(p=>p.objektId===selObj);

    return (
      <div style={{flex:1,overflow:"auto",padding:24}}>
        <button onClick={()=>setSelObj(null)} style={{...bS,padding:"5px 12px",fontSize:12,marginBottom:18,display:"inline-flex"}}>← Dashboard</button>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:18}}>
          <div>
            <h2 style={{color:C.text,fontSize:20,fontWeight:800,margin:0}}>{obj.name}</h2>
            <p style={{color:C.muted,fontSize:13,marginTop:2}}>{obj.adresse}</p>
          </div>
          <div style={{display:"flex",gap:8}}>
            <button style={bS} onClick={()=>setModal({t:"editObjekt",obj})}>✏ Bearbeiten</button>
            <button style={bP} onClick={()=>setModal({t:"vertrag",objektId:selObj})}>＋ Mietvertrag</button>
          </div>
        </div>
        <div style={{display:"flex",gap:2,marginBottom:20,borderBottom:`1px solid ${C.border}`,overflowX:"auto",WebkitOverflowScrolling:"touch",scrollbarWidth:"none"}}>
          {[{id:"matrix",l:"Mietkontrolle"},{id:"mieter",l:"Mieter"},{id:"zaehler",l:"Zähler"},{id:"fotos",l:"Fotos & Grundrisse"},{id:"posten",l:"Offene Posten"},{id:"dateien",l:"Dateien"}].map(t=>(
            <button key={t.id} onClick={()=>setTab(t.id)} style={{background:"none",border:"none",color:tab===t.id?C.blue:C.muted,padding:"9px 13px",cursor:"pointer",fontSize:13,fontWeight:tab===t.id?700:400,borderBottom:tab===t.id?`2px solid ${C.blue}`:"2px solid transparent",whiteSpace:"nowrap",flexShrink:0}}>{t.l}</button>
          ))}
        </div>

        {/* Mietkontrolle */}
        {tab==="matrix"&&(
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
              <div style={{color:C.muted,fontSize:13}}>Zahlungsstatus {jahr}</div>
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                <label style={{color:C.muted,fontSize:12}}>Jahr:</label>
                <select style={{...inp,width:"auto",padding:"6px 10px"}} value={jahr} onChange={e=>setJahr(parseInt(e.target.value))}>
                  {Array.from({length:5},(_,i)=>Y0-i).map(y=>(
                    <option key={y} value={y}>{y}{y===Y0?" (aktuell)":""}</option>
                  ))}
                </select>
              </div>
            </div>
          <div style={{overflowX:"auto"}}>
            <table style={{width:"100%",borderCollapse:"collapse",minWidth:550}}>
              <thead><tr>
                <th style={{background:C.card2,color:C.muted,fontSize:11,fontWeight:600,textAlign:"left",padding:"9px 12px",position:"sticky",left:0,zIndex:2}}>Mieter</th>
                {monate12.map(mn=>(
                  <th key={mn.key} style={{background:mn.akt?"#c8d8ee":C.card2,color:mn.akt?C.blue2:C.muted,fontSize:11,textAlign:"center",padding:"9px 5px",minWidth:48,borderBottom:mn.akt?`2px solid ${C.blue}`:"2px solid transparent"}}>
                    <div>{mn.kurz}</div><div style={{fontSize:9,color:C.m2}}>{mn.y}</div>
                  </th>
                ))}
                <th style={{background:C.card2,color:C.muted,fontSize:11,textAlign:"right",padding:"9px 12px",minWidth:90}}>Warmmiete</th>
                <th style={{background:C.card2,color:C.muted,fontSize:11,textAlign:"center",padding:"9px 12px",minWidth:100}}>Offene Posten</th>
              </tr></thead>
              <tbody>
                {vvMatrix.map((v,ri)=>{
                  const mi=getMi(v.mieterId);
                  const posten=db.offenePosten.filter(p=>p.vertragsId===v.id);
                  const offenePosten=posten.filter(p=>!p.bezahlt&&!p.leerstandAusgabe);
                  return (
                    <tr key={v.id} style={{background:ri%2===0?C.card:C.card2}}>
                      <td style={{padding:"9px 12px",position:"sticky",left:0,background:ri%2===0?C.card:C.card2,zIndex:1}}>
                        <button onClick={()=>setModal({t:"mieterPosten",v,mi})} style={{background:"none",border:"none",textAlign:"left",cursor:"pointer",padding:0}}>
                          <div style={{color:C.text,fontWeight:600,fontSize:13,display:"flex",alignItems:"center",gap:6}}>
                            {mi?.name}
                            {offenePosten.length>0&&<span style={{width:8,height:8,borderRadius:"50%",background:C.rT,display:"inline-block"}} title={`${offenePosten.length} offen`}/>}
                          </div>
                          <div style={{color:C.muted,fontSize:11}}>{v.einheit}</div>
                        </button>
                      </td>
                      {monate12.map(mn=>{
                        const z=zdA(v.id,mn.m,mn.y);
                        const fut=new Date(mn.y,mn.m,1)>NOW;
                        const parseD = s => { if(!s) return null; const [y,m,d]=s.split("-").map(Number); return new Date(y,m-1,d||1); };
                        const nachAuszug = v.mietEnde && new Date(mn.y,mn.m,1)>parseD(v.mietEnde);
                        const beginn = v.mietBeginn||v.einzug;
                        const beginnD = beginn ? parseD(beginn) : null;
                        // Nur Monate VOR dem Einzugsmonat blockieren, nicht den Einzugsmonat selbst (für halbe Monate)
                        const vorBeginn = beginnD && (mn.y < beginnD.getFullYear() || (mn.y===beginnD.getFullYear() && mn.m < beginnD.getMonth()));
                        return (
                          <td key={mn.key} style={{textAlign:"center",padding:"7px 3px"}}>
                            {fut||nachAuszug||vorBeginn?<span style={{color:C.border}}>–</span>:z
                              ?<div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:1}}>
                                <button title={`${z.betrag} €`} style={{background:"none",border:"none",color:C.gT,fontSize:17,cursor:"pointer",padding:0}} onClick={()=>setModal({t:"zahlDetail",z,v})}>✓</button>
                                <span style={{color:C.muted,fontSize:12,lineHeight:1,fontWeight:600}}>{fmt(z.betrag)}</span>
                              </div>
                              :<button style={{background:"none",border:"none",color:C.rT,fontSize:17,cursor:"pointer"}} onClick={()=>setModal({t:"zahlung",v,m:mn.m,y:mn.y})}>✗</button>}
                          </td>
                        );
                      })}
                      <td style={{textAlign:"right",padding:"9px 12px",color:C.gT,fontWeight:700,fontSize:13}}>{fmt(warmmiete(v))} €</td>
                      <td style={{textAlign:"center",padding:"9px 8px"}}>
                        {posten.length===0?null:
                          <button onClick={()=>setModal({t:"mieterPosten",v,mi})} style={{background:"none",border:"none",cursor:"pointer",display:"flex",flexDirection:"column",gap:3,alignItems:"center",margin:"0 auto"}}>
                            {posten.map(p=>{
                              const teilzSumM = (p.teilzahlungen||[]).reduce((s,t)=>s+parseFloat(t.betrag||0),0);
                              const restM = parseFloat(p.betrag||0) - teilzSumM;
                              return (
                              <span key={p.id} style={{background:p.bezahlt?C.g2:C.r2,color:p.bezahlt?C.gT:C.rT,padding:"2px 8px",borderRadius:12,fontSize:11,fontWeight:600,whiteSpace:"nowrap"}}>
                                {p.bezahlt?"✓":"⚠"} {fmt(p.bezahlt?p.betrag:restM)} €
                              </span>
                              );
                            })}
                          </button>}
                      </td>
                    </tr>
                  );
                })}
                <tr style={{background:C.card2,borderTop:`2px solid ${C.border}`}}>
                  <td style={{padding:"9px 12px",color:C.muted,fontWeight:700,fontSize:11,position:"sticky",left:0,background:C.card2,zIndex:1}}>GESAMT</td>
                  {monate12.map(mn=>{
                    const s=vvMatrix.reduce((ss,v)=>{const z=zdA(v.id,mn.m,mn.y);return ss+(z?parseFloat(z.betrag):0);},0);
                    return <td key={mn.key} style={{textAlign:"center",padding:"9px 3px",color:s>0?C.blue:C.border,fontSize:11,fontWeight:600}}>{s>0?fmt(s):"—"}</td>;
                  })}
                  <td style={{textAlign:"right",padding:"9px 12px",color:C.gT,fontWeight:800}}>{fmt(vvMatrix.reduce((s,v)=>{
                    const parseD3 = str => { if(!str) return null; const [y,m,d]=str.split("-").map(Number); return new Date(y,m-1,d||1); };
                    const beginn = parseD3(v.mietBeginn||v.einzug);
                    const heuteMonat = new Date(NOW.getFullYear(), NOW.getMonth(), 1);
                    if(beginn && (NOW.getFullYear() < beginn.getFullYear() || (NOW.getFullYear()===beginn.getFullYear() && NOW.getMonth() < beginn.getMonth()))) return s; // noch nicht eingezogen
                    const ende = parseD3(v.mietEnde);
                    if(ende && heuteMonat > new Date(ende.getFullYear(), ende.getMonth(), 1)) return s; // schon ausgezogen
                    return s+anteiligeMiete(v, NOW.getMonth(), NOW.getFullYear());
                  },0))} €</td>
                  <td style={{textAlign:"center",padding:"9px 8px",color:C.muted,fontWeight:600,fontSize:11}}>
                    {(()=>{const off=db.offenePosten.filter(p=>p.objektId===selObj&&!p.bezahlt&&!p.leerstandAusgabe&&!db.vertraege.find(v=>v.id===p.vertragsId&&v.leerstand));return off.length>0?<span style={{color:C.rT,fontWeight:600}}>{off.length} offen</span>:null;})()}
                  </td>
                </tr>
              </tbody>
            </table>
            <div style={{display:"flex",gap:16,marginTop:10}}>
              <span style={{color:C.rT,fontSize:12,fontWeight:600,display:"flex",alignItems:"center",gap:4}}>✗ <span style={{color:C.muted,fontWeight:400}}>anklicken um Zahlung zu erfassen</span></span>
              <span style={{color:C.gT,fontSize:12,fontWeight:600,display:"flex",alignItems:"center",gap:4}}>✓ <span style={{color:C.muted,fontWeight:400}}>anklicken für Details</span></span>
            </div>
          </div>
          </div>
        )}

        {/* Mieter */}
        {tab==="mieter"&&(
          <div style={{display:"flex",flexDirection:"column",gap:8}}>
            <div style={{gridColumn:"1/-1",display:"flex",justifyContent:"flex-end",marginBottom:4}}>
              <div style={{display:"flex",gap:8}}>
                <button style={{...bS,color:C.yT,borderColor:C.yT+"44"}} onClick={()=>setModal({t:"leerstand",objektId:selObj})}>🏚 Leerstand eintragen</button>
                <button style={bP} onClick={()=>setModal({t:"neuerMieter",objektId:selObj})}>＋ Neuer Mieter</button>
              </div>
            </div>
            {vv.length===0&&<p style={{color:C.muted,gridColumn:"1/-1"}}>Noch keine Mietverträge angelegt.</p>}
            {vv.map(v=>{
              const mi=getMi(v.mieterId);
              const isLeerstand = v.leerstand === true;
              const dd=db.dateien.filter(d=>d.mieterId===mi?.id);
              const vertraege_docs = dd.filter(d=>d.typ_kat==="mietvertrag");
              const protokoll_docs = dd.filter(d=>d.typ_kat==="protokoll");
              const andere_docs = dd.filter(d=>!d.typ_kat||d.typ_kat==="dokument");
              const bezahlt=zdA(v.id,monat,jahr);
              const istAusgezogen = !v.aktiv && !v.leerstand;
              const offenePostenMieter = db.offenePosten.filter(p=>p.vertragsId===v.id&&!p.bezahlt&&!p.leerstandAusgabe);
              const offeneBetrag = offenePostenMieter.reduce((s,p)=>s+parseFloat(p.betrag||0),0);
              const teilzahlungenBetrag = offenePostenMieter.reduce((s,p)=>s+(p.teilzahlungen||[]).reduce((ts,tz)=>ts+parseFloat(tz.betrag||0),0),0);
              return (
                <div key={v.id} style={{background:isLeerstand?"rgba(245,158,11,.06)":istAusgezogen?C.card2:C.card,borderRadius:12,border:`1px solid ${isLeerstand?C.yT+"44":offenePostenMieter.length>0?C.rT+"33":istAusgezogen?C.border:C.border}`,overflow:"hidden",opacity:istAusgezogen?.75:1}}>
                {/* Kompakter Header - immer sichtbar */}
                <div style={{padding:"12px 16px",display:"flex",justifyContent:"space-between",alignItems:"center",cursor:"pointer",background:expandedCards[v.id]?C.card2:"transparent"}}
                  onClick={()=>toggleCard(v.id)}>
                  <div style={{display:"flex",alignItems:"center",gap:10}}>
                    <div style={{width:34,height:34,borderRadius:8,background:isLeerstand?C.y2:istAusgezogen?C.card2:`${C.blue}20`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,flexShrink:0,opacity:istAusgezogen?.6:1}}>
                      {isLeerstand?"🏚":istAusgezogen?"🚪":"👤"}
                    </div>
                    <div>
                      <div style={{color:istAusgezogen?C.muted:C.text,fontWeight:700,fontSize:14}}>
                        {isLeerstand?"Leerstand":mi?.name||"?"}
                        {istAusgezogen&&<span style={{color:C.muted,fontWeight:400,fontSize:11,marginLeft:8}}>ausgezogen {fmtD(v.mietEnde)}</span>}
                      </div>
                      <div style={{color:C.muted,fontSize:12}}>
                        {v.einheit} · {fmt(warmmiete(v))} €/Monat
                        {v.qm>0&&<span style={{color:C.muted}}> · {(parseFloat(v.kaltmiete)/parseFloat(v.qm)).toFixed(2)} €/m²</span>}
                      </div>
                    </div>
                  </div>
                  <div style={{display:"flex",alignItems:"center",gap:8}}>
                    {offenePostenMieter.length>0&&(
                      <div style={{background:C.r2,borderRadius:7,padding:"3px 10px",border:`1px solid ${C.rT}44`}}>
                        <span style={{color:C.rT,fontSize:12,fontWeight:700}}>⚠ {fmt(offeneBetrag-teilzahlungenBetrag)} € offen</span>
                      </div>
                    )}
                    {!isLeerstand&&!istAusgezogen&&bezahlt&&<span style={{color:C.gT,fontSize:12,fontWeight:600}}>✓ bezahlt</span>}
                    {!isLeerstand&&!istAusgezogen&&!bezahlt&&<span style={{color:C.rT,fontSize:12}}>✗ offen</span>}
                    {isLeerstand&&<span style={{color:C.yT,fontSize:11,fontWeight:600}}>{fmt(v.nebenkosten)} €/Monat Kosten</span>}
                    <span style={{color:C.muted,fontSize:16}}>{expandedCards[v.id]?"▲":"▼"}</span>
                  </div>
                </div>
                {isLeerstand&&!expandedCards[v.id]&&<div style={{padding:"4px 16px 8px",color:C.yT,fontSize:11}}>🏚 NK {fmt(v.nebenkosten)} €/Monat als Ausgabe gebucht</div>}
                {/* Details - nur wenn aufgeklappt */}
                {expandedCards[v.id]&&<div style={{padding:"0 16px 16px",borderTop:`1px solid ${C.border}`}}>
                {isLeerstand&&<div style={{background:C.y2,borderRadius:7,padding:"5px 10px",marginBottom:10,marginTop:10,color:C.yT,fontSize:11,fontWeight:700}}>🏚 LEERSTAND · NK {fmt(v.nebenkosten)} €/Monat als Ausgabe</div>}
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:12}}>
                    <div style={{display:"flex",gap:10,alignItems:"center"}}>
                      <div style={{width:40,height:40,background:`linear-gradient(135deg,${C.blue},${C.pT})`,borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontWeight:800,fontSize:16}}>{mi?.name?.charAt(0)}</div>
                      <div>
                        <div style={{display:"flex",alignItems:"center",gap:8}}>
                          <div style={{color:C.text,fontWeight:700,fontSize:15}}>{mi?.name}</div>
                          {v.qm&&v.kaltmiete&&<span style={{color:C.muted,fontSize:11}}>{(parseFloat(v.kaltmiete)/parseFloat(v.qm)).toFixed(2)} €/m²</span>}
                        </div>
                        <div style={{display:"flex",gap:10,alignItems:"center",flexWrap:"wrap"}}>
                          <span style={{color:C.muted,fontSize:12}}>{v.einheit}</span>
                          {v.qm&&<span style={{color:C.muted,fontSize:12}}>{v.qm} m²</span>}
                          {v.zimmer&&<span style={{color:C.muted,fontSize:12}}>{v.zimmer} Zi.</span>}
                          <span style={{color:C.muted,fontSize:12}}>{v.mietBeginn?`Beginn: ${fmtD(v.mietBeginn)}`:`Einzug: ${fmtD(v.einzug)}`}{v.mietEnde?` · Ende: ${fmtD(v.mietEnde)}`:""}</span>
                        </div>
                      </div>
                    </div>
                    <div style={{display:"flex",gap:6,alignItems:"center"}}>
                      {!bezahlt&&<Bdg col="red" ch="⚠ Offen"/>}
                      <button style={{background:`${C.blue}18`,border:`1px solid ${C.blue}44`,borderRadius:7,color:C.blue,padding:"5px 10px",fontSize:12,fontWeight:600,cursor:"pointer",display:"flex",alignItems:"center",gap:4}} onClick={()=>setModal({t:"editMieterVertrag",v,mi})}>✏ Bearbeiten</button>
                    </div>
                  </div>
                  <div style={{display:"flex",gap:12,marginBottom:10}}>
                    <span style={{color:C.muted,fontSize:12}}>✉ {mi?.email}</span>
                    <span style={{color:C.muted,fontSize:12}}>📞 {mi?.telefon}</span>
                  </div>
                  {(()=>{
                    const wz=db.zaehler?.[v.objektId]?.wohnungen?.[v.einheit]||[];
                    const strom=wz.find(x=>x.typ==="strom");
                    const gas=wz.find(x=>x.typ==="gas");
                    const lS=strom?.ablesungen?.slice(-1)[0];
                    const lG=gas?.ablesungen?.slice(-1)[0];
                    if(!lS&&!lG) return null;
                    return <div style={{display:"flex",gap:10,marginBottom:10}}>
                      {lS&&<div style={{background:C.card,borderRadius:7,padding:"5px 10px",fontSize:12}}><span style={{color:C.muted}}>⚡ Strom: </span><span style={{color:C.text,fontWeight:600}}>{lS.stand}</span><span style={{color:C.muted,fontSize:10}}> ({fmtD(lS.datum)})</span></div>}
                      {lG&&<div style={{background:C.card,borderRadius:7,padding:"5px 10px",fontSize:12}}><span style={{color:C.muted}}>🔥 Gas: </span><span style={{color:C.text,fontWeight:600}}>{lG.stand}</span><span style={{color:C.muted,fontSize:10}}> ({fmtD(lG.datum)})</span></div>}
                    </div>;
                  })()}
                  <div style={{background:C.card,borderRadius:9,padding:"10px 12px",marginBottom:10}}>
                    {[{l:"Kaltmiete",v:v.kaltmiete,c:C.blue},{l:"Nebenkosten",v:v.nebenkosten,c:C.pT},{l:"Stellplatz",v:v.stellplatz,c:C.yT},{l:"Küche",v:v.kueche,c:C.gT}].filter(r=>parseFloat(r.v)>0).map((r,i)=>(
                      <div key={i} style={{display:"flex",justifyContent:"space-between",marginBottom:4}}>
                        <span style={{color:C.muted,fontSize:12,display:"flex",alignItems:"center",gap:5}}><span style={{width:6,height:6,borderRadius:"50%",background:r.c,display:"inline-block"}}/>{r.l}</span>
                        <span style={{color:C.text,fontSize:12,fontWeight:600}}>{fmt(r.v)} €</span>
                      </div>
                    ))}
                    <div style={{borderTop:`1px solid ${C.border}`,paddingTop:6,marginTop:4,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <span style={{color:C.text,fontWeight:700,fontSize:13}}>Warmmiete</span>
                      <span style={{color:C.gT,fontWeight:800,fontSize:14}}>{fmt(warmmiete(v))} €</span>
                    </div>
                    {v.qm&&v.kaltmiete&&(
                      <div style={{borderTop:`1px solid ${C.border}`,paddingTop:5,marginTop:4,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                        <span style={{color:C.muted,fontSize:11}}>Kaltmiete pro m²</span>
                        <span style={{color:C.muted,fontSize:11,fontWeight:600}}>{(parseFloat(v.kaltmiete)/parseFloat(v.qm)).toFixed(2)} €/m²</span>
                      </div>
                    )}
                  </div>
                  {v.kaution>0&&<div style={{display:"flex",justifyContent:"space-between",marginBottom:10}}>
                    <span style={{color:C.muted,fontSize:12}}>Kaution</span>
                    <span style={{color:v.kautionBezahlt?C.gT:C.rT,fontSize:12,fontWeight:600}}>{fmt(v.kaution)} € {v.kautionBezahlt?"✓":"⚠"}</span>
                  </div>}
                  <div style={{background:C.card,borderRadius:9,padding:"10px 12px",marginBottom:10,border:`1px solid ${C.border}`}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:dd.length>0?8:0}}>
                      <span style={{color:C.muted,fontSize:12,fontWeight:600}}>📁 Dokumente ({dd.length})</span>
                      <label style={{...bS,padding:"3px 9px",fontSize:11,cursor:"pointer"}}>
                        ＋ Hochladen
                        <input type="file" multiple style={{display:"none"}} onChange={e=>{Array.from(e.target.files).forEach(f=>upd("dateien",dd=>[...dd,{id:uid(),mieterId:mi?.id,objektId:selObj,name:f.name,size:f.size,datum:new Date().toISOString().split("T")[0]}]));say("Hochgeladen ✓");}}/>
                      </label>
                    </div>
                    {dd.length===0&&<div style={{color:C.muted,fontSize:11,fontStyle:"italic"}}>Keine Dokumente</div>}
                    {dd.map(d=>{
                      const fileData = d.pdfData || d.data;
                      return (
                      <div key={d.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"6px 0",borderTop:`1px solid ${C.border}`}}>
                        <span style={{color:C.text,fontSize:12,flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{d.typ_kat==="mietvertrag"?"📄":d.typ_kat==="protokoll"?"📋":d.typ==="pdf_brief"?"📋":"📎"} {d.name}</span>
                        <div style={{display:"flex",gap:6,alignItems:"center",flexShrink:0}}>
                          <span style={{color:C.muted,fontSize:11}}>{fmtD(d.datum)}</span>
                          {fileData&&<button style={{background:"none",border:"none",color:C.blue,cursor:"pointer",fontSize:14}} title="Öffnen" onClick={()=>window.open(fileData,"_blank")}>👁</button>}
                          {fileData&&<button style={{background:"none",border:"none",color:C.gT,cursor:"pointer",fontSize:14}} title="Download" onClick={()=>{const a=document.createElement("a");a.href=fileData;a.download=d.name;a.click();}}>⬇</button>}
                          <button style={{background:"none",border:"none",color:C.rT,cursor:"pointer",fontSize:13}} title="Löschen" onClick={()=>{upd("dateien",dd=>dd.filter(x=>x.id!==d.id));say("Gelöscht");}}>✕</button>
                        </div>
                      </div>
                      );
                    })}
                  </div>
                  {/* Notizen */}
                  <div style={{marginTop:10,paddingTop:10,borderTop:`1px solid ${C.border}`}}>
                    <div style={{color:C.muted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:5}}>Notizen</div>
                    <textarea style={{width:"100%",background:C.bg,border:`1px solid ${C.border}`,borderRadius:7,color:C.text,padding:"8px 10px",fontSize:12,resize:"none",outline:"none",fontFamily:"inherit",lineHeight:1.5,minHeight:60,boxSizing:"border-box"}}
                      placeholder="Notizen zu diesem Mieter…"
                      value={mi?.notizen||""}
                      onChange={e=>{upd("mieter",mm=>mm.map(m=>m.id===mi?.id?{...m,notizen:e.target.value}:m));}}
                    />
                  </div>
                  <div style={{display:"flex",gap:7,paddingTop:10,borderTop:`1px solid ${C.border}`,flexWrap:"wrap"}}>
                    {!istAusgezogen&&!isLeerstand&&<button style={{...bS,padding:"5px 9px",fontSize:12,flex:1,justifyContent:"center"}} onClick={()=>setModal({t:"frist",v})}>📅 Kündigung</button>}
                    {!istAusgezogen&&!isLeerstand&&<button style={{...bS,padding:"5px 9px",fontSize:12,flex:1,justifyContent:"center"}} onClick={()=>setModal({t:"mieterhöhung",v,mi,obj:getOb(v.objektId)})}>💶 Miete ändern</button>}
                    {!istAusgezogen&&!isLeerstand&&<button style={{...bS,padding:"5px 9px",fontSize:12,flex:1,justifyContent:"center"}} onClick={()=>setModal({t:"posten",objektId:selObj})}>＋ Posten</button>}
                    <button style={{...bS,padding:"5px 9px",fontSize:12,flex:1,justifyContent:"center"}} onClick={()=>setModal({t:"mietvertragPDF",v,mi,obj:getOb(selObj)})}>📄 Mietvertrag</button>
                    <button style={{...bS,padding:"5px 9px",fontSize:12,flex:1,justifyContent:"center"}} onClick={()=>setModal({t:"uebergabeProtokoll",v,mi,obj:getOb(selObj)})}>📋 Protokoll</button>
                    <button style={{...bS,padding:"5px 9px",fontSize:12,flex:1,justifyContent:"center"}} onClick={()=>setModal({t:"nkAbrechnung",v,mi,obj:getOb(selObj)})}>🧾 NK-Abrechnung</button>
                    {isLeerstand?(
                      <button style={{background:C.rT,border:"none",color:"#fff",borderRadius:8,padding:"7px 14px",cursor:"pointer",fontSize:12,fontWeight:700}} onClick={()=>{
                        if(window.confirm("Leerstand beenden und alle zugehörigen Posten löschen?")) {
                          upd("vertraege",vv=>vv.map(x=>x.id===v.id?{...x,aktiv:false}:x));
                          upd("mieter",mm=>mm.filter(m=>m.id!==v.mieterId));
                          upd("offenePosten",pp=>pp.filter(p=>p.vertragsId!==v.id));
                          say("Leerstand beendet ✓");
                        }
                      }}>🏚 Leerstand beenden</button>
                    ):(
                      <button style={{background:C.rT,border:"none",color:"#fff",borderRadius:8,padding:"7px 14px",cursor:"pointer",fontSize:12,fontWeight:700,display:"flex",alignItems:"center",gap:6}} onClick={()=>setModal({t:"mieterLoeschen",v,mi})}>🗑 Mieter löschen</button>
                    )}
                  </div>
                </div>}
                </div>
              );
            })}
          </div>
        )}

        {/* Ausgaben */}
        {tab==="ausgaben_disabled"&&(
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
              <div style={{display:"flex",gap:10}}>
                {[{l:`Ausgaben ${jahr}`,v:ausgaben.filter(a=>a.datum?.startsWith(String(jahr))).reduce((s,a)=>s+parseFloat(a.betrag),0),c:C.rT},
                  {l:`Einnahmen ${jahr}`,v:vv.reduce((s,v)=>s+db.zahlungen.filter(z=>z.vertragsId===v.id&&z.monat.endsWith(String(jahr))).reduce((ss,z)=>ss+parseFloat(z.betrag),0),0),c:C.gT}
                ].map((x,i)=>(
                  <div key={i} style={{background:C.card2,borderRadius:8,padding:"7px 14px"}}>
                    <div style={{color:C.muted,fontSize:11}}>{x.l}</div>
                    <div style={{color:x.c,fontWeight:700,fontSize:15}}>{fmt(x.v)} €</div>
                  </div>
                ))}
              </div>
              <button style={bP} onClick={()=>setModal({t:"ausgabe",objektId:selObj})}>＋ Ausgabe</button>
            </div>
            {ausgaben.length===0?<p style={{color:C.muted}}>Noch keine Ausgaben.</p>:(
              <div style={{overflowX:"auto",WebkitOverflowScrolling:"touch"}}>
              <table style={{width:"100%",borderCollapse:"collapse",minWidth:550}}>
                <thead><tr style={{background:C.card2}}>{["Datum","Rechnungs-Nr.","Kategorie","Beschreibung","Betrag",""].map((h,i)=><th key={i} style={{color:C.muted,fontSize:11,padding:"9px 12px",textAlign:i>=4?"right":"left",fontWeight:600,whiteSpace:"nowrap"}}>{h}</th>)}</tr></thead>
                <tbody>{ausgaben.sort((a,b)=>b.datum.localeCompare(a.datum)).map((a,ri)=>(
                  <tr key={a.id} style={{background:ri%2===0?C.card:C.card2,borderTop:`1px solid ${C.border}`}}>
                    <td style={{padding:"9px 12px",color:C.muted,fontSize:13,whiteSpace:"nowrap"}}>{fmtD(a.datum)}</td>
                    <td style={{padding:"9px 12px",color:C.text,fontSize:12,fontFamily:"monospace",whiteSpace:"nowrap"}}>{a.rechnungNr||"—"}</td>
                    <td style={{padding:"9px 12px",whiteSpace:"nowrap"}}><Bdg col="blue" ch={a.kategorie}/></td>
                    <td style={{padding:"9px 12px",color:C.text,fontSize:13}}>{a.beschreibung}</td>
                    <td style={{padding:"9px 12px",color:C.rT,fontWeight:700,textAlign:"right",whiteSpace:"nowrap"}}>{fmt(a.betrag)} €</td>
                    <td style={{padding:"9px 12px",textAlign:"right"}}><button style={{...bD,padding:"4px 8px",fontSize:11}} onClick={()=>{upd("ausgaben",aa=>aa.filter(x=>x.id!==a.id));say("Gelöscht");}}>🗑</button></td>
                  </tr>
                ))}</tbody>
              </table>
              </div>
            )}
          </div>
        )}

        {/* Mieterhöhungs-Erinnerungen */}
        {(()=>{
          const heute = new Date();
          const hinweise = [];
          db.vertraege.filter(v=>v.aktiv).forEach(v=>{
            const letzte = (db.mieterhöhungen||[]).filter(m=>m.vertragsId===v.id).sort((a,b)=>new Date(b.datum)-new Date(a.datum))[0];
            const mi = db.mieter.find(m=>m.id===v.mieterId);
            const obj = db.objekte.find(o=>o.id===v.objektId);
            if(letzte){
              const letzteDate = new Date(letzte.datum);
              const monate = (heute.getFullYear()-letzteDate.getFullYear())*12+(heute.getMonth()-letzteDate.getMonth());
              if(monate>=11) hinweise.push({v,mi,obj,letzte,monate,typ:"erhöhung"});
            }
          });
          // Automatische Mahnstufen-Erinnerungen
          db.offenePosten.filter(p=>!p.bezahlt&&p.faelligAm&&!p.leerstandAusgabe).forEach(p=>{
            const diff = Math.ceil((new Date()-new Date(p.faelligAm))/(1000*60*60*24));
            const aktStufe = p.mahnStufe||0;
            // Stufe 1 ab 3 Tage, Stufe 2 ab 14 Tage, Stufe 3 ab 30 Tage
            const fälligeStufe = diff>=30?3:diff>=14?2:diff>=3?1:0;
            if(fälligeStufe>aktStufe){
              const vt=p.vertragsId?db.vertraege.find(v=>v.id===p.vertragsId):null;
              const mi=vt?db.mieter.find(m=>m.id===vt.mieterId):null;
              hinweise.push({typ:"mahnung",p,mi,fälligeStufe,diff});
            }
          });
          // Zahlungsziel-Erinnerungen
          (db.zahlungsplaene||[]).forEach(p=>{
            const gesamt=parseFloat(p.gesamtbetrag||0);
            const gezahlt=(p.raten||[]).filter(r=>r.bezahlt).reduce((s,r)=>s+parseFloat(r.betrag||0),0);
            if(gezahlt>=gesamt) return;
            (p.raten||[]).filter(r=>!r.bezahlt).forEach(r=>{
              if(!r.datum) return;
              const diff=Math.ceil((new Date(r.datum)-heute)/(1000*60*60*24));
              const vorlauf=r.vorlauf||db.erinnerungsSettings?.vorlauf||3;
              const erinTyp=r.erinTyp||db.erinnerungsSettings?.typ||"dashboard";
              if(diff>=0&&diff<=vorlauf&&(erinTyp==="dashboard"||erinTyp==="beide")){
                hinweise.push({typ:"rate",plan:p,rate:r,diff});
              }
            });
          });
          if(hinweise.length===0) return null;
          return (
            <div style={{marginBottom:18}}>
              {hinweise.map((h,i)=>(
                <div key={i} style={{background:h.typ==="erhöhung"?C.y2:C.r2,border:`1px solid ${h.typ==="erhöhung"?C.yT:C.rT}44`,borderRadius:10,padding:"11px 16px",marginBottom:8,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  {h.typ==="mahnung"?(
                    <>
                      <div>
                        <div style={{color:C.rT,fontWeight:700,fontSize:13}}>
                          {h.fälligeStufe===3?"🚨":h.fälligeStufe===2?"⚠️":"📋"} Mahnstufe {h.fälligeStufe} empfohlen: {h.mi?.name||"Allgemein"} – {fmt(h.p.betrag)} €
                        </div>
                        <div style={{color:C.rT,fontSize:12,marginTop:2}}>
                          Seit {h.diff} Tagen überfällig · Aktuelle Stufe: {h.p.mahnStufe||0}
                        </div>
                      </div>
                      <button style={{...bS,fontSize:12,color:C.rT,borderColor:C.rT+"44"}}
                        onClick={()=>setModal({t:"mahnung",p:h.p})}>
                        Mahnung erstellen
                      </button>
                    </>
                  ):h.typ==="erhöhung"?(
                    <>
                      <div>
                        <div style={{color:h.typ==="erhöhung"?C.yT:C.rT,fontWeight:700,fontSize:13}}>
                          📈 Mieterhöhung möglich: {h.mi?.name} – {h.v.einheit}
                        </div>
                        <div style={{color:h.typ==="erhöhung"?C.yT:C.rT,fontSize:12,marginTop:2}}>
                          Letzte Erhöhung vor {h.monate} Monaten · Sendbar ab Monat 12 · Mieter hat 3 Monate Bedenkzeit
                        </div>
                      </div>
                      <button style={{...bS,fontSize:12,color:C.yT,borderColor:C.yT+"44"}}
                        onClick={()=>setModal({t:"mieterhöhung",v:h.v,mi:h.mi,obj:h.obj,letzte:h.letzte})}>
                        Erhöhung anlegen
                      </button>
                    </>
                  ):(
                    <div>
                      <div style={{color:C.rT,fontWeight:700,fontSize:13}}>
                        ⏰ Rate fällig: {h.plan.bezeichnung} – {fmt(h.rate.betrag)} €
                      </div>
                      <div style={{color:C.rT,fontSize:12,marginTop:2}}>
                        {h.diff===0?"Heute fällig":`In ${h.diff} Tag(en) fällig`} · {fmtD(h.rate.datum)}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          );
        })()}

        {/* Offene Posten */}
        {tab==="posten"&&(
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
              <div style={{color:C.text,fontWeight:700,fontSize:16}}>Offene Posten & Rückstände</div>
              <button style={bP} onClick={()=>setModal({t:"posten",objektId:selObj})}>＋ Neuer Posten</button>
            </div>

            {/* Mietrückstände - alle Monate seit Mietbeginn */}
            {(()=>{
              const rueckstaende = [];
              vv.filter(v=>!v.leerstand&&v.aktiv).forEach(v=>{
                const mi = getMi(v.mieterId);
                // Datum-Strings direkt parsen ohne UTC-Timezone-Versatz
                const parseDatum = (s) => { if(!s) return null; const [y,m,d]=s.split("-").map(Number); return new Date(y,m-1,d||1); };
                const beginn = parseDatum(v.mietBeginn||v.einzug) || new Date(2020,0,1);
                const endeD = v.mietEnde ? parseDatum(v.mietEnde) : null;
                const stop = endeD && endeD < NOW ? endeD : NOW;
                // Alle Monate von Mietbeginn bis heute (oder Auszug)
                let cur = new Date(beginn.getFullYear(), beginn.getMonth(), 1);
                while(cur <= stop) {
                  const m = cur.getMonth(); // 0-basiert
                  const y = cur.getFullYear();
                  if(!zdA(v.id,m,y)){
                    rueckstaende.push({v,mi,m,y,betrag:anteiligeMiete(v,m,y),label:`${MK[m]} ${y}`});
                  }
                  cur = new Date(y, m+1, 1);
                }
              });
              if(rueckstaende.length===0) return null;
              return (
                <div style={{marginBottom:16}}>
                  <div style={{color:C.rT,fontWeight:700,fontSize:12,textTransform:"uppercase",letterSpacing:1,marginBottom:8}}>
                    🔴 Mietrückstände ({rueckstaende.length})
                  </div>
                  <div style={{background:C.r2,borderRadius:8,padding:"8px 14px",marginBottom:8,display:"flex",justifyContent:"space-between",fontSize:12,fontWeight:700}}>
                    <span style={{color:C.rT}}>Gesamt Rückstand</span>
                    <span style={{color:C.rT}}>{fmt(rueckstaende.reduce((s,r)=>s+r.betrag,0))} €</span>
                  </div>
                  {rueckstaende.map(({v,mi,m,y,betrag,label},i)=>(
                    <div key={i} style={{background:C.r2,borderRadius:9,padding:"11px 14px",marginBottom:6,border:`1px solid ${C.rT}44`,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <div>
                        <div style={{color:C.text,fontWeight:600,fontSize:13}}>{mi?.name} · {v.einheit}</div>
                        <div style={{color:C.muted,fontSize:12}}>{label} – Miete nicht eingegangen</div>
                      </div>
                      <div style={{display:"flex",gap:8,alignItems:"center"}}>
                        <span style={{color:C.rT,fontWeight:700}}>{fmt(betrag)} €</span>
                        <button style={{...bP,padding:"4px 9px",fontSize:12}} onClick={()=>setModal({t:"zahlung",v,m,y})}>✓ Erfassen</button>
                      </div>
                    </div>
                  ))}
                </div>
              );
            })()}

            {/* Offene Posten */}
            {(()=>{
              const offene = opList.filter(p=>!p.bezahlt&&!p.leerstandAusgabe);
              const leerstandKosten = opList.filter(p=>!p.bezahlt&&p.leerstandAusgabe);
              const bezahlte = opList.filter(p=>p.bezahlt);
              return (<>
                {offene.length>0&&(
                  <div style={{marginBottom:16}}>
                    <div style={{color:C.yT,fontWeight:700,fontSize:12,textTransform:"uppercase",letterSpacing:1,marginBottom:8}}>
                      ⚠ Offene Posten ({offene.length}) · Gesamt: {fmt(offene.reduce((s,p)=>{
                        const tzS = (p.teilzahlungen||[]).reduce((ts,t)=>ts+parseFloat(t.betrag||0),0);
                        return s+(parseFloat(p.betrag||0)-tzS);
                      },0))} €
                    </div>
                    {offene.map(p=>{
                      const ueb=p.faelligAm&&new Date(p.faelligAm)<NOW;
                      const mi = p.vertragsId ? getMi(db.vertraege.find(v=>v.id===p.vertragsId)?.mieterId) : null;
                      const teilzSumO = (p.teilzahlungen||[]).reduce((s,t)=>s+parseFloat(t.betrag||0),0);
                      const restO = parseFloat(p.betrag||0) - teilzSumO;
                      return (
                        <div key={p.id} style={{background:ueb?C.r2:C.card2,borderRadius:9,padding:"11px 14px",marginBottom:6,border:`1px solid ${ueb?C.rT+"44":C.border}`,display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:8}}>
                          <div>
                            <div style={{color:C.text,fontWeight:600,fontSize:13}}>{p.bezeichnung}</div>
                            <div style={{color:C.muted,fontSize:12}}>
                              {mi&&<span style={{color:C.text}}>{mi.name} · </span>}
                              Fällig: {fmtD(p.faelligAm)}
                              {ueb&&<span style={{color:C.rT,fontWeight:600}}> · ÜBERFÄLLIG</span>}
                              {p.gemahnt&&` · Gemahnt ${fmtD(p.mahnDatum)}`}
                              {teilzSumO>0&&` · Teilzahlung: ${fmt(teilzSumO)} €`}
                            </div>
                          </div>
                          <div style={{display:"flex",gap:7,alignItems:"center"}}>
                            <span style={{color:ueb?C.rT:C.yT,fontWeight:700}}>{fmt(restO)} €</span>
                            <button style={{background:`${C.yT}18`,border:`1px solid ${C.yT}44`,color:C.yT,borderRadius:7,padding:"4px 9px",fontSize:12,fontWeight:600,cursor:"pointer"}} onClick={()=>setModal({t:"mahnung",p})}>
                              {p.mahnStufe>=3?"🚨":p.mahnStufe>0?`⚠️ Stufe ${(p.mahnStufe||0)+1}`:"📋 Mahnung"}
                            </button>
                            <button style={{...bP,padding:"4px 9px",fontSize:12}} onClick={()=>{upd("offenePosten",pp=>pp.map(x=>x.id===p.id?{...x,bezahlt:true,bezahltAm:new Date().toISOString().split("T")[0]}:x));say("Bezahlt ✓");}}>✓</button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
                {offene.length===0&&opList.filter(p=>!p.leerstandAusgabe).length>0&&(
                  <div style={{background:C.g2,borderRadius:9,padding:14,marginBottom:16,color:C.gT,fontSize:13,textAlign:"center"}}>✓ Alle Posten bezahlt</div>
                )}
                {leerstandKosten.length>0&&(
                  <div style={{marginBottom:16}}>
                    <div style={{color:C.yT,fontWeight:700,fontSize:12,textTransform:"uppercase",letterSpacing:1,marginBottom:8}}>
                      🏚 Leerstandskosten · {fmt(leerstandKosten.reduce((s,p)=>s+parseFloat(p.betrag||0),0))} €
                    </div>
                    {leerstandKosten.map(p=>(
                      <div key={p.id} style={{background:C.y2,borderRadius:9,padding:"11px 14px",marginBottom:6,border:`1px solid ${C.yT}33`,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                        <div>
                          <div style={{color:C.text,fontWeight:600,fontSize:13}}>{p.bezeichnung}</div>
                          <div style={{color:C.muted,fontSize:12}}>Fällig: {fmtD(p.faelligAm)} · Eigene Kosten</div>
                        </div>
                        <div style={{display:"flex",gap:7,alignItems:"center"}}>
                          <span style={{color:C.yT,fontWeight:700}}>{fmt(p.betrag)} €</span>
                          <button style={{...bP,padding:"4px 9px",fontSize:12}} onClick={()=>{upd("offenePosten",pp=>pp.map(x=>x.id===p.id?{...x,bezahlt:true}:x));say("Gebucht ✓");}}>✓ Gebucht</button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                {bezahlte.filter(p=>!p.leerstandAusgabe).length>0&&(
                  <div>
                    <div style={{color:C.muted,fontWeight:700,fontSize:12,textTransform:"uppercase",letterSpacing:1,marginBottom:8}}>✓ Bezahlte Posten</div>
                    {bezahlte.filter(p=>!p.leerstandAusgabe).map(p=>(
                      <div key={p.id} style={{background:C.card2,borderRadius:9,padding:"10px 14px",marginBottom:5,border:`1px solid ${C.border}`,display:"flex",justifyContent:"space-between",alignItems:"center",opacity:.7}}>
                        <div>
                          <div style={{color:C.muted,fontSize:13}}>{p.bezeichnung}</div>
                          <div style={{color:C.muted,fontSize:11}}>Fällig: {fmtD(p.faelligAm)}</div>
                        </div>
                        <div style={{display:"flex",gap:8,alignItems:"center"}}>
                          <span style={{color:C.gT,fontWeight:600}}>{fmt(p.betrag)} €</span>
                          <Bdg col="green" ch="✓"/>
                          <button style={{...bS,padding:"3px 7px",fontSize:11,color:C.yT}} onClick={()=>{upd("offenePosten",pp=>pp.map(x=>x.id===p.id?{...x,bezahlt:false,bezahltAm:null}:x));say("Als offen markiert");}}>↩</button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                {opList.filter(p=>!p.leerstandAusgabe).length===0&&(
                  <div style={{color:C.muted,textAlign:"center",padding:24,fontSize:13}}>Keine Posten für dieses Objekt</div>
                )}
              </>);
            })()}
          </div>
        )}


        {/* Zähler */}
        {tab==="zaehler"&&(
          <div>
            <div style={{marginBottom:20}}>
              <div style={{color:C.muted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1.5,marginBottom:12}}>Allgemeinzähler (Objekt-Ebene)</div>
              {(()=>{
                const allg = db.zaehler?.[selObj]?.allgemein||[];
                const typen = [{t:"strom",l:"Strom",e:"⚡"},{t:"wasser",l:"Wasser",e:"💧"},{t:"gas",l:"Gas",e:"🔥"}];
                return (
                  <div style={{display:"flex",flexDirection:"column",gap:10}}>
                    {typen.map(({t,l,e})=>{
                      const z = allg.find(x=>x.typ===t);
                      const ablesungen = z?.ablesungen||[];
                      const letzter = ablesungen[ablesungen.length-1];
                      return (
                        <div key={t} style={{background:C.card2,borderRadius:10,padding:14,border:`1px solid ${C.border}`}}>
                          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
                            <div style={{display:"flex",gap:8,alignItems:"center"}}>
                              <span style={{fontSize:16}}>{e}</span>
                              <div>
                                <div style={{color:C.text,fontWeight:600,fontSize:13}}>{l} – Allgemein</div>
                                {z?.nr&&<div style={{color:C.muted,fontSize:11}}>Nr: {z.nr}</div>}
                              </div>
                            </div>
                            {letzter&&<div style={{textAlign:"right"}}>
                              <div style={{color:C.gT,fontWeight:700,fontSize:14}}>{letzter.stand}</div>
                              <div style={{color:C.muted,fontSize:11}}>{fmtD(letzter.datum)}</div>
                            </div>}
                          </div>
                          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr auto",gap:8,marginBottom:8}}>
                            <input style={{...inp,fontSize:12}} placeholder="Zähler-Nr." defaultValue={z?.nr||""}
                              onBlur={e=>{const v=e.target.value;upd("zaehler",zz=>{const cur=zz?.[selObj]||{allgemein:[],wohnungen:{}};const allg=[...cur.allgemein];const idx=allg.findIndex(x=>x.typ===t);if(idx>=0)allg[idx]={...allg[idx],nr:v};else allg.push({id:uid(),typ:t,nr:v,ablesungen:[]});return{...zz,[selObj]:{...cur,allgemein:allg}};});}}/>
                            <input style={{...inp,fontSize:12}} placeholder="Neuer Stand" id={`allg_stand_${t}_${selObj}`}/>
                            <input type="date" style={{...inp,fontSize:12}} defaultValue={new Date().toISOString().split("T")[0]} id={`allg_datum_${t}_${selObj}`}/>
                            <button style={bP} onClick={()=>{
                              const stand=document.getElementById(`allg_stand_${t}_${selObj}`)?.value;
                              const datum=document.getElementById(`allg_datum_${t}_${selObj}`)?.value;
                              if(!stand)return;
                              upd("zaehler",zz=>{
                                const cur=zz?.[selObj]||{allgemein:[],wohnungen:{}};
                                const allg=[...cur.allgemein];
                                const idx=allg.findIndex(x=>x.typ===t);
                                const neueAblesung={id:uid(),stand,datum:datum||new Date().toISOString().split("T")[0]};
                                // Max 3 Jahre = ~36 Einträge behalten
                                if(idx>=0){
                                  const ab=[...allg[idx].ablesungen,neueAblesung].slice(-36);
                                  allg[idx]={...allg[idx],ablesungen:ab};
                                }else allg.push({id:uid(),typ:t,nr:"",ablesungen:[neueAblesung]});
                                return{...zz,[selObj]:{...cur,allgemein:allg}};
                              });
                              say("Ablesung gespeichert ✓");
                              document.getElementById(`allg_stand_${t}_${selObj}`).value="";
                            }}>＋</button>
                          </div>
                          {ablesungen.length>0&&(
                            <div style={{maxHeight:120,overflowY:"auto"}}>
                              <div style={{color:C.muted,fontSize:10,fontWeight:700,textTransform:"uppercase",marginBottom:5}}>Historie</div>
                              {[...ablesungen].reverse().map((a,i)=>(
                                <div key={a.id} style={{display:"flex",justifyContent:"space-between",padding:"3px 0",borderBottom:`1px solid ${C.border}`,fontSize:12}}>
                                  <span style={{color:C.muted}}>{fmtD(a.datum)}</span>
                                  <span style={{color:C.text,fontWeight:i===0?700:400}}>{a.stand}{i===0&&" (aktuell)"}</span>
                                  {i>0&&ablesungen[ablesungen.length-1-i-1]&&<span style={{color:C.muted}}>+{(parseFloat(a.stand)-parseFloat(ablesungen[ablesungen.length-2-i]?.stand||0)).toFixed(0)}</span>}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                );
              })()}
            </div>

            <div style={{color:C.muted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1.5,marginBottom:12}}>Wohnungszähler (Strom & Gas pro Mieter)</div>
            {vv.map(v=>{
              const mi=getMi(v.mieterId);
              const wZaehler=db.zaehler?.[selObj]?.wohnungen?.[v.einheit]||[];
              const typen=[{t:"strom",l:"Strom",e:"⚡"},{t:"gas",l:"Gas",e:"🔥"}];
              return (
                <div key={v.id} style={{background:C.card,borderRadius:11,padding:16,marginBottom:12,border:`1px solid ${C.border}`}}>
                  <div style={{color:C.text,fontWeight:700,fontSize:14,marginBottom:12}}>{v.einheit} – {mi?.name}</div>
                  <div style={{display:"flex",flexDirection:"column",gap:10}}>
                    {typen.map(({t,l,e})=>{
                      const z=wZaehler.find(x=>x.typ===t);
                      const ablesungen=z?.ablesungen||[];
                      const letzter=ablesungen[ablesungen.length-1];
                      return (
                        <div key={t} style={{background:C.card2,borderRadius:9,padding:12,border:`1px solid ${C.border}`}}>
                          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                            <div style={{display:"flex",gap:6,alignItems:"center"}}>
                              <span>{e}</span>
                              <span style={{color:C.text,fontSize:13,fontWeight:600}}>{l}</span>
                              {z?.nr&&<span style={{color:C.muted,fontSize:11}}>Nr: {z.nr}</span>}
                            </div>
                            {letzter&&<div style={{textAlign:"right"}}>
                              <span style={{color:C.gT,fontWeight:700,fontSize:13}}>{letzter.stand}</span>
                              <span style={{color:C.muted,fontSize:11,marginLeft:8}}>{fmtD(letzter.datum)}</span>
                            </div>}
                          </div>
                          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr auto",gap:7,marginBottom:7}}>
                            <input style={{...inp,fontSize:12}} placeholder="Zähler-Nr." defaultValue={z?.nr||""}
                              onBlur={e=>{const v2=e.target.value;upd("zaehler",zz=>{const cur=zz?.[selObj]||{allgemein:[],wohnungen:{}};const wohn={...cur.wohnungen};const wb=[...(wohn[v.einheit]||[])];const idx=wb.findIndex(x=>x.typ===t);if(idx>=0)wb[idx]={...wb[idx],nr:v2};else wb.push({id:uid(),typ:t,nr:v2,ablesungen:[]});wohn[v.einheit]=wb;return{...zz,[selObj]:{...cur,wohnungen:wohn}};});}}/>
                            <input style={{...inp,fontSize:12}} placeholder="Stand eintragen" id={`w_stand_${t}_${v.einheit}_${selObj}`}/>
                            <input type="date" style={{...inp,fontSize:12}} defaultValue={new Date().toISOString().split("T")[0]} id={`w_datum_${t}_${v.einheit}_${selObj}`}/>
                            <button style={bP} onClick={()=>{
                              const stand=document.getElementById(`w_stand_${t}_${v.einheit}_${selObj}`)?.value;
                              const datum=document.getElementById(`w_datum_${t}_${v.einheit}_${selObj}`)?.value;
                              if(!stand)return;
                              upd("zaehler",zz=>{
                                const cur=zz?.[selObj]||{allgemein:[],wohnungen:{}};
                                const wohn={...cur.wohnungen};
                                const wb=[...(wohn[v.einheit]||[])];
                                const idx=wb.findIndex(x=>x.typ===t);
                                const neueAblesung={id:uid(),stand,datum:datum||new Date().toISOString().split("T")[0]};
                                if(idx>=0){wb[idx]={...wb[idx],ablesungen:[...wb[idx].ablesungen,neueAblesung].slice(-36)};}
                                else wb.push({id:uid(),typ:t,nr:"",ablesungen:[neueAblesung]});
                                wohn[v.einheit]=wb;
                                return{...zz,[selObj]:{...cur,wohnungen:wohn}};
                              });
                              say("Ablesung gespeichert ✓");
                              document.getElementById(`w_stand_${t}_${v.einheit}_${selObj}`).value="";
                            }}>＋</button>
                          </div>
                          {ablesungen.length>0&&(
                            <div style={{maxHeight:100,overflowY:"auto"}}>
                              {[...ablesungen].reverse().map((a,i)=>(
                                <div key={a.id} style={{display:"flex",justifyContent:"space-between",padding:"2px 0",borderBottom:`1px solid ${C.border}`,fontSize:11}}>
                                  <span style={{color:C.muted}}>{fmtD(a.datum)}</span>
                                  <span style={{color:i===0?C.gT:C.text,fontWeight:i===0?700:400}}>{a.stand}{i===0?" ✓":""}</span>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        )}


        {/* Fotos & Grundrisse */}
        {tab==="fotos"&&(
          <div>
            <div style={{marginBottom:20}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
                <div>
                  <div style={{color:C.text,fontWeight:700,fontSize:15}}>Fotos & Grundrisse</div>
                  <div style={{color:C.muted,fontSize:12,marginTop:2}}>Bilder und Grundrisse pro Wohneinheit oder für das Gesamtobjekt</div>
                </div>
                <label style={{...bP,cursor:"pointer"}}>
                  📷 Bilder hochladen
                  <input type="file" accept="image/*,.pdf" multiple style={{display:"none"}} onChange={e=>{
                    Array.from(e.target.files).forEach(file=>{
                      const reader=new FileReader();
                      reader.onload=ev=>{
                        upd("fotos",ff=>{
                          const cur=ff||{};
                          const objFotos=cur[selObj]||[];
                          return {...cur,[selObj]:[...objFotos,{
                            id:uid(),name:file.name,datum:new Date().toISOString().split("T")[0],
                            typ:file.type,data:ev.target.result,einheit:"Objekt allgemein",
                            groesse:file.size
                          }]};
                        });
                      };
                      reader.readAsDataURL(file);
                    });
                    say("Bild(er) hochgeladen ✓");
                  }}/>
                </label>
              </div>

              {(()=>{
                const alleFotos=(db.fotos||{})[selObj]||[];
                const einheiten=["Objekt allgemein",...vv.map(v=>v.einheit)];

                if(alleFotos.length===0) return (
                  <div style={{background:C.card2,borderRadius:12,padding:40,textAlign:"center",border:`2px dashed ${C.border}`}}>
                    <div style={{fontSize:40,marginBottom:12}}>🏠</div>
                    <div style={{color:C.muted,fontSize:14}}>Noch keine Fotos oder Grundrisse hochgeladen</div>
                    <div style={{color:C.muted,fontSize:12,marginTop:6}}>Klicke auf „Bilder hochladen" um zu starten</div>
                  </div>
                );

                return einheiten.map(einheit=>{
                  const fotos=alleFotos.filter(f=>f.einheit===einheit);
                  if(fotos.length===0) return null;
                  return (
                    <div key={einheit} style={{marginBottom:20}}>
                      <div style={{color:C.muted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1.5,marginBottom:10}}>{einheit}</div>
                      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))",gap:10}}>
                        {fotos.map(foto=>(
                          <div key={foto.id} style={{background:C.card2,borderRadius:10,overflow:"hidden",border:`1px solid ${C.border}`,position:"relative",group:true}}>
                            {foto.typ==="application/pdf"?(
                              <div style={{height:120,display:"flex",alignItems:"center",justifyContent:"center",background:C.card,fontSize:36}}>📄</div>
                            ):(
                              <img src={foto.data} alt={foto.name} style={{width:"100%",height:120,objectFit:"cover",cursor:"pointer"}}
                                onClick={()=>window.open(foto.data,"_blank")}/>
                            )}
                            <div style={{padding:"8px 10px"}}>
                              <div style={{color:C.text,fontSize:11,fontWeight:600,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{foto.name}</div>
                              <div style={{color:C.muted,fontSize:10,marginTop:2}}>{fmtD(foto.datum)}</div>
                              <div style={{display:"flex",gap:5,marginTop:7}}>
                                <button style={{...bS,padding:"3px 7px",fontSize:10,flex:1,justifyContent:"center"}}
                                  onClick={()=>{const a=document.createElement("a");a.href=foto.data;a.download=foto.name;a.click();}}>⬇</button>
                                <button style={{...bD,padding:"3px 7px",fontSize:10}}
                                  onClick={()=>{upd("fotos",ff=>{const cur={...ff};cur[selObj]=(cur[selObj]||[]).filter(x=>x.id!==foto.id);return cur;});say("Gelöscht");}}>🗑</button>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                });
              })()}

              {/* Zuordnung ändern */}
              {((db.fotos||{})[selObj]||[]).length>0&&(
                <div style={{background:C.card,borderRadius:10,padding:14,border:`1px solid ${C.border}`,marginTop:10}}>
                  <div style={{color:C.muted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:10}}>Bild einer Einheit zuordnen</div>
                  <div style={{display:"flex",flexDirection:"column",gap:7}}>
                    {((db.fotos||{})[selObj]||[]).map(foto=>(
                      <div key={foto.id} style={{display:"flex",alignItems:"center",gap:9}}>
                        <span style={{color:C.text,fontSize:12,flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{foto.name}</span>
                        <select style={{...inp,width:"auto",fontSize:12,padding:"4px 8px"}} value={foto.einheit}
                          onChange={e=>{const val=e.target.value;upd("fotos",ff=>{const cur={...ff};cur[selObj]=(cur[selObj]||[]).map(x=>x.id===foto.id?{...x,einheit:val}:x);return cur;});}}>
                          {["Objekt allgemein",...vv.map(v=>v.einheit)].map(e=><option key={e} value={e}>{e}</option>)}
                        </select>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Dateien */}
        {tab==="dateien"&&(
          <div>
            <div style={{background:C.card2,borderRadius:11,padding:20,textAlign:"center",border:`2px dashed ${C.b2}`,marginBottom:14,cursor:"pointer"}} onClick={()=>fileRef.current?.click()}>
              <input ref={fileRef} type="file" multiple style={{display:"none"}} onChange={e=>{Array.from(e.target.files).forEach(f=>upd("dateien",dd=>[...dd,{id:uid(),objektId:selObj,name:f.name,size:f.size,datum:new Date().toISOString().split("T")[0]}]));say("Hochgeladen ✓");}}/>
              <div style={{fontSize:28}}>📁</div><p style={{color:C.muted,fontSize:13,marginTop:6}}>Objekt-Dateien hochladen</p>
            </div>
            {db.dateien.filter(d=>d.objektId===selObj&&!d.mieterId).map(d=>(
              <div key={d.id} style={{background:C.card2,borderRadius:8,padding:"10px 14px",display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:7}}>
                <div style={{display:"flex",gap:9,alignItems:"center"}}><span style={{fontSize:20}}>📄</span><div><div style={{color:C.text,fontSize:13}}>{d.name}</div><div style={{color:C.muted,fontSize:11}}>{fmtD(d.datum)} · {(d.size/1024).toFixed(1)} KB</div></div></div>
                <button style={{...bD,padding:"4px 8px"}} onClick={()=>{upd("dateien",dd=>dd.filter(x=>x.id!==d.id));say("Gelöscht");}}>🗑</button>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  // ── BRIEF SCHREIBEN ──────────────────────────────────────────────
  const BriefSchreiben = () => {
    const isMobile = useIsMobile();
    const [auswahlTyp,setAuswahlTyp] = useState("einzeln"); // einzeln | objekt | alle
    const [selMieter,setSelMieter] = useState([]);
    const [selObjFilter,setSelObjFilter] = useState("");
    const [betreff,setBetreff] = useState("");
    const [text,setText] = useState("Sehr geehrte/r {Anrede} {Name},\n\n\n\nMit freundlichen Grüßen\n"+(db.absender?.name||""));
    const [vorschau,setVorschau] = useState(false);
    const [pdfLoading,setPdfLoading] = useState(false);

    // Empfänger ermitteln
    const aktiveMieterMitVertrag = db.vertraege.filter(v=>v.aktiv).map(v=>({v,mi:getMi(v.mieterId),obj:getOb(v.objektId)})).filter(x=>x.mi&&x.obj);
    let empfaenger=[];
    if(auswahlTyp==="alle") empfaenger=aktiveMieterMitVertrag;
    else if(auswahlTyp==="objekt"&&selObjFilter) empfaenger=aktiveMieterMitVertrag.filter(x=>x.obj.id===selObjFilter);
    else if(auswahlTyp==="einzeln") empfaenger=aktiveMieterMitVertrag.filter(x=>selMieter.includes(x.v.id));

    const heuteStr = new Date().toLocaleDateString("de-DE",{day:"2-digit",month:"long",year:"numeric"});

    const empfAdresse = (x) => {
      if(x.mi.nachsende) return x.mi.nachsende;
      return `${x.obj.strasse||x.obj.adresse}\n${x.obj.plz||""} ${x.obj.stadt||""}`.trim();
    };

    const briefText = (x) => {
      return text
        .replace(/\{Anrede\}/g,x.mi.anrede||"")
        .replace(/\{Name\}/g,x.mi.name||"")
        .replace(/\{Einheit\}/g,x.v.einheit||"")
        .replace(/\{Adresse\}/g,x.obj.adresse||"")
        .replace(/\{Strasse\}/g,x.obj.strasse||"")
        .replace(/\{PLZ\}/g,x.obj.plz||"")
        .replace(/\{Stadt\}/g,x.obj.stadt||"");
    };

    const briefAlsPDF = async (nurVorschau=false) => {
      if(empfaenger.length===0){say("Keine Empfänger ausgewählt");return;}
      if(!betreff){say("Bitte Betreff eingeben");return;}
      setPdfLoading(true);
      try {
        const pdfs = await erstellePDF(db.absender, empfaenger, betreff, briefText, heuteStr, empfAdresse);
        if(nurVorschau){
          // Ersten Brief im Browser öffnen
          const blob = pdfs[0].doc.output("blob");
          const url = URL.createObjectURL(blob);
          window.open(url,"_blank");
        } else {
          // Alle herunterladen + bei Mietern speichern
          const datum=new Date().toISOString().split("T")[0];
          pdfs.forEach(({doc, name, dateiname}, i) => {
            // Download
            doc.save(dateiname);
            // Bei Mieter speichern als Referenz
            const x = empfaenger[i];
            upd("dateien",dd=>[...dd,{id:uid(),mieterId:x.mi.id,objektId:x.obj.id,
              name:dateiname,size:0,datum,typ:"pdf_brief",
              pdfData:doc.output("datauristring")}]);
          });
          say(`${pdfs.length} PDF(s) erstellt & gespeichert ✓`);
          setBetreff("");setText("Sehr geehrte/r {Anrede} {Name},\n\n\n\nMit freundlichen Grüßen\n"+(db.absender?.name||""));
          setSelMieter([]);setVorschau(false);
        }
      } catch(e) {
        say("PDF-Fehler: "+e.message);
      } finally {
        setPdfLoading(false);
      }
    };

    const briefDrucken = async () => {
      if(empfaenger.length===0){say("Keine Empfänger ausgewählt");return;}
      if(!betreff){say("Bitte Betreff eingeben");return;}
      setPdfLoading(true);
      try {
        const pdfs = await erstellePDF(db.absender, empfaenger, betreff, briefText, heuteStr, empfAdresse);
        pdfs.forEach(({doc}) => {
          const blob = doc.output("blob");
          const url = URL.createObjectURL(blob);
          const w = window.open(url,"_blank");
          setTimeout(()=>w?.print(),800);
        });
      } catch(e){ say("Druckfehler: "+e.message); }
      finally { setPdfLoading(false); }
    };

    const briefSpeichern = () => {
      if(empfaenger.length===0){say("Keine Empfänger ausgewählt");return;}
      if(!betreff){say("Bitte Betreff eingeben");return;}
      const datum=new Date().toISOString().split("T")[0];
      empfaenger.forEach(x=>{
        const inhalt=briefText(x);
        const a=db.absender||{};
        const voll=`${a.name||""}\n${a.strasse||""}\n${a.plz||""} ${a.stadt||""}\n\n\n${x.mi.anrede||""} ${x.mi.name||""}\n${empfAdresse(x)}\n\n\n${x.obj.stadt||"Ort"}, den ${heuteStr}\n\nBetreff: ${betreff}\n\n${inhalt}`;
        upd("dateien",dd=>[...dd,{id:uid(),mieterId:x.mi.id,objektId:x.obj.id,name:`Brief - ${betreff} (${heuteStr}).txt`,size:voll.length,datum,typ:"brief",inhalt:voll}]);
      });
      say(`${empfaenger.length} Brief(e) gespeichert ✓`);
      setBetreff("");setText("Sehr geehrte/r {Anrede} {Name},\n\n\n\nMit freundlichen Grüßen\n"+(db.absender?.name||""));
      setSelMieter([]);setVorschau(false);
    };

    const absenderFehlt = !db.absender?.name;

    return (
      <div style={{padding:isMobile?"8px 10px 0":"28px",overflowY:"auto",flex:1,WebkitOverflowScrolling:"touch"}}>
        <h2 style={{color:C.text,fontSize:20,fontWeight:800,margin:"0 0 6px"}}>Brief schreiben</h2>
        <p style={{color:C.muted,fontSize:13,marginBottom:20}}>Serienbrief an Mieter · wird automatisch bei jedem Empfänger unter Dokumente gespeichert</p>

        {absenderFehlt&&(
          <div style={{background:C.y2,border:`1px solid ${C.yT}44`,borderRadius:9,padding:"11px 14px",marginBottom:18,color:C.yT,fontSize:13}}>
            ⚠ Noch keine Absenderdaten hinterlegt. Bitte zuerst in den <b>Einstellungen</b> deine Absenderadresse eintragen.
          </div>
        )}

        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:18}}>
          {/* Links: Empfänger + Einstellungen */}
          <div>
            <div style={{background:C.card,borderRadius:11,padding:18,border:`1px solid ${C.border}`,marginBottom:16}}>
              <div style={{color:C.muted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:12}}>Empfänger</div>
              <div style={{display:"flex",gap:8,marginBottom:14}}>
                {[{v:"einzeln",l:"Einzelne"},{v:"objekt",l:"Ganzes Objekt"},{v:"alle",l:"Alle Mieter"}].map(o=>(
                  <button key={o.v} onClick={()=>setAuswahlTyp(o.v)} style={{flex:1,padding:"8px",borderRadius:8,border:`2px solid ${auswahlTyp===o.v?C.blue:C.border}`,background:auswahlTyp===o.v?`${C.blue}12`:C.card2,color:auswahlTyp===o.v?C.blue2:C.text,fontWeight:600,fontSize:12,cursor:"pointer"}}>{o.l}</button>
                ))}
              </div>
              {auswahlTyp==="objekt"&&(
                <select style={inp} value={selObjFilter} onChange={e=>setSelObjFilter(e.target.value)}>
                  <option value="">— Objekt wählen —</option>
                  {db.objekte.map(o=><option key={o.id} value={o.id}>{o.adresse}</option>)}
                </select>
              )}
              {auswahlTyp==="einzeln"&&(
                <div>
                  <div style={{marginBottom:10}}>
                    <label style={lbl}>Objekt wählen</label>
                    <select style={inp} value={selObjFilter} onChange={e=>{setSelObjFilter(e.target.value);setSelMieter([]);}}>
                      <option value="">— Objekt wählen —</option>
                      {db.objekte.map(o=><option key={o.id} value={o.id}>{o.adresse}</option>)}
                    </select>
                  </div>
                  {selObjFilter&&(
                    <div style={{maxHeight:200,overflowY:"auto",display:"flex",flexDirection:"column",gap:4}}>
                      {aktiveMieterMitVertrag.filter(x=>x.obj.id===selObjFilter).map(x=>(
                        <label key={x.v.id} style={{display:"flex",alignItems:"center",gap:8,padding:"7px 10px",borderRadius:7,background:selMieter.includes(x.v.id)?`${C.blue}12`:C.card2,cursor:"pointer"}}>
                          <input type="checkbox" checked={selMieter.includes(x.v.id)} onChange={e=>setSelMieter(p=>e.target.checked?[...p,x.v.id]:p.filter(id=>id!==x.v.id))}/>
                          <div>
                            <div style={{color:C.text,fontSize:13,fontWeight:600}}>{x.mi.anrede} {x.mi.name}</div>
                            <div style={{color:C.muted,fontSize:11}}>{x.v.einheit}</div>
                          </div>
                        </label>
                      ))}
                      {aktiveMieterMitVertrag.filter(x=>x.obj.id===selObjFilter).length===0&&<p style={{color:C.muted,fontSize:13}}>Keine Mieter in diesem Objekt.</p>}
                    </div>
                  )}
                </div>
              )}
              {auswahlTyp==="alle"&&<div style={{color:C.muted,fontSize:13}}>Alle {aktiveMieterMitVertrag.length} aktiven Mieter werden angeschrieben.</div>}
              <div style={{marginTop:12,paddingTop:12,borderTop:`1px solid ${C.border}`,color:C.blue2,fontSize:13,fontWeight:600}}>
                {empfaenger.length} Empfänger ausgewählt
              </div>
            </div>

            {/* Platzhalter-Hilfe */}
            <div style={{background:C.card,borderRadius:11,padding:18,border:`1px solid ${C.border}`}}>
              <div style={{color:C.muted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:10}}>Platzhalter</div>
              <div style={{color:C.muted,fontSize:12,lineHeight:1.9}}>
                <div><code style={{color:C.blue2}}>{"{Anrede}"}</code> → Herr / Frau</div>
                <div><code style={{color:C.blue2}}>{"{Name}"}</code> → Name des Mieters</div>
                <div><code style={{color:C.blue2}}>{"{Einheit}"}</code> → z.B. WE 2</div>
                <div><code style={{color:C.blue2}}>{"{Strasse}"}</code> <code style={{color:C.blue2}}>{"{PLZ}"}</code> <code style={{color:C.blue2}}>{"{Stadt}"}</code></div>
              </div>
              <div style={{color:C.m2,fontSize:11,marginTop:10}}>Diese werden pro Mieter automatisch ersetzt.</div>
            </div>
          </div>

          {/* Rechts: Brief */}
          <div>
            <div style={{background:C.card,borderRadius:11,padding:18,border:`1px solid ${C.border}`}}>
              <div style={{color:C.muted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:12}}>Briefinhalt</div>
              <F label="Betreff" ch={<input style={inp} value={betreff} onChange={e=>setBetreff(e.target.value)} placeholder="z.B. Ankündigung Heizungswartung"/>}/>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
                <label style={{...lbl,margin:0}}>Text</label>
                <button style={{...bS,padding:"3px 10px",fontSize:12}} onClick={async()=>{
                  if(!text.trim()){say("Kein Text vorhanden");return;}
                  say("Prüfe Rechtschreibung…");
                  try{
                    const r=await fetch("https://api.languagetool.org/v2/check",{method:"POST",headers:{"Content-Type":"application/x-www-form-urlencoded"},body:`text=${encodeURIComponent(text)}&language=de-DE`});
                    const d=await r.json();
                    if(!d.matches||d.matches.length===0){say("✓ Keine Fehler gefunden");}
                    else{const fehler=d.matches.map(m=>`• "${text.substr(m.offset,m.length)}" → ${m.replacements?.[0]?.value||m.message}`).slice(0,8).join("\n");alert(`${d.matches.length} Hinweis(e):\n\n${fehler}`);}
                  }catch(e){say("Rechtschreibprüfung nicht verfügbar");}
                }}>🔤 Rechtschreibprüfung</button>
              </div>
              <textarea spellCheck={true} lang="de" style={{...inp,minHeight:280,fontSize:14,lineHeight:1.6,resize:"vertical",fontFamily:"inherit"}} value={text} onChange={e=>setText(e.target.value)}/>
              <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:14,flexWrap:"wrap"}}>
                <button style={bS} onClick={()=>setVorschau(v=>!v)} disabled={empfaenger.length===0}>👁 Vorschau</button>
                <button style={bS} onClick={()=>briefAlsPDF(true)} disabled={pdfLoading||empfaenger.length===0}>📄 PDF öffnen</button>
                <button style={bS} onClick={briefDrucken} disabled={pdfLoading||empfaenger.length===0}>🖨 Drucken</button>
                <button style={bP} onClick={()=>briefAlsPDF(false)} disabled={pdfLoading||empfaenger.length===0}>
                  {pdfLoading?"⟳ Erstelle PDF…":"⬇ PDF erstellen & speichern"}
                </button>
              </div>
            </div>

            {/* Vorschau */}
            {vorschau&&empfaenger.length>0&&(()=>{
              const x=empfaenger[0];
              const a=db.absender||{};
              return (
                <div style={{background:"#fff",borderRadius:11,padding:24,border:`1px solid ${C.border}`,marginTop:16,fontSize:13,lineHeight:1.6,color:"#222",whiteSpace:"pre-wrap"}}>
                  <div style={{color:C.muted,fontSize:11,marginBottom:12,fontFamily:"sans-serif"}}>VORSCHAU (1. Empfänger):</div>
                  <div style={{fontSize:11,color:"#666"}}>{a.name} · {a.strasse} · {a.plz} {a.stadt}</div>
                  <div style={{marginTop:20}}>{x.mi.anrede} {x.mi.name}<br/>{empfAdresse(x)}</div>
                  <div style={{marginTop:20,textAlign:"right"}}>{x.obj.stadt||"Ort"}, den {heuteStr}</div>
                  <div style={{marginTop:16,fontWeight:700}}>Betreff: {betreff||"(kein Betreff)"}</div>
                  <div style={{marginTop:16}}>{briefText(x)}</div>
                </div>
              );
            })()}
          </div>
        </div>
      </div>
    );
  };

  // ── MITARBEITER ──────────────────────────────────────────────────
  const Mitarbeiter = () => {
    const [tab,setTab] = useState("team");
    const [nf,setNf] = useState(false);
    const [mf,setMf] = useState({name:"",rolle:"hausmeister",email:"",telefon:"",objektZugang:[]});
    const [af,setAf] = useState(false);
    const [aForm,setAForm] = useState({titel:"",objektId:"",zugewiesen:"",prioritaet:"mittel",faellig:"",notiz:""});
    const rolL={hausmeister:"Hausmeister",verwalter:"Verwalter",extern:"Extern"};
    const prioC={hoch:"red",mittel:"yellow",niedrig:"green"};
    return (
      <div style={{padding:isMobile?"8px 10px 0":"28px",overflowY:"auto",flex:1,WebkitOverflowScrolling:"touch"}}>
        <h2 style={{color:C.text,fontSize:20,fontWeight:800,margin:"0 0 20px"}}>Mitarbeiter & Aufgaben</h2>
        <div style={{display:"flex",gap:2,marginBottom:20,borderBottom:`1px solid ${C.border}`}}>
          {[{id:"team",l:"👥 Team"},{id:"aufgaben",l:"📋 Aufgaben-Board"},{id:"stunden",l:"⏱ Stundenzettel"}].map(t=>(
            <button key={t.id} onClick={()=>setTab(t.id)} style={{background:"none",border:"none",color:tab===t.id?C.blue:C.muted,padding:"9px 13px",cursor:"pointer",fontSize:13,fontWeight:tab===t.id?700:400,borderBottom:tab===t.id?`2px solid ${C.blue}`:"2px solid transparent"}}>{t.l}</button>
          ))}
        </div>
        {tab==="team"&&(
          <div>
            <div style={{display:"flex",justifyContent:"flex-end",marginBottom:14}}><button style={bP} onClick={()=>setNf(true)}>＋ Mitarbeiter</button></div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:14}}>
              {db.mitarbeiter.map(ma=>{
                const anz=db.aufgaben.filter(a=>a.zugewiesen===ma.id&&a.status!=="erledigt").length;
                return (
                  <div key={ma.id} style={{background:C.card,borderRadius:11,padding:18,border:`1px solid ${C.border}`}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:10}}>
                      <div style={{display:"flex",gap:10,alignItems:"center"}}>
                        <div style={{width:40,height:40,background:`linear-gradient(135deg,${C.blue},${C.pT})`,borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontWeight:800}}>{ma.name.charAt(0)}</div>
                        <div><div style={{color:C.text,fontWeight:700}}>{ma.name}</div><Bdg col="blue" ch={rolL[ma.rolle]}/></div>
                      </div>
                      <button style={{...bD,padding:"4px 8px"}} onClick={()=>{upd("mitarbeiter",mm=>mm.filter(x=>x.id!==ma.id));say("Entfernt");}}>🗑</button>
                    </div>
                    <div style={{color:C.muted,fontSize:12,marginBottom:8}}>✉ {ma.email} · 📞 {ma.telefon}</div>
                    <div style={{background:C.card2,borderRadius:7,padding:"7px 11px",display:"flex",justifyContent:"space-between"}}>
                      <span style={{color:C.muted,fontSize:12}}>{ma.objektZugang.length===db.objekte.length?"Alle Objekte":ma.objektZugang.map(id=>db.objekte.find(o=>o.id===id)?.name).join(", ")}</span>
                      <span style={{color:anz>0?C.yT:C.gT,fontSize:12,fontWeight:600}}>{anz} offen</span>
                    </div>
                  </div>
                );
              })}
            </div>
            {nf&&(
              <div style={{background:C.card2,borderRadius:11,padding:18,marginTop:16,border:`1px solid ${C.b2}`}}>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10,marginBottom:10}}>
                  <div><label style={lbl}>Name</label><input style={inp} value={mf.name} onChange={e=>setMf(p=>({...p,name:e.target.value}))}/></div>
                  <div><label style={lbl}>Rolle</label><select style={inp} value={mf.rolle} onChange={e=>setMf(p=>({...p,rolle:e.target.value}))}><option value="hausmeister">Hausmeister</option><option value="verwalter">Verwalter</option><option value="extern">Extern</option></select></div>
                  <div><label style={lbl}>E-Mail</label><input style={inp} value={mf.email} onChange={e=>setMf(p=>({...p,email:e.target.value}))}/></div>
                </div>
                <div style={{marginBottom:12}}>
                  <label style={lbl}>Objekt-Zugang</label>
                  <div style={{display:"flex",gap:12,flexWrap:"wrap"}}>
                    {db.objekte.map(o=><label key={o.id} style={{display:"flex",alignItems:"center",gap:5,color:C.text,fontSize:13,cursor:"pointer"}}><input type="checkbox" checked={mf.objektZugang.includes(o.id)} onChange={e=>setMf(p=>({...p,objektZugang:e.target.checked?[...p.objektZugang,o.id]:p.objektZugang.filter(x=>x!==o.id)}))} />{o.name}</label>)}
                  </div>
                </div>
                <div style={{display:"flex",gap:8}}>
                  <button style={bP} onClick={()=>{if(!mf.name)return;upd("mitarbeiter",mm=>[...mm,{...mf,id:uid(),aktiv:true}]);setNf(false);setMf({name:"",rolle:"hausmeister",email:"",telefon:"",objektZugang:[]});say("Angelegt ✓");}}>✓ Speichern</button>
                  <button style={bS} onClick={()=>setNf(false)}>✕</button>
                </div>
              </div>
            )}
          </div>
        )}
        {tab==="aufgaben"&&(
          <div>
            <div style={{display:"flex",justifyContent:"flex-end",marginBottom:14}}><button style={bP} onClick={()=>setAf(true)}>＋ Aufgabe</button></div>
            <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"repeat(3,1fr)",gap:14}}>
              {[{s:"offen",l:"Offen",c:C.rT},{s:"in_bearbeitung",l:"In Bearbeitung",c:C.yT},{s:"erledigt",l:"Erledigt",c:C.gT}].map(col=>(
                <div key={col.s}>
                  <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:10}}>
                    <div style={{width:7,height:7,borderRadius:"50%",background:col.c}}/><span style={{color:C.muted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1}}>{col.l}</span>
                    <span style={{color:C.m2,fontSize:11}}>({db.aufgaben.filter(a=>a.status===col.s).length})</span>
                  </div>
                  {db.aufgaben.filter(a=>a.status===col.s).map(a=>{
                    const ma=db.mitarbeiter.find(m=>m.id===a.zugewiesen);
                    return (
                      <div key={a.id} style={{background:C.card2,borderRadius:9,padding:13,marginBottom:9,border:`1px solid ${C.border}`}}>
                        <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}><span style={{color:C.text,fontWeight:600,fontSize:13}}>{a.titel}</span><Bdg col={prioC[a.prioritaet]} ch={a.prioritaet}/></div>
                        <div style={{color:C.muted,fontSize:12,marginBottom:6}}>{getOb(a.objektId)?.name}{a.faellig&&` · ${fmtD(a.faellig)}`}</div>
                        {a.notiz&&<div style={{color:C.muted,fontSize:11,fontStyle:"italic",marginBottom:6}}>„{a.notiz}"</div>}
                        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                          <span style={{color:C.muted,fontSize:11}}>👤 {ma?.name||"—"}</span>
                          <div style={{display:"flex",gap:4}}>
                            {col.s!=="erledigt"&&<button style={{...bS,padding:"3px 7px",fontSize:11}} onClick={()=>upd("aufgaben",aa=>aa.map(x=>x.id===a.id?{...x,status:col.s==="offen"?"in_bearbeitung":"erledigt"}:x))}>{col.s==="offen"?"▶":"✓"}</button>}
                            <button style={{...bD,padding:"3px 7px",fontSize:11}} onClick={()=>{upd("aufgaben",aa=>aa.filter(x=>x.id!==a.id));say("Gelöscht");}}>🗑</button>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
            {af&&(
              <div style={{background:C.card2,borderRadius:11,padding:18,marginTop:16,border:`1px solid ${C.b2}`}}>
                <div style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr",gap:10,marginBottom:10}}>
                  <div><label style={lbl}>Titel</label><input style={inp} value={aForm.titel} onChange={e=>setAForm(p=>({...p,titel:e.target.value}))} placeholder="z.B. Fenster reparieren"/></div>
                  <div><label style={lbl}>Objekt</label><select style={inp} value={aForm.objektId} onChange={e=>setAForm(p=>({...p,objektId:e.target.value}))}><option value="">—</option>{db.objekte.map(o=><option key={o.id} value={o.id}>{o.name}</option>)}</select></div>
                  <div><label style={lbl}>Zuweisen</label><select style={inp} value={aForm.zugewiesen} onChange={e=>setAForm(p=>({...p,zugewiesen:e.target.value}))}><option value="">—</option>{db.mitarbeiter.map(m=><option key={m.id} value={m.id}>{m.name}</option>)}</select></div>
                  <div><label style={lbl}>Priorität</label><select style={inp} value={aForm.prioritaet} onChange={e=>setAForm(p=>({...p,prioritaet:e.target.value}))}><option value="hoch">Hoch</option><option value="mittel">Mittel</option><option value="niedrig">Niedrig</option></select></div>
                </div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:12}}>
                  <div><label style={lbl}>Fällig am</label><input type="date" style={inp} value={aForm.faellig} onChange={e=>setAForm(p=>({...p,faellig:e.target.value}))}/></div>
                  <div><label style={lbl}>Notiz</label><input style={inp} value={aForm.notiz} onChange={e=>setAForm(p=>({...p,notiz:e.target.value}))}/></div>
                </div>
                <div style={{display:"flex",gap:8}}>
                  <button style={bP} onClick={()=>{if(!aForm.titel)return;upd("aufgaben",aa=>[...aa,{...aForm,id:uid(),status:"offen"}]);setAf(false);setAForm({titel:"",objektId:"",zugewiesen:"",prioritaet:"mittel",faellig:"",notiz:""});say("Angelegt ✓");}}>✓</button>
                  <button style={bS} onClick={()=>setAf(false)}>✕</button>
                </div>
              </div>
            )}
          </div>
        )}
        {tab==="stunden"&&(
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
              <div>
                <div style={{color:C.text,fontWeight:700,fontSize:15}}>Stundenzettel</div>
                <div style={{color:C.muted,fontSize:12,marginTop:2}}>Arbeitsstunden der Mitarbeiter erfassen</div>
              </div>
              <button style={bP} onClick={()=>setModal({t:"neueStunde"})}>＋ Stunden erfassen</button>
            </div>
            {/* Zusammenfassung pro Mitarbeiter */}
            <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"repeat(2,1fr)",gap:12,marginBottom:18}}>
              {db.mitarbeiter.map(ma=>{
                const maStunden = (db.stundenzettel||[]).filter(s=>s.mitarbeiterId===ma.id);
                const gesamtH = maStunden.reduce((s,z)=>s+(parseFloat(z.stunden)||0),0);
                const dieserMonat = maStunden.filter(s=>s.datum?.startsWith(`${Y0}-${String(M0+1).padStart(2,"0")}`)).reduce((s,z)=>s+(parseFloat(z.stunden)||0),0);
                return (
                  <div key={ma.id} style={{background:C.card2,borderRadius:10,padding:14,border:`1px solid ${C.border}`}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:10}}>
                      <div>
                        <div style={{color:C.text,fontWeight:700,fontSize:14}}>{ma.name}</div>
                        <div style={{color:C.muted,fontSize:12}}>{ma.beruf||"Mitarbeiter"}</div>
                      </div>
                      <div style={{textAlign:"right"}}>
                        <div style={{color:C.gT,fontWeight:800,fontSize:18}}>{dieserMonat.toFixed(1)}h</div>
                        <div style={{color:C.muted,fontSize:11}}>diesen Monat</div>
                      </div>
                    </div>
                    <div style={{color:C.muted,fontSize:12,marginBottom:8}}>Gesamt: {gesamtH.toFixed(1)}h · {maStunden.length} Einträge</div>
                    {/* Letzte 5 Einträge */}
                    {[...maStunden].sort((a,b)=>new Date(b.datum)-new Date(a.datum)).slice(0,3).map(s=>(
                      <div key={s.id} style={{display:"flex",justifyContent:"space-between",padding:"4px 0",borderTop:`1px solid ${C.border}`,fontSize:12}}>
                        <span style={{color:C.muted}}>{fmtD(s.datum)}</span>
                        <span style={{color:C.text}}>{s.beschreibung||"Einsatz"}</span>
                        <span style={{color:C.gT,fontWeight:600}}>{s.stunden}h</span>
                        <button style={{background:"none",border:"none",color:C.rT,cursor:"pointer",fontSize:11,padding:"0 4px"}} onClick={()=>{upd("stundenzettel",ss=>ss.filter(x=>x.id!==s.id));say("Gelöscht");}}>✕</button>
                      </div>
                    ))}
                  </div>
                );
              })}
              {db.mitarbeiter.length===0&&<div style={{gridColumn:"1/-1",background:C.card2,borderRadius:10,padding:24,textAlign:"center",color:C.muted}}>Erst Mitarbeiter im Team-Tab anlegen</div>}
            </div>
            {/* Alle Einträge Liste */}
            {(db.stundenzettel||[]).length>0&&(
              <div style={{background:C.card,borderRadius:11,border:`1px solid ${C.border}`,overflow:"hidden"}}>
                <div style={{padding:"10px 16px",borderBottom:`1px solid ${C.border}`,color:C.muted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1.5}}>Alle Einträge</div>
                {[...(db.stundenzettel||[])].sort((a,b)=>new Date(b.datum)-new Date(a.datum)).map(s=>{
                  const ma=db.mitarbeiter.find(m=>m.id===s.mitarbeiterId);
                  const obj=db.objekte.find(o=>o.id===s.objektId);
                  return (
                    <div key={s.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 16px",borderBottom:`1px solid ${C.border2||C.border}`,fontSize:13}}>
                      <div>
                        <span style={{color:C.text,fontWeight:600}}>{ma?.name||"?"}</span>
                        <span style={{color:C.muted,marginLeft:8}}>{fmtD(s.datum)}</span>
                        {obj&&<span style={{color:C.muted,marginLeft:8,fontSize:11}}>· {obj.name}</span>}
                        {s.beschreibung&&<div style={{color:C.muted,fontSize:12}}>{s.beschreibung}</div>}
                      </div>
                      <div style={{display:"flex",alignItems:"center",gap:10}}>
                        <span style={{color:C.gT,fontWeight:700}}>{s.stunden}h</span>
                        <button style={{...bD,padding:"3px 8px",fontSize:11}} onClick={()=>{upd("stundenzettel",ss=>ss.filter(x=>x.id!==s.id));say("Gelöscht");}}>🗑</button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  // ── EINSTELLUNGEN ─────────────────────────────────────────────────
  const Einstellungen = () => {
    const isMobile = useIsMobile();
    return (
      <div style={{padding:isMobile?"8px 10px 0":"28px",overflowY:"auto",flex:1,WebkitOverflowScrolling:"touch"}}>
        <h2 style={{color:C.text,fontSize:20,fontWeight:800,margin:"0 0 6px"}}>Einstellungen</h2>
        <p style={{color:C.muted,fontSize:13,marginBottom:22}}>Allgemeine App-Einstellungen</p>
        {/* Hidden dummy fields to trick password managers */}
      <input type="text" style={{display:"none"}} aria-hidden="true"/>
      <input type="password" autoComplete="new-password" style={{display:"none"}} aria-hidden="true"/>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:18,alignItems:"start"}}>
          <div>
            <AbsenderCard absender={db.absender} onSave={a=>upd("absender",()=>a)}/>
            <div style={{background:C.card,borderRadius:11,padding:13,border:`1px solid ${C.border}`}}>
              <div style={{color:C.muted,fontSize:10,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:12}}>Design</div>
              <div style={{display:"flex",flexDirection:"column",gap:6}}>
                {Object.entries(THEMES).map(([key,t])=>(
                  <button key={key} onClick={async()=>{
                      localStorage.setItem("immo_theme",key);
                      // Daten erst speichern, dann neu laden
                      try {
                        await fetch("/api/state",{method:"POST",headers:{"Content-Type":"application/json",Authorization:`Bearer ${token}`},body:JSON.stringify(db)});
                      } catch(e){}
                      window.location.reload();
                    }}
                    style={{background:theme===key?`${C.blue}22`:C.card2,border:`2px solid ${theme===key?C.blue:C.border}`,borderRadius:8,padding:"8px 10px",cursor:"pointer",textAlign:"left",display:"flex",alignItems:"center",gap:8}}>
                    <span style={{fontSize:14}}>{t.icon}</span>
                    <span style={{color:theme===key?C.blue:C.text,fontSize:12,fontWeight:theme===key?700:400}}>{t.name}</span>
                    {theme===key&&<span style={{color:C.blue,fontSize:10,marginLeft:"auto"}}>✓ Aktiv</span>}
                  </button>
                ))}
              </div>
              <div style={{color:C.muted,fontSize:11,marginTop:12,paddingTop:10,borderTop:`1px solid ${C.border}`}}>
                <div>Version 1.0.0</div><div>Steuer: {(STEUER*100).toFixed(0)}%</div>
              </div>
            </div>
          </div>
          <div>
            <PwCard token={token}/>

            {/* Muster-Mietvertrag */}
            {user?.role==="admin"&&(
              <div style={{background:C.card,borderRadius:11,padding:16,border:`1px solid ${C.border}`,marginTop:12}}>
                <div style={{color:C.muted,fontSize:10,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:8}}>Muster-Mietvertrag</div>
                <div style={{color:C.muted,fontSize:12,marginBottom:10}}>Hinterlege deine Mietvertragsvorlage – wird bei neuen Mietverträgen angeboten</div>
                {db.musterMietvertrag?(
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",background:C.card2,borderRadius:8,padding:"10px 14px",marginBottom:10}}>
                    <div>
                      <div style={{color:C.text,fontSize:13,fontWeight:600}}>📄 {db.musterMietvertrag.name}</div>
                      <div style={{color:C.muted,fontSize:11}}>Hochgeladen: {fmtD(db.musterMietvertrag.datum)}</div>
                    </div>
                    <div style={{display:"flex",gap:8}}>
                      <button style={{...bS,padding:"5px 10px",fontSize:12}} onClick={()=>{const a=document.createElement("a");a.href=db.musterMietvertrag.data;a.download=db.musterMietvertrag.name;a.click();}}>⬇ Download</button>
                      <button style={{...bD,padding:"5px 10px",fontSize:12}} onClick={()=>{upd("musterMietvertrag",()=>null);say("Muster gelöscht");}}>🗑</button>
                    </div>
                  </div>
                ):(
                  <div style={{background:C.card2,borderRadius:8,padding:14,textAlign:"center",border:`2px dashed ${C.border}`,marginBottom:10}}>
                    <div style={{color:C.muted,fontSize:13}}>Noch kein Muster hinterlegt</div>
                  </div>
                )}
                <label style={{...bP,cursor:"pointer",display:"inline-flex",alignItems:"center",gap:6}}>
                  📎 Muster hochladen (PDF, Word, Bild)
                  <input type="file" style={{display:"none"}} accept=".pdf,.doc,.docx,image/*"
                    onChange={e=>{
                      const file=e.target.files[0]; if(!file) return;
                      const reader=new FileReader();
                      reader.onload=ev=>{
                        upd("musterMietvertrag",()=>({name:file.name,typ:file.type,data:ev.target.result,datum:new Date().toISOString().split("T")[0]}));
                        say("Muster-Mietvertrag gespeichert ✓");
                      };
                      reader.readAsDataURL(file);
                    }}/>
                </label>
              </div>
            )}
            <TwoFACard token={token}/>
            {/* Push-Benachrichtigungen */}
            <div style={{background:C.card,borderRadius:11,padding:16,border:`1px solid ${C.border}`,marginTop:12}}>
              <div style={{color:C.muted,fontSize:10,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:8}}>Push-Benachrichtigungen</div>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <div>
                  <div style={{color:pushEnabled?C.gT:C.muted,fontSize:13}}>{pushEnabled?"🔔 Aktiv – du wirst bei offenen Zahlungen benachrichtigt":"🔕 Nicht aktiv"}</div>
                  <div style={{color:C.muted,fontSize:11,marginTop:2}}>Benachrichtigung wenn Mietzahlungen ausstehen</div>
                </div>
                {!pushEnabled
                  ? <button style={{...bP,padding:"7px 14px",fontSize:12}} onClick={enablePush}>Aktivieren</button>
                  : <button style={{...bS,padding:"7px 14px",fontSize:12}} onClick={()=>{localStorage.removeItem("immo_push");setPushEnabled(false);say("Push deaktiviert");}}>Deaktivieren</button>
                }
              </div>
            </div>
            <ErinnerungsCard settings={db.erinnerungsSettings} onSave={s=>upd("erinnerungsSettings",()=>s)}/>

            <div style={{background:C.card,borderRadius:11,padding:18,border:`1px solid ${C.border}`,marginTop:14}}>
              <div style={{color:C.muted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:12}}>Auto-Abmeldung</div>
              <div>
                <label style={lbl}>Automatisch abmelden nach Inaktivität</label>
                <select style={inp} value={db.autoLogout??30}
                  onChange={e=>upd("autoLogout",()=>parseInt(e.target.value))}>
                  <option value={5}>5 Minuten</option>
                  <option value={15}>15 Minuten</option>
                  <option value={30}>30 Minuten</option>
                  <option value={60}>1 Stunde</option>
                  <option value={180}>3 Stunden</option>
                  <option value={360}>6 Stunden</option>
                  <option value={480}>8 Stunden</option>
                  <option value={0}>Nie</option>
                </select>
                <div style={{color:C.muted,fontSize:11,marginTop:8}}>
                  Bei Inaktivität wird die Sitzung automatisch beendet. Mausbewegung oder Tastendruck setzt den Timer zurück.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

    // ── MIETER BEARBEITEN MODAL ──────────────────────────────────────
  const EditMieterVertragModal = ({v, mi}) => {
    const [mf, setMf] = useState({name:mi?.name||"",anrede:mi?.anrede||"Herr",email:mi?.email||"",telefon:mi?.telefon||"",nachsende:mi?.nachsende||""});
    const [vf, setVf] = useState({einheit:v.einheit,kaltmiete:v.kaltmiete,nebenkosten:v.nebenkosten,stellplatz:v.stellplatz,kueche:v.kueche,mietBeginn:v.mietBeginn||v.einzug||"",mietEnde:v.mietEnde||"",kaution:v.kaution,kautionBezahlt:v.kautionBezahlt,qm:v.qm||"",zimmer:v.zimmer||""});
    return <Modal title="Mieter & Vertrag bearbeiten" onClose={cm} w={600}>
      <div style={{color:C.muted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:10}}>Mieterdaten</div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 2fr",gap:10,marginBottom:10}}>
        <F label="Anrede" ch={<select style={inp} value={mf.anrede} onChange={e=>setMf(p=>({...p,anrede:e.target.value}))}><option>Herr</option><option>Frau</option><option>Familie</option><option>Divers</option></select>}/>
        <F label="Name" ch={<input style={inp} value={mf.name} onChange={e=>setMf(p=>({...p,name:e.target.value}))}/>}/>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10}}>
        <F label="Telefon" ch={<input style={inp} value={mf.telefon} onChange={e=>setMf(p=>({...p,telefon:e.target.value}))}/>}/>
        <F label="E-Mail" ch={<input style={inp} value={mf.email} onChange={e=>setMf(p=>({...p,email:e.target.value}))}/>}/>
      </div>
      <F label="Nachsende-Adresse (nur bei Auszug, sonst leer)" ch={<input style={inp} value={mf.nachsende} onChange={e=>setMf(p=>({...p,nachsende:e.target.value}))} placeholder="Neue Straße 5, 54321 Neustadt"/>}/>
      <div style={{color:C.muted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1,margin:"6px 0 10px"}}>Vertragsdaten</div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
        <F label="Einheit" ch={<input style={inp} value={vf.einheit} onChange={e=>setVf(p=>({...p,einheit:e.target.value}))}/>}/>
        <F label="Kaution €" ch={<input type="number" style={inp} value={vf.kaution} onChange={e=>setVf(p=>({...p,kaution:e.target.value}))}/>}/>
        <F label="Wohnfläche m²" ch={<input type="number" style={inp} value={vf.qm||""} onChange={e=>setVf(p=>({...p,qm:e.target.value}))} placeholder="65"/>}/>
        <F label="Anzahl Zimmer" ch={<input type="number" style={inp} value={vf.zimmer||""} onChange={e=>setVf(p=>({...p,zimmer:e.target.value}))} placeholder="3" step="0.5"/>}/>
        <F label="Mietbeginn" ch={<input type="date" style={inp} value={vf.mietBeginn} onChange={e=>setVf(p=>({...p,mietBeginn:e.target.value}))}/>}/>
        <F label="Mietende (leer = unbefristet)" ch={<input type="date" style={inp} value={vf.mietEnde} onChange={e=>setVf(p=>({...p,mietEnde:e.target.value}))}/>}/>
        <F label="Kaltmiete €" ch={<input type="number" style={inp} value={vf.kaltmiete} onChange={e=>setVf(p=>({...p,kaltmiete:e.target.value}))}/>}/>
        <F label="Nebenkosten €" ch={<input type="number" style={inp} value={vf.nebenkosten} onChange={e=>setVf(p=>({...p,nebenkosten:e.target.value}))}/>}/>
        <F label="Stellplatz €" ch={<input type="number" style={inp} value={vf.stellplatz} onChange={e=>setVf(p=>({...p,stellplatz:e.target.value}))}/>}/>
        <F label="Küche €" ch={<input type="number" style={inp} value={vf.kueche} onChange={e=>setVf(p=>({...p,kueche:e.target.value}))}/>}/>
      </div>
      <div style={{display:"flex",alignItems:"center",gap:7,margin:"10px 0"}}>
        <input type="checkbox" id="kb2" checked={vf.kautionBezahlt} onChange={e=>setVf(p=>({...p,kautionBezahlt:e.target.checked}))}/>
        <label htmlFor="kb2" style={{color:C.muted,fontSize:13}}>Kaution vollständig bezahlt</label>
      </div>
      {(+(vf.kaltmiete)||0)+(+(vf.nebenkosten)||0)>0&&<div style={{background:C.card2,borderRadius:8,padding:"8px 12px",marginBottom:12,color:C.gT,fontWeight:700,fontSize:14}}>Warmmiete: {fmt((+(vf.kaltmiete)||0)+(+(vf.nebenkosten)||0)+(+(vf.stellplatz)||0)+(+(vf.kueche)||0))} €</div>}
      <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
        <button style={bS} onClick={cm}>Abbrechen</button>
        <button style={bP} onClick={()=>{
          upd("mieter",mm=>mm.map(m=>m.id===mi.id?{...m,...mf}:m));
          const mietEndeDate = vf.mietEnde ? new Date(vf.mietEnde) : null;
          const istAbgelaufen = mietEndeDate && mietEndeDate < new Date();
          upd("vertraege",vv=>vv.map(x=>x.id===v.id?{...x,...vf,aktiv:istAbgelaufen?false:x.aktiv}:x));
          // Offene Posten nach Auszugsdatum automatisch entfernen
          if(mietEndeDate) {
            upd("offenePosten",pp=>pp.filter(p=>{
              if(p.vertragsId!==v.id) return true;
              if(!p.faelligAm) return true;
              // Posten die nach dem Auszug fällig sind entfernen
              return new Date(p.faelligAm) <= mietEndeDate;
            }));
          }
          say("Gespeichert ✓");cm();
        }}>Speichern</button>
      </div>
    </Modal>;
  };

  const NeuerMieterModal = ({objektId}) => {
    const [modus, setModus] = useState("neu"); // "neu" oder "bestehend"
    const [mf,setMf] = useState({name:"",anrede:"Herr",email:"",telefon:"",nachsende:""});
    const [vf,setVf] = useState({einheit:"",kaltmiete:"",nebenkosten:"",stellplatz:"",kueche:"",mietBeginn:"",mietEnde:"",kaution:"",kautionBezahlt:false,qm:"",zimmer:""});
    const [selMieterId, setSelMieterId] = useState("");
    const total=(+(vf.kaltmiete)||0)+(+(vf.nebenkosten)||0)+(+(vf.stellplatz)||0)+(+(vf.kueche)||0);
    // Mieter die noch keinen aktiven Vertrag in diesem Objekt haben
    const verfügbareMieter = db.mieter.filter(m=>{
      const hatAktivenVertrag = db.vertraege.some(v=>v.mieterId===m.id&&v.aktiv&&v.objektId===objektId);
      return !hatAktivenVertrag;
    });
    return <Modal title="Neuer Mietvertrag" onClose={cm} w={600}>
      {/* Modus-Auswahl */}
      <div style={{display:"flex",gap:8,marginBottom:18}}>
        <button onClick={()=>setModus("neu")} style={{flex:1,padding:"10px",borderRadius:9,border:`2px solid ${modus==="neu"?C.blue:C.border}`,background:modus==="neu"?`${C.blue}15`:C.card2,cursor:"pointer",color:modus==="neu"?C.blue:C.muted,fontWeight:700,fontSize:13}}>
          ＋ Neuen Mieter anlegen
        </button>
        <button onClick={()=>setModus("bestehend")} style={{flex:1,padding:"10px",borderRadius:9,border:`2px solid ${modus==="bestehend"?C.blue:C.border}`,background:modus==="bestehend"?`${C.blue}15`:C.card2,cursor:"pointer",color:modus==="bestehend"?C.blue:C.muted,fontWeight:700,fontSize:13}}>
          👤 Bestehenden Mieter wählen
        </button>
      </div>

      {modus==="neu"?(
        <>
          <div style={{color:C.muted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:10}}>Mieterdaten</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 2fr",gap:10,marginBottom:10}}>
            <F label="Anrede" ch={<select style={inp} value={mf.anrede} onChange={e=>setMf(p=>({...p,anrede:e.target.value}))}><option>Herr</option><option>Frau</option><option>Familie</option><option>Divers</option></select>}/>
            <F label="Name" ch={<input style={inp} value={mf.name} onChange={e=>setMf(p=>({...p,name:e.target.value}))} placeholder="Vor- und Nachname"/>}/>
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:16}}>
            <F label="Telefon" ch={<input style={inp} value={mf.telefon} onChange={e=>setMf(p=>({...p,telefon:e.target.value}))} placeholder="0170 1234567"/>}/>
            <F label="E-Mail" ch={<input style={inp} value={mf.email} onChange={e=>setMf(p=>({...p,email:e.target.value}))} placeholder="email@beispiel.de"/>}/>
          </div>
        </>
      ):(
        <>
          <div style={{color:C.muted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:10}}>Mieter auswählen</div>
          {verfügbareMieter.length===0?(
            <div style={{background:C.y2,borderRadius:8,padding:"10px 14px",marginBottom:16,color:C.yT,fontSize:13}}>
              ⚠ Keine verfügbaren Mieter ohne aktiven Vertrag in diesem Objekt.
            </div>
          ):(
            <div style={{marginBottom:16}}>
              <select style={{...inp,marginBottom:0}} value={selMieterId} onChange={e=>setSelMieterId(e.target.value)}>
                <option value="">— Mieter auswählen —</option>
                {verfügbareMieter.map(m=><option key={m.id} value={m.id}>{m.name} ({m.anrede})</option>)}
              </select>
              {selMieterId&&(()=>{
                const m=db.mieter.find(x=>x.id===selMieterId);
                return m?(
                  <div style={{background:C.card2,borderRadius:8,padding:"8px 12px",marginTop:8,fontSize:12,color:C.muted}}>
                    {m.email&&<span>✉ {m.email} · </span>}
                    {m.telefon&&<span>📞 {m.telefon}</span>}
                  </div>
                ):null;
              })()}
            </div>
          )}
        </>
      )}

      <div style={{color:C.muted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:10}}>Vertragsdaten</div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
        <F label="Einheit" ch={
          <select style={inp} value={vf.einheit} onChange={e=>{
            const val = e.target.value;
            if(val && val!=="__neu") {
              const letzter = [...db.vertraege]
                .filter(x=>x.objektId===objektId&&x.einheit===val)
                .sort((a,b)=>new Date(b.mietBeginn||0)-new Date(a.mietBeginn||0))[0];
              if(letzter) {
                setVf(p=>({...p, einheit:val, einheitNeu:"",
                  qm: letzter.qm||p.qm,
                  zimmer: letzter.zimmer||p.zimmer,
                  kaltmiete: p.kaltmiete||letzter.kaltmiete||"",
                  nebenkosten: p.nebenkosten||letzter.nebenkosten||"",
                  stellplatz: p.stellplatz||letzter.stellplatz||"",
                  kueche: p.kueche||letzter.kueche||"",
                  kaution: p.kaution||letzter.kaution||"",
                })); return;
              }
            }
            setVf(p=>({...p,einheit:val==="__neu"?"":val,einheitNeu:""}));
          }}>            <option value="">— Einheit wählen —</option>
            {[...new Set(db.vertraege.filter(v=>v.objektId===objektId).map(v=>v.einheit).filter(Boolean))].map(e=>(
              <option key={e} value={e}>{e}</option>
            ))}
            <option value="__neu">+ Neue Einheit eingeben</option>
          </select>
        }/>
        {(vf.einheit===""&&vf.einheitNeu!==undefined||vf.einheit==="__neu")&&
          <F label="Neue Einheit" ch={<input style={inp} value={vf.einheitNeu||""} onChange={e=>setVf(p=>({...p,einheitNeu:e.target.value,einheit:"__neu"}))} placeholder="z.B. WE 3" autoFocus/>}/>
        }
        <F label="Kaution €" ch={<input type="number" style={inp} value={vf.kaution} onChange={e=>setVf(p=>({...p,kaution:e.target.value}))}/>}/>
        <F label="Wohnfläche m²" ch={<input type="number" style={inp} value={vf.qm||""} onChange={e=>setVf(p=>({...p,qm:e.target.value}))} placeholder="65"/>}/>
        <F label="Anzahl Zimmer" ch={<input type="number" style={inp} value={vf.zimmer||""} onChange={e=>setVf(p=>({...p,zimmer:e.target.value}))} placeholder="3" step="0.5"/>}/>
        <F label="Mietbeginn" ch={<input type="date" style={inp} value={vf.mietBeginn} onChange={e=>setVf(p=>({...p,mietBeginn:e.target.value}))}/>}/>
        <F label="Mietende (leer = unbefristet)" ch={<input type="date" style={inp} value={vf.mietEnde} onChange={e=>setVf(p=>({...p,mietEnde:e.target.value}))}/>}/>
        <F label="Kaltmiete €" ch={<input type="number" style={inp} value={vf.kaltmiete} onChange={e=>setVf(p=>({...p,kaltmiete:e.target.value}))}/>}/>
        <F label="Nebenkosten €" ch={<input type="number" style={inp} value={vf.nebenkosten} onChange={e=>setVf(p=>({...p,nebenkosten:e.target.value}))}/>}/>
        <F label="Stellplatz €" ch={<input type="number" style={inp} value={vf.stellplatz} onChange={e=>setVf(p=>({...p,stellplatz:e.target.value}))}/>}/>
        <F label="Küche €" ch={<input type="number" style={inp} value={vf.kueche} onChange={e=>setVf(p=>({...p,kueche:e.target.value}))}/>}/>
      </div>
      <div style={{display:"flex",alignItems:"center",gap:10,margin:"12px 0",background:vf.kautionBezahlt?C.g2:C.r2,borderRadius:9,padding:"10px 14px",border:`1px solid ${vf.kautionBezahlt?C.gT:C.rT}44`,cursor:"pointer"}}
        onClick={()=>setVf(p=>({...p,kautionBezahlt:!p.kautionBezahlt}))}>
        <div style={{width:40,height:22,borderRadius:11,background:vf.kautionBezahlt?C.gT:C.border,position:"relative",flexShrink:0,transition:"background .2s"}}>
          <div style={{position:"absolute",top:3,left:vf.kautionBezahlt?20:3,width:16,height:16,borderRadius:8,background:"#fff",transition:"left .2s"}}/>
        </div>
        <div>
          <div style={{color:vf.kautionBezahlt?C.gT:C.rT,fontWeight:700,fontSize:13}}>
            {vf.kautionBezahlt?"✓ Kaution vollständig bezahlt":"⚠ Kaution noch nicht bezahlt"}
          </div>
          {vf.kaution&&<div style={{color:C.muted,fontSize:11,marginTop:2}}>{fmt(vf.kaution)} € {vf.kautionBezahlt?"erhalten":"ausstehend"}</div>}
        </div>
      </div>
      {total>0&&<div style={{background:C.card2,borderRadius:8,padding:"8px 12px",marginBottom:12,color:C.gT,fontWeight:700,fontSize:14}}>Warmmiete: {fmt(total)} €</div>}
      <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
        <button style={bS} onClick={cm}>Abbrechen</button>
        <button style={bP} onClick={()=>{
          const einheit = vf.einheit==="__neu" ? vf.einheitNeu : vf.einheit;
          if(!einheit){say("Bitte Einheit eingeben");return;}
          const vfSave = {...vf, einheit};
          if(modus==="neu"){
            if(!mf.name){say("Bitte Name eingeben");return;}
            const newMieterId=uid();
            upd("mieter",mm=>[...mm,{...mf,id:newMieterId}]);
            upd("vertraege",vv=>[...vv,{...vfSave,id:uid(),objektId,mieterId:newMieterId,einzug:vfSave.mietBeginn||"",aktiv:true,kuendigung:null}]);
            say("Mieter & Vertrag angelegt ✓");
          } else {
            if(!selMieterId){say("Bitte Mieter auswählen");return;}
            upd("vertraege",vv=>[...vv,{...vfSave,id:uid(),objektId,mieterId:selMieterId,einzug:vfSave.mietBeginn||"",aktiv:true,kuendigung:null}]);
            say("Vertrag angelegt ✓");
          }
          cm();
        }}>Speichern</button>
      </div>
    </Modal>;
  };

  // ── MODALS ────────────────────────────────────────────────────────
  const UebergabeProtokollModal = ({v,mi,obj}) => {
    const [typ,setTyp] = useState("einzug");
    const RAEUME = ["Wohnzimmer","Schlafzimmer","Flur","Bad","Bad 2","WC","Küche","Zimmer 1","Zimmer 2","Zimmer 3","Zimmer 4","Zimmer 5","Abstellraum","Keller","Wintergarten/Balkon","Einbauküche"];
    const [raeumeStatus, setRaeumeStatus] = useState(Object.fromEntries(RAEUME.map(r=>[r,{ok:true,bemerkung:""}])));
    const zaehlerAusSystem = (db.zaehler||{})[v.objektId]?.[v.id] || {};
    const [zaehler, setZaehler] = useState({wasserKalt:zaehlerAusSystem.wasser||"",wasserWarm:"",wasserWaschma:"",strom:zaehlerAusSystem.strom||"",strom2:"",gas:zaehlerAusSystem.gas||"",wasserKalt2:"",wasserWarm2:"",nrWasserKalt:"",nrWasserWarm:"",nrStrom:"",nrStrom2:"",nrGas:""});
    const [schluessel, setSchluessel] = useState({haustuere:"2",wohnungstuere:"2",keller:"1",briefkasten:"1",zimmer:"0",garage:"0",fernbedienung:"0",sonstige:"0"});
    const [maengelVermieter, setMaengelVermieter] = useState("");
    const [maengelMieter, setMaengelMieter] = useState("");
    const [verzicht, setVerzicht] = useState(false);
    const [neueAnschrift, setNeueAnschrift] = useState("");
    const [datum, setDatum] = useState(new Date().toISOString().split("T")[0]);
    const abs = db.absender||{};
    return <Modal title="📋 Übergabeprotokoll" onClose={cm} w={680}>
        {/* Header */}
        <div style={{background:C.card2,borderRadius:9,padding:12,marginBottom:14,display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:8}}>
          <div>
            <strong style={{color:C.text}}>{mi?.name}</strong>
            <span style={{color:C.muted,fontSize:12}}> · {v.einheit} · {obj?.adresse}</span>
          </div>
          <input type="date" style={{...inp,width:"auto"}} value={datum} onChange={e=>setDatum(e.target.value)}/>
        </div>

        {/* Einzug / Auszug */}
        <div style={{display:"flex",gap:8,marginBottom:16}}>
          {["einzug","auszug"].map(tt=>(
            <button key={tt} onClick={()=>setTyp(tt)} style={{flex:1,padding:"10px",borderRadius:8,border:`2px solid ${typ===tt?C.blue:C.border}`,background:typ===tt?`${C.blue}15`:C.card2,cursor:"pointer",color:typ===tt?C.blue:C.muted,fontWeight:700,fontSize:13}}>
              {tt==="einzug"?"🔑 Einzug":"🚪 Auszug"}
            </button>
          ))}
        </div>

        {/* Räume */}
        <div style={{color:C.muted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:8}}>Räume</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6,marginBottom:16}}>
          {RAEUME.map(r=>{
            const s = raeumeStatus[r];
          return (
              <div key={r} style={{background:C.card2,borderRadius:8,padding:"8px 10px",border:`1px solid ${s.ok?C.border:C.rT+"44"}`}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:s.ok?0:6}}>
                  <span style={{color:C.text,fontSize:12,fontWeight:600}}>{r}</span>
                  <div style={{display:"flex",gap:6,alignItems:"center"}}>
                    <span style={{color:C.muted,fontSize:11}}>i.O.</span>
                    <div style={{width:36,height:20,borderRadius:10,background:s.ok?C.gT:C.border,cursor:"pointer",position:"relative",transition:"background .2s"}}
                      onClick={()=>setRaeumeStatus(p=>({...p,[r]:{...p[r],ok:!p[r].ok}}))}>
                      <div style={{position:"absolute",top:2,left:s.ok?18:2,width:16,height:16,borderRadius:8,background:"#fff",transition:"left .2s"}}/>
                    </div>
                  </div>
                </div>
                {!s.ok&&<input style={{...inp,fontSize:11,padding:"4px 8px"}} value={s.bemerkung} onChange={e=>setRaeumeStatus(p=>({...p,[r]:{...p[r],bemerkung:e.target.value}}))} placeholder="Bemerkung…"/>}
              </div>
            );
          })}
        </div>

        {/* Zählerstände */}
        <div style={{color:C.muted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:8}}>Zählerstände</div>
        <div style={{background:C.card2,borderRadius:9,padding:12,marginBottom:16,border:`1px solid ${C.border}`}}>
          {zaehlerAusSystem.strom&&<div style={{color:C.gT,fontSize:11,marginBottom:8}}>✓ Zählerstände aus System vorbelegt – bitte prüfen</div>}
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8}}>
            {[
              {l:"Wasser kalt",k:"wasserKalt",nr:"nrWasserKalt",ph:"m³"},
              {l:"Wasser warm",k:"wasserWarm",nr:"nrWasserWarm",ph:"m³"},
              {l:"Wasser Waschma.",k:"wasserWaschma",nr:null,ph:"m³"},
              {l:"Strom",k:"strom",nr:"nrStrom",ph:"kWh"},
              {l:"Strom 2",k:"strom2",nr:"nrStrom2",ph:"kWh"},
              {l:"Gas",k:"gas",nr:"nrGas",ph:"m³"},
            ].map(({l,k,nr,ph})=>(
              <div key={k}>
                <div style={{color:C.muted,fontSize:10,marginBottom:3}}>{l}</div>
                <input style={{...inp,fontSize:12,padding:"5px 8px",marginBottom:nr?3:0}} value={zaehler[k]} onChange={e=>setZaehler(p=>({...p,[k]:e.target.value}))} placeholder={ph}/>
                {nr&&<input style={{...inp,fontSize:10,padding:"3px 8px"}} value={zaehler[nr]} onChange={e=>setZaehler(p=>({...p,[nr]:e.target.value}))} placeholder="Zähler-Nr."/>}
              </div>
            ))}
          </div>
        </div>

        {/* Schlüssel */}
        <div style={{color:C.muted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:8}}>Schlüssel übergeben</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8,marginBottom:16}}>
          {[
            {l:"Haustür",k:"haustuere"},{l:"Wohnungstür",k:"wohnungstuere"},
            {l:"Keller",k:"keller"},{l:"Briefkasten",k:"briefkasten"},
            {l:"Zimmer",k:"zimmer"},{l:"Garage",k:"garage"},
            {l:"Fernbed. TG",k:"fernbedienung"},{l:"Sonstige",k:"sonstige"},
          ].map(({l,k})=>(
            <div key={k}>
              <div style={{color:C.muted,fontSize:10,marginBottom:3}}>{l}</div>
              <input type="number" min="0" style={{...inp,fontSize:13,padding:"5px 8px",textAlign:"center"}} value={schluessel[k]} onChange={e=>setSchluessel(p=>({...p,[k]:e.target.value}))}/>
            </div>
          ))}
        </div>

        {/* Mängel */}
        <div style={{color:C.muted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:8}}>Mängel</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:8}}>
          <F label="Vermieter beseitigt bis" ch={<input type="date" style={inp} value={maengelVermieter} onChange={e=>setMaengelVermieter(e.target.value)}/>}/>
          <F label="Mieter beseitigt bis" ch={<input type="date" style={inp} value={maengelMieter} onChange={e=>setMaengelMieter(e.target.value)}/>}/>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:16}}>
          <div style={{width:36,height:20,borderRadius:10,background:verzicht?C.gT:C.border,cursor:"pointer",position:"relative"}} onClick={()=>setVerzicht(p=>!p)}>
            <div style={{position:"absolute",top:2,left:verzicht?18:2,width:16,height:16,borderRadius:8,background:"#fff",transition:"left .2s"}}/>
          </div>
          <span style={{color:C.muted,fontSize:12}}>Auf Beseitigung der Mängel wird verzichtet</span>
        </div>

        {/* Neue Anschrift */}
        {typ==="auszug"&&<F label="Neue Anschrift des Mieters" ch={<input style={inp} value={neueAnschrift} onChange={e=>setNeueAnschrift(e.target.value)} placeholder="Straße, PLZ Ort"/>}/>}

        {/* Bestehende Protokolle */}
        <div style={{background:C.card2,borderRadius:9,padding:12,marginBottom:14,border:`1px solid ${C.border}`}}>
          <div style={{color:C.muted,fontSize:11,fontWeight:700,marginBottom:8}}>📎 Bestehende Protokolle hochladen</div>
          {(db.dateien||[]).filter(d=>d.mieterId===mi?.id&&d.typ_kat==="protokoll").map(d=>(
            <div key={d.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4,fontSize:12}}>
              <span style={{color:C.text}}>📋 {d.name}</span>
              <button style={{...bS,padding:"2px 8px",fontSize:11}} onClick={()=>{const a=document.createElement("a");a.href=d.data;a.download=d.name;a.click();}}>⬇</button>
            </div>
          ))}
          <label style={{...bS,cursor:"pointer",display:"inline-flex",alignItems:"center",gap:6,fontSize:12,marginTop:4}}>
            📎 Protokoll hochladen
            <input type="file" style={{display:"none"}} accept=".pdf,image/*"
              onChange={e=>{
                const file=e.target.files[0]; if(!file) return;
                const reader=new FileReader();
                reader.onload=ev=>{
                  upd("dateien",dd=>[...dd,{id:uid(),mieterId:mi?.id,name:file.name,typ:file.type,typ_kat:"protokoll",data:ev.target.result,datum:new Date().toISOString().split("T")[0]}]);
                  say("Protokoll gespeichert ✓");
                };
                reader.readAsDataURL(file);
              }}/>
          </label>
        </div>
        {/* Bestehendes Protokoll hochladen */}
        <div style={{background:C.card2,borderRadius:9,padding:12,marginBottom:14,border:`1px solid ${C.border}`}}>
          <div style={{color:C.muted,fontSize:12,fontWeight:700,marginBottom:8}}>📎 Bestehendes Protokoll hochladen</div>
          {(()=>{
            const vorhandene = (db.dateien||[]).filter(d=>d.mieterId===mi?.id&&d.typ_kat==="protokoll");
          return (<>
              {vorhandene.map(d=>(
                <div key={d.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4,fontSize:12}}>
                  <span style={{color:C.text}}>📋 {d.name}</span>
                  <button style={{...bS,padding:"2px 8px",fontSize:11}} onClick={()=>{const a=document.createElement("a");a.href=d.data;a.download=d.name;a.click();}}>⬇</button>
                </div>
              ))}
              <label style={{...bS,cursor:"pointer",display:"inline-flex",alignItems:"center",gap:6,fontSize:12}}>
                📎 Protokoll hochladen
                <input type="file" style={{display:"none"}} accept=".pdf,image/*"
                  onChange={e=>{
                    const file=e.target.files[0]; if(!file) return;
                    const reader=new FileReader();
                    reader.onload=ev=>{
                      upd("dateien",dd=>[...dd,{id:uid(),mieterId:mi?.id,name:file.name,typ:file.type,typ_kat:"protokoll",data:ev.target.result,datum:new Date().toISOString().split("T")[0]}]);
                      say("Protokoll gespeichert ✓");
                    };
                    reader.readAsDataURL(file);
                  }}/>
              </label>
            </>);
          })()}
        </div>

        <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:14}}>
          <button style={bS} onClick={cm}>Abbrechen</button>
          <button style={bP} onClick={exportProtokoll}>⬇ Exportieren & Speichern</button>
        </div>
      </Modal>;
  };

  const NkAbrechnungModal = ({v,mi,obj}) => {
    const [abrJahr,setAbrJahr] = useState(Y0-1);
    const nkVorausz = (parseFloat(v.nebenkosten)||0) * 12;
    const ausgabenNK = db.ausgaben.filter(a=>a.objektId===v.objektId&&a.steuerkat==="Umlagefähige Nebenkosten"&&new Date(a.datum).getFullYear()===abrJahr);
    const gesamtNK = ausgabenNK.reduce((s,a)=>s+parseFloat(a.betrag||0),0);
    const mieterAnteil = v.qm && db.vertraege.filter(x=>x.objektId===v.objektId&&x.aktiv&&!x.leerstand).reduce((s,x)=>s+(parseFloat(x.qm)||0),0) > 0
      ? (parseFloat(v.qm)/db.vertraege.filter(x=>x.objektId===v.objektId&&x.aktiv&&!x.leerstand).reduce((s,x)=>s+(parseFloat(x.qm)||0),0)) * gesamtNK
      : gesamtNK / Math.max(db.vertraege.filter(x=>x.objektId===v.objektId&&x.aktiv&&!x.leerstand).length, 1);
    const differenz = nkVorausz - mieterAnteil;
    return <Modal title="🧾 NK-Abrechnung" onClose={cm} w={540}>
        <div style={{background:C.card2,borderRadius:9,padding:12,marginBottom:14,fontSize:13}}>
          <strong style={{color:C.text}}>{mi?.name}</strong> · {v.einheit} · {obj?.adresse}
        </div>
        <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:16}}>
          <label style={{color:C.muted,fontSize:13}}>Abrechnungsjahr:</label>
          <select style={{...inp,width:"auto"}} value={abrJahr} onChange={e=>setAbrJahr(parseInt(e.target.value))}>
            {[Y0-2,Y0-1,Y0].map(j=><option key={j} value={j}>{j}</option>)}
          </select>
        </div>
        <div style={{background:C.card,borderRadius:9,border:`1px solid ${C.border}`,overflow:"hidden",marginBottom:14}}>
          <div style={{padding:"10px 14px",background:C.card2,borderBottom:`1px solid ${C.border}`,fontWeight:700,fontSize:12,color:C.muted}}>NEBENKOSTENABRECHNUNG {abrJahr}</div>
          <div style={{padding:"10px 14px",borderBottom:`1px solid ${C.border}`,display:"flex",justifyContent:"space-between",fontSize:13}}>
            <span style={{color:C.muted}}>Geleistete Vorauszahlungen</span>
            <span style={{color:C.text,fontWeight:600}}>{fmt(nkVorausz)} €</span>
          </div>
          {ausgabenNK.map((a,i)=>(
            <div key={i} style={{padding:"8px 14px",borderBottom:`1px solid ${C.border}`,display:"flex",justifyContent:"space-between",fontSize:12}}>
              <span style={{color:C.muted}}>{a.beschreibung} ({fmtD(a.datum)})</span>
              <span style={{color:C.rT}}>{fmt(a.betrag)} €</span>
            </div>
          ))}
          {ausgabenNK.length===0&&<div style={{padding:"10px 14px",color:C.muted,fontSize:12}}>Keine NK-Ausgaben für {abrJahr} erfasst</div>}
          <div style={{padding:"10px 14px",borderBottom:`1px solid ${C.border}`,display:"flex",justifyContent:"space-between",fontSize:13}}>
            <span style={{color:C.muted}}>Anteil Mieter ({v.qm||"gleich"}m²)</span>
            <span style={{color:C.rT,fontWeight:600}}>{fmt(mieterAnteil)} €</span>
          </div>
          <div style={{padding:"12px 14px",background:differenz>=0?C.g2:C.r2,display:"flex",justifyContent:"space-between",fontSize:14,fontWeight:800}}>
            <span style={{color:differenz>=0?C.gT:C.rT}}>{differenz>=0?"Guthaben Mieter":"Nachzahlung Mieter"}</span>
            <span style={{color:differenz>=0?C.gT:C.rT}}>{fmt(Math.abs(differenz))} €</span>
          </div>
        </div>
        <button style={{...bP,width:"100%",justifyContent:"center"}} onClick={()=>{
          const inhalt = `NEBENKOSTENABRECHNUNG ${abrJahr}
${"=".repeat(40)}

Mieter: ${mi?.name}
Einheit: ${v.einheit}
Objekt: ${obj?.adresse}

Geleistete Vorauszahlungen: ${fmt(nkVorausz)} €
Tatsächliche NK (Anteil): ${fmt(mieterAnteil)} €

${differenz>=0?"GUTHABEN: "+fmt(differenz)+" €\n(wird verrechnet/erstattet)":"NACHZAHLUNG: "+fmt(Math.abs(differenz))+" €\n(bitte überweisen)"}

${"─".repeat(40)}
Erstellt am: ${new Date().toLocaleDateString("de-DE")}`;
          const blob = new Blob([inhalt],{type:"text/plain;charset=utf-8"});
          const url = URL.createObjectURL(blob);
          const a=document.createElement("a");a.href=url;a.download=`NK_Abrechnung_${abrJahr}_${mi?.name?.replace(/\s/g,"_")}.txt`;a.click();
          URL.revokeObjectURL(url); say("NK-Abrechnung exportiert ✓");
        }}>⬇ Abrechnung exportieren</button>
      </Modal>;
  };

  const MieterPostenModal = ({v,mi}) => {
    const posten=db.offenePosten.filter(p=>p.vertragsId===v.id);
    const offen=posten.filter(p=>!p.bezahlt);
    const summeOffen=offen.reduce((s,p)=>s+parseFloat(p.betrag),0);
    const [editStates, setEditStates] = useState({});
    const [teilzForms, setTeilzForms] = useState({});
    const toggleEdit = (id) => setEditStates(p=>({...p,[id]:!p[id]}));
    const getTeilzForm = (id) => teilzForms[id]||{betrag:"",datum:new Date().toISOString().split("T")[0],notiz:""};
    const setTeilzForm = (id, val) => setTeilzForms(p=>({...p,[id]:typeof val==="function"?val(getTeilzForm(id)):val}));
    return <Modal title="Offene Posten" onClose={cm}>
        <div style={{background:C.card2,borderRadius:8,padding:11,marginBottom:14}}>
          <div style={{color:C.text,fontWeight:600}}>{mi?.name} · {v.einheit}</div>
          <div style={{color:C.muted,fontSize:12}}>{getOb(v.objektId)?.adresse}</div>
        </div>
        {posten.length===0?<p style={{color:C.muted,fontSize:14}}>Keine Posten für diesen Mieter.</p>:posten.map(p=>{
          const ueb=p.faelligAm&&new Date(p.faelligAm)<NOW&&!p.bezahlt;
          const teilz = p.teilzahlungen||[];
          const teilzSum = teilz.reduce((s,t)=>s+parseFloat(t.betrag||0),0);
          const restBetrag = parseFloat(p.betrag||0) - teilzSum;
        return (
            <div key={p.id} style={{background:p.bezahlt?C.g2:ueb?C.r2:C.card2,borderRadius:9,padding:"12px 14px",marginBottom:9,border:`1px solid ${p.bezahlt?C.gT+"33":ueb?C.rT+"44":C.border}`}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8}}>
                <div style={{flex:1}}>
                  {editStates[p.id]?(
                    <input style={{...inp,fontSize:13,marginBottom:4}} value={p.bezeichnung}
                      onChange={e=>upd("offenePosten",pp=>pp.map(x=>x.id===p.id?{...x,bezeichnung:e.target.value}:x))}/>
                  ):<div style={{color:C.text,fontWeight:600,fontSize:13}}>{p.bezeichnung}</div>}
                  <div style={{color:C.muted,fontSize:11,marginTop:2}}>
                    Fällig: {fmtD(p.faelligAm)}
                    {p.gemahnt&&` · Gemahnt ${fmtD(p.mahnDatum)}`}
                    {ueb&&<span style={{color:C.rT,fontWeight:600}}> · ÜBERFÄLLIG</span>}
                  </div>
                  {teilzSum>0&&(
                    <div style={{color:C.muted,fontSize:11,marginTop:3}}>
                      Teilzahlungen: {fmt(teilzSum)} € · Noch offen: <strong style={{color:restBetrag>0?C.rT:C.gT}}>{fmt(restBetrag)} €</strong>
                    </div>
                  )}
                </div>
                <div style={{display:"flex",gap:6,alignItems:"center",flexShrink:0,marginLeft:10}}>
                  {editStates[p.id]?(
                    <input type="number" style={{...inp,width:90,fontSize:13}} value={p.betrag}
                      onChange={e=>upd("offenePosten",pp=>pp.map(x=>x.id===p.id?{...x,betrag:e.target.value}:x))}/>
                  ):<span style={{color:p.bezahlt?C.gT:C.rT,fontWeight:700,fontSize:14}}>{fmt(p.bezahlt?p.betrag:restBetrag)} €</span>}
                  <button style={{background:"none",border:"none",color:C.muted,cursor:"pointer",fontSize:14,padding:"2px 4px"}} onClick={()=>toggleEdit(p.id)} title="Bearbeiten">✏️</button>
                </div>
              </div>

              {/* Teilzahlungen anzeigen */}
              {teilz.length>0&&(
                <div style={{marginBottom:8}}>
                  {teilz.map((t,ti)=>(
                    <div key={ti} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"4px 8px",background:C.card,borderRadius:6,marginBottom:3,fontSize:12}}>
                      <span style={{color:C.muted}}>{fmtD(t.datum)} {t.notiz&&`· ${t.notiz}`}</span>
                      <div style={{display:"flex",gap:6,alignItems:"center"}}>
                        <span style={{color:C.gT,fontWeight:600}}>+{fmt(t.betrag)} €</span>
                        <button style={{background:"none",border:"none",color:C.rT,cursor:"pointer",fontSize:11}} onClick={()=>upd("offenePosten",pp=>pp.map(x=>x.id===p.id?{...x,teilzahlungen:x.teilzahlungen.filter((_,i)=>i!==ti)}:x))}>✕</button>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* Teilzahlung hinzufügen */}
              {!p.bezahlt&&editStates[p.id]&&(
                <div style={{background:C.card,borderRadius:7,padding:"8px 10px",marginBottom:8,border:`1px solid ${C.border}`}}>
                  <div style={{color:C.muted,fontSize:11,fontWeight:700,marginBottom:6}}>Teilzahlung hinzufügen</div>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 2fr",gap:6,marginBottom:6}}>
                    <input type="number" style={{...inp,fontSize:12,padding:"5px 8px"}} value={getTeilzForm(p.id).betrag} onChange={e=>setTeilzForm(p.id,f=>({...f,betrag:e.target.value}))} placeholder="Betrag €"/>
                    <input type="date" style={{...inp,fontSize:12,padding:"5px 8px"}} value={getTeilzForm(p.id).datum} onChange={e=>setTeilzForm(p.id,f=>({...f,datum:e.target.value}))}/>
                    <input style={{...inp,fontSize:12,padding:"5px 8px"}} value={getTeilzForm(p.id).notiz} onChange={e=>setTeilzForm(p.id,f=>({...f,notiz:e.target.value}))} placeholder="Notiz"/>
                  </div>
                  <button style={{...bS,padding:"4px 10px",fontSize:11}} onClick={()=>{
                    const tf = getTeilzForm(p.id);
                    if(!tf.betrag){say("Betrag erforderlich");return;}
                    const neueT = [...teilz,{...tf,betrag:parseFloat(tf.betrag)}];
                    const neueSum = neueT.reduce((s,t)=>s+parseFloat(t.betrag||0),0);
                    const vollBezahlt = neueSum >= parseFloat(p.betrag||0);
                    upd("offenePosten",pp=>pp.map(x=>x.id===p.id?{...x,teilzahlungen:neueT,bezahlt:vollBezahlt}:x));
                    setTeilzForm(p.id,{betrag:"",datum:new Date().toISOString().split("T")[0],notiz:""});
                    say(vollBezahlt?"Vollständig bezahlt ✓":"Teilzahlung gespeichert ✓");
                  }}>＋ Teilzahlung speichern</button>
                </div>
              )}

              {/* Aktionen */}
              <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                {!p.bezahlt&&<button style={{...bP,padding:"4px 10px",fontSize:11}} onClick={()=>{upd("offenePosten",pp=>pp.map(x=>x.id===p.id?{...x,bezahlt:true,bezahltAm:new Date().toISOString().split("T")[0]}:x));say("Als bezahlt markiert ✓");}}>✓ Vollständig bezahlt</button>}
                {p.bezahlt&&<button style={{...bS,padding:"4px 10px",fontSize:11,color:C.yT}} onClick={()=>{upd("offenePosten",pp=>pp.map(x=>x.id===p.id?{...x,bezahlt:false,bezahltAm:null}:x));say("Als offen markiert");}}>↩ Als offen markieren</button>}
                {!p.bezahlt&&<button style={{...bS,padding:"4px 10px",fontSize:11,color:C.blue2}} onClick={()=>{
                  const restBetragRaten = restBetrag>0?restBetrag:parseFloat(p.betrag||0);
                  setModal({t:"neuerPlan", objektId:v.objektId, vorausfuellung:{
                    bezeichnung:p.bezeichnung, objektId:v.objektId, vertragsId:v.id,
                    richtung:"forderung", gesamtbetrag:String(restBetragRaten),
                  }});
                }}>📅 In Raten aufteilen</button>}
                <button style={{...bD,padding:"4px 10px",fontSize:11}} onClick={()=>{if(window.confirm("Posten löschen?"))upd("offenePosten",pp=>pp.filter(x=>x.id!==p.id));}}>🗑</button>
              </div>
            </div>
          );
        })}
        {offen.length>0&&<div style={{borderTop:`2px solid ${C.border}`,marginTop:8,paddingTop:10,display:"flex",justifyContent:"space-between"}}>
          <span style={{color:C.text,fontWeight:700}}>Summe offen</span>
          <span style={{color:C.rT,fontWeight:800,fontSize:16}}>{fmt(summeOffen)} €</span>
        </div>}
        <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:14}}>
          <button style={bS} onClick={()=>setModal({t:"posten",objektId:v.objektId})}>＋ Neuer Posten</button>
          <button style={bP} onClick={cm}>Schließen</button>
        </div>
      </Modal>;
  };

  const LeerstandModal = ({objektId}) => {
    const obj = db.objekte.find(o=>o.id===objektId);
    const letzterVertrag = [...db.vertraege].filter(v=>v.objektId===objektId&&!v.leerstand).sort((a,b)=>new Date(b.mietBeginn||0)-new Date(a.mietBeginn||0))[0];
    const [lf, setLf] = useState({einheit:letzterVertrag?.einheit||"",nebenkosten:String(letzterVertrag?.nebenkosten||""),beginn:new Date().toISOString().split("T")[0],notiz:""});
    return <Modal title="🏚 Leerstand eintragen" onClose={cm} w={500}>
        <div style={{background:C.y2,borderRadius:9,padding:"12px 14px",marginBottom:16,border:`1px solid ${C.yT}44`}}>
          <div style={{color:C.yT,fontWeight:700,fontSize:13,marginBottom:4}}>Leerstandskosten</div>
          <div style={{color:C.yT,fontSize:12}}>Die NK-Vorauszahlung wird als monatliche Ausgabe gebucht – so entsteht kein Rückstand bei den Nebenkosten.</div>
        </div>
        {letzterVertrag&&(
          <div style={{background:C.card2,borderRadius:9,padding:"10px 14px",marginBottom:16,fontSize:12,color:C.muted}}>
            <span style={{color:C.text,fontWeight:600}}>Vormieter: </span>
            {db.mieter.find(m=>m.id===letzterVertrag.mieterId)?.name||"Unbekannt"} ·
            NK-Vorauszahlung: <span style={{color:C.yT,fontWeight:700}}>{fmt(letzterVertrag.nebenkosten)} €/Monat</span>
          </div>
        )}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:12}}>
          <F label="Einheit" ch={
            <select style={inp} value={lf.einheit} onChange={e=>setLf(p=>({...p,einheit:e.target.value}))}>
              <option value="">— Einheit wählen —</option>
              {[...new Set(db.vertraege.filter(v=>v.objektId===objektId).map(v=>v.einheit).filter(Boolean))].map(e=>(
                <option key={e} value={e}>{e}</option>
              ))}
              <option value="__neu">+ Neue Einheit eingeben</option>
            </select>
          }/>
          {lf.einheit==="__neu"&&<F label="Einheit Name" ch={<input style={inp} value={lf.einheitNeu||""} onChange={e=>setLf(p=>({...p,einheitNeu:e.target.value}))} placeholder="z.B. WE 3" autoFocus/>}/>}
          <F label="Leerstand ab" ch={<input type="date" style={inp} value={lf.beginn} onChange={e=>setLf(p=>({...p,beginn:e.target.value}))}/>}/>
        </div>
        <F label="NK-Vorauszahlung pro Monat €" ch={
          <input type="number" style={inp} value={lf.nebenkosten}
            onChange={e=>setLf(p=>({...p,nebenkosten:e.target.value}))}
            placeholder="z.B. 120"/>
        }/>
        <div style={{color:C.muted,fontSize:11,marginTop:4,marginBottom:12}}>
          Automatisch vom Vormieter übernommen – kannst du anpassen
        </div>
        <F label="Notiz (optional)" ch={<input style={inp} value={lf.notiz} onChange={e=>setLf(p=>({...p,notiz:e.target.value}))} placeholder="z.B. Renovierung läuft"/>}/>
        <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:14}}>
          <button style={bS} onClick={cm}>Abbrechen</button>
          <button style={bP} onClick={()=>{
            const einheit = lf.einheit==="__neu" ? lf.einheitNeu : lf.einheit;
            if(!einheit||!lf.nebenkosten){say("Einheit und NK-Betrag erforderlich");return;}
            // Leerstand als speziellen Vertrag anlegen
            const lsId = uid();
            const lsMieterId = uid();
            // Pseudo-Mieter "Leerstand"
            upd("mieter",mm=>[...mm,{id:lsMieterId,name:"Leerstand",anrede:"",email:"",telefon:"",leerstand:true}]);
            upd("vertraege",vv=>[...vv,{
              id:lsId,
              objektId,
              mieterId:lsMieterId,
              einheit:einheit,
              kaltmiete:0,
              nebenkosten:parseFloat(lf.nebenkosten)||0,
              stellplatz:0,
              kueche:0,
              mietBeginn:lf.beginn,
              mietEnde:"",
              kaution:0,
              kautionBezahlt:false,
              aktiv:true,
              leerstand:true,
              notiz:lf.notiz,
            }]);
            // Monatliche Ausgabe für aktuelle + nächste Monate automatisch als offenen Posten anlegen
            const nk = parseFloat(lf.nebenkosten)||0;
            const heute = new Date(lf.beginn);
            const opEintraege = [];
            for(let i=0;i<3;i++){
              const d = new Date(heute.getFullYear(), heute.getMonth()+i, 1);
              opEintraege.push({
                id:uid(),
                objektId,
                vertragsId:lsId,
                bezeichnung:`Leerstand NK ${d.toLocaleString("de-DE",{month:"long",year:"numeric"})}`,
                betrag:nk,
                faelligAm:d.toISOString().split("T")[0],
                bezahlt:false,
                leerstandAusgabe:true,
                notiz:lf.notiz||"",
              });
            }
            upd("offenePosten",pp=>[...pp,...opEintraege]);
            say("Leerstand eingetragen ✓");
            cm();
          }}>🏚 Leerstand eintragen</button>
        </div>
      </Modal>;
  };

    const MieterhöhungModal = ({v,mi,obj,letzte}) => {
    const [neueKaltmiete,setNeueKaltmiete] = useState(String(v.kaltmiete||""));
    const [neueNebenkosten,setNeueNebenkosten] = useState(String(v.nebenkosten||""));
    const [datum,setDatum] = useState(new Date().toISOString().split("T")[0]);
    const vor36 = new Date(); vor36.setMonth(vor36.getMonth()-36);
    const frühere = (db.mieterhöhungen||[]).filter(m=>m.vertragsId===v.id&&new Date(m.datum)>=vor36).sort((a,b)=>new Date(a.datum)-new Date(b.datum));
    const basisMiete = frühere.length>0?parseFloat(frühere[0].alteMiete||v.kaltmiete):parseFloat(v.kaltmiete||0);
    const maxErhöhung = basisMiete*1.20;
    const neueZahl = parseFloat(neueKaltmiete||0);
    const steigerungProzent = basisMiete>0 ? (((neueZahl-basisMiete)/basisMiete)*100).toFixed(1) : "0";
    const überschreitet = neueZahl > maxErhöhung;
    const nkGeändert = parseFloat(neueNebenkosten||0) !== parseFloat(v.nebenkosten||0);
    return <Modal title="Miete ändern" onClose={cm} w={500}>
        <div style={{background:C.card2,borderRadius:9,padding:12,marginBottom:16}}>
          <div style={{color:C.text,fontSize:13,fontWeight:600}}>{mi?.name} – {v.einheit}</div>
          <div style={{color:C.muted,fontSize:12,marginTop:3}}>{obj?.adresse} · Aktuell: {fmt(v.kaltmiete)} € Kaltmiete + {fmt(v.nebenkosten)} € NK</div>
        </div>

        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:14}}>
          <div><label style={lbl}>Neue Kaltmiete €</label>
            <input type="number" style={inp} value={neueKaltmiete} onChange={e=>setNeueKaltmiete(e.target.value)} onWheel={e=>e.target.blur()} placeholder={String(v.kaltmiete)}/>
          </div>
          <div><label style={lbl}>Neue Nebenkosten €</label>
            <input type="number" style={inp} value={neueNebenkosten} onChange={e=>setNeueNebenkosten(e.target.value)} onWheel={e=>e.target.blur()} placeholder={String(v.nebenkosten)}/>
          </div>
          <div style={{gridColumn:"1/-1"}}><label style={lbl}>Wirksam ab</label>
            <input type="date" style={inp} value={datum} onChange={e=>setDatum(e.target.value)}/>
          </div>
        </div>

        {neueZahl>0&&neueZahl!==parseFloat(v.kaltmiete)&&(
          <div style={{background:überschreitet?C.r2:C.g2,border:`1px solid ${überschreitet?C.rT:C.gT}44`,borderRadius:9,padding:"12px 14px",marginBottom:14}}>
            <div style={{color:überschreitet?C.rT:C.gT,fontWeight:700,fontSize:13,marginBottom:6}}>
              {überschreitet?"⚠ Kappungsgrenze überschritten!":"✓ Innerhalb der Kappungsgrenze"}
            </div>
            <div style={{color:überschreitet?C.rT:C.gT,fontSize:12}}>
              Steigerung: {steigerungProzent}% · Max. erlaubt: 20% in 36 Monaten
            </div>
            <div style={{color:C.muted,fontSize:11,marginTop:4}}>
              Basis: {fmt(basisMiete)} € · Maximum: {fmt(maxErhöhung)} € · Neu: {fmt(neueZahl)} €
            </div>
          </div>
        )}

        {nkGeändert&&(
          <div style={{background:C.card2,borderRadius:8,padding:"10px 12px",marginBottom:14,fontSize:12,color:C.muted}}>
            Nebenkosten: {fmt(v.nebenkosten)} € → {fmt(neueNebenkosten)} € (keine Kappungsgrenze für NK-Anpassungen)
          </div>
        )}

        <div style={{background:C.y2,borderRadius:8,padding:"10px 12px",marginBottom:14,color:C.yT,fontSize:12}}>
          ℹ Bei Kaltmieterhöhung: frühestens 12 Monate nach der letzten Erhöhung, 3 Monate Bedenkzeit für den Mieter.
          Nebenkosten-Anpassungen (z.B. nach NK-Abrechnung) unterliegen keiner Kappungsgrenze.
        </div>

        <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
          <button style={bS} onClick={cm}>Abbrechen</button>
          <button style={{...bP,opacity:überschreitet?.6:1}} onClick={()=>{
            if(!neueKaltmiete){say("Bitte neue Kaltmiete eingeben");return;}
            const kaltmieteGeändert = neueZahl !== parseFloat(v.kaltmiete);
            if(kaltmieteGeändert){
              upd("mieterhöhungen",mm=>[...(mm||[]),{
                id:uid(),vertragsId:v.id,datum,
                alteMiete:v.kaltmiete,neueMiete:neueZahl,
                überschreitetKappung:überschreitet
              }]);
            }
            // Vertrag aktualisieren (Kaltmiete UND Nebenkosten)
            upd("vertraege",vv=>vv.map(x=>x.id===v.id?{...x,kaltmiete:neueZahl,nebenkosten:parseFloat(neueNebenkosten||0)}:x));
            say(überschreitet?"Miete angepasst (Kappungsgrenze beachten!) ⚠":"Miete angepasst ✓");
            cm();
          }}>{überschreitet?"Trotzdem speichern ⚠":"Speichern"}</button>
        </div>
      </Modal>;
  };
    const NeuerPlanModal = ({objektId, vorausfuellung}) => {
    const defEr = {typ: db.erinnerungsSettings?.typ||"dashboard", vorlauf: db.erinnerungsSettings?.vorlauf||3};
    const [pf,setPf] = useState({bezeichnung:"",objektId:db.objekte[0]?.id||"",vertragsId:"",richtung:"ausgabe",gesamtbetrag:"",kategorie:"Werbungskosten",erinTyp:defEr.typ,datei:null,dateiName:"",raten:[{id:uid(),betrag:"",datum:"",bezahlt:false,erinTyp:defEr.typ,vorlauf:defEr.vorlauf}],...vorausfuellung});
    const addRate = () => setPf(p=>({...p,raten:[...p.raten,{id:uid(),betrag:"",datum:"",bezahlt:false,erinTyp:defEr.typ,vorlauf:defEr.vorlauf}]}));
    const updRate = (i,feld,wert) => setPf(p=>({...p,raten:p.raten.map((r,ri)=>ri===i?{...r,[feld]:wert}:r)}));
    const gesamtRaten = pf.raten.reduce((s,r)=>s+(parseFloat(r.betrag)||0),0);
    const mieterDesObjekts = db.vertraege.filter(v=>v.objektId===pf.objektId&&v.aktiv&&!v.leerstand);
    return <Modal title="Neues Zahlungsziel" onClose={cm} w={600}>
        <div style={{display:"flex",gap:6,marginBottom:14}}>
          <button onClick={()=>setPf(p=>({...p,richtung:"ausgabe",vertragsId:""}))} style={{flex:1,padding:"8px",borderRadius:7,border:`2px solid ${pf.richtung==="ausgabe"?C.blue:C.border}`,background:pf.richtung==="ausgabe"?`${C.blue}12`:C.card2,color:pf.richtung==="ausgabe"?C.blue2:C.muted,fontWeight:600,fontSize:12,cursor:"pointer"}}>💸 Meine Ausgabe (Ratenzahlung)</button>
          <button onClick={()=>setPf(p=>({...p,richtung:"forderung"}))} style={{flex:1,padding:"8px",borderRadius:7,border:`2px solid ${pf.richtung==="forderung"?C.blue:C.border}`,background:pf.richtung==="forderung"?`${C.blue}12`:C.card2,color:pf.richtung==="forderung"?C.blue2:C.muted,fontWeight:600,fontSize:12,cursor:"pointer"}}>💰 Mieter-Ratenzahlung (Forderung)</button>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:14}}>
          <div style={{gridColumn:"1/-1"}}><label style={lbl}>Bezeichnung</label><input style={inp} value={pf.bezeichnung} onChange={e=>setPf(p=>({...p,bezeichnung:e.target.value}))} placeholder={pf.richtung==="forderung"?"z.B. Nachzahlung NK-Abrechnung":"z.B. Dachreparatur Rechnung"}/></div>
          <div><label style={lbl}>Objekt</label>
            <select style={inp} value={pf.objektId} onChange={e=>setPf(p=>({...p,objektId:e.target.value,vertragsId:""}))}>
              {db.objekte.map(o=><option key={o.id} value={o.id}>{o.adresse}</option>)}
            </select>
          </div>
          {pf.richtung==="forderung"?(
            <div><label style={lbl}>Mieter</label>
              <select style={inp} value={pf.vertragsId} onChange={e=>setPf(p=>({...p,vertragsId:e.target.value}))}>
                <option value="">— Mieter wählen —</option>
                {mieterDesObjekts.map(v=>{const mi=getMi(v.mieterId);return <option key={v.id} value={v.id}>{mi?.name} · {v.einheit}</option>;})}
              </select>
            </div>
          ):(
            <div><label style={lbl}>Kategorie</label>
              <select style={inp} value={pf.kategorie} onChange={e=>setPf(p=>({...p,kategorie:e.target.value}))}>
                <option>Werbungskosten</option>
                <option>Umlagefähige Nebenkosten</option>
                <option>Sonstiges</option>
              </select>
            </div>
          )}
          <div><label style={lbl}>Gesamtbetrag €</label><input type="number" style={inp} value={pf.gesamtbetrag} onChange={e=>setPf(p=>({...p,gesamtbetrag:e.target.value}))} placeholder="1500.00"/></div>
          <div><label style={lbl}>Rechnung hochladen</label>
            <label style={{...bS,cursor:"pointer",width:"100%",justifyContent:"center",boxSizing:"border-box"}}>
              {pf.dateiName||"📎 Datei wählen"}
              <input type="file" accept="image/*,.pdf" style={{display:"none"}} onChange={e=>{
                const f=e.target.files[0]; if(!f) return;
                const reader=new FileReader();
                reader.onload=ev=>setPf(p=>({...p,datei:ev.target.result,dateiName:f.name}));
                reader.readAsDataURL(f);
              }}/>
            </label>
          </div>
        </div>

        <div style={{color:C.muted,fontSize:11,fontWeight:700,textTransform:"uppercase",letterSpacing:1,marginBottom:10}}>Raten</div>
        {pf.raten.map((r,i)=>(
          <div key={r.id} style={{background:C.card2,borderRadius:9,padding:12,marginBottom:8,border:`1px solid ${C.border}`}}>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr auto",gap:8,marginBottom:8}}>
              <div><label style={lbl}>Betrag €</label><input type="number" style={inp} value={r.betrag} onChange={e=>updRate(i,"betrag",e.target.value)} placeholder="500.00"/></div>
              <div><label style={lbl}>Fällig am</label><input type="date" style={inp} value={r.datum} onChange={e=>updRate(i,"datum",e.target.value)}/></div>
              <div><label style={lbl}>Erinnerung</label>
                <select style={inp} value={r.erinTyp||defEr.typ} onChange={e=>updRate(i,"erinTyp",e.target.value)}>
                  <option value="dashboard">Dashboard</option>
                  <option value="email">E-Mail</option>
                  <option value="beide">Beide</option>
                  <option value="keine">Keine</option>
                </select>
              </div>
              <div style={{display:"flex",alignItems:"flex-end"}}>
                {pf.raten.length>1&&<button style={{...bD,padding:"9px 10px"}} onClick={()=>setPf(p=>({...p,raten:p.raten.filter((_,ri)=>ri!==i)}))}>🗑</button>}
              </div>
            </div>
            <div><label style={lbl}>Vorlauf</label>
              <select style={{...inp,width:"auto",fontSize:12}} value={r.vorlauf||defEr.vorlauf} onChange={e=>updRate(i,"vorlauf",parseInt(e.target.value))}>
                <option value={1}>1 Tag vorher</option>
                <option value={3}>3 Tage vorher</option>
              </select>
            </div>
          </div>
        ))}
        <button style={{...bS,marginBottom:14}} onClick={addRate}>＋ Rate hinzufügen</button>

        {pf.gesamtbetrag&&gesamtRaten>0&&(
          <div style={{background:Math.abs(gesamtRaten-parseFloat(pf.gesamtbetrag))>0.01?C.y2:C.g2,borderRadius:8,padding:"8px 12px",marginBottom:14,fontSize:12,color:Math.abs(gesamtRaten-parseFloat(pf.gesamtbetrag))>0.01?C.yT:C.gT}}>
            {Math.abs(gesamtRaten-parseFloat(pf.gesamtbetrag))>0.01
              ?`⚠ Raten (${fmt(gesamtRaten)} €) ≠ Gesamtbetrag (${fmt(pf.gesamtbetrag)} €)`
              :"✓ Raten stimmen mit Gesamtbetrag überein"}
          </div>
        )}

        <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
          <button style={bS} onClick={cm}>Abbrechen</button>
          <button style={bP} onClick={()=>{
            if(!pf.bezeichnung||!pf.gesamtbetrag){say("Bezeichnung und Betrag erforderlich");return;}
            if(pf.richtung==="forderung"&&!pf.vertragsId){say("Bitte Mieter auswählen");return;}
            upd("zahlungsplaene",pp=>[...(pp||[]),{...pf,id:uid(),erstellt:new Date().toISOString().split("T")[0]}]);
            say("Zahlungsziel angelegt ✓");cm();
          }}>Speichern</button>
        </div>
      </Modal>;
  };
    const NeueStundeModal = () => {
    const [sf, setSf] = useState({mitarbeiterId:"",objektId:"",datum:new Date().toISOString().split("T")[0],stunden:"8",beschreibung:""});
    return <Modal title="Stunden erfassen" onClose={cm}>
        <F label="Mitarbeiter" ch={<select style={inp} value={sf.mitarbeiterId} onChange={e=>setSf(p=>({...p,mitarbeiterId:e.target.value}))}>
          <option value="">— Mitarbeiter wählen —</option>
          {db.mitarbeiter.map(m=><option key={m.id} value={m.id}>{m.name}</option>)}
        </select>}/>
        <F label="Objekt (optional)" ch={<select style={inp} value={sf.objektId} onChange={e=>setSf(p=>({...p,objektId:e.target.value}))}>
          <option value="">— Kein Objekt —</option>
          {db.objekte.map(o=><option key={o.id} value={o.id}>{o.adresse}</option>)}
        </select>}/>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
          <F label="Datum" ch={<input type="date" style={inp} value={sf.datum} onChange={e=>setSf(p=>({...p,datum:e.target.value}))}/>}/>
          <F label="Stunden" ch={<input type="number" step="0.5" style={inp} value={sf.stunden} onChange={e=>setSf(p=>({...p,stunden:e.target.value}))} placeholder="8"/>}/>
        </div>
        <F label="Beschreibung (optional)" ch={<input style={inp} value={sf.beschreibung} onChange={e=>setSf(p=>({...p,beschreibung:e.target.value}))} placeholder="z.B. Reparatur Heizung, WE3"/>}/>
        <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
          <button style={bS} onClick={cm}>Abbrechen</button>
          <button style={bP} onClick={()=>{
            if(!sf.mitarbeiterId||!sf.stunden){say("Mitarbeiter und Stunden erforderlich");return;}
            upd("stundenzettel",ss=>[...(ss||[]),{...sf,id:uid()}]);
            say("Stunden gespeichert ✓");cm();
          }}>✓ Speichern</button>
        </div>
      </Modal>;
  };

  const renderModal = () => {
    if(!modal) return null;
    const {t} = modal;
    if(t==="objekt"||t==="editObjekt") {
      const init=t==="editObjekt"?{strasse:modal.obj.strasse||"",plz:modal.obj.plz||"",stadt:modal.obj.stadt||""}:{strasse:"",plz:"",stadt:""};
      return <ModalForm title={t==="objekt"?"Neues Objekt":"Objekt bearbeiten"} init={init}
        fields={[{k:"strasse",l:"Straße & Hausnummer",ph:"Musterstraße 1"},{k:"plz",l:"PLZ",ph:"12345"},{k:"stadt",l:"Stadt",ph:"Musterstadt"}]}
        onSave={f=>{const adresse=`${f.strasse}, ${f.plz} ${f.stadt}`.replace(/^, | $/g,"").trim();const obj={...f,adresse,name:adresse};t==="objekt"?upd("objekte",oo=>[...oo,{...obj,id:uid()}]):upd("objekte",oo=>oo.map(o=>o.id===modal.obj.id?{...o,...obj}:o));say("Gespeichert ✓");}}/>;
    }
    if(t==="vertrag") {
      return <VertragModal objektId={modal.objektId}/>;
    }
    if(t==="zahlung") {
      const v=modal.v;
      return <ZahlungModal v={v}/>;
    }
    if(t==="zahlDetail") {
      const {z,v}=modal;
      const soll=warmmiete(v);
      return <Modal title="Zahlungsdetails" onClose={cm}>
        <div style={{background:C.card2,borderRadius:8,padding:11,marginBottom:14}}>
          <div style={{color:C.text,fontWeight:600}}>{getMi(v.mieterId)?.name} · {v.einheit}</div>
          <div style={{color:C.muted,fontSize:12}}>{z.monat}</div>
        </div>
        {[{l:"Kaltmiete",val:v.kaltmiete,c:C.blue},{l:"Nebenkosten",val:v.nebenkosten,c:C.pT},{l:"Stellplatz",val:v.stellplatz,c:C.yT},{l:"Küche",val:v.kueche,c:C.gT}].filter(r=>parseFloat(r.val)>0).map((r,i)=>(
          <div key={i} style={{display:"flex",justifyContent:"space-between",padding:"8px 0",borderBottom:`1px solid ${C.border}`}}>
            <span style={{color:C.text,fontSize:14,display:"flex",alignItems:"center",gap:7}}><span style={{width:8,height:8,borderRadius:"50%",background:r.c,display:"inline-block"}}/>{r.l}</span>
            <span style={{color:r.c,fontWeight:700,fontSize:14}}>{fmt(r.val)} €</span>
          </div>
        ))}
        <div style={{display:"flex",justifyContent:"space-between",padding:"10px 0 4px",borderTop:`2px solid ${C.border}`,marginTop:4}}>
          <span style={{color:C.text,fontWeight:700}}>Warmmiete gesamt</span>
          <span style={{color:C.gT,fontWeight:800,fontSize:16}}>{fmt(soll)} €</span>
        </div>
        <div style={{background:C.g2,borderRadius:9,padding:"11px 14px",marginTop:12,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div><div style={{color:C.gT,fontSize:12,marginBottom:2}}>✓ Eingegangen</div><div style={{color:C.text,fontWeight:700,fontSize:16}}>{fmt(z.betrag)} €</div></div>
          <div style={{textAlign:"right"}}><div style={{color:C.muted,fontSize:12}}>Datum</div><div style={{color:C.text,fontSize:14,fontWeight:600}}>{fmtD(z.datum)}</div></div>
        </div>
        <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:14}}>
          <button style={{...bD,fontSize:13}} onClick={()=>{upd("zahlungen",zz=>zz.filter(x=>x.id!==z.id));say("Gelöscht");cm();}}>🗑 Löschen</button>
          <button style={bS} onClick={cm}>Schließen</button>
        </div>
      </Modal>;
    }
    if(t==="posten") {
      return <PostenModal objektId={modal.objektId}/>;
    }
    if(t==="ausgabe") {
      return <AusgabeModal objektId={modal.objektId} bearbeiten={modal.bearbeiten}/>;
    }
    if(t==="mahnung") {
      const p=modal.p; const vt=p.vertragsId?getVt(p.vertragsId):null; const mi=vt?getMi(vt.mieterId):null;
      const txt=`Sehr geehrte/r ${mi?.name||"Mieter/in"},\n\nhiermit weisen wir Sie auf folgenden offenen Betrag hin:\n\nBetreff: ${p.bezeichnung}\nBetrag: ${fmt(p.betrag)} €\nFällig seit: ${fmtD(p.faelligAm)}\nObjekt: ${getOb(p.objektId)?.name}\n\nBitte überweisen Sie den Betrag bis zum [Frist].\n\nMit freundlichen Grüßen`;
      return <MahnungModal p={p} txt={txt}/>;
    }
    if(t==="mietvertragPDF") {
      const {v,mi,obj} = modal;
      const abs = db.absender||{};
      const muster = db.musterMietvertrag || null;
      return <Modal title="📄 Mietvertrag" onClose={cm} w={560}>
        <div style={{background:C.card2,borderRadius:9,padding:14,marginBottom:16,fontSize:13,color:C.muted}}>
          Mietvertrag für <strong style={{color:C.text}}>{mi?.name}</strong> · {v.einheit} · {obj?.adresse}
        </div>

        {/* Bestehenden Mietvertrag hochladen */}
        <div style={{background:C.card2,borderRadius:9,padding:14,marginBottom:14,border:`1px solid ${C.border}`}}>
          <div style={{color:C.text,fontWeight:700,fontSize:13,marginBottom:10}}>📎 Bestehenden Mietvertrag hochladen</div>
          {(()=>{
            const vorhandene = db.dateien.filter(d=>d.mieterId===mi?.id&&d.typ_kat==="mietvertrag");
            return (<>
              {vorhandene.length>0&&vorhandene.map(d=>(
                <div key={d.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"6px 0",borderBottom:`1px solid ${C.border}`,fontSize:12}}>
                  <span style={{color:C.text}}>📄 {d.name}</span>
                  <div style={{display:"flex",gap:6}}>
                    <button style={{...bS,padding:"3px 8px",fontSize:11}} onClick={()=>{const a=document.createElement("a");a.href=d.data;a.download=d.name;a.click();}}>⬇</button>
                    <button style={{...bD,padding:"3px 8px",fontSize:11}} onClick={()=>{upd("dateien",dd=>dd.filter(x=>x.id!==d.id));say("Gelöscht");}}>🗑</button>
                  </div>
                </div>
              ))}
              <label style={{...bS,cursor:"pointer",marginTop:8,display:"inline-flex",alignItems:"center",gap:6}}>
                📎 Datei hochladen (PDF, Bild)
                <input type="file" style={{display:"none"}} accept=".pdf,image/*"
                  onChange={e=>{
                    const file=e.target.files[0]; if(!file) return;
                    const reader=new FileReader();
                    reader.onload=ev=>{
                      upd("dateien",dd=>[...dd,{id:uid(),mieterId:mi?.id,name:file.name,typ:file.type,typ_kat:"mietvertrag",data:ev.target.result,datum:new Date().toISOString().split("T")[0]}]);
                      say("Mietvertrag gespeichert ✓");
                    };
                    reader.readAsDataURL(file);
                  }}/>
              </label>
              {muster&&<label style={{...bS,cursor:"pointer",marginTop:8,marginLeft:8,display:"inline-flex",alignItems:"center",gap:6}}>
                📋 Muster verwenden
                <input type="hidden"/>
              </label>}
            </>);
          })()}
        </div>

        <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginBottom:16}}>
          <button style={bP} onClick={()=>{
            const inhalt = `MIETVERTRAG
${"=".repeat(50)}

ZWISCHEN

Vermieter:
${abs.name||"[Vermieter]"}
${abs.strasse||""}
${abs.ort||""}

UND

Mieter:
${mi?.name}

WIRD FOLGENDER MIETVERTRAG GESCHLOSSEN:

§ 1 MIETOBJEKT
Das Mietobjekt befindet sich in: ${obj?.adresse}
Mieteinheit: ${v.einheit}
Wohnfläche: ${v.qm||"k.A."} m²
Anzahl Zimmer: ${v.zimmer||"k.A."}

§ 2 MIETDAUER
Mietbeginn: ${fmtD(v.mietBeginn)}
${v.mietEnde?"Mietende: "+fmtD(v.mietEnde):"Unbefristetes Mietverhältnis"}

§ 3 MIETE
Kaltmiete: ${fmt(v.kaltmiete)} € / Monat
Nebenkosten (Vorauszahlung): ${fmt(v.nebenkosten)} € / Monat
${v.stellplatz>0?"Stellplatz: "+fmt(v.stellplatz)+" € / Monat\n":""}${v.kueche>0?"Küche: "+fmt(v.kueche)+" € / Monat\n":""}Gesamtmiete (Warmmiete): ${fmt(warmmiete(v))} € / Monat

§ 4 KAUTION
Mietkaution: ${fmt(v.kaution)} €
${v.kautionBezahlt?"Die Kaution wurde vollständig bezahlt.":"Die Kaution ist bei Einzug zu zahlen."}

§ 5 UNTERSCHRIFTEN

Ort, Datum: ________________________

Vermieter: ________________________

Mieter: ________________________`;
            const blob = new Blob([inhalt],{type:"text/plain;charset=utf-8"});
            const url = URL.createObjectURL(blob);
            const a=document.createElement("a");a.href=url;a.download=`Mietvertrag_${mi?.name?.replace(/\s/g,"_")}_${v.einheit}.txt`;a.click();
            URL.revokeObjectURL(url); say("Mietvertrag exportiert ✓");
          }}>⬇ Als Text exportieren</button>
        </div>
        <div style={{background:C.bg,borderRadius:9,padding:16,fontSize:12,color:C.text,lineHeight:1.7,whiteSpace:"pre-wrap",maxHeight:360,overflowY:"auto",fontFamily:"monospace"}}>
{`MIETVERTRAG
${"=".repeat(40)}

VERMIETER: ${abs.name||"[Vermieter]"}, ${abs.strasse||""}, ${abs.ort||""}

MIETER: ${mi?.name}

§ 1 MIETOBJEKT
Adresse: ${obj?.adresse}
Einheit: ${v.einheit}  |  Fläche: ${v.qm||"k.A."} m²  |  Zimmer: ${v.zimmer||"k.A."}

§ 2 MIETDAUER
Beginn: ${fmtD(v.mietBeginn)}  |  ${v.mietEnde?"Ende: "+fmtD(v.mietEnde):"Unbefristet"}

§ 3 MIETE
Kaltmiete: ${fmt(v.kaltmiete)} €  |  NK: ${fmt(v.nebenkosten)} €  |  Gesamt: ${fmt(warmmiete(v))} €

§ 4 KAUTION
${fmt(v.kaution)} € – ${v.kautionBezahlt?"bezahlt ✓":"ausstehend"}

${"─".repeat(40)}
Ort/Datum: ____________  Vermieter: ____________  Mieter: ____________`}
        </div>
      </Modal>;
    }

    if(t==="uebergabeProtokoll") {
      const {v,mi,obj} = modal;
      return <UebergabeProtokollModal v={v} mi={mi} obj={obj}/>;
    }

    if(t==="nkAbrechnung") {
      const {v,mi,obj} = modal;
      return <NkAbrechnungModal v={v} mi={mi} obj={obj}/>;
    }

    if(t==="leerstand") {
      const {objektId} = modal;
      return <LeerstandModal objektId={objektId}/>;
    }

    if(t==="neuerMieter") {
      return <NeuerMieterModal objektId={modal.objektId}/>;
    }
    if(t==="editMieterVertrag") {
      return <EditMieterVertragModal v={modal.v} mi={modal.mi}/>;
    }
    if(t==="frist") {
      return <FristModal v={modal.v}/>;
    }
    if(t==="mieterhöhung") {
      const {v,mi,obj,letzte}=modal;
      return <MieterhöhungModal v={v} mi={mi} obj={obj} letzte={letzte}/>;
    }

    if(t==="neuerPlan") {
      return <NeuerPlanModal objektId={modal.objektId} vorausfuellung={modal.vorausfuellung}/>;
    }

    if(t==="neueStunde") {
      return <NeueStundeModal/>;
    }

    if(t==="mieterLoeschen") {
      const {v,mi} = modal;
      return <Modal title="Mieter löschen" onClose={cm}>
        <div style={{textAlign:"center",padding:"10px 0"}}>
          <div style={{fontSize:48,marginBottom:16}}>⚠️</div>
          <p style={{color:C.text,fontSize:16,fontWeight:700,marginBottom:8}}>Wirklich löschen?</p>
          <p style={{color:C.muted,fontSize:14,marginBottom:6}}><strong>{mi?.name}</strong></p>
          <p style={{color:C.muted,fontSize:13,marginBottom:20}}>{v.einheit} · Einzug: {fmtD(v.einzug)}</p>
          <div style={{background:C.r2,borderRadius:9,padding:"12px 16px",marginBottom:20,textAlign:"left"}}>
            <p style={{color:C.rT,fontSize:13,fontWeight:600,marginBottom:4}}>Dies wird unwiderruflich gelöscht:</p>
            <ul style={{color:C.rT,fontSize:13,marginLeft:16}}>
              <li>Mietvertrag und alle Vertragsdaten</li>
              <li>Zugehörige Zahlungshistorie</li>
              <li>Hochgeladene Dokumente</li>
            </ul>
          </div>
          <div style={{display:"flex",gap:10,justifyContent:"center"}}>
            <button style={{...bS,padding:"10px 20px",fontSize:14}} onClick={cm}>Abbrechen</button>
            <button style={{background:C.rT,border:"none",color:"#fff",borderRadius:8,padding:"10px 20px",cursor:"pointer",fontSize:14,fontWeight:700}} onClick={()=>{
              upd("vertraege",vv=>vv.filter(x=>x.id!==v.id));
              upd("zahlungen",zz=>zz.filter(z=>z.vertragsId!==v.id));
              upd("dateien",dd=>dd.filter(d=>d.mieterId!==mi?.id));
              say("Mieter gelöscht");cm();
            }}>Ja, endgültig löschen</button>
          </div>
        </div>
      </Modal>;
    }
    if(t==="mieterPosten") {
      const {v,mi}=modal;
      return <MieterPostenModal v={v} mi={mi}/>;
    }

    return null;
  };

  // Sub-Modals als reine Funktionskomponenten außerhalb
  const ModalForm = ({title,init,fields,onSave}) => {
    const [f,setF] = useState(init);
    return <Modal title={title} onClose={cm}>
      {fields.map(x=><F key={x.k} label={x.l} ch={<input style={inp} value={f[x.k]||""} onChange={e=>setF(p=>({...p,[x.k]:e.target.value}))} placeholder={x.ph}/>}/>)}
      <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}><button style={bS} onClick={cm}>Abbrechen</button><button style={bP} onClick={()=>{onSave(f);cm();}}>Speichern</button></div>
    </Modal>;
  };
  const VertragModal = ({objektId}) => {
    const [f,setF] = useState({objektId:objektId||"",mieterId:"",einheit:"",kaltmiete:"",nebenkosten:"",stellplatz:"",kueche:"",einzug:"",kaution:"",kautionBezahlt:false});
    const total=(+(f.kaltmiete)||0)+(+(f.nebenkosten)||0)+(+(f.stellplatz)||0)+(+(f.kueche)||0);
    return <Modal title="Neuer Mietvertrag" onClose={cm} w={600}>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
        <F label="Objekt" ch={<select style={inp} value={f.objektId} onChange={e=>setF(p=>({...p,objektId:e.target.value}))}><option value="">—</option>{db.objekte.map(o=><option key={o.id} value={o.id}>{o.name}</option>)}</select>}/>
        <F label="Mieter" ch={<select style={inp} value={f.mieterId} onChange={e=>setF(p=>({...p,mieterId:e.target.value}))}><option value="">—</option>{db.mieter.map(m=><option key={m.id} value={m.id}>{m.name}</option>)}</select>}/>
        <F label="Einheit" ch={<input style={inp} value={f.einheit} onChange={e=>setF(p=>({...p,einheit:e.target.value}))} placeholder="WE 3"/>}/>
        <F label="Einzug" ch={<input type="date" style={inp} value={f.einzug} onChange={e=>setF(p=>({...p,einzug:e.target.value}))}/>}/>
        <F label="Kaltmiete €" ch={<input type="number" style={inp} value={f.kaltmiete} onChange={e=>setF(p=>({...p,kaltmiete:e.target.value}))}/>}/>
        <F label="Nebenkosten €" ch={<input type="number" style={inp} value={f.nebenkosten} onChange={e=>setF(p=>({...p,nebenkosten:e.target.value}))}/>}/>
        <F label="Stellplatz €" ch={<input type="number" style={inp} value={f.stellplatz} onChange={e=>setF(p=>({...p,stellplatz:e.target.value}))}/>}/>
        <F label="Küche €" ch={<input type="number" style={inp} value={f.kueche} onChange={e=>setF(p=>({...p,kueche:e.target.value}))}/>}/>
        <F label="Kaution €" ch={<input type="number" style={inp} value={f.kaution} onChange={e=>setF(p=>({...p,kaution:e.target.value}))}/>}/>
        <div style={{display:"flex",alignItems:"center",gap:7,paddingTop:16}}><input type="checkbox" checked={f.kautionBezahlt} onChange={e=>setF(p=>({...p,kautionBezahlt:e.target.checked}))}/><label style={{color:C.muted,fontSize:13}}>Kaution bezahlt</label></div>
      </div>
      {total>0&&<div style={{background:C.card2,borderRadius:8,padding:"9px 13px",margin:"10px 0",color:C.gT,fontWeight:700}}>Warmmiete: {fmt(total)} €</div>}
      <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:4}}><button style={bS} onClick={cm}>Abbrechen</button><button style={bP} onClick={()=>{upd("vertraege",vv=>[...vv,{...f,id:uid(),aktiv:true,kuendigung:null}]);say("Angelegt ✓");cm();}}>Speichern</button></div>
    </Modal>;
  };
  const ZahlungModal = ({v}) => {
    const zm0 = modal.m ?? monat; // 0-basiert (von monate12 und monat state)
    const zy = modal.y || jahr;
    const heute = new Date();
    // 3. Werktag des Zielmonats als Standard-Datum
    const dritterWerktag = nterWerktag(3, zm0, zy);
    const defaultDatum = dritterWerktag.toISOString().split("T")[0];
    const [f,setF] = useState({betrag:String(anteiligeMiete(v, zm0, zy)),datum:defaultDatum,notiz:""});
    const istAnteilig = anteiligeMiete(v, zm0, zy) !== warmmiete(v);
    const zielMonat = new Date(zy, zm0, 1).toLocaleString("de-DE",{month:"long",year:"numeric"});
    const istNachtrag = zm0 !== heute.getMonth() || zy !== heute.getFullYear();
    return <Modal title="Zahlung erfassen" onClose={cm}>
      <div style={{background:C.card2,borderRadius:8,padding:11,marginBottom:14}}>
        <div style={{color:C.text,fontWeight:600}}>{getMi(v.mieterId)?.name}</div>
        <div style={{color:C.muted,fontSize:12}}>Soll: {fmt(warmmiete(v))} € · {zielMonat}</div>
      </div>
      {istNachtrag?<div style={{background:C.y2,borderRadius:7,padding:"8px 12px",marginBottom:12,color:C.yT,fontSize:12}}>⚠ Nachträgliche Zahlung für <strong>{zielMonat}</strong></div>:null}
      {istAnteilig?<div style={{background:C.card2,borderRadius:7,padding:"8px 12px",marginBottom:12,color:C.muted,fontSize:12}}>ℹ Anteiliger Betrag für {zielMonat} (Ein-/Auszug mitten im Monat) – volle Warmmiete wäre {fmt(warmmiete(v))} €</div>:null}
      <F label="Betrag €" ch={<input type="number" style={inp} value={f.betrag} onChange={e=>setF(p=>({...p,betrag:e.target.value}))}/>}/>
      <F label="Eingangsdatum" ch={<input type="date" style={inp} value={f.datum} onChange={e=>setF(p=>({...p,datum:e.target.value}))}/>}/>
      <F label="Notiz" ch={<input style={inp} value={f.notiz} onChange={e=>setF(p=>({...p,notiz:e.target.value}))} placeholder="Optional"/>}/>
      <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
        <button style={bS} onClick={cm}>Abbrechen</button>
        <button style={bP} onClick={()=>{
          upd("zahlungen",zz=>[...zz,{...f,id:uid(),vertragsId:v.id,monat:mk(zm0,zy)}]);
          say(`Zahlung für ${zielMonat} erfasst ✓`);
          cm();
        }}>Speichern</button>
      </div>
    </Modal>;
  };
  const PostenModal = ({objektId}) => {
    const [f,setF] = useState({bezeichnung:"",betrag:"",faelligAm:"",vertragsId:"",erinnerungEmail:false});
    const vv=db.vertraege.filter(v=>v.objektId===objektId&&v.aktiv);
    return <Modal title="Offener Posten" onClose={cm}>
      <F label="Mieter/Vertrag" ch={<select style={inp} value={f.vertragsId} onChange={e=>setF(p=>({...p,vertragsId:e.target.value}))}><option value="">— Allgemein —</option>{vv.map(v=><option key={v.id} value={v.id}>{getMi(v.mieterId)?.name} ({v.einheit})</option>)}</select>}/>
      <F label="Bezeichnung" ch={<input style={inp} value={f.bezeichnung} onChange={e=>setF(p=>({...p,bezeichnung:e.target.value}))} placeholder="z.B. NK-Nachzahlung 2024"/>}/>
      <F label="Betrag €" ch={<input type="number" style={inp} value={f.betrag} onChange={e=>setF(p=>({...p,betrag:e.target.value}))}/>}/>
      <F label="Fällig am" ch={<input type="date" style={inp} value={f.faelligAm} onChange={e=>setF(p=>({...p,faelligAm:e.target.value}))}/>}/>
      <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:14,padding:"10px 12px",background:C.card2,borderRadius:8,border:`1px solid ${C.border}`}}>
        <input type="checkbox" id="erinnerung_email" checked={f.erinnerungEmail} onChange={e=>setF(p=>({...p,erinnerungEmail:e.target.checked}))} style={{cursor:"pointer",width:16,height:16}}/>
        <label htmlFor="erinnerung_email" style={{color:C.text,fontSize:13,cursor:"pointer"}}>
          E-Mail-Erinnerung am Fälligkeitstag senden
        </label>
        {f.erinnerungEmail&&!db.erinnerungsSettings?.email&&(
          <span style={{color:C.yT,fontSize:11}}>⚠ Keine E-Mail in Einstellungen hinterlegt</span>
        )}
      </div>
      <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
        <button style={bS} onClick={cm}>Abbrechen</button>
        <button style={bP} onClick={()=>{
          upd("offenePosten",pp=>[...pp,{...f,id:uid(),objektId,bezahlt:false,gemahnt:false,mahnDatum:null}]);
          say("Angelegt ✓");cm();
        }}>Speichern</button>
      </div>
    </Modal>;
  };
  const AusgabeModal = ({objektId, bearbeiten}) => {
    const [f,setF] = useState(bearbeiten
      ? {kategorie:bearbeiten.kategorie||"Reparatur",steuerkat:bearbeiten.steuerkat||"Sonstiges",beschreibung:bearbeiten.beschreibung||"",betrag:String(bearbeiten.betrag||""),datum:bearbeiten.datum||new Date().toISOString().split("T")[0],rechnungNr:bearbeiten.rechnungNr||"",intervall:bearbeiten.intervall||"einmalig"}
      : {kategorie:"Reparatur",steuerkat:"Sonstiges",beschreibung:"",betrag:"",datum:new Date().toISOString().split("T")[0],rechnungNr:"",intervall:"einmalig"});
    const handleBeschreibung = (val) => {
      const erkannt = autoErkenne(val);
      setF(p=>({...p,beschreibung:val,steuerkat:erkannt.steuerkat,kategorie:erkannt.kategorie}));
    };
    const perioden = {monatlich:12, quartalsweise:4, halbjaehrlich:2, jaehrlich:1}[f.intervall];
    return <Modal title={bearbeiten?"Ausgabe bearbeiten":"Ausgabe manuell erfassen"} onClose={cm} w={560}>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10}}>
        <F label="Kategorie" ch={<select style={inp} value={f.kategorie} onChange={e=>setF(p=>({...p,kategorie:e.target.value}))}>{["Reparatur","Instandhaltung","Versicherung","Verwaltung","Betriebskosten","Grundsteuer","Straßenreinigung","Müllabfuhr","Sonstiges"].map(k=><option key={k}>{k}</option>)}</select>}/>
        <F label="Rechnungs-Nr." ch={<input style={inp} value={f.rechnungNr} onChange={e=>setF(p=>({...p,rechnungNr:e.target.value}))}/>}/>
        <F label="Betrag € (Gesamtbetrag der Rechnung)" ch={<input type="number" style={inp} value={f.betrag} onChange={e=>setF(p=>({...p,betrag:e.target.value}))}/>}/>
        <F label="Datum (erste Fälligkeit)" ch={<input type="date" style={inp} value={f.datum} onChange={e=>setF(p=>({...p,datum:e.target.value}))}/>}/>
        <div style={{gridColumn:"1/-1"}}><label style={lbl}>Zahlungsintervall</label>
          <select style={inp} value={f.intervall} onChange={e=>setF(p=>({...p,intervall:e.target.value}))}>
            <option value="einmalig">Einmalig (kompletter Betrag am Datum)</option>
            <option value="monatlich">Monatlich (auf 12 Raten verteilt)</option>
            <option value="quartalsweise">Quartalsweise (auf 4 Raten verteilt)</option>
            <option value="halbjaehrlich">Halbjährlich (auf 2 Raten verteilt)</option>
            <option value="jaehrlich">Jährlich (einmal pro Jahr)</option>
          </select>
        </div>
      </div>
      {f.intervall!=="einmalig"&&f.betrag>0&&(
        <div style={{background:C.card2,borderRadius:8,padding:"8px 12px",marginBottom:10,fontSize:12,color:C.muted}}>
          ℹ Wird automatisch verteilt: <strong style={{color:C.text}}>{fmt(parseFloat(f.betrag)/perioden)} €</strong> pro Rate ({perioden}× im Jahr), beginnend ab {fmtD(f.datum)}
        </div>
      )}
      <F label="Beschreibung (Auto-Erkennung aktiv)" ch={<input style={inp} value={f.beschreibung} onChange={e=>handleBeschreibung(e.target.value)} placeholder="z.B. Heizungswartung – Kategorie wird automatisch erkannt"/>}/>
      {f.beschreibung&&<div style={{background:C.card2,borderRadius:7,padding:"7px 12px",marginBottom:10,display:"flex",gap:8,alignItems:"center"}}>
        <Bdg col={f.steuerkat==="Umlagefähige Nebenkosten"?"green":f.steuerkat==="Werbungskosten"?"blue":"yellow"} ch={f.steuerkat}/>
        <span style={{color:C.muted,fontSize:12}}>automatisch erkannt · klicke unten zum Ändern</span>
      </div>}
      <div style={{display:"flex",gap:6,marginBottom:14}}>
        {["Umlagefähige Nebenkosten","Werbungskosten","Sonstiges"].map(s=>(
          <button key={s} onClick={()=>setF(p=>({...p,steuerkat:s}))} style={{flex:1,padding:"6px",borderRadius:7,border:`2px solid ${f.steuerkat===s?C.blue:C.border}`,background:f.steuerkat===s?`${C.blue}12`:C.card2,color:f.steuerkat===s?C.blue2:C.muted,fontWeight:600,fontSize:11,cursor:"pointer"}}>{s}</button>
        ))}
      </div>
      <div style={{display:"flex",gap:8,justifyContent:"space-between"}}>
        {bearbeiten&&<button style={bD} onClick={()=>{if(window.confirm("Ausgabe wirklich löschen?")){upd("ausgaben",aa=>aa.filter(x=>x.id!==bearbeiten.id));say("Gelöscht");cm();}}}>🗑 Löschen</button>}
        <div style={{display:"flex",gap:8,marginLeft:"auto"}}>
          <button style={bS} onClick={cm}>Abbrechen</button>
          <button style={bP} onClick={()=>{
            if(!f.betrag||!f.beschreibung){say("Bitte Betrag und Beschreibung ausfüllen");return;}
            if(bearbeiten){
              upd("ausgaben",aa=>aa.map(x=>x.id===bearbeiten.id?{...x,...f}:x));
              say("Aktualisiert ✓");
            } else {
              upd("ausgaben",aa=>[...aa,{...f,id:uid(),objektId}]);
              say("Gespeichert ✓");
            }
            cm();
          }}>Speichern</button>
        </div>
      </div>
    </Modal>;
  };
  const MahnungModal = ({p}) => {
    const vt = p.vertragsId ? db.vertraege.find(v=>v.id===p.vertragsId) : null;
    const mi = vt ? db.mieter.find(m=>m.id===vt.mieterId) : null;
    const obj = db.objekte.find(o=>o.id===p.objektId);
    const aktStufe = p.mahnStufe||0;
    const naechsteStufe = Math.min(aktStufe+1, 3);
    const heute = new Date().toLocaleDateString("de-DE");
    const frist14 = new Date(); frist14.setDate(frist14.getDate()+14);
    const fristStr = frist14.toLocaleDateString("de-DE");
    const absender = db.absender?.name||"ImManager";
    // Verzugszinsen berechnen
    const basiszins = db.erinnerungsSettings?.basiszins ?? 2.62;
    const verzugszins = basiszins + 5;
    const tageFällig = p.faelligAm ? Math.max(0, Math.ceil((new Date()-new Date(p.faelligAm))/(1000*60*60*24))) : 0;
    const zinsbetrag = tageFällig>0 ? (parseFloat(p.betrag||0) * (verzugszins/100) * tageFällig/365) : 0;
    const mahnkosten = db.erinnerungsSettings?.mahnkosten || {1:0,2:5,3:10};

    const mahnTexte = {
      1: `Sehr geehrte/r ${mi?.anrede||""} ${mi?.name||"Mieter/in"},

wir möchten Sie freundlich daran erinnern, dass folgender Betrag noch aussteht:

Betreff: ${p.bezeichnung}
Hauptforderung: ${fmt(p.betrag)} €
Fällig seit: ${fmtD(p.faelligAm)}
Objekt: ${obj?.adresse||""}${mahnkosten[1]>0?`
Mahnkosten: ${fmt(mahnkosten[1])} €`:""}${zinsbetrag>0?`
Verzugszinsen (${verzugszins.toFixed(2)}% p.a., ${tageFällig} Tage): ${zinsbetrag.toFixed(2)} €`:""}
${(mahnkosten[1]>0||zinsbetrag>0)?`
Gesamtforderung: ${fmt(parseFloat(p.betrag||0)+mahnkosten[1]+zinsbetrag)} €
`:""}
Bitte überweisen Sie den ausstehenden Betrag innerhalb der nächsten 14 Tage bis zum ${fristStr}.

Sollte die Zahlung bereits erfolgt sein, betrachten Sie dieses Schreiben bitte als gegenstandslos.

Mit freundlichen Grüßen
${absender}`,
      2: `Sehr geehrte/r ${mi?.anrede||""} ${mi?.name||"Mieter/in"},

trotz unserer Zahlungserinnerung ist folgender Betrag noch nicht bei uns eingegangen:

Betreff: ${p.bezeichnung}
Hauptforderung: ${fmt(p.betrag)} €
Fällig seit: ${fmtD(p.faelligAm)}
Objekt: ${obj?.adresse||""}
Mahnkosten: ${fmt(mahnkosten[2])} €
Verzugszinsen (${verzugszins.toFixed(2)}% p.a., ${tageFällig} Tage): ${zinsbetrag.toFixed(2)} €
Gesamtforderung: ${fmt(parseFloat(p.betrag||0)+mahnkosten[2]+zinsbetrag)} €

Wir fordern Sie hiermit auf, den Gesamtbetrag bis spätestens ${fristStr} zu begleichen.

Bei Nichtbeachtung behalten wir uns rechtliche Schritte vor.

Mit freundlichen Grüßen
${absender}`,
      3: `Sehr geehrte/r ${mi?.anrede||""} ${mi?.name||"Mieter/in"},

leider haben Sie trotz mehrfacher Aufforderung folgenden Betrag nicht beglichen:

Betreff: ${p.bezeichnung}
Hauptforderung: ${fmt(p.betrag)} €
Fällig seit: ${fmtD(p.faelligAm)}
Objekt: ${obj?.adresse||""}
Mahnkosten: ${fmt(mahnkosten[3])} €
Verzugszinsen (${verzugszins.toFixed(2)}% p.a., ${tageFällig} Tage): ${zinsbetrag.toFixed(2)} €
Gesamtforderung: ${fmt(parseFloat(p.betrag||0)+mahnkosten[3]+zinsbetrag)} €

Dies ist unsere letzte Mahnung. Sollte der Gesamtbetrag nicht bis zum ${fristStr} vollständig eingegangen sein, werden wir ohne weitere Ankündigung rechtliche Schritte einleiten.

Mit freundlichen Grüßen
${absender}`,
    };

    const stufeInfo = {
      1: {label:"Zahlungserinnerung", col:"yellow", icon:"📋"},
      2: {label:"1. Mahnung", col:"orange", icon:"⚠️"},
      3: {label:"Letzte Mahnung", col:"red", icon:"🚨"},
    };

    const [tx, setTx] = useState(mahnTexte[naechsteStufe]||mahnTexte[1]);
    const [stufe, setStufe] = useState(naechsteStufe);

    return <Modal title="Mahnungs-Assistent" onClose={cm} w={580}>
      {/* Mieter Info */}
      <div style={{background:C.card2,borderRadius:9,padding:"10px 14px",marginBottom:14,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div>
          <div style={{color:C.text,fontWeight:600,fontSize:13}}>{mi?.name||"Allgemein"} · {fmt(p.betrag)} €</div>
          <div style={{color:C.muted,fontSize:11}}>Fällig: {fmtD(p.faelligAm)} · {obj?.adresse}</div>
        </div>
        {aktStufe>0&&<Bdg col={aktStufe>=3?"red":"yellow"} ch={`Mahnstufe ${aktStufe}`}/>}
      </div>

      {/* Mahnstufen Auswahl */}
      <div style={{marginBottom:14}}>
        <label style={lbl}>Mahnstufe wählen</label>
        <div style={{display:"flex",gap:8}}>
          {[1,2,3].map(s=>(
            <button key={s} onClick={()=>{setStufe(s);setTx(mahnTexte[s]);}}
              style={{flex:1,padding:"10px 8px",borderRadius:9,border:`2px solid ${stufe===s?C.blue:C.border}`,background:stufe===s?`${C.blue}15`:C.card2,cursor:"pointer",textAlign:"center"}}>
              <div style={{fontSize:16}}>{stufeInfo[s].icon}</div>
              <div style={{color:stufe===s?C.blue:C.text,fontWeight:700,fontSize:12,marginTop:3}}>{stufeInfo[s].label}</div>
              {s<=aktStufe&&<div style={{color:C.gT,fontSize:10,marginTop:2}}>✓ bereits versendet</div>}
            </button>
          ))}
        </div>
      </div>

      {/* Text Editor */}
      <F label="Text (bearbeiten)" ch={<textarea style={{...inp,minHeight:220,fontSize:12,lineHeight:1.6,resize:"vertical",fontFamily:"monospace"}} value={tx} onChange={e=>setTx(e.target.value)}/>}/>

      {/* Buttons */}
      <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:4}}>
        <button style={bS} onClick={()=>navigator.clipboard?.writeText(tx).then(()=>say("Text kopiert ✓"))}>📋 Kopieren</button>
        <button style={bS} onClick={cm}>Abbrechen</button>
        <button style={bP} onClick={async()=>{
          const heute2 = new Date().toISOString().split("T")[0];
          upd("offenePosten",pp=>pp.map(x=>x.id===p.id?{...x,gemahnt:true,mahnDatum:heute2,mahnStufe:stufe}:x));
          if(mi?.email){
            try{
              await fetch("/api/email",{method:"POST",headers:{"Content-Type":"application/json",Authorization:`Bearer ${token}`},
                body:JSON.stringify({
                  to:mi.email, toName:mi.name,
                  subject:`${stufeInfo[stufe].label}: ${p.bezeichnung} – ${fmt(p.betrag)} €`,
                  text:tx
                })});
              say(`Mahnstufe ${stufe} gespeichert & E-Mail gesendet ✓`);
            }catch(e){say(`Mahnstufe ${stufe} gespeichert (E-Mail fehlgeschlagen)`);}
          } else {
            say(`Mahnstufe ${stufe} gespeichert ✓ (keine E-Mail-Adresse hinterlegt)`);
          }
          cm();
        }}>✓ Mahnstufe {stufe} speichern & E-Mail senden</button>
      </div>
    </Modal>;
  };
  const FristModal = ({v}) => {
    const [kd,setKd] = useState(v.kuendigung||"");
    const az=auszugDatum(kd);
    return <Modal title="Kündigungsfrist" onClose={cm}>
      <div style={{background:C.card2,borderRadius:8,padding:11,marginBottom:14}}><div style={{color:C.text,fontWeight:600}}>{getMi(v.mieterId)?.name}</div><div style={{color:C.muted,fontSize:12}}>{v.einheit}</div></div>
      <F label="Kündigungsdatum (Eingang)" ch={<input type="date" style={inp} value={kd} onChange={e=>setKd(e.target.value)}/>}/>
      {az&&<div style={{background:C.y2,border:`1px solid ${C.yT}33`,borderRadius:9,padding:14,margin:"10px 0"}}><div style={{color:C.yT,fontSize:11,marginBottom:3}}>FRÜHESTES AUSZUGSDATUM</div><div style={{color:C.text,fontSize:22,fontWeight:800}}>{fmtD(az)}</div></div>}
      <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}><button style={bS} onClick={cm}>Schließen</button>{kd&&<button style={bP} onClick={()=>{upd("vertraege",vv=>vv.map(x=>x.id===v.id?{...x,kuendigung:kd}:x));say("Gespeichert ✓");cm();}}>Speichern</button>}</div>
    </Modal>;
  };

  // ── RENDER ────────────────────────────────────────────────────────
  const navItems=[{id:"dashboard",l:"Dashboard",e:"🏠"},{id:"brief",l:"Brief schreiben",e:"✉️"},{id:"finanzen",l:"Finanzen & Steuer",e:"📊"},{id:"mitarbeiter",l:"Mitarbeiter",e:"👷"},{id:"einstellungen",l:"Einstellungen",e:"⚙️"}];
  if(user?.role==="admin") navItems.push({id:"benutzer",l:"Benutzerverwaltung",e:"👤"});
  // Mitarbeiter nur Aufgaben + Stundenzettel sehen
  const visibleNavItems = user?.role==="mitarbeiter" ? [{id:"mitarbeiter",l:"Aufgaben",e:"👷"},{id:"einstellungen",l:"Einstellungen",e:"⚙️"}] : navItems;

  // Login Screen
  if (!geladen) return <div style={{display:"flex",alignItems:"center",justifyContent:"center",height:"100dvh",minHeight:"-webkit-fill-available",maxHeight:"100dvh",background:C.bg}}><div style={{color:C.text,fontSize:16}}>Lädt…</div></div>;

  // ── 2FA Code eingeben Screen ──
  if (twoFAState) return (
    <div style={{display:"flex",alignItems:"center",justifyContent:"center",height:"100dvh",minHeight:"-webkit-fill-available",background:"linear-gradient(135deg,#0a0a0a,#1a1a1a)",fontFamily:"'Segoe UI',system-ui,sans-serif"}}>
      <div style={{background:"#1a1a1a",borderRadius:16,padding:40,width:360,border:"1px solid #333",boxShadow:"0 20px 60px rgba(0,0,0,.5)",textAlign:"center"}}>
        <div style={{fontSize:48,marginBottom:16}}>🔐</div>
        <h2 style={{color:"#fff",fontSize:20,fontWeight:800,marginBottom:8}}>Zwei-Faktor-Authentifizierung</h2>
        <p style={{color:"#666",fontSize:13,marginBottom:24}}>Gib den 6-stelligen Code aus deiner Authenticator-App ein</p>
        <input style={{background:"#111",border:"1px solid #444",borderRadius:8,color:"#fff",padding:"14px",fontSize:22,width:"100%",textAlign:"center",letterSpacing:8,outline:"none",boxSizing:"border-box",marginBottom:12}}
          type="text" inputMode="numeric" maxLength={6} value={twoFACode}
          onChange={e=>setTwoFACode(e.target.value.replace(/\D/g,""))}
          onKeyDown={e=>e.key==="Enter"&&doVerify2FA()} autoFocus placeholder="000000"/>
        {twoFAError&&<div style={{background:"#2a1010",borderRadius:7,padding:"8px",color:"#ff6b6b",fontSize:13,marginBottom:12}}>{twoFAError}</div>}
        <div style={{marginBottom:14,textAlign:"left"}}>
          <div style={{color:"#666",fontSize:11,marginBottom:6}}>Dieses Gerät merken für:</div>
          <div style={{display:"flex",gap:6}}>
            {[{d:0,l:"Nicht merken"},{d:7,l:"7 Tage"},{d:14,l:"14 Tage"},{d:30,l:"30 Tage"}].map(({d,l})=>(
              <button key={d} onClick={()=>setTrustDays(d)} style={{flex:1,padding:"7px 4px",borderRadius:7,border:`1px solid ${trustDays===d?"#6366f1":"#333"}`,background:trustDays===d?"#6366f115":"#111",color:trustDays===d?"#818cf8":"#555",cursor:"pointer",fontSize:11,fontWeight:trustDays===d?700:400}}>{l}</button>
            ))}
          </div>
        </div>
        <button style={{width:"100%",background:"linear-gradient(135deg,#3d6494,#2e5280)",border:"none",color:"#fff",borderRadius:8,padding:"12px",cursor:"pointer",fontSize:15,fontWeight:700,marginBottom:10}}
          onClick={doVerify2FA}>✓ Bestätigen</button>
        <p style={{color:"#444",fontSize:11,marginTop:8}}>Handy verloren? Backup-Code eingeben statt 6-stelliger Code</p>
        <button style={{background:"none",border:"none",color:"#555",cursor:"pointer",fontSize:12,marginTop:4}} onClick={()=>{setTwoFAState(null);setTwoFACode("");setTwoFAError("");}}>← Zurück zum Login</button>
      </div>
    </div>
  );

  if (!user) return (
    <div style={{display:"flex",alignItems:"center",justifyContent:"center",height:"100dvh",minHeight:"-webkit-fill-available",background:`linear-gradient(135deg,${C.bg},${C.card})`,paddingTop:"env(safe-area-inset-top)",paddingBottom:"env(safe-area-inset-bottom)",fontFamily:"'Segoe UI',system-ui,sans-serif"}}>
      <div style={{background:C.card,borderRadius:16,padding:40,width:380,border:`1px solid ${C.border}`,boxShadow:"0 20px 60px rgba(0,0,0,.5)"}}>
        <div style={{textAlign:"center",marginBottom:32}}>
          <img src={LOGO_URL} alt="ImManager" style={{width:72,height:72,borderRadius:14,margin:"0 auto 14px",display:"block"}}/>
          <h1 style={{color:"#fff",fontSize:22,fontWeight:800,margin:0}}>ImManager</h1>
          <p style={{color:"#666",fontSize:13,marginTop:6}}>Immobilienverwaltung</p>
        </div>
        <div style={{marginBottom:14}}>
          <label style={lbl}>E-Mail</label>
          <input style={{...inp,padding:"11px 14px",fontSize:14}}
            type="email" value={loginForm.email} onChange={e=>setLoginForm(f=>({...f,email:e.target.value}))}
            onKeyDown={e=>e.key==="Enter"&&doLogin()} placeholder="email@beispiel.de" autoFocus/>
        </div>
        <div style={{marginBottom:20}}>
          <label style={lbl}>Passwort</label>
          <input style={{...inp,padding:"11px 14px",fontSize:14}}
            type="password" value={loginForm.password} onChange={e=>setLoginForm(f=>({...f,password:e.target.value}))}
            onKeyDown={e=>e.key==="Enter"&&doLogin()} placeholder="••••••••"/>
        </div>
        {loginForm.error&&<div style={{background:C.r2,border:`1px solid ${C.rT}44`,borderRadius:8,padding:"10px 14px",color:C.rT,fontSize:13,marginBottom:14}}>{loginForm.error}</div>}
        <button style={{width:"100%",background:`linear-gradient(135deg,${C.blue},${C.blue2})`,border:"none",color:"#fff",borderRadius:8,padding:"12px",cursor:"pointer",fontSize:15,fontWeight:700}}
          onClick={doLogin} disabled={loginForm.loading}>
          {loginForm.loading?"Einloggen…":"Einloggen"}
        </button>
        <p style={{color:C.muted,fontSize:11,textAlign:"center",marginTop:20}}>ImManager · Sichere Immobilienverwaltung</p>
      </div>
    </div>
  );

  return (
    <div style={{display:"flex",flexDirection:isMobile?"column":"row",height:"100dvh",minHeight:"-webkit-fill-available",maxHeight:"100dvh",background:C.bg,fontFamily:"'Segoe UI',system-ui,sans-serif",color:C.text,paddingTop:isMobile?"env(safe-area-inset-top)":0}}>
      {/* DESKTOP SIDEBAR */}
      {!isMobile&&<div style={{width:sidebar?210:54,minWidth:sidebar?210:54,background:C.bg,borderRight:`1px solid ${C.border}`,display:"flex",flexDirection:"column",transition:"width .2s,min-width .2s",overflow:"hidden"}}>
        <div style={{padding:"16px 13px",borderBottom:`1px solid ${C.border}`,display:"flex",alignItems:"center",gap:9}}>
          <img src={LOGO_URL} alt="ImManager" style={{width:30,height:30,borderRadius:7,flexShrink:0}}/>
          {sidebar&&<span style={{color:C.text,fontWeight:800,fontSize:13,whiteSpace:"nowrap"}}>ImManager</span>}
        </div>
        <div style={{flex:1,paddingTop:6}}>
          {visibleNavItems.map(item=>(
            <button key={item.id} onClick={()=>{setNav(item.id);setSelObj(null);localStorage.removeItem("immo_selObj");}} style={{width:"100%",background:nav===item.id&&!selObj?`${C.blue}18`:"none",border:"none",borderLeft:`3px solid ${nav===item.id&&!selObj?C.blue:"transparent"}`,color:nav===item.id&&!selObj?C.blue2:C.muted,display:"flex",alignItems:"center",gap:10,padding:"10px 13px",cursor:"pointer",fontSize:13,fontWeight:700,textAlign:"left"}}>
              <span style={{fontSize:15,flexShrink:0}}>{item.e}</span>
              {sidebar&&<span style={{whiteSpace:"nowrap"}}>{item.l}</span>}
            </button>
          ))}
        </div>
        <div style={{padding:9,borderTop:`1px solid ${C.border}`,display:"flex",flexDirection:"column",gap:6}}>
          {sidebar&&<a href="/datenschutz" target="_blank" style={{color:C.muted,fontSize:10,textAlign:"center",textDecoration:"none",padding:"2px 0"}}>Datenschutz</a>}
          {sidebar&&user&&<div style={{padding:"6px 8px",borderRadius:7,background:C.card2}}>
            <div style={{color:C.text,fontSize:12,fontWeight:600,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{user.name||user.email}</div>
            <div style={{color:C.muted,fontSize:10}}>{user.role==="admin"?"Administrator":"Benutzer"}</div>
          </div>}
          {sidebar&&<button onClick={doLogout} style={{...bS,width:"100%",justifyContent:"center",padding:"6px",fontSize:12,color:C.rT,borderColor:C.rT+"44"}}>⏻ Abmelden</button>}
          <button onClick={()=>setSidebar(p=>!p)} style={{...bS,width:"100%",justifyContent:"center",padding:"7px"}}>{sidebar?"◀":"▶"}</button>
        </div>
      </div>}

      {/* MOBILE BOTTOM NAV */}
      {isMobile&&(
        <div style={{position:"fixed",bottom:0,left:0,right:0,background:C.card,borderTop:`1px solid ${C.border}`,display:"flex",zIndex:100,paddingBottom:"max(env(safe-area-inset-bottom),8px)",boxShadow:"0 -1px 0 rgba(255,255,255,.08)",backdropFilter:"blur(20px)",WebkitBackdropFilter:"blur(20px)"}}>
          {visibleNavItems.slice(0,4).map(item=>(
            <button key={item.id} onClick={()=>{setNav(item.id);setSelObj(null);localStorage.removeItem("immo_selObj");}}
              style={{flex:1,background:"none",border:"none",padding:"8px 2px 4px",cursor:"pointer",display:"flex",flexDirection:"column",alignItems:"center",gap:2}}>
              <span style={{fontSize:22,opacity:nav===item.id&&!selObj?1:.45,filter:nav===item.id&&!selObj?"none":"grayscale(0.3)"}}>{item.e}</span>
              <span style={{color:nav===item.id&&!selObj?C.blue:C.muted,fontSize:10,fontWeight:nav===item.id&&!selObj?700:400,whiteSpace:"nowrap"}}>{item.l.split(" ")[0]}</span>
            </button>
          ))}
          <button onClick={()=>{setNav("einstellungen");setSelObj(null);}}
            style={{flex:1,background:"none",border:"none",padding:"8px 2px 4px",cursor:"pointer",display:"flex",flexDirection:"column",alignItems:"center",gap:2}}>
            <span style={{fontSize:22,opacity:nav==="einstellungen"||nav==="benutzer"?1:.45}}>⚙️</span>
            <span style={{color:nav==="einstellungen"||nav==="benutzer"?C.blue:C.muted,fontSize:10,fontWeight:nav==="einstellungen"||nav==="benutzer"?700:400}}>Mehr</span>
          </button>
          <button onClick={doLogout} style={{flex:1,background:"none",border:"none",padding:"8px 2px 4px",cursor:"pointer",display:"flex",flexDirection:"column",alignItems:"center",gap:2}}>
            <span style={{fontSize:22,opacity:.45}}>⏻</span>
            <span style={{color:C.rT,fontSize:10}}>Logout</span>
          </button>
        </div>
      )}

      <div style={{flex:1,display:"flex",flexDirection:"column",overflow:"hidden",paddingBottom:isMobile?"calc(64px + env(safe-area-inset-bottom))":"0",WebkitOverflowScrolling:"touch"}}>
        {/* Global Search Bar */}
        {(nav==="dashboard"||nav==="mitarbeiter")&&!selObj&&(
          <div style={{padding:"10px 16px 0",background:C.bg}}>
            <div style={{position:"relative"}}>
              <span style={{position:"absolute",left:10,top:"50%",transform:"translateY(-50%)",color:C.muted,fontSize:14}}>🔍</span>
              <input style={{width:"100%",background:C.card,border:`1px solid ${C.border}`,borderRadius:9,color:C.text,padding:"9px 12px 9px 32px",fontSize:14,outline:"none",boxSizing:"border-box",fontFamily:"inherit"}}
                placeholder="Mieter, Objekt oder Einheit suchen…"
                value={search} onChange={e=>setSearch(e.target.value)}/>
              {search&&<button onClick={()=>setSearch("")} style={{position:"absolute",right:10,top:"50%",transform:"translateY(-50%)",background:"none",border:"none",color:C.muted,cursor:"pointer",fontSize:16}}>✕</button>}
            </div>
            {search.trim().length>1&&(()=>{
              const q = search.toLowerCase();
              const results = [];
              db.mieter.forEach(m=>{
                if(m.leerstand) return;
                if(m.name?.toLowerCase().includes(q)||m.email?.toLowerCase().includes(q)||m.telefon?.includes(q)){
                  const v = db.vertraege.find(x=>x.mieterId===m.id&&x.aktiv);
                  const obj = v ? db.objekte.find(o=>o.id===v.objektId) : null;
                  results.push({type:"mieter",m,v,obj});
                }
              });
              db.objekte.forEach(o=>{
                if(o.adresse?.toLowerCase().includes(q)||o.name?.toLowerCase().includes(q)){
                  results.push({type:"objekt",o});
                }
              });
              db.vertraege.filter(v=>v.aktiv&&!v.leerstand).forEach(v=>{
                if(v.einheit?.toLowerCase().includes(q)){
                  const m = db.mieter.find(x=>x.id===v.mieterId);
                  const o = db.objekte.find(x=>x.id===v.objektId);
                  if(!results.find(r=>r.type==="mieter"&&r.m?.id===m?.id))
                    results.push({type:"mieter",m,v,obj:o});
                }
              });
              if(results.length===0) return <div style={{background:C.card,borderRadius:9,padding:"10px 14px",marginTop:6,color:C.muted,fontSize:13}}>Keine Ergebnisse für „{search}"</div>;
              return (
                <div style={{background:C.card,borderRadius:9,marginTop:6,border:`1px solid ${C.border}`,overflow:"hidden",maxHeight:280,overflowY:"auto"}}>
                  {results.slice(0,8).map((r,i)=>(
                    <div key={i} style={{padding:"10px 14px",borderBottom:`1px solid ${C.border}`,cursor:"pointer",display:"flex",alignItems:"center",gap:10}}
                      onClick={()=>{
                        if(r.type==="objekt"){setSelObj(r.o.id);setNav("dashboard");}
                        else if(r.type==="mieter"&&r.obj){setSelObj(r.obj.id);setNav("dashboard");}
                        setSearch("");
                      }}>
                      <span style={{fontSize:18}}>{r.type==="objekt"?"🏢":"👤"}</span>
                      <div>
                        <div style={{color:C.text,fontSize:13,fontWeight:600}}>
                          {r.type==="objekt"?r.o.adresse:r.m?.name}
                        </div>
                        <div style={{color:C.muted,fontSize:11}}>
                          {r.type==="objekt"?`${db.vertraege.filter(v=>v.objektId===r.o.id&&v.aktiv&&!v.leerstand).length} Mieter`:
                            `${r.obj?.adresse||"?"} · ${r.v?.einheit||""}`}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              );
            })()}
          </div>
        )}
        {nav==="dashboard"&&!selObj&&<Dashboard/>}
        {user?.role==="mitarbeiter"&&nav!=="mitarbeiter"&&nav!=="einstellungen"&&nav!=="dashboard"&&(
          <div style={{padding:28,display:"flex",alignItems:"center",justifyContent:"center",flex:1}}>
            <div style={{textAlign:"center"}}><div style={{fontSize:48,marginBottom:12}}>🔒</div><div style={{color:C.muted}}>Kein Zugriff auf diesen Bereich</div></div>
          </div>
        )}
        {nav==="dashboard"&&selObj&&<ObjektDetail/>}
        {nav==="finanzen"&&<Finanzen ctx={{db,upd,say,getOb,vvObj,istObj,zdA,getMi,gesamtE,gesamtA,exportCSV,fmtD,fmt,uid,user,token,C,bP,bS,bD,inp,setModal}}/>}
        {nav==="mitarbeiter"&&<Mitarbeiter/>}
        {nav==="brief"&&<BriefSchreiben/>}
        {nav==="einstellungen"&&<Einstellungen/>}
        {nav==="benutzer"&&user?.role==="admin"&&<Benutzerverwaltung token={token} currentUser={user}/>}
      </div>
      {renderModal()}
      {/* 2FA Erster-Login Dialog */}
  {showSetup2FA&&(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.7)",zIndex:9000,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
      <div style={{background:C.card,borderRadius:16,padding:28,width:"100%",maxWidth:480,border:`1px solid ${C.border}`}}>
        {setup2FAStep==="ask"&&(<>
          <div style={{textAlign:"center",marginBottom:20}}>
            <div style={{fontSize:44,marginBottom:12}}>🛡️</div>
            <div style={{color:C.text,fontWeight:800,fontSize:18,marginBottom:8}}>Konto besser schützen?</div>
            <div style={{color:C.muted,fontSize:13,lineHeight:1.6}}>Mit der Zwei-Faktor-Authentifizierung (2FA) ist dein Account auch dann sicher, wenn jemand dein Passwort kennt. Du brauchst dazu nur eine kostenlose App wie <strong style={{color:C.text}}>Google Authenticator</strong> oder <strong style={{color:C.text}}>Authy</strong>.</div>
          </div>
          <div style={{display:"flex",gap:10}}>
            <button style={{...bS,flex:1,justifyContent:"center"}} onClick={()=>setShowSetup2FA(false)}>Später</button>
            <button style={{...bP,flex:1,justifyContent:"center"}} onClick={start2FASetup}>🔐 2FA aktivieren</button>
          </div>
        </>)}
        {setup2FAStep==="scan"&&setup2FAData&&(<>
          <div style={{color:C.text,fontWeight:800,fontSize:16,marginBottom:4}}>QR-Code scannen</div>
          <div style={{color:C.muted,fontSize:12,marginBottom:16}}>Öffne Google Authenticator oder Authy und scanne diesen Code:</div>
          <div style={{textAlign:"center",marginBottom:16}}>
            <img src={setup2FAData.qrUrl} alt="QR Code" style={{width:180,height:180,borderRadius:10}}/>
          </div>
          <div style={{color:C.muted,fontSize:11,marginBottom:4}}>Oder manuell eingeben:</div>
          <div style={{background:C.card2,borderRadius:7,padding:"8px 12px",fontFamily:"monospace",fontSize:12,color:C.text,marginBottom:16,wordBreak:"break-all"}}>{setup2FAData.secret}</div>
          <div style={{color:C.muted,fontSize:12,marginBottom:6}}>Dann den 6-stelligen Code aus der App eingeben:</div>
          <input style={{...Object.fromEntries(Object.entries({background:C.card2,border:`1px solid ${C.border}`,borderRadius:8,color:C.text,padding:"10px",fontSize:20,width:"100%",textAlign:"center",letterSpacing:6,outline:"none",boxSizing:"border-box",marginBottom:12}))}}
            type="text" inputMode="numeric" maxLength={6} value={setup2FACode}
            onChange={e=>setSetup2FACode(e.target.value.replace(/\D/g,""))} placeholder="000000"/>
          <div style={{display:"flex",gap:10}}>
            <button style={{...bS,flex:1,justifyContent:"center"}} onClick={()=>{setSetup2FAStep("ask");setSetup2FACode("");}}>← Zurück</button>
            <button style={{...bP,flex:1,justifyContent:"center"}} onClick={confirm2FASetup} disabled={setup2FACode.length!==6}>✓ Bestätigen</button>
          </div>
        </>)}
        {setup2FAStep==="backup"&&(<>
          <div style={{textAlign:"center",marginBottom:16}}>
            <div style={{fontSize:36,marginBottom:8}}>✅</div>
            <div style={{color:C.gT,fontWeight:800,fontSize:16,marginBottom:4}}>2FA aktiviert!</div>
            <div style={{color:C.muted,fontSize:12}}>Speichere diese Backup-Codes sicher – du brauchst sie wenn du dein Handy verlierst:</div>
          </div>
          <div style={{background:C.card2,borderRadius:10,padding:16,marginBottom:16,display:"grid",gridTemplateColumns:"1fr 1fr",gap:6}}>
            {backupCodes.map((c,i)=><div key={i} style={{fontFamily:"monospace",fontSize:13,color:C.text,padding:"4px 8px",background:C.bg,borderRadius:5,textAlign:"center"}}>{c}</div>)}
          </div>
          <button style={{...bP,width:"100%",justifyContent:"center"}} onClick={()=>{setShowSetup2FA(false);setSetup2FAStep("ask");say("2FA erfolgreich aktiviert ✓");}}>
            ✓ Codes gespeichert – Fertig
          </button>
        </>)}
      </div>
    </div>
  )}

  {toast&&<div style={{position:"fixed",bottom:isMobile?"calc(70px + env(safe-area-inset-bottom))":22,right:22,background:C.card,border:`1px solid ${C.gT}`,color:C.gT,borderRadius:9,padding:"11px 18px",fontSize:13,fontWeight:600,zIndex:9999,boxShadow:"0 6px 20px rgba(0,0,0,.15)"}}>{toast}</div>}
      <style>{`
    @keyframes spin{from{transform:rotate(0)}to{transform:rotate(360deg)}}
    * { -webkit-tap-highlight-color: transparent; box-sizing: border-box; }
    html, body, #root { height: 100%; overflow: hidden; overscroll-behavior: none; }
    input, textarea, select { font-size: 16px !important; -webkit-appearance: none; }
    button { -webkit-appearance: none; touch-action: manipulation; }
    ::-webkit-scrollbar { width: 0; height: 0; display: none; }
    scrollbar-width: none;
    @supports(padding: max(0px)) {
      body { padding-top: env(safe-area-inset-top); }
    }
    @media (max-width: 767px) {
      input, textarea, select { font-size: 16px !important; border-radius: 10px !important; }
      button { min-height: 44px; }
      .modal-inner {
        max-height: 92dvh !important;
        overflow-y: auto !important;
        -webkit-overflow-scrolling: touch;
        padding-bottom: calc(20px + env(safe-area-inset-bottom)) !important;
        border-radius: 18px 18px 0 0 !important;
      }
      h1 { font-size: 18px !important; }
      h2 { font-size: 16px !important; }
      table { font-size: 12px !important; }
    }
  `}</style>
    </div>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <AppInner/>
    </ErrorBoundary>
  );
}
